(function () {
  'use strict';

  angular.module('BlurAdmin.config', [
   'BlurAdmin.utils',
  ]);

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.coreview', [
   'ui.router',
   'BlurAdmin.metadata',
 ]);
 
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.metadata', ['BlurAdmin.utils'])

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.resourceserver', [
   'ui.router',
   'BlurAdmin.utils',
   'BlurAdmin.config',
  ])

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.translations', [
            'pascalprecht.translate'
        ])
        .config(translationsConfig);

    /** @ngInject */
    function translationsConfig($translateProvider) {
        $translateProvider.registerAvailableLanguageKeys(['en', 'pl']);

        $translateProvider.translations('en', {
            ERROR_CONNECTION_REFUSED: "Server is currently undergoing maintenance. Please try again later.",
            ERROR_FAILED_TO_LOAD_OAUTH: "Failed to load permissions.",
            ERROR_FAILED_TO_LOAD_METADATA: "Failed to load data.",
            ERROR_FAILED_TO_LOAD_RESOURCES: "Failed to load resource.",
            SIDEBAR_TITLE__REPORT_TEMPLATES: "Report templates",
            SIDEBAR_TITLE__REPORT_TEMPLATES_DEMO: "Report templates (demo)",
            REPORT_TEMPLATES_NEW__TITLE: "New report template",
            REPORT_TEMPLATES_EDIT__TITLE: "Edit report template",
            COMMONS__DESCRIPTION: "Description",
            COMMONS__TYPE: "Type",
            COMMONS__TIME_INTERVAL: "Time interval",
            COMMONS__DETAILED: "Detailed",
            COMMONS__ELEMENTS: "Elements",
            COMMONS__YES: "Yes",
            COMMONS__NO: "No",
            REPORT_TEMPLATES_DETAILS__TITLE: "Report template details",
            COMMONS__TEMPLATE_DATA: "Template data",
            Vehicles: "Vehicles",
            ChargeBoxes: "ChargeBoxes",
            currentDay: "Current day",
            currentWeek: "Current week",
            currentMonth: "Current month",
            currentQuarter: "Current quarter",
            currentYear: "Current year",
            previousDay: "Previous day",
            previousWeek: "Previous week",
            previousMonth: "Previous month",
            previousQuarter: "Previous quarter",
            previousYear: "Previous year",
            true: "Yes",
            false: "No",
            EmergencyStop: "Emergency stop",
            EVDisconnected: "Vehicle disconnected",
            HardReset: "Hard reset",
            Local: "Locally",
            Other: "Other",
            PowerLoss: "Power loss",
            Reboot: "Reboot",
            Remote: "Remote",
            SoftReset: "Soft reset",
            UnlockCommand: "Unlock command",
            DeAuthorized: "No authorization",
            IdleTimeout: "Idle Timeout",
            IdleTimeoutMissingData: "Timout and Missing data",
            COMMONS__SAVE_PASSWORD: "Zapisz hasło",
            ALERT_VIEW__DELETE: "Delete alert",
            ALERTS_LIST__ARCHIVED: "",
            REQUEST_TIME: "Request Time",
            CHARGE_BOX_VIEW__CONNECTOR: "Connector",
            COMMON_PROTOCOL: "Protocol",
            AlertAdministrationList: "AlertList",
            AuthorizationTagAdministrationList: "AuthorizationTagList",
            ChargeBoxAdministrationList: "ChargeBoxList",
            ChargeBoxGroupAdministrationList: "ChargeBoxGroupList",
            RoleAdministrationList: "RoleList",
            RolePermissionsAdministrationList: "RolePermissionsList",
            UserAdministrationList: "UserList",
            VehicleAdministrationList: "VehicleList",
            AlertList: "AlertList",
            CHARGE_BOX_DIAGNOSTICS__TITLE: "Diagnostics",
            CHARGE_BOX_CONFIGURATION__GET_DIAGNOSTICS: "Send request",
            CHARGE_BOX_VIEW__SHOW_DIAGNOSTICS: "Show diagnostics",
            ChargeBoxesConfiguration: "ChargeBoxesConfiguration",
            ChargeBoxActivityHoursList: "ChargeBoxActivityHoursList",
            ChargeBoxesChargingList: "ChargeBoxesChargingList",
            ChargeBoxesErrorList: "ChargeBoxesErrorList",
            ChargeBoxesList: "ChargeBoxesList",
            ChargeBoxesOfflineList: "ChargeBoxesOfflineList",
            ChargeBoxesOnlineList: "ChargeBoxesOnlineList",
            ChargeBoxesWarningList: "ChargeBoxesWarningList",
            ChargeBoxesGroupList: "ChargeBoxesGroupList",
            ChargingProfilesList: "ChargingProfilesList",
            ChargeBoxesActivityList: "ChargeBoxesActivityList",
            VehicleDistanceList: "VehicleDistanceList",
            ChargeBoxMap: "ChargeBoxMap",
            ChargeBoxConsumedEnergyReportList: "ChargeBoxConsumedEnergyReportList",
            ChargeBoxGroupConsumedEnergyReportList: "ChargeBoxGroupConsumedEnergyReportList",
            TransactionsReportList: "TransactionsReportList",
            VehicleConsumedEnergyReportList: "VehicleConsumedEnergyReportList",
            ReportTemplatesList: "ReportTemplate",
            ReportTemplatesDetailsList: "ReporTemplateDetail",
            TransactionList: "TransactionList",
            VehicleList: "VehicleList",
            OFFLINE_CHART_STATE: "Offline",
            ONLINE_CHART_STATE: "Online",
            ERROR_CHART_STATE: "Error",
            CHARGING_CHART_STATE: "Charging",
            MISSING_PERMISSIONS: "Missing permissions. Please contact with application administrator.",
            DEFAULT_ERROR_MESSAGE: "An error occurred, the product administrator was automatically notified.",
            COMMONS__MAX_POWER: "Max power [kW]",
            MAX_POWER_WAS_CHANGED: "Max power was changed",
            COMMONS__CHANGE_PASSWORD: "Change password",
            Percent: "%",
            Available: "Available",
            Reserved: "Reserved",
            Faulted: "Faulted",
            Unavailable: "Unavailable",
            Occupied: "Occupied",
            Preparing: "Preparing",
            Charging: "Charging",
            SuspendedEV: "SuspendedEV",
            SuspendedEVSE: "SuspendedEVSE",
            Finishing: "Finishing",
            DASHBOARD_CHARGE_POINT_STATUS: "Status",
            SIDEBAR_TITLE__TRANSACTIONS_EXPORT: "Export transactions",
            PLEASE_CHANGE_TO_TIME_SEARCH_INPUT: "Please change to time search input",
            COMMONS__SOC_AT_BEGIN: "SOC(p) [%]",
            COMMONS__SOC_AT_END: "SOC(k) [%]",
            COMMONS__SOC_DELTA: "SOC(Δ) [%]",
            DASHBOARD_TIME_TO_CHARGING_END: "Time to end",
            DASHBOARD_FACTORY_POWER: "Factory power [kW]",
            DASHBOARD_SOCb: "SOC(b) [%]",
            DASHBOARD_SOCk: "SOC(k) [%]",
            EXPORT_FILE_WAS_DOWNLOADED: "Export file was downloaded",
            TRANSACTIONS_TABLE__CHARGE_BOX_NAME: "Name",
            TRANSACTIONS_TABLE__CHARGE_BOX: "ChargeBox",
            TRANSACTIONS_TABLE__SOCK: "Soc(k) [%]",
            DIAGNOSTICS__LOCATION: "Location",
            DIAGNOSTICS__START_TIME: "StartTime",
            DIAGNOSTICS__STOP_TIME: "StopTime",
            DIAGNOSTICS__RETRIES: "Retries",
            DIAGNOSTICS__RETRY_INTERVAL: "RetryInterval",

            CONFIGURATION_DOWNLOADED: "Configuration downloaded.",
            CONFIGURATION_WAS_CHANGED: "Configuration was changed.",
            TRANSACTION_WAS_STARTED: "Transaction was started.",
            TRANSACTION_WAS_STOPPED: "Transaction was stopped.",
            RESET_ACCEPTED: "Reset was accepted",
            CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL: "Communication protocol",
            COMMONS__RESULTS_ARE_EMPTY: "Results are empty",
            CHARGEBOX_ACTIVITY__TABLE__TRANSACTION_ID: "TransactionId",
            CHARGE_BOX_VIEW__CHARGING_PROFILES: "Charging profiles",
            SIDEBAR_TITLE__CHARGEBOX_SENDED_CHARGING_PROFILES: "SendedChargingProfiles",
            SIDEBAR_TITLE__CHARGEBOX_SEND_CHARGING_PROFILE: "SendChargingProfile",
            PROFILE_ID: "Id",
            TRANSACTION_ID: "Transaction Id",
            STACK_LEVEL: "StackLevel",
            PROFILE_PURPOSE: "Purpose",
            PROFILE_KIND: "Kind",
            RECURRENCY_KIND: "RecurrencyKind",
            FROM: "From",
            TO: "To",
            SIDEBAR_TITLE__CHARGEBOX_GET_CHARGING_SCHEDULE: "GetChargingSchedule",
            RESULTS_FOR: "ResultsFor",
            COMMONS__START_PERIOD: "StartPeriod",
            COMMONS__LIMIT: "Limit",
            CHARGE_BOX__NUMBER_PHASES: "NumberPhases",
            SIDEBAR_TITLE__CHARGING_PROFILES: "Charging profiles",
            CHARGE_BOX__GET_CHARGING_SCHEDULE: "Get charging schedule",
            CHARGE_BOX__ARCHIVED_SET_CHARGING_PROFILE: "Archived set charing profile",
            REQUEST_WAS_REJECTED: "Request was rejected",
            CHARGING_PROFILE__CHARGING_SCHEDULE_PERIOD: "ChargingSchedulePeriod",
            CHARGING_PROFILE__START_PERIOD: "StartPeriod",
            CHARGING_PROFILE__LIMIT: "Limit",
            CHARGING_PROFILE__NUMBER_PHASES: "NumberPhases",
            CHARGING_PROFILE__NUMBER_OF_PHASES: "NumberPhases",
            CHARGING_PROFILE__ADD_SCHEDULE_PERIOD: "Add schedule period",
            CHARGING_PROFILE__CONNECTOR: "Connector",
            CHARGING_PROFILE__STACK_LEVEL: "StackLevel",
            CHARGING_PROFILE__CHARGING_PROFILE_PURPOSE: "ChargingProfilePurpose",
            CHARGING_PROFILE__CHARGING_PROFILE_KIND: "ChargingProfileKind",
            CHARGING_PROFILE__RECURRENCY_KIND: "RecurrencyKind",
            CHARGING_PROFILE__VALID_FROM: "ValidFrom",
            CHARGING_PROFILE__VALID_TO: "ValidTo",
            CHARGING_PROFILE__DURATION: "Duration",
            CHARGING_PROFILE__START_SCHEDULE: "StartSchedule",
            CHARGING_PROFILE__CHARGING_RATE_UNIT: "ChargingRateUnit",
            CHARGING_PROFILE__MIN_CHARGING_RATE: "MinChargingRate",
            CHARGING_PROFILE__EDIT: "ChargingProfile edit",
            CHARGING_PROFILE__REGISTER: "Charging profile register",
            CHARGING_PROFILE__IDENTITY: "Identity",
            CHARGE_BOX__SET_CHARGING_PROFILE: "Set charging profile",
            CHARGING_PROFILE__TRANSACTION_ID: "TransactionId",
            CHARGING_PROFILE__PRESET: "Preset",
            CHARGING_PROFILE__DETAILS: "ChargingProfile details",
            COMMONS__SEND: "Send",
            CHARGE_BOX_VIEW__REFRESH_MAX_POWER: "RefreshMaxPower",
            CHARGE_BOX_GROUP_EDIT__POWER: "Power for group",
            CHARGE_BOX_GROUP_EDIT__DYNAMIC_POWER: "Power settings",
            CHARGE_BOX_GROUP_EDIT__IS_CHARGE_BOX_CONNECTED: "ChargeBox connected",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_NAME: "ChargeBox name",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_POWER: "ChargeBox power",
            CHARGE_BOX_GROUP_EDIT__WEIGHT: "Weight",
            CHARGE_BOX_GROUP_EDIT__PERCENTAGE_OF_POWER: "Percentage of power",
            CHARGE_BOX_GROUP_EDIT__MAX_POWER_BY_PRIORITY: "Max power by priority",
            CHARGE_BOX_GROUP_EDIT__PRIORITY: "Priority",
            CHARGE_BOX_GROUP_EDIT__SIMULATION: "Simulation",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_STATE: "State",
            CHARGE_BOX_GROUP_EDIT__PERCENTAGE_USE: "PercentageUse",
            CHARGE_BOX_GROUP_EDIT__SUMMARY: "Summary",
            // chargebox configuration
            iccid:"iccid",
            chargeBoxSerialNumber:"chargeBoxSerialNumber",
            chargePointSerialNumber:"chargePointSerialNumber",
            chargePointVendor:"chargePointVendor",
            meterType:"meterType",
            meterSerialNumber:"meterSerialNumber",
            imsi:"imsi",
            proximityLockRetries:"proximityLockRetries",
            stopTxnAlignedData:"stopTxnAlignedData",
            meterValueSampleInterval:"meterValueSampleInterval",
            heartBeatInterval:"heartBeatInterval",
            lightIntensity:"lightIntensity",
            blinkRepeat:"blinkRepeat",
            meterValuesAlignedData:"meterValuesAlignedData",
            meterValuesSampledData:"meterValuesSampledData",
            proximityContactRetries:"proximityContactRetries",
            chargeBoxIdentity:"chargeBoxIdentity",
            resetRetries:"resetRetries",
            firmwareVersion:"firmwareVersion",
            connectionTimeOut:"connectionTimeOut",
            stopTxnSampledData:"stopTxnSampledData",
            chargePointId:"chargePointId",
            COMMONS_SHOW_DETAILS: "ShowDetails",
            SIDEBAR_TITLE__VEHICLE_DISTANCE: "VehicleDistance",
            VEHICLE_DISTANCE_DETAILS__TITLE: "VehicleDistance details",
            VEHICLE_DISTANCE__TABLE__MESSAGE_ID: "MessageId",
            VEHICLE_DISTANCE__VEHICLE_ID: "VehicleId",
            VEHICLE_DISTANCE__SESSION_ID: "SessionId",
            VEHICLE_DISTANCE__DISTANCE: "Distance",
            VEHICLE_DISTANCE__TRANSACTION_ID: "TransactionId",
            VEHICLE_DISTANCE__DATE_TIME: "DateTime",
            VEHICLE_DISTANCE__STATUS: "Status",
            VEHICLE_REPORT_SEARCH_FORM__VEHICLE_IDENTITY: "Vehicle identity",
            VEHICLE_REPORT_SEARCH_FORM__VEHICLE_NAME: "Vehicle side number",
            COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY: "Average returned energy [Wh]",
            COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY: "Total returned energy [Wh]",
            REPORT_CHARGE_BOX_GROUP__GROUP_NAME: "Group name",
            SIDEBAR_TITLE__CHARGE_BOX_ENERGY: "ChargeBox: energy",
            SIDEBAR_TITLE__CHARGE_BOX_GROUP_ENERGY: "ChargeBoxGroup: energy",
            SIDEBAR_TITLE__VEHICLE_ENERGY: "Vehicle: energy",
            TableNoMoreElementsTitle: "NoMoreElements",
            TableNoMoreElementsDescription: "NoMoreElements",
            USER_PROFILE__USER_DATA: "UserData",
            USER_PROFILE__EMAIL: "Email",
            USER_PROFILE__FIRST_NAME: "FirstName",
            USER_PROFILE__LAST_NAME: "LastName",
            USER_PROFILE__PHONE: "Phone",
            USER_PROFILE__LANGUAGE: "Language",
            USER_PROFILE__ROLES: "Roles",
            USER_EDIT__TITLE: "Edit user",
            CHARGE_BOX_VIEW__REMAINING_TIME_TO_BULK_SOC: "Time to 80%",
            CHARGE_BOX_VIEW__REMAINING_TIME_TO_FULL_SOC: "Time to 100%",
            // commons
            without_group: "Default group",
            COMMONS__LANGUAGE: "Language",
            COMMONS__ID: "Id",
            COMMONS__LP: "No.",
            COMMONS__STATE: "State",
            COMMONS__SUMMARY: "Summary",
            COMMONS__CHARGEBOXES: "ChargeBoxes",
            COMMONS__CHARGEBOX_GROUPS: "ChargeBox groups",
            COMMONS__VEHICLES: "Vehicles",
            CHARGE_BOX__IS_IN_OFFLINE_STATE: "ChargeBox is in offline state.",
            SIDEBAR_TITLE__CHARGE_BOX_GROUP_CONSUMED_ENERGY: "Group consumed energy",
            SIDEBAR_TITLE__VEHICLE_CONSUMED_ENERGY: "Vehicle consumed energy",
            ALERT_DETAILS__TITLE: "Alert details",
            MISSING_CHARGE_BOX_PROTOCOL: "Missing chargeBox protocol",
            CHARGE_BOX_CONFIGURATION__DOWNLOAD_CONFIGURATION: "Download configuration",
            CHARGE_BOX_CONFIGURATION__READ_ONLY: "Read only configuration",
            CHARGE_BOX_CONFIGURATION__READ_WRITE: "Read write configuration",
            COMMONS__CHARGE_BOX_GROUP_IDENTITY: "ChargeBoxGroup identity",
            COMMONS__CHARGE_BOX_GROUP_NAME: "ChargeBoxGroup name",
            COMMONS__VEHICLE_IDENTITY: "Vehicle identity",
            COMMONS__VEHICLE_NAME: "Vehicle name",
            COMMONS__TIME_RANGE: "Time range",
            COMMONS_SERVER_IS_BUSY_TITLE: "Server is busy",
            COMMONS_SERVER_IS_BUSY_MESSAGE: "Server is busy",
            COMMONS_DATA__WAS_LOADED: "Data was loaded.",
            COMMONS__FIRST: "First",
            COMMONS__PREVIOUS: "Previous",
            COMMONS__NEXT: "Next",
            COMMONS__LAST: "Last",
            COMMONS__SAVE: "Save",
            COMMONS__SEARCH: "Search",
            COMMONS__RESET: "Reset",
            COMMONS__CANCEL: "Cancel",
            COMMONS__OPEN_SEARCH_CRITERIA: "Open search criteria",
            COMMONS__RELOAD_TABLE_DATA: "Refresh table entries",
            COMMONS__EXPORT_XLSX: "Export xlsx",
            COMMONS__EXPORT_CSV: "Export",
            COMMONS__ITEMS_PER_PAGE: "Items per page",
            COMMONS__ADD_NEW_ITEM: "Add",
            COMMONS__EDIT: "Edit",
            COMMONS__VIEW: "View",
            COMMONS__IMPORT: "Import",
            COMMONS__DATA_RELOADED: "Data reloaded",
            COMMONS__SERVER_OFFLINE: "Server offline! Please contact with administrator: mail@mail.mail",
            COMMONS__DATA_SYNCHRONIZATION: "Synchonize data",
            COMMONS__AUTO_RELOAD: 'Auto reload',
            COMMONS__SEND_DATA_REQUEST: 'Send data request',
            COMMONS__CHARGE_BOX: 'ChargeBox',
            COMMONS_REQUEST__TIME: 'Time',
            COMMONS_REQUEST__RESPONSE_STATUS: 'Response Status',
            COMMONS_REQUEST__STATUS: 'Status',
            COMMONS__ACTIONS: 'Actions',
            COMMONS__DEACTIVATE: 'Deactivate',
            COMMONS__ACTIVATE: 'Activate',
            COMMONS__ACTIVE: 'Active',
            COMMONS__ADDED_DATE_TIME: "AddedDateTime",
            COMMONS__SHOW: "Show",
            COMMONS__ADD_RECEIVER: "Add receiver",
            COMMONS__BEGIN: "Begin",
            COMMONS__END: "End",
            COMMONS__DURATION: "Duration",
            COMMONS__SOCKET: "Socket",
            COMMONS__CONSUMED_ENERGY: "Consumed energy",
            COMMONS__RETURNED_ENERGY: "Returned energy",
            COMMONS__VEHICLE: "Vehicle",
            COMMONS__TRANSACTION: "transaction",
            COMMONS__TRANSACTIONS: "transactions",
            COMMONS__FINAL_SOC: "Final SOC",
            COMMONS__SEARCH_COMPARISION_OPERATOR: "Comparission operator",
            COMMONS__REQUEST: "Request",
            COMMONS__RESPONSE: "Response",
            COMMONS__SEND_REQUEST: "Send request",
            COMMONS__CHANGE: "Change",
            COMMONS__CLOSE: "Close",
            COMMONS__ERROR: "Error",
            COMMONS__SERVER_IS_NOT_AVAILABLE: "Server is not available please contact with administrator.",
            COMMONS__PERIOD: "Period",
            COMMONS__PERIOD_6_H: "6H",
            COMMONS__PERIOD_24_H: "24H",
            COMMONS__PERIOD_10_D: "10D",
            COMMONS__PERIOD_30_D: "30D",
            COMMONS__PERIOD_6_M: "6M",
            COMMONS__PERIOD_12_M: "12M",
            COMMONS__CHARGE_POINT: "ChargePoint",
            COMMONS__REFRESH: "Refresh",
            COMMONS__OUTLET_POWER_ACTIVE_IMPORT: "Outlet power",
            COMMONS__INLET_POWER_ACTIVE_IMPORT: "Inlet power",
            COMMONS__OUTLET_ENERGY_ACTIVE_IMPORT_REGISTER: "Outlet energy to vehicle",
            COMMONS__INLET_ENERGY_ACTIVE_IMPORT_REGISTER: "Inlet energy from vehicle",
            COMMONS__IMPORT_VOLTAGE_OUTLET: "Outlet voltage [V]",
            COMMONS__IMPORT_VOLTAGE_INLET: "Inlet voltage [V]",
            COMMONS__VOLTAGE_TARGET_OUTLET: "Targeted outlet voltage [V]",
            COMMONS__VOLTAGE_PRESENT_INLET: "Present inlet voltage [V]",
            COMMONS__CURRENT_IMPORT_OUTLET: "Outlet current [A]",
            COMMONS__CURRENT_IMPORT_INLET: "Input current [A]",
            COMMONS__TARGET_CURRENT_OUTLET: "Targeted outlet current [A]",
            COMMONS__CURRENT_PRESENT_OUTLET: "Present outlet current [A]",
            COMMONS__SOC: "SOC [%]",
            COMMONS__Energy: "Energy",
            COMMONS__Power: "Power",
            COMMONS__Voltage: "Voltage",
            COMMONS__Current: "Current",
            COMMONS__Soc: "SOC",
            COMMONS__STATUS: "Status",
            COMMONS__Temperature: "Temperature",
            COMMONS__Other: "Other",
            COMMONS__Humidity: "Humidity",
            COMMONS__EXPORT_DATA: "Export data",
            COMMONS__AVAILABLE: "Available",
            COMMONS__SELECTED: "Selected",
            COMMONS__PRIVILEGES: "Privileges",
            COMMONS__REMOTE_RESET: "Reset",
            COMMONS__PROFILE:  "Profile",
            COMMONS__SIGN_OUT:  "Sign out",
            CHARGE_BOX__RESET_TYPE: "Reset type",
            SIDEBAR_TITLE__USER_PROFILE: "User profile",
            CHARGE_BOX_DETAILS__TITLE: "ChargeBox details",
            COMMONS__IDENTITY: "Identity",
            COMMONS__NAME: "Name",
            CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER: "Charger serial number",
            COMMONS__IP_ADDRESS: "Ip address",
            COMMONS__LAST_ACTIVITY_TIME: "Last activity time",
            COMMONS__BATTERY_CAPACITY: "Battery capacity",
            CHARGING_TRANSACTION_DETAILS__TITLE: "Charging transaction details",
            MAP_CHARGE_BOX__TITLE: "Map",
            SIDEBAR_TITLE__CHARGE_BOX_CONSUMED_ENERGY: "ChargeBox consumed energy",
            COMMONS__CHARGE_BOX_IDENTITY: "ChargeBox identity",
            COMMONS__CHARGE_BOX_NAME: "ChargeBox name",
            COMMONS__TOTAL_CHARGING_TIME: "Total charging time",
            COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY: "Transactions quantity",
            COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY: "Average consumed energy",
            COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY: "Total consumed energy",
            COMMONS__SHOW_DETAILS: "Show details",
            GENERATE: "Generate",
            VERSION: "Version",
            SIDEBAR_TITLE__ALERTS_DEFINITIONS: "Alert definitions",
            USER_ACTIVITY_ALERT: "Alert",
            USER_ACTIVITY_CHARGEBOXGROUP: "Groups",
            USER_ACTIVITY_AUTHORIZATIONTAG: "Authorization tags",
            USER_ACTIVITY_VEHICLE: "Vehicle",
            USER_ACTIVITY_CHARGEPOINT: 'Chargepoint',
            USER_ACTIVITY_ROLE: 'Role',
            USER_ACTIVITY_USER: 'User',
            USER_ACTIVITY_CHARGINGPROFILE: 'Charging profiles',
            USER_ACTIVITY_GETCONFIGURATION: 'Get configuration',
            USER_ACTIVITY_CHANGECONFIGURATION: 'Change configuration',
            USER_ACTIVITY_REMOTESTARTTRANSACTION: 'Remote start',
            USER_ACTIVITY_REMOTESTOPTRANSACTION: 'Remote stop',
            USER_ACTIVITY_REMOTERESETSOFT: 'Soft reset',
            USER_ACTIVITY_REMOTERESETHARD: 'Hard reset',
            // --------------------------------------------------------------
            // date
            DATE__YEAR: "year",
            DATE__DAY: "day",
            DATE__DAY_PLURAL: "day",
            DATE__HOUR: "hour",
            DATE__MINUTE: "minute",
            DATE__SECOND: "second",
            DATE__LESS_THAN_SECOND: "less than a second",
            // --------------------------------------------------------------
            // dialog
            DIALOG__ERROR_TITLE: "Error",
            DIALOG__SUCCESS_TITLE: "Success",
            DIALOG__EMTPY_SEARCH_CRITERIA: "Search criteria are empty.",
            DIALOG__ITEM_SAVED: "Item was saved.",
            DIALOG__ITEM_UPDATED: "Item was updated.",
            DIALOG__EMPTY_RESULTS: "Empty results.",
            // --------------------------------------------------------------
            // preconditions
            PRECONDITIONS__EMPTY_SEARCH_QUERY: "Search query cannot be empty",
            // --------------------------------------------------------------
            // login
            LOGIN__PLEASE_LOGIN: "Please login",
            LOGIN__EMAIL_ADDRESS: "Email address",
            LOGIN__PASSWORD: "Password",
            LOGIN__REMEMBER_ME: "Remember me",
            LOGIN__LOGIN: "Login",
            LOGIN__FORGOT_PASSWORD: "Forgot your password?",
            LOGIN__RESET_PASSWORD: "Type your new password",
            LOGIN__FORGOT_PASSWORD_MESSAGE: "Enter your email below and we'll send you a link to reset your password ",
            LOGIN__FORGOT_PASSWORD_CONFIRMATION: "Message has been sent to your email.",
            LOGIN__SEND: "Send",
            LOGIN__SET: "Set",
            LOGIN__INVALID_EMAIL: "Invalid email",
            // --------------------------------------------------------------
            // reset password
            RESET_PASSWORD_TOKEN__VALID: "Valid",
            RESET_PASSWORD_TOKEN__INVALID: "Invalid token",
            RESET_PASSWORD_TOKEN__EXPIRED: "Expired token",
            RESET_PASSWORD_TOKEN__ERROR: "Error occured while checking token.",
            RESET_PASSWORD__COMPLETED: "Your password has been changed.",
            RESET_PASSWORD__ERROR: "Error occured while trying to change password.",
            // --------------------------------------------------------------
            // menu
            // --------------------------------------------------------------
            SIDEBAR_TITLE__AUTHORIZATION_TAGS: "Authorization tags",
            SIDEBAR_TITLE__CHARGE_BOX_ACTIVITIES: "ChargeBox activities",
            SIDEBAR_TITLE__CHARGEBOX_AUTHORIZATION: "Authorization",
            SIDEBAR_TITLE__BOOT_NOTIFICATION: "Boot notification",
            SIDEBAR_TITLE__DATA_TRANSFER: "Data transfer",
            SIDEBAR_TITLE__DIAGNOSTICS_NOTIFICATION: "Diagnostics notiication",
            SIDEBAR_TITLE__FIRMWARE_NOTIFICATION: "Firmware notification",
            SIDEBAR_TITLE__HEARTBEAT: "Heartbeat",
            SIDEBAR_TITLE__METER_VALUES: "Meter values",
            SIDEBAR_TITLE__STATUS_NOTIFICATION: "Status notification",
            SIDEBAR_TITLE__CHARGING_TRANSACTION: "Charging transaction",
            SIDEBAR_TITLE__CHARGEBOXES: "Chargers",
            SIDEBAR_TITLE__CHARGEBOXES_ALL: "ALL",
            SIDEBAR_TITLE__CHARGEBOXES_ERROR: "ERROR",
            SIDEBAR_TITLE__CHARGEBOXES_CHARGING: "ACTIVE",
            SIDEBAR_TITLE__CHARGEBOXES_ONLINE: "READY",
            SIDEBAR_TITLE__CHARGEBOXES_WARNING: "WARNING",
            SIDEBAR_TITLE__CHARGEBOXES_OFFLINE: "OFFLINE",
            SIDEBAR_TITLE__IMPORT_DATA: "Import data",
            SIDEBAR_TITLE__IMPORT_REGISTRATION_DATA: "Import registration data",
            SIDEBAR_TITLE__METER_VALUES_CURRENT: "Current",
            SIDEBAR_TITLE__METER_VALUES_ALL: "All",
            SIDEBAR_TITLE__REGISTRATION: "Registration",
            SIDEBAR_TITLE__REGISTRATION_CHARGEBOX: "Chargebox",
            SIDEBAR_TITLE__REGISTRATION_AUTHORIZATION_TAG: "AuthorizationTag",
            SIDEBAR_TITLE__ROLES: "Roles",
            SIDEBAR_TITLE__REGISTRATION_ROLE: "Role",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS: "Transactions history",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS_CURRENT: "Current",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS_ALL: "All",
            SIDEBAR_TITLE__USERS: "Users",
            SIDEBAR_TITLE__REGISTRATION_USER: "User",
            SIDEBAR_TITLE__VEHICLE: "Vehicle",
            SIDEBAR_TITLE__CHARGEBOX_DETAILS: "ChargeBox details",
            SIDEBAR_TITLE__MAP: "Map",
            SIDEBAR_TITLE__CHARGEBOX_STATE_ACTIVITIES: "ChargeBox hours activities",
            SIDEBAR_TITLE__CHARGEBOX_TRANSACTIONS: "ChargeBox transactions",
            SIDEBAR_TITLE__CHARGEBOX_ALERTS: "ChargeBox alerts",
            SIDEBAR_TITLE__USERACTIVITY: "Users activity",
            // --------------------------------------------------------------
            // dashboard
            DASHBOARD__CHARGE_BOXES_LIST__CHARGE_POINT_NAME: "Charger name",
            DASHBOARD__CHARGE_BOXES_LIST__SERIAL_NUMBER: "Serial number",
            DASHBOARD__CHARGE_BOXES_LIST__LAST_ACTIVITY: "Last activity",
            DASHBOARD__CHARGE_BOXES_LIST__LAST_CHARGING: "Last charging",
            DASHBOARD__CHARGE_BOXES_LIST__IP_ADDRESS: "IP address",
            DASHBOARD__CHARGE_BOXES_LIST__ERROR: "ERROR",
            DASHBOARD__CHARGE_BOXES_LIST__CHARGING:	"CHARGING",
            DASHBOARD__CHARGE_BOXES_LIST__WARNING: "WARNING",
            DASHBOARD__CHARGE_BOXES_LIST__ONLINE: "ONLINE",
            DASHBOARD__CHARGE_BOXES_LIST__OFFLINE: "OFFLINE",
            DASHBOARD_CHARGEBOX_QUANTITY: "Chargers quantity",
            DASHBOARD_TOTAL_POWER: "Total power [kW]",
            DASHBOARD_POWER: "Power",
            DASHBOARD_LAST_ACTIVITY: "Last activity",
            DASHBOARD_LAST_CHARGING: "Last charging",
            DASHBOARD_LAST_ERROR: "Last error",
            DASHBOARD_LAST_WARNING: "Last warning",
            DASHBOARD_IP: "IP",
            DASHBOARD_SOC: "SOC [%]",
            DASHBOARD_VEHICLE: "Vehicles",
            DASHBOARD_FROM_WHEN: "Since",
            // authorization tags
            AUTHORIZATION_TAG_LIST__TITLE: "Authorization tags",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__PARENT_ID_TOKEN: "Parent id token",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__ID_TOKEN: "Id token",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__STATUS: "Status",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__EXPIRY_DATE: "Expiry date",
            AUTHORIZATION_TAG_LIST__TABLE__PARENT_ID_TOKEN: "Parent id token",
            AUTHORIZATION_TAG_LIST__TABLE__ID_TOKEN: "Id token",
            AUTHORIZATION_TAG_LIST__TABLE__STATUS: "Status",
            AUTHORIZATION_TAG_LIST__TABLE__EXPIRY_DATE: "Expiry date",
            AUTHORIZATION_TAG_DETAILS__TITLE: "Authorization tag details",
            AUTHORIZATION_TAG_EDIT__TITLE: "Authorization tag edit",
            AUTHORIZATION_TAG_DETAILS__PARENT_ID_TOKEN: "Parent id token",
            AUTHORIZATION_TAG_DETAILS__ID_TOKEN: "Id token",
            AUTHORIZATION_TAG_DETAILS__STATUS: "Status",
            AUTHORIZATION_TAG_DETAILS__EXPIRY_DATE: "Expiry date",
            AUTHORIZATION_TAG_REGISTER__TITLE: "Register authorization tag",
            // chargeboxes
            CHARGE_BOXES_ALL_LIST__TITLE: "ChargeBoxes",
            CHARGE_BOXES_CHARGING_LIST__TITLE: "Charging chargeBoxes",
            CHARGE_BOXES_ERROR_LIST__TITLE: "Error chargeBoxes",
            CHARGE_BOXES_OFFLINE_LIST__TITLE: "Offline chargeBoxes",
            CHARGE_BOXES_ONLINE_LIST__TITLE: "Offline chargeBoxes",
            CHARGE_BOXES_SEARCH_FORM__INPUT_NAME: "Name",
            CHARGE_BOXES_SEARCH_FORM__INPUT_CHARGE_BOX_IDENTITY: "Identity",
            CHARGE_BOXES_SEARCH_FORM__INPUT_CHARGE_BOX_SERIAL_NUMBER: "Serial number",
            CHARGE_BOXES_SEARCH_FORM__INPUT_IP_ADDRESS: "IP address",
            CHARGE_BOXES_TABLE__CHARGE_POINT_NAME: "Name",
            CHARGE_BOXES_TABLE__CHARGE_BOX_IDENTITY: "Identity",
            CHARGE_BOXES_TABLE__CHARGE_BOX_SERIAL_NUMBER: "Serial number",
            CHARGE_BOXES_TABLE__IP_ADDRESS: "IP address",
            CHARGE_BOXES_TABLE__PROTOCOL: "Protocol",
            CHARGE_BOXES_TABLE__LAST_ACTIVITY: "Last activity",
            CHARGE_BOXES_TABLE__CHARGE_POINT_STATUS: "Status",
            CHARGE_BOX_EDIT__TITLE: "Charger edit",
            CHARGE_BOX_EDIT__IDENTITY: "Identity",
            CHARGE_BOX_EDIT__SN: "S/N",
            CHARGE_BOX_EDIT__GPS: "GPS Position",
            CHARGE_BOX_EDIT__MAX_POWER: "Max power",
            CHARGE_BOX_EDIT__GROUP: "Group",
            CHARGE_BOX_EDIT__ACTIVE: "Active",
            CHARGE_BOX_EDIT__ADDED_DATE_TIME: 'Added',
            CHARGE_BOX_EDIT__LAST_ACTIVITY_TIME: 'Last activity time',
            CHARGE_BOX_EDIT__LAST_ACTIVITY: 'Last activity',
            CHARGE_BOX_EDIT__LAST_CHARGING: 'Last charging',
            CHARGE_BOX_EDIT__CHARGE_BOX_STATUS: 'Status',
            CHARGE_BOX_EDIT__NAME: 'Name',
            CHARGE_BOX_EDIT__IP_ADDRESS: 'IP address',
            CHARGE_BOX_EDIT__OCPP_PROTOCOL_VERSION: 'Ocpp protocol version',
            CHARGE_BOX_EDIT__CHARGE_BOX_IDENTITY: 'ChargeBox identity',
            CHARGE_BOX_EDIT__CHARGE_POINT_VENDOR: 'ChargePoint vendor',
            CHARGE_BOX_EDIT__CHARGE_POINT_MODEL: 'ChargePoint model',
            CHARGE_BOX_EDIT__CHARGE_POINT_SERIAL_NUMBER: 'ChargePoint serial number',
            CHARGE_BOX_EDIT__CHARGE_BOX_SERIAL_NUMBER: 'ChargeBox serial number',
            CHARGE_BOX_EDIT__FIRMWARE_VERSION: 'Firmware version',
            CHARGE_BOX_EDIT__ICCID: 'ICCID',
            CHARGE_BOX_EDIT__IMSI: 'IMSI',
            CHARGE_BOX_EDIT__METER_TYPE: 'Meter type',
            CHARGE_BOX_EDIT__METER_SERIAL_NUMBER: 'Meter serial number',
            CHARGE_BOX_EDIT__SOAP_SERVICES_ENDPOINT_URL: 'Soap services endpoint URL',
            CHARGE_BOX_EDIT__ADDRESS: 'Address',
            CHARGE_BOX_EDIT__LATITUDE: 'Latitude',
            CHARGE_BOX_EDIT__LONGTITUDE: 'Longtitude',
            CHARGE_BOX_EDIT__MAX_FACTORY_POWER: "Max factory power [kW]",
            CHARGE_BOX_VIEW__TITLE: "ChargeBox details",
            CHARGE_BOX_VIEW__CHARGE_BOX: "ChargeBox",
            CHARGE_BOX_VIEW__ADDED_DATE_TIME: "Added",
            CHARGE_BOX_VIEW__NAME: "Name",
            CHARGE_BOX_VIEW__IP_ADDRESS: "IP address",
            CHARGE_BOX_VIEW__OCPP_PROTOCOL_VERSION: "Ocpp protocol version",
            CHARGE_BOX_VIEW__CHARGE_BOX_IDENTITY: "ChargeBox identity",
            CHARGE_BOX_VIEW__CHARGE_POINT_VENDOR: "ChargePoint vendor",
            CHARGE_BOX_VIEW__CHARGE_POINT_MODEL: "ChargePoint model",
            CHARGE_BOX_VIEW__CHARGE_POINT_SERIAL_NUMBER: "ChargePoint serial number",
            CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER: "ChargeBox serial number",
            CHARGE_BOX_VIEW__FIRMWARE_VERSION: "Firmware version",
            CHARGE_BOX_VIEW__ICCID: "ICCID",
            CHARGE_BOX_VIEW__IMSI: "IMSI",
            CHARGE_BOX_VIEW__METER_TYPE: "Meter type",
            CHARGE_BOX_VIEW__METER_SERIAL_NUMBER: "Meter serial number",
            CHARGE_BOX_VIEW__SOAP_SERVICES_ENDPOINT_URL: "Soap services endpoint URL",
            CHARGE_BOX_VIEW__LAST_ACTIVITY_TIME: "Last activity time",
            CHARGE_BOX_VIEW__LAST_ACTIVITY: "Last activity",
            CHARGE_BOX_VIEW__LAST_CHARGING_TIME: "Last charging time",
            CHARGE_BOX_VIEW__CHARGEBOX_STATUS: "ChargeBox status",
            COMMONS__REMOTE_START_TRANSACTION: "Remote Start Transaction",
            COMMONS__REMOTE_STOP_TRANSACTION: "Remote Stop Transaction",
            REMOTE_STOP_TRANSACTION__TRANSACTION_ID: "Transaction Id",
            CHARGE_BOX_VIEW__SHOW_HISTORIC_SESSIONS: "Historic sessions",
            CHARGE_BOX_VIEW__SHOW_HISTORIC_ALERTS: "Historic alerts",
            CHARGE_BOX_VIEW__SHOW_ON_MAP: "Show on map",
            CHARGE_BOX_VIEW__MAX_POWER: "Max power",
            CHARGE_BOX_VIEW__SET_POWER: "Set power [kW]",
            CHARGE_BOX_VIEW__PRODUCT_GROUPS: "Chargers group",
            CHARGE_BOX_VIEW__OTHER_INFORMATIONS: "Other information",
            CHARGE_BOX_VIEW__CHARGING_DETAILS: "Charging details",
            CHARGE_BOX_VIEW__CHARGING_START: "Start",
            CHARGE_BOX_VIEW__CHARGING_END: "End",
            CHARGE_BOX_VIEW__CHARGING_DURATION: "Duration",
            CHARGE_BOX_VIEW__CHARGING_SOCKET: "Socket",
            CHARGE_BOX_VIEW__CHARGING_STATE: "State",
            CHARGE_BOX_VIEW__CHARGING_CONSUMED_ENERGY: "Consumed energy [kWh]",
            CHARGE_BOX_VIEW__CHARGING_DEVOTED_ENERGY: "Returned energy ",
            CHARGE_BOX_VIEW__CHARGING_VEHICLE: "Vehicle",
            CHARGE_BOX_VIEW__ACTIVITY_HOURS: "Activity hours",
            CHARGE_BOX_VIEW__CHARGING_TIME: "Charging time",
            CHARGE_BOX_VIEW__ONLINE_TIME: "Online time",
            CHARGE_BOX_VIEW__LAST_FAIL: "Last fail",
            CHARGE_BOX_VIEW__SOC_AT_BEGIN: "SOC(s) [%]",
            CHARGE_BOX_VIEW__SOC_CURRENT: "SOC(a) [%]",
            CHARGE_BOX_VIEW__SOC_END: "SOC(e) [%]",
            CHARGE_BOX_VIEW__SOC_DELTA: "SOC(Δ) [%]",
            CHARGE_BOX_VIEW__DISTANCE: "Distance",
            CHARGE_BOX_VIEW__TOTAL_CONSUMED_ENERGY: "Total consumed energy",
            CHARGE_BOX_VIEW__LAST_WARNING: "Last warning",
            CHARGE_BOX_VIEW__EXPECTED_TIME: "Charging expected time",
            CHARGE_BOX_VIEW__MAX_FACTORY_POWER: "Maximum factory power [kW]",
            CHARGE_BOX_VIEW__MAX_POWER_SET: "Maximum set power",
            CHARGE_BOX__CHANGE_CONFIGURATION: "Change configuration",
            CHANGE_CONFIGURATION__KEY: "Key",
            CHANGE_CONFIGURATION__VALUE: "Value",
            CHARGE_BOX__HISTORIC_TRANSACTIONS: "Historic transactions",
            CHARGE_BOX_STATUS__ONLINE: "Online",
            CHARGE_BOX_STATUS__ERROR: "Error",
            CHARGE_BOX_STATUS__CHARGING: "Charging",
            CHARGE_BOX_STATUS__READY: "Ready",
            CHARGE_BOX_STATUS__OFFLINE: "Offline",
            CHARGE_BOX_VIEW__SHOW_CONFIGURATION: "Show configuration",
            // transactions
            TRANSACTIONS_LIST__TITLE: "Transactions",
            TRANSACTIONS_SEARCH_FORM__START_TIMESTAMP: "Since",
            TRANSACTIONS_SEARCH_FORM__STOP_TIMESTAMP: "To",
            TRANSACTIONS_SEARCH_FORM__CHARGE_BOX_IDENTITY: "Identity",
            TRANSACTIONS_SEARCH_FORM__VEHICLE_NAME: "Vehicle",
            TRANSACTIONS_SEARCH_FORM__TRANSACTION_ID: "Transaction id",
            TRANSACTIONS_TABLE__TRANSACTION_ID: "Transaction id",
            TRANSACTIONS_TABLE__ID: "Id",
            TRANSACTIONS_TABLE__START_TIMESTAMP: "Start",
            TRANSACTIONS_TABLE__STOP_TIMESTAMP: "Stop",
            TRANSACTIONS_TABLE__CHARGING_TIME: "Charging time",
            TRANSACTIONS_TABLE__ENERGY: "Energy",
            TRANSACTIONS_TABLE__ENERGY_IN: "Energy in [kWh]",
            TRANSACTIONS_TABLE__ENERGY_OUT: "Energy out [kWh]",
            TRANSACTIONS_TABLE__CHARGE_BOX_Name: "Name",
            TRANSACTIONS_TABLE__CHARGE_BOX_IDENTITY: "ChargeBox Identity",
            TRANSACTIONS_TABLE__CHARGE_BOX_SERIAL: "Serial number",
            TRANSACTIONS_TABLE__SOC_START: "SOC(s) [%]",
            TRANSACTIONS_TABLE__SOC_END: "SOC(e) [%]",
            TRANSACTIONS_TABLE__VEHICLE: "Vehicle",
            TRANSACTIONS_TABLE__EOC_REASON: "Reason of EOC",
            TRANSACTION_DETAILS__TITLE: "Transaction details",
            TRANSACTION_DETAILS__TRANSACTION_ID: "Transaction id",
            TRANSACTION_DETAILS__CONNECTOR_ID: "Connector id",
            TRANSACTION_DETAILS__ID_TAG: "IdTag",
            TRANSACTION_DETAILS__RESERVATION_ID: "Reservation id",
            TRANSACTION_DETAILS__START_TIMESTAMP: "Start timestamp",
            TRANSACTION_DETAILS__STOP_TIMESTAMP: "Stop timestamp",
            TRANSACTION_DETAILS__STOP_REASON: "StopReason",
            TRANSACTION_DETAILS__ENERGY: "Energy",
            TRANSACTION_DETAILS__DURATION: "Duration",
            TRANSACTION_DETAILS__META_DATA: "Meta data",
            TRANSACTION_DETAILS__METER_VALUES: "Meter values",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__TIMESTAMP: "MeterValue timestamp",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__VALUE: "Value",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__READING_CONTEXT: "Context",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__VALUE_FORMAT: "Format",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__MEASURAND: "Measurand",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__LOCATION: "Location",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__MEASURE_OF_UNIT: "MeasureOfUnit",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__PHASE: "Phase",
            TRANSACTION_DETAILS__METER_VALUES_CHART_TITLE: "Chart",
            // meter values
            METER_VALUES_LIST__TITLE: "MeterValues",
            METER_VALUES_CURRENT_LIST__TITLE: "Current MeterValues",
            METER_VALUES_SEARCH_FORM__CHARGE_BOX_IDENTITY: "ChargeBoxIdentity",
            METER_VALUES_SEARCH_FORM__CONNECTOR_ID: "ConnectorId",
            METER_VALUES_SEARCH_FORM__TRANSACTION_ID: "TransactionId",
            METER_VALUES_TABLE__TIMESTAMP: "meterValueTimestamp",
            METER_VALUES_TABLE__CHARGEBOX: "chargebox",
            METER_VALUES_TABLE__TRANSACTION: "transaction",
            METER_VALUES_TABLE__CONNECTOR: "connector",
            METER_VALUES_TABLE__VALUE: "value",
            METER_VALUES_TABLE__READING_CONTEXT: "context",
            METER_VALUES_TABLE__VALUE_FORMAT: "format",
            METER_VALUES_TABLE__MEASURAND: "measurand",
            METER_VALUES_TABLE__LOCATION: "location",
            METER_VALUES_TABLE__MEASURE_OF_UNIT: "measureOfUnit",
            METER_VALUES_TABLE__PHASE: "phase",
            METER_VALUES_TABLE__VIEW: "view",
            METER_VALUES_DIALOG__TITLE: "MeterValues details",
            METER_VALUES_DIALOG__META_DATA: "MeterValues",
            METER_VALUES_DIALOG__CHARGEBOX: "ChargeBox",
            METER_VALUES_DIALOG__CONNECTOR_ID: "ConnectorId",
            METER_VALUES_DIALOG__TRANSACTION_ID: "TransactionId",
            METER_VALUES_DIALOG__TIMESTAMP: "Timestamp",
            // registration chargebox
            REGISTRATION_CHARGE_BOX__TITLE: "Chargebox registration",
            REGISTRATION_CHARGE_BOX__REGISTRATION_SUCCESS: "ChargeBox successfully registered.",
            REGISTRATION_CHARGE_BOX__IDENTITY: "Identity",
            REGISTRATION_CHARGE_BOX__SOAP_ENDPOINT_PATH: "Soap endpoint path",
            REGISTRATION_CHARGE_BOX__PROTOCOL: "Protocol",
            // current transactions
            CURRENT_TRANSACTIONS_LIST__TITLE: "Current transactions",
            // import data
            IMPORT_REGISTRATION_DATA__TITLE: "Import registration data",
            IMPORT_REGISTRATION_DATA__SUCCESSFULLY_IMPORTED: "AuthorizationTag successfully registered",
            IMPORT_REGISTRATION_DATA__CONTENT_TO_IMPORT: "Content to import",
            IMPORT_REGISTRATION_DATA__IMPORT: "Import",
            // chargeBox configuration
            SIDEBAR_TITLE__CHARGEBOX_CONFIGURATION: 'Configurations',
            CHARGEBOX_CONFIGURATION_LIST__TITLE: 'ChargePoint Configurations',
            CHARGEBOX_CONFIGURATION__TABLE__CHARGEBOX_IDENTITY: "ChargeBox identity",
            CHARGEBOX_CONFIGURATION__TABLE__REQUEST_TIME: "RequestTime",
            CHARGEBOX_CONFIGURATION__TABLE__RESPONSE_STATUS: "ResponseStatus",
            CHARGEBOX_CONFIGURATION__TABLE__LIST_VERSIOON: "List",
            CHARGEBOX_DETAILS__MISSING_CONFIGURATION_TITLE: "Missing ChargeBox configuration",
            CHARGEBOX_DETAILS__MISSING_CONFIGURATION_MESSAGE: "Missing ChargeBox configuration",
            // roles
            CHARGEBOX_CONFIGURATION__TABLE__CLEAR_CACHE_STATUS: 'Status',
            // chargeBox authorizations
            CHARGEBOX_AUTHORIZATIONS_LIST__TITLE: 'Chargebox authorizations',
            // chargeBox activity
            CHARGEBOX_ACTIVITY_LIST__TITLE: 'ChargeBox activity',
            CHARGEBOX_ACTIVITY__TABLE__CHARGEBOX_IDENTITY: 'ChargeBox ID',
            CHARGEBOX_ACTIVITY__TABLE__ACTIVITY_TYPE: 'Activity type',
            CHARGEBOX_ACTIVITY__TABLE__REQUEST_TIME: 'Request time',
            CHARGEBOX_ACTIVITY__TABLE__RESPONSE_STATUS: 'Response status',
            CHARGEBOX_ACTIVITY_SEARCH_FORM__FROM_DATETIME: "From date time",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__TO_DATETIME: "To date time",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__TYPE: "type",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__CHARGE_BOX_IDENTITY: "ChargeBoxIdentity",
            // chargeBox activities
            CHARGEBOX_BOOT_NOTIFICATION_LIST__TITLE: 'Bootnotifications',
            CHARGEBOX_DATA_TRANSFER_LIST__TITLE: 'Data Transfers',
            CHARGEBOX_DIAGNOSTICS_LIST__TITLE: 'Diagnostics',
            CHARGEBOX_FIRMWARE_NOTIFICATION_LIST__TITLE: 'Firmware',
            CHARGEBOX_HEARTBEAT_LIST__TITLE: 'Heartbeats',
            CHARGEBOX_METER_VALUES_LIST__TITLE: 'Metervalues',
            CHARGEBOX_STATUS_NOTIFICATION_LIST__TITLE: 'Status Notifications',
            CHARGEBOX_TRANSACTION_LIST__TITLE: '',
            CHARGE_BOX__START_TRANSACTION: 'StartTransaction',
            CHARGE_BOX__STOP_TRANSACTION: 'StopTransaction',
            REMOTE_START_TRANSACTION__CONNECTOR_ID: "ConnectorId",
            REMOTE_START_TRANSACTION__ID_TAG: "IdTag",
            // chargeBox register
            CHARGE_BOX_REGISTER__TITLE: 'Register chargebox',
            // roles
            ROLES_LIST__TITLE: "Roles list",
            ROLE_TABLE__NAME: 'Role name',
            // local list version
            SIDEBAR_TITLE__LOCAL_LIST_VERSION: "LocalListVersion",
            // clear cache
            SIDEBAR_TITLE__CLEAR_CACHE: 'ClearCache',
            CHARGEBOX_CLEAR_CACHE_LIST__TITLE: 'ClearCache list',
            // chargebox activity
            CHARGE_BOX_ACTIVITY_DETAILS__TITLE: "Activity",
            SIDEBAR_TITLE__CHARGEBOX_ACTIVITY: 'Activity',
            CHARGEBOX_ACTIVITY_VIEW__TITLE: 'ChargeBox Activity',
            // update firmware
            SIDEBAR_TITLE__UPDATE_FIRMWARE: 'UpdateFirmware',
            // unlock connector
            SIDEBAR_TITLE__UNLOCK_CONNECTOR: 'UnlockConnector',
            UNLOCK_CONNECTOR_LIST__TITLE: 'UnlockConnector list',
            // reset
            SIDEBAR_TITLE__RESET: "Reset",
            RESET_LIST__TITLE: "Reset list",
            RESET__TABLE__RESET_TYPE: 'Reset type',
            // reservation
            SIDEBAR_TITLE__CANCEL_RESERVATION: "CancelReservation",
            CANCEL_RESERVATION__TITLE: 'CancelReservation list',
            // change availability
            SIDEBAR_TITLE__CHANGE_AVAILABILITY: "ChangeAvailability",
            CHANGE_AVAILABILITY_LIST__TITLE: 'ChangeAvailability list',
            // change configuration
            SIDEBAR_TITLE__CHANGE_CONFIGURATION: "ChangeConfiguration",
            CHANGE_CONFIGURATION_LIST__TITLE: 'ChangeConfigurations List',
            // diagnostics
            SIDEBAR_TITLE__DIAGNOSTICS: "Diagnostics",
            GET_DIAGNOSTICS_LIST__TITLE: 'GetDiagnostics list',
            // remote start transaction
            SIDEBAR_TITLE__REMOTE_START_TRANSACTION: "RemoteStartTransaction",
            REMOTE_START_TRANSACTION_LIST__TITLE: 'RemoteStartTransaction list',
            // remote stop transaction
            SIDEBAR_TITLE__REMOTE_STOP_TRANSACTION: "RemoteStopTransaction",
            REMOTE_STOP_TRANSACTION_LIST__TITLE: 'RemoteStopTransaction list',
            // reserve now
            SIDEBAR_TITLE__RESERVE_NOW: "ReserveNow",
            RESERVE_NOW_LIST__TITLE: 'Reservations list',
            // send local list
            SIDEBAR_TITLE__SEND_LOCAL_LIST: "SendLocalList",
            // data transfer
            DATA_TRANSFER_LIST__TITLE: 'DataTransfers list',
            SEND_LOCAL_LIST_LIST__TITLE: 'SendLocalList list',
            ADVANCED_SEARCH: 'Advanced search:',
            ADVANCED_SEARCH_FIELDS: 'Search query available field:',
            // alerts
            SIDEBAR_TITLE__ALERTS_HISTORY: "Alerts history",
            ALERT_HISTORY_LIST__TITLE: "Alerts history",
            SIDEBAR_TITLE__ALERTS: "Alerts history",
            ALERT_EDIT__TITLE: "Edit alert",
            ALERT_LIST__TITLE: "Alerts",
            ALERT_REGISTER__TITLE: "Register alert",
            ALERTS_LIST__TRIGGER_METHOD: "Trigger method",
            ALERTS_LIST__ALERT_TIME: "Alert time",
            ALERTS_LIST__CHARGE_BOX_IDENTITY: "ChargeBoxIdentity",
            ALERT_VIEW__TITLE: "Alert details",
            ALERT_VIEW__ALERT_TIME: "Alert time",
            ALERT_VIEW__TRIGGER_METHOD: "Trigger method",
            ALERT_VIEW__CONDITION: "Conditions",
            ALERT_VIEW__NOTIFICATION_TYPE: "Notification type",
            ALERT_VIEW__RECEIVERS: "Receivers",
            ALERT_VIEW__STATUS: "Status",
            ALERT_VIEW__ERROR_CODE: "Error code",
            ALERT_VIEW__VENDOR_ERROR_CODE: "Vendor error code",
            ALERT_VIEW__SUBJECT: "Subject",
            ALERT_VIEW__CONTENT: "Content",
            // administration
            SIDEBAR_TITLE__ADMINISTRATION: "Administration",
            SIDEBAR_TITLE__ADMINISTRATION_CHARGEBOXES: "Manage charge points",
            SIDEBAR_TITLE__ADMINISTRATION_CHARGEBOXES_GROUPS: "Manage charge points groups",
            SIDEBAR_TITLE__ADMINISTRATION_ALERTS: "Manage alerts",
            SIDEBAR_TITLE__ADMINISTRATION_OPERATORS: "Manage operators accounts",
            ADMINISTRATION_CHARGE_BOXES_LIST__TITLE: "Charge points",
            ADMINISTRATION_CHARGE_BOXES_LIST__NAME: "Charge point name",
            ADMINISTRATION_CHARGE_BOXES_LIST__IDENTITY: "Identity",
            ADMINISTRATION_CHARGE_BOXES_LIST__SERIAL_NUMBER: "Serial Number",
            ADMINISTRATION_CHARGE_BOXES_LIST__IP_ADDRESS: "IP Adress",
            ADMINISTRATION_CHARGE_BOXES_LIST__LAST_ACTIVITY: "Last activity",
            ADMINISTRATION_CHARGE_BOXES_LIST__STATUS: "Status",
            ADMINISTRATION_ALERTS_LIST__NAME: "Alert name",
            ADMINISTRATION_ALERTS_LIST__EVENT: "Event",
            ADMINISTRATION_ALERTS_LIST__CHARGE_BOX: "Charge box",
            ADMINISTRATION_ALERTS_LIST__RECEIVERS: "Receivers",
            ADMINISTRATION_ALERTS_LIST__ACTIVE: "Active",
            // chargebox groups
            SIDEBAR_TITLE__CHARGEBOX_GROUPS: "Groups",
            // accounts
            SIDEBAR_TITLE__ACCOUNTS: "Accounts",
            // chargebox configuration
            CHARGE_BOX_CONFIGURATION__TITLE: "Charge point configuration",
            CHARGE_BOX_CONFIGURATION_LIST__TITLE: "Configuration",
            // chargebox group
            SIDEBAR_TITLE__CHARGE_BOX_GROUPS: "Groups",
            CHARGE_BOX_GROUP_LIST__TITLE: "Groups",
            CHARGE_BOX_GROUP_VIEW__TITLE: "Group details",
            CHARGE_BOX_GROUP_EDIT__NAME: "Group name",
            CHARGE_BOX_GROUP_EDIT__CHARGE_POINTS: "Charge points",
            CHARGE_BOX_GROUP_EDIT__MAXIMUM_CONNECTOR_POWER: "Maximum connector power",
            CHARGE_BOX_GROUP_EDIT__DESCRIPTION: "Description",
            CHARGE_BOX_GROUP_TABLE__NAME: "Group name",
            CHARGE_BOX_GROUP_TABLE__ACTIVE: "Active",
            CHARGE_BOX_GROUP_TABLE__CHARGER_COUNT: "Chargers count",
            CHARGE_BOX_GROUP_TABLE__SUMMARY_POWER: "Summary power",
            CHARGE_BOX_GROUP_TABLE__EDIT_POWER: "Edit power",
            CHARGE_BOX_GROUP_TABLE__EDIT_GROUP: "Edit group",
            CHARGE_BOX_GROUP_EDIT__TITLE: "Edit ChargeBox Group",
            CHARGE_BOX_GROUP_REGISTER__TITLE: "Register ChargeBox Group",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOXES: "ChargeBoxes",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX: "ChargeBox",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_PRIORITY: "Priority",
            CHARGE_BOX_GROUP_SEARCH__NAME: "Name",
            CHARGE_BOX_GROUP_DETAILS__TITLE: "ChargeBoxGroup details",
            CHARGE_BOX_GROUP_VIEW__NAME: "Name",
            CHARGE_BOX_GROUP_VIEW__DESCRIPTION: "Description",
            CHARGE_BOX_GROUP_VIEW__CHARGE_BOXES: "ChargeBoxes",
            // user list
            USER_LIST__TITLE: "User list",
            USERS_TABLE__IDENTITY: 'Identity',
            USERS_TABLE__EMAIL: "Email",
            USERS_TABLE__FIRST_NAME: "First name",
            USERS_TABLE__LAST_NAME: "Last name",
            USERS_TABLE__PHONE: "Phone",
            USERS_TABLE__ROLES: "Roles",
            USERS_TABLE__ADDED_DATE_TIME: "Add date time",
            USERS_TABLE__PASSWORD: "Password",
            USERS_TABLE__CONFIRM_PASSWORD: "Confirm password",
            USERS_TABLE__ROLE: "Role",
            USERS_TABLE__PASSWORD_CONFIRM: "Confirm password",
            USER_REGISTER__TITLE: 'Register user',
            USERS_SEARCH_FORM__EMAIL: "E-mail",
            USERS_SEARCH_FORM__FIRST_NAME: "First name",
            USERS_SEARCH_FOR__LAST_NAME: "Last name",
            USERS_SEARCH_FORM__FROM_DATETIME: "Added from time",
            USERS_SEARCH_FORM__TO_DATETIME: "Added to time",
            // role list
            ROLE_EDIT__TITLE: "Role edit",
            ROLE_LIST__TITLE: "Role list",
            ROLE_REGISTER__TITLE: "Role register",
            // map
            SIDEBAR_TITLE__CHARGE_BOX_MAP: "Map",
            CHARGE_BOX_MAP__TITLE: "Map",
            // DEVELOPER
            SIDEBAR_TITLE__DEVELOPER: "Developer",
            // REPORTS
            SIDEBAR_TITLE__REPORTS: "Reports",
            REPORTS_LIST__TITLE: "Reports",
            REPORTS_CHARGEBOXES__CHARGEBOX_IDENTIFIER: "Identity",
            REPORTS_CHARGEBOXES__CHARGEBOX_NAME: "Name",
            SIDEBAR_TITLE__REPORTS_VEHICLE: "VehicleReports",
            REPORTS_CHARGEBOXES__VEHICLE_IDENTITY: "Vehicle identity",
            REPORTS_CHARGEBOXES__VEHICLE_NAME: "Vehicle name",
            REPORTS_CHARGEBOXES__CHARGING_TIME: "Charging time",
            REPORTS_CHARGEBOXES__CHARGING_QUANTITY: "Charging quantity",
            REPORTS_CHARGEBOXES__AVERAGE_CHARGING_ENERGY: "Average charging energy",
            REPORTS_CHARGEBOXES__COSUMED_ENERGY: "Consumed energy",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX: "Charge points - data",
            SIDEBAR_TITLE__REPORTS_VEHICLE_USAGE: "Energy usage per vehicle",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX_USAGE: "Energy usage per charge point",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX_HOURS: "Charge points - working hours",
            REPORTS__IDENTITY: "Identity",
            REPORTS__NAME: "Name",
            REPORTS__DESCRIPTION: "Description",
            REPORTS__DEFINITION: "Definition",
            REPORT_DEFINITION_SEARCH_FORM__IDENTITY: "Identity",
            REPORT_DEFINITION_SEARCH_FORM__NAME: "Name",
            REPORT__TYPE: "Type",
            REPORT__ITEMS: "Items",
            REPORT__INTERVAL: "Scope",
            REPORT__DETAILS: "Detailed",
            REPORT__START_DATE: "Start date",
            REPORT__END_DATE: "End date",
            XLSX_REPORT_CHARGE_BOX: "chargeBox.xlsx",
            XLSX_REPORT_CHARGE_BOX_GROUP: "chargeBoxGroup.xlsx",
            XLSX_CONSUMED_ENERGY_REPORT_VEHICLE: "vehicle_consumed_energy.xlsx",
            XLSX_HISTORY_TRANSACTIONS: "transactions_history.xlsx",
            XLSX_REPORT_VEHICLE: "vehicles.xlsx",
            XLSX_HISTORY_ALERT: "alert_history.xlsx",
            XLSX_REPORT_CHARGE_BOX_CONSUMED_ENERGY: "chargeBox_consumed_energy.xlsx",
            XLSX_REPORT_CHARGE_BOX_GROUP_CONSUMED_ENERGY: "chargeBox_group_consumed_energy.xlsx",
            XLSX_REPORT_VEHICLE_CONSUMED_ENERGY: "vehicles_consumed_energy.xlsx",
            XLSX_REPORT_AUTHORIZATION_ID_TAG: "authorization_tags.xlsx",
            XLSX_REPORT_ALERT_DEFINITION: "alert_definitions.xlsx",
            XLSX_REPORT_TEMPLATE: "report_remplate.xlsx",

            // ALERTS
            ALERT_DEFINITION__HIDDEN: 'Deleted',
            ALERT_DEFINITION__TRIGGER_METHOD: "TriggerMethod",
            ALERT_DEFINITION__EXPRESSION: "Expression",
            ALERT_DEFINITION__NOTIFICATION_TYPE: "NotificationType",
            ALERT_DEFINITION__NOTIFICATION_SUBJECT_TEMPLATE: "NotificationSubjectTemplate",
            ALERT_DEFINITION__NOTIFICATION_CONTENT_TEMPLATE: "NotifiationContentTemplate",
            ALERT_DEFINITION__NOTIFICATION_RECEIVERS: "Receivers",
            ALERT_DEFINITION_SEARCH_FORM__TRIGGER_METHOD: "Trigger method",
            ALERT_DEFINITION_SEARCH_FORM__NOTIFICATION_METHOD: "Notification method",
            ALERT_DEFINITION_SEARCH_FORM__RECEIVER: "Receiver",
            ALERTS_LIST__TITLE: "Alerts",
            ALERT_SEARCH_FORM__FROM_DATETIME: "From",
            ALERT_SEARCH_FORM__TO_DATETIME: "To",
            ALERT_SEARCH_FORM__TRIGGER_METHOD: "Trigger method",
            // VEHICLE
            ADMINISTRATION_VEHICLE_LIST__TITLE: "Vehicle list",
            VEHICLE_TABLE__IDENTITY: "Identity",
            VEHICLE_TABLE__SIDE_NUMBER: "Side number",
          	VEHICLE_TABLE__NAME: "Name",
            VEHICLE_TABLE__BATTERY_CAPACITY: "Battery capacity",
            VEHICLE_SEARCH_FORM__INPUT_IDENTITY: "Identity",
            VEHICLE_SEARCH_FORM__INPUT_NAME: "Name",
            VEHICLE__IDENTITY: "Identity",
            VEHICLE__NAME: "Name",
            VEHICLE__BATTERY_CAPACITY: "Battery capacity",
            VEHICLE_EDIT__TITLE: "Vehicle edit",
            VEHICLE_REGISTER__TITLE: "Vehicle register",
            VEHICLE_VIEW__IDENTITY: "Identity",
            VEHICLE_VIEW__NAME: "Name",
            VEHICLE_VIEW__BATTERY_CAPACITY: "Battery capacity",
            VEHICLE_VIEW__TITLE: "Vehicle details",
            VEHICLE_LIST__TITLE: "Vehicles",
            CHARGEOBOX_DETAILS__MAX_POWER_CANOT_BE_HIGHER_THAN_FABRIC_POWER: "Max power cannot be higher than fabric power.",
            // USERACTIVITY
            ADMINISTRATION_USERACTIVITY_LIST__TITLE: "Changes list",
            USERACTIVITY_SEARCH_FORM__USERNAME: "Username",
            USERACTIVITY_SEARCH_FORM__CHANGED_OBJECT: "Object type",
            USERACTIVITY_SEARCH_FORM__CHANGED_OBJECT_NAME: "Object name",
            USERACTIVITY__CHANGED_TIMESTAMP: "Change date",
            USERACTIVITY__CHANGED_OBJECT: "Object type",
            USERACTIVITY__CHANGED_OBJECT_NAME: "Object name",
            USERACTIVITY__CHANGED_PARAMETER: "Parameter",
            USERACTIVITY__CHANGED_SUB_PARAMETER: "Sub object",
            USERACTIVITY__OLD_VALUE: "Old value",
            USERACTIVITY__NEW_VALUE: "New value",
            USERACTIVITY__USERNAME: "User",
            USERACTIVITY__TYPE: "Change type",
        });

        $translateProvider.translations('pl', {
            ERROR_CONNECTION_REFUSED: "Przepraszamy, ale serwer przechodzi w tym momencie konserwację. Prosimy, spróbuj ponownie za chwilę.",
            ERROR_FAILED_TO_LOAD_OAUTH: "Wystąpił błąd podczas wczytywania uprawnień.",
            ERROR_FAILED_TO_LOAD_METADATA: "Wystąpił błąd przy wczytywaniu danych.",
            ERROR_FAILED_TO_LOAD_RESOURCES: "Wystąpił błąd podczas wczytywania danych.",
            SIDEBAR_TITLE__REPORT_TEMPLATES: "Szablony raportów",
            SIDEBAR_TITLE__REPORT_TEMPLATES_DEMO: "Szablony raportów (demo)",
            REPORT_TEMPLATES_NEW__TITLE: "Nowy szablon raportu",
            REPORT_TEMPLATES_EDIT__TITLE: "Edycja szablonu raportu",
            COMMONS__DESCRIPTION: "Opis",
            COMMONS__TYPE: "Typ",
            COMMONS__TIME_INTERVAL: "Okres",
            COMMONS__DETAILED: "Szczegółowy",
            COMMONS__ELEMENTS: "Elementy",
            COMMONS__YES: "Tak",
            COMMONS__NO: "Nie",
            REPORT_TEMPLATES_DETAILS__TITLE: "Szczegóły raportu",
            COMMONS__TEMPLATE_DATA: "Dane szablonu",
            Vehicles: "Pojazdy",
            ChargeBoxes: "Stacje ładowania",
            currentDay: "Bieżąca doba",
            currentWeek: "Bieżący tydzień",
            currentMonth: "Bieżący miesiąc",
            currentQuarter: "Bieżący kwartał",
            currentYear: "Bieżący rok",
            previousDay: "Poprzednia doba",
            previousWeek: "Poprzedni tydzień",
            previousMonth: "Poprzedni miesiąc",
            previousQuarter: "Poprzedni kwartał",
            previousYear: "Poprzedni rok",
            true: "Tak",
            false: "Nie",
            EmergencyStop: "Awaryjny stop",
            EVDisconnected:"Rozłączenie pojazdu",
            HardReset: "Twardy reset",
            Local: "Lokalnie",
            Other: "Inny",
            PowerLoss: "Utrata mocy",
            Reboot: "Restart",
            Remote: "Zdalny",
            SoftReset: "Miękki reset",
            UnlockCommand: "Komenda odblokowania",
            DeAuthorized: "Brak autoryzacji",
            IdleTimeout: "Bezczynność",
            IdleTimeoutMissingData: "Bezczynność i brak danych",
            COMMONS__SAVE_PASSWORD: "Zapisz hasło",
            ALERT_VIEW__DELETE: "Usuń powiadomienie",
            ALERTS_LIST__ARCHIVED: "",
            REQUEST_TIME: "Czas żądania",
            COMMON_PROTOCOL: "Protokół",
            CHARGE_BOX_VIEW__CONNECTOR: "Konektor",
            AlertAdministrationList: "Alerty",
            AuthorizationTagAdministrationList: "ZnacznikiAutoryzacyjne",
            ChargeBoxAdministrationList: "Ładowarki",
            ChargeBoxGroupAdministrationList: "GrupyŁadowarek",
            RoleAdministrationList: "Role",
            RolePermissionsAdministrationList: "Uprawnienia",
            UserAdministrationList: "Użytkownicy",
            VehicleAdministrationList: "Pojazdy",
            AlertList: "Alerty",
            CHARGE_BOX_DIAGNOSTICS__TITLE: "Diagnostyka ładowarki",
            CHARGE_BOX_CONFIGURATION__GET_DIAGNOSTICS: "Wyślij żądanie",
            CHARGE_BOX_VIEW__SHOW_DIAGNOSTICS: "Pokaż diagnostyke",
            ChargeBoxesConfiguration: "KonfiguracjaŁadowarki",
            ChargeBoxActivityHoursList: "GodzinyAktywnościŁadowarki",
            ChargeBoxesChargingList: "Ładowarki",
            ChargeBoxesErrorList: "Ładowarki",
            ChargeBoxesList: "Ładowarki",
            ChargeBoxesOfflineList: "Ładowarki",
            ChargeBoxesOnlineList: "Ładowarki",
            ChargeBoxesWarningList: "Ładowarki",
            ChargeBoxesGroupList: "GrupyŁadowarek",
            ChargingProfilesList: "ProfileŁadowania",
            ChargeBoxesActivityList: "AktywnościŁadowarek",
            VehicleDistanceList: "PojazdyDystans",
            ChargeBoxMap: "MapaŁadowarek",
            ChargeBoxConsumedEnergyReportList: "ŁadowarkiPobranaEnergia",
            ChargeBoxGroupConsumedEnergyReportList: "GrupyŁadowarekPobranaEnergia",
            TransactionsReportList: "Transakcje",
            VehicleConsumedEnergyReportList: "PojazdyPobranaEnergia",
            ReportTemplatesList: "SzablonRaportu",
            ReportTemplatesDetailsList: "SzczegółySzablonuRaportu",
            TransactionList: "Transakcje",
            VehicleList: "Pojazdy",
            OFFLINE_CHART_STATE: "Wyłączona",
            ONLINE_CHART_STATE: "Gotowa",
            ERROR_CHART_STATE: "Błąd",
            CHARGING_CHART_STATE: "Aktywna",
            MISSING_PERMISSIONS: "Brak uprawnień. Proszę skontaktować się z administratorem aplikacji.",
            DEFAULT_ERROR_MESSAGE: "Wystąpił błąd, administrator techniczny produktu został automatycznie o nim powiadomiony.",
            COMMONS__MAX_POWER: "Maksymalna moc [kW]",
            MAX_POWER_WAS_CHANGED: "Maksymalna moc została zmieniona",
            COMMONS__CHANGE_PASSWORD: "Zmień hasło",
            Percent: "%",
            Available: "Dostępna",
            Reserved: "Zarezerwowana",
            Faulted: "Usterka",
            Unavailable: "Niedostępna",
            Occupied: "Occupied",
            Preparing: "Przygotowanie",
            Charging: "Ładowanie",
            SuspendedEV: "SuspendedEV",
            SuspendedEVSE: "SuspendedEVSE",
            Finishing: "Kończenie",
            DASHBOARD_CHARGE_POINT_STATUS: "Status",
            SIDEBAR_TITLE__TRANSACTIONS_EXPORT: "Eksport transakcji",
            PLEASE_CHANGE_TO_TIME_SEARCH_INPUT: "Data w polu 'Do' nie może być wcześniejsza niż data w polu 'Od'",
            COMMONS__SOC_AT_BEGIN: "SOC(p) [%]",
            COMMONS__SOC_AT_END: "SOC(k) [%]",
            COMMONS__SOC_DELTA: "SOC(Δ) [%]",
            DASHBOARD_TIME_TO_CHARGING_END: "Do końca",
            DASHBOARD_FACTORY_POWER: "Moc fabryczna",
            DASHBOARD_SOCb: "SOC(b) [%]",
            DASHBOARD_SOCk: "SOC(k) [%]",
            EXPORT_FILE_WAS_DOWNLOADED: "Plik eskportu został zapisany",
            TRANSACTIONS_TABLE__CHARGE_BOX_NAME: "Nazwa",
            TRANSACTIONS_TABLE__CHARGE_BOX: "Ładowarka",
            TRANSACTIONS_TABLE__SOCK: "Soc(k) [%]",
            DIAGNOSTICS__LOCATION: "Url",
            DIAGNOSTICS__START_TIME: "Czas początkowy",
            DIAGNOSTICS__STOP_TIME: "Czas końcowy",
            DIAGNOSTICS__RETRIES: "Ilość  powtórzeń",
            DIAGNOSTICS__RETRY_INTERVAL: "Odstęp pomiędzy powtórzeniami",
            USER_EDIT__TITLE: "Edycja konta użytkownika",
            CONFIGURATION_DOWNLOADED: "Konfiguracja została pobrana.",
            CONFIGURATION_WAS_CHANGED: "Konfiguracja została zmieniona.",
            TRANSACTION_WAS_STARTED: "Transakcja została rozpocząta.",
            TRANSACTION_WAS_STOPPED: "Transakcja została zakończona.",
            RESET_ACCEPTED: "Reset został przyjęty.",
            CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL: "Protokół komunikacyjny",
            COMMONS__RESULTS_ARE_EMPTY: "Brak wyników",
            CHARGEBOX_ACTIVITY__TABLE__TRANSACTION_ID: "Transakcja",
            CHARGE_BOX_VIEW__CHARGING_PROFILES: "Profile ładowania",
            SIDEBAR_TITLE__CHARGEBOX_SENDED_CHARGING_PROFILES: "Wysłane profile ładowania",
            SIDEBAR_TITLE__CHARGEBOX_SEND_CHARGING_PROFILE: "Wyślij profil ładowania",
            PROFILE_ID: "Id",
            TRANSACTION_ID: "Id transakcji",
            STACK_LEVEL: "Poziom na stosie",
            PROFILE_PURPOSE: "Przeznaczenie",
            PROFILE_KIND: "Rodzaj",
            RECURRENCY_KIND: "Rodzaj powtarzania",
            FROM: "Od",
            TO: "Do",
            SIDEBAR_TITLE__CHARGEBOX_GET_CHARGING_SCHEDULE: "Pobierz plan ładowania",
            RESULTS_FOR: "Wyniki",
            COMMONS__START_PERIOD: "Okres rozpoczęcia",
            COMMONS__LIMIT: "Limit",
            CHARGE_BOX__NUMBER_PHASES: "Ilość faz",
            SIDEBAR_TITLE__CHARGING_PROFILES: "Profile ładowania",
            CHARGE_BOX__GET_CHARGING_SCHEDULE: "Pobierz plan ładowania",
            CHARGE_BOX__ARCHIVED_SET_CHARGING_PROFILE: "Wysłane profile ładowania",
            REQUEST_WAS_REJECTED: "Żądanie zostało odrzucone",
            CHARGING_PROFILE__CHARGING_SCHEDULE_PERIOD: "Okres planu ładowania",
            CHARGING_PROFILE__START_PERIOD: "Okres startu",
            CHARGING_PROFILE__LIMIT: "Limit",
            CHARGING_PROFILE__NUMBER_PHASES: "Ilość faz",
            CHARGING_PROFILE__NUMBER_OF_PHASES: "Ilość faz",
            CHARGING_PROFILE__ADD_SCHEDULE_PERIOD: "Dodaj okres dla planu",
            CHARGING_PROFILE__CONNECTOR: "Łącze",
            CHARGING_PROFILE__STACK_LEVEL: "Poziom na stosie",
            CHARGING_PROFILE__CHARGING_PROFILE_PURPOSE: "Przeznaczenie profilu ładowania",
            CHARGING_PROFILE__CHARGING_PROFILE_KIND: "Rodzaj profilu ładowania",
            CHARGING_PROFILE__RECURRENCY_KIND: "Rodzaj powtarzania",
            CHARGING_PROFILE__VALID_FROM: "Ważny od",
            CHARGING_PROFILE__VALID_TO: "Ważny do",
            CHARGING_PROFILE__DURATION: "Czas trwania",
            CHARGING_PROFILE__START_SCHEDULE: "Początek planu",
            CHARGING_PROFILE__CHARGING_RATE_UNIT: "Jednostka tempa ładowania",
            CHARGING_PROFILE__MIN_CHARGING_RATE: "Minimalne tempo ładowania",
            CHARGING_PROFILE__EDIT: "Edycja profilu ładowania",
            CHARGING_PROFILE__REGISTER: "Rejestracja profilu ładowania",
            CHARGING_PROFILE__IDENTITY: "Identyfikator",
            CHARGE_BOX__SET_CHARGING_PROFILE: "Wyślij profil ładowania",
            CHARGING_PROFILE__TRANSACTION_ID: "Id transakcji",
            CHARGING_PROFILE__PRESET: "Ustawienie wstępne",
            CHARGING_PROFILE__DETAILS: "Szczegóły profilu ładowania",
            COMMONS__SEND: "Wyślij",
            CHARGE_BOX_VIEW__REFRESH_MAX_POWER: "Pobierz maksymalną moc",
            CHARGE_BOX_GROUP_EDIT__POWER: "Moc dla grupy [kW]",
            CHARGE_BOX_GROUP_EDIT__DYNAMIC_POWER: "Ustawienia mocy [kW]",
            CHARGE_BOX_GROUP_EDIT__IS_CHARGE_BOX_CONNECTED: "Ładowarka podłączona",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_NAME: "Nazwa ładowarki",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_POWER: "Moc ładowarki",
            CHARGE_BOX_GROUP_EDIT__WEIGHT: "Waga",
            CHARGE_BOX_GROUP_EDIT__PERCENTAGE_OF_POWER: "Procent mocy",
            CHARGE_BOX_GROUP_EDIT__MAX_POWER_BY_PRIORITY: "Maksymalna moc według priorytetu",
            CHARGE_BOX_GROUP_EDIT__PRIORITY: "Priorytet",
            CHARGE_BOX_GROUP_EDIT__SIMULATION: "Symulacja",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_STATE: "Stan",
            CHARGE_BOX_GROUP_EDIT__PERCENTAGE_USE: "Procentowe użycie",
            CHARGE_BOX_GROUP_EDIT__SUMMARY: "Podsumowanie",
            // chargebox configuration
            iccid:"iccid",
            chargeBoxSerialNumber:"chargeBoxSerialNumber",
            chargePointSerialNumber:"chargePointSerialNumber",
            chargePointVendor:"chargePointVendor",
            meterType:"meterType",
            meterSerialNumber:"meterSerialNumber",
            imsi:"imsi",
            proximityLockRetries:"proximityLockRetries",
            stopTxnAlignedData:"stopTxnAlignedData",
            meterValueSampleInterval:"meterValueSampleInterval",
            heartBeatInterval:"heartBeatInterval",
            lightIntensity:"lightIntensity",
            blinkRepeat:"blinkRepeat",
            meterValuesAlignedData:"meterValuesAlignedData",
            meterValuesSampledData:"meterValuesSampledData",
            proximityContactRetries:"proximityContactRetries",
            chargeBoxIdentity:"chargeBoxIdentity",
            resetRetries:"resetRetries",
            firmwareVersion:"firmwareVersion",
            connectionTimeOut:"connectionTimeOut",
            stopTxnSampledData:"stopTxnSampledData",
            chargePointId:"chargePointId",
            COMMONS_SHOW_DETAILS: "Pokaż szczegóły",
            SIDEBAR_TITLE__VEHICLE_DISTANCE: "Dystans pojazdu",
            VEHICLE_DISTANCE_DETAILS__TITLE: "Dystans pojazdu szczegóły",
            VEHICLE_DISTANCE__TABLE__MESSAGE_ID: "ID komunikatu",
            VEHICLE_DISTANCE__VEHICLE_ID: "ID pojazdu",
            VEHICLE_DISTANCE__SESSION_ID: "ID sesji",
            VEHICLE_DISTANCE__DISTANCE: "Dystans",
            VEHICLE_DISTANCE__TRANSACTION_ID: "ID transakcji",
            VEHICLE_DISTANCE__DATE_TIME: "Data/Czas",
            VEHICLE_DISTANCE__STATUS: "Status",
            VEHICLE_REPORT_SEARCH_FORM__VEHICLE_IDENTITY: "Identyfikator pojazdu",
            VEHICLE_REPORT_SEARCH_FORM__VEHICLE_NAME: "Numer boczny pojazdu",
            COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY: "Śr oddana energia ",
            COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY: "Oddana energia ",
            REPORT_CHARGE_BOX_GROUP__GROUP_NAME: "Nazwa grupy",
            SIDEBAR_TITLE__CHARGE_BOX_ENERGY: "Punkt ładowania: energia",
            SIDEBAR_TITLE__CHARGE_BOX_GROUP_ENERGY: "Grupa ładowarek: energia",
            SIDEBAR_TITLE__VEHICLE_ENERGY: "Pojazd: energia",
            TableNoMoreElementsTitle: "Lista wyników:",
            TableNoMoreElementsDescription: "Koniec wyników.",
            USER_PROFILE__USER_DATA: "Dane użytkownika",
            USER_PROFILE__EMAIL: "Email",
            USER_PROFILE__FIRST_NAME: "Imię",
            USER_PROFILE__LAST_NAME: "Nazwisko",
            USER_PROFILE__PHONE: "Telefon",
            USER_PROFILE__LANGUAGE: "Język",
            USER_PROFILE__ROLES: "Role",
            CHARGE_BOX_VIEW__REMAINING_TIME_TO_BULK_SOC: "Czas do 80%",
            CHARGE_BOX_VIEW__REMAINING_TIME_TO_FULL_SOC: "Czas do 100%",
            // commons
            without_group: "Nieprzypisane",
            COMMONS__LANGUAGE: "Język",
            COMMONS__ID: "Id",
            COMMONS__LP: "Lp.",
            COMMONS__STATE: "Stan",
            COMMONS__SUMMARY: "Podsumowanie",
            COMMONS__CHARGEBOXES: "Ładowarki",
            COMMONS__CHARGEBOX_GROUPS: "Grupy ładowarek",
            COMMONS__VEHICLES: "Pojazdy",
            CHARGE_BOX__IS_IN_OFFLINE_STATE: "Ładowarka jest wyłączona.",
            SIDEBAR_TITLE__CHARGE_BOX_GROUP_CONSUMED_ENERGY: "Grupy ładowarek pobrana energia",
            SIDEBAR_TITLE__VEHICLE_CONSUMED_ENERGY: "Pojazdy pobrana energia",
            ALERT_DETAILS__TITLE: "Alert szczegóły",
            MISSING_CHARGE_BOX_PROTOCOL: "Ładowarka nie określa protokołu",
            CHARGE_BOX_CONFIGURATION__DOWNLOAD_CONFIGURATION: "Pobierz konfiguracje",
            CHARGE_BOX_CONFIGURATION__READ_ONLY: "Konfiguracja do odczytu",
            CHARGE_BOX_CONFIGURATION__READ_WRITE: "Konfiguracja do odczytu i zapisu",
            COMMONS__CHARGE_BOX_GROUP_IDENTITY: "Identyfikator grupy ładowarek",
            COMMONS__CHARGE_BOX_GROUP_NAME: "Nazwa grupy ładowarek",
            COMMONS__VEHICLE_IDENTITY: "Identyfikator pojazdu",
            COMMONS__VEHICLE_NAME: "Nazwa pojazdu",
            COMMONS__TIME_RANGE: "Okno czasowe",
            COMMONS_SERVER_IS_BUSY_TITLE: "Serwer jest zajęty",
            COMMONS_SERVER_IS_BUSY_MESSAGE: "Serwer jest zajęty, poczekaj aż skończy aktualne zadanie.",
            COMMONS_DATA__WAS_LOADED: "Dane zostały załadowane.",
            COMMONS__FIRST: "Pierwsza",
            COMMONS__PREVIOUS: "Poprzednia",
            COMMONS__NEXT: "Następna",
            COMMONS__LAST: "Ostatnia",
            COMMONS__HOME: "Początek",
            COMMONS__SAVE: "Zapisz",
            COMMONS__SEARCH: "Szukaj",
            COMMONS__RESET: "Reset",
            COMMONS__CANCEL: "Anuluj",
            COMMONS__OPEN_SEARCH_CRITERIA: "Pokaż kryteria wyszukiwania",
            COMMONS__RELOAD_TABLE_DATA: "Odśwież wynik",
            COMMONS__EXPORT_XLSX: "Eksportuj xlsx",
            COMMONS__EXPORT_CSV: "Eksportuj",
            COMMONS__ITEMS_PER_PAGE: "Wyników na stronę",
            COMMONS__ADD_NEW_ITEM: "Dodaj",
            COMMONS__EDIT: "Edycja",
            COMMONS__VIEW: "Szczegóły",
            COMMONS__IMPORT: "Import",
            COMMONS__DATA_RELOADED: "Przeładowano dane",
            COMMONS__SERVER_OFFLINE: "Serwer jest wyłączony! Skontaktuj się z administratorem: mail@mail.mail",
            COMMONS__DATA_SYNCHRONIZATION: "Synchronizacja danych",
            COMMONS__AUTO_RELOAD: 'Automatyczne odświeżanie',
            COMMONS__SEND_DATA_REQUEST: 'Wyślij żądanie',
            COMMONS__CHARGE_BOX: 'Ładowarka',
            COMMONS_REQUEST__TIME: 'Czas',
            COMMONS_REQUEST__RESPONSE_STATUS: 'Status odpowiedzi',
            COMMONS_REQUEST__STATUS: 'Status',
            COMMONS__ACTIONS: 'Akcje',
            COMMONS__DEACTIVATE: 'Deaktywuj',
            COMMONS__ACTIVATE: 'Aktywuj',
            COMMONS__ACTIVE: 'Aktywny',
            COMMONS__ADDED_DATE_TIME: "Data dodania",
            COMMONS__SHOW: "Pokaż",
            COMMONS__ADD_RECEIVER: "Dodaj odbiorcę",
            COMMONS__BEGIN: "Początek",
            COMMONS__END: "Koniec",
            COMMONS__DURATION: "Czas trwania",
            COMMONS__SOCKET: "Gniazdo",
            COMMONS__CONSUMED_ENERGY: "Pobrana energia [kWh]",
            COMMONS__RETURNED_ENERGY: "Oddana energia ",
            COMMONS__VEHICLE: "Pojazd",
            COMMONS__TRANSACTION: "transakcja",
            COMMONS__TRANSACTIONS: "transakcje",
            COMMONS__FINAL_SOC: "Końcowy SOC [%]",
            COMMONS__SEARCH_COMPARISION_OPERATOR: "Sposób porównania",
            COMMONS__REQUEST: "Żądanie",
            COMMONS__RESPONSE: "Odpowiedź",
            COMMONS__SEND_REQUEST: "Wyślij żądanie",
            COMMONS__CHANGE: "Zmień",
            COMMONS__CLOSE: "Zamknij",
            COMMONS__ERROR: "Błąd",
            COMMONS__SERVER_IS_NOT_AVAILABLE: "Serwer jest niedostępny, skontaktuj się z administratorem",
            COMMONS__PERIOD: "Okres",
            COMMONS__PERIOD_6_H: "6H",
            COMMONS__PERIOD_24_H: "24H",
            COMMONS__PERIOD_10_D: "10D",
            COMMONS__PERIOD_30_D: "30D",
            COMMONS__PERIOD_6_M: "6M",
            COMMONS__PERIOD_12_M: "12M",
            COMMONS__CHARGE_POINT: "Punkt ładowania",
            COMMONS__REFRESH: "Odświerz",
            COMMONS__OUTLET_POWER_ACTIVE_IMPORT: "Moc wyjściowa",
            COMMONS__INLET_POWER_ACTIVE_IMPORT: "Moc wejściowa ",
            COMMONS__OUTLET_ENERGY_ACTIVE_IMPORT_REGISTER: "Energia pobrana przez pojazd",
            COMMONS__INLET_ENERGY_ACTIVE_IMPORT_REGISTER: "Całkowita energia pobrana",
            COMMONS__IMPORT_VOLTAGE_OUTLET: "Napięcie wyjściowe [V]",
            COMMONS__IMPORT_VOLTAGE_INLET: "Napięcie wejściowe [V]",
            COMMONS__VOLTAGE_TARGET_OUTLET: "Napięcie żądane [V]",
            COMMONS__VOLTAGE_PRESENT_INLET: "Bieżące napięcie [V]",
            COMMONS__CURRENT_IMPORT_OUTLET: "Bieżący prąd wyjściowy [A]",
            COMMONS__CURRENT_IMPORT_INLET: "Bieżący prąd wejściowy [A]",
            COMMONS__TARGET_CURRENT_OUTLET: "Prąd żądany [A]",
            COMMONS__CURRENT_PRESENT_OUTLET: "Bieżący prąd [A]",
            COMMONS__SOC: "SOC [%]",
            COMMONS__Energy: "Energia",
            COMMONS__Power: "Moc",
            COMMONS__Voltage: "Napięcie",
            COMMONS__Current: "Prąd",
            COMMONS__Soc: "SOC",
            COMMONS__STATUS: "Status",
            COMMONS__Temperature: "Temperatura",
            COMMONS__Other: "Pozostałe",
            COMMONS__Humidity: "Wilgotność",
            COMMONS__EXPORT_DATA: "Eksport danych",
            COMMONS__AVAILABLE: "Dostępne",
            COMMONS__SELECTED: "Wybrane",
            COMMONS__PRIVILEGES: "Uprawnienia",
            COMMONS__REMOTE_RESET: "Reset",
            COMMONS__PROFILE:  "Profil",
            COMMONS__SIGN_OUT:  "Wyloguj",
            CHARGE_BOX__RESET_TYPE: "Typ resetu",
            SIDEBAR_TITLE__USER_PROFILE: "Profil użytkownika",
            CHARGE_BOX_DETAILS__TITLE: "Szczegóły punktu ładowania",
            COMMONS__IDENTITY: "Identyfikator",
            COMMONS__NAME: "Nazwa",
            CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER: "Numer seryjny punktu ładowania",
            COMMONS__IP_ADDRESS: "Adres Ip",
            COMMONS__LAST_ACTIVITY_TIME: "Czas ostatniej aktywności",
            COMMONS__BATTERY_CAPACITY: "Pojemność baterii [kWh]",
            CHARGING_TRANSACTION_DETAILS__TITLE: "Szczegóły ładowania",
            MAP_CHARGE_BOX__TITLE: "Mapa punktów ładowania",
            SIDEBAR_TITLE__CHARGE_BOX_CONSUMED_ENERGY: "Punkt ładowania: pobrana energia",
            COMMONS__CHARGE_BOX_IDENTITY: "Identyfikator punktu ładowania",
            COMMONS__CHARGE_BOX_NAME: "Nazwa punktu ładowania",
            COMMONS__TOTAL_CHARGING_TIME: "Łączny czas ładowania",
            COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY: "Liczba transakcji",
            COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY: "Śr pobrana energia [kWh]",
            COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY: "Pobrana energia [kWh]",
            COMMONS__SHOW_DETAILS: "Pokaż szczegóły",
            GENERATE: "Generuj",
            VERSION: "Wersja",
            SIDEBAR_TITLE__ALERTS_DEFINITIONS: "Definicje alertów",
            USER_ACTIVITY_ALERT: "Powiadomienie",
            USER_ACTIVITY_CHARGEBOXGROUP: "Grupa",
            USER_ACTIVITY_AUTHORIZATIONTAG: "Znacznik",
            USER_ACTIVITY_CHARGEPOINT: 'Ładowarka',
            USER_ACTIVITY_ROLE: 'Rola',
            USER_ACTIVITY_VEHICLE: 'Pojazd',
            USER_ACTIVITY_USER: 'Użytkownik',
            USER_ACTIVITY_CHARGINGPROFILE: 'Profil ładowania',
            USER_ACTIVITY_GETCONFIGURATION: 'Pobranie konfiguracji',
            USER_ACTIVITY_CHANGECONFIGURATION: 'Zmiana konfiguracji',
            USER_ACTIVITY_REMOTESTARTTRANSACTION: 'Zdalny start',
            USER_ACTIVITY_REMOTESTOPTRANSACTION: 'Zdalny stop',
            USER_ACTIVITY_REMOTERESETSOFT: 'Soft reset',
            USER_ACTIVITY_REMOTERESETHARD: 'Hard reset',
            // --------------------------------------------------------------
            // date
            DATE__YEAR: "rok",
            DATE__YEAR_PLURAL: "lat",
            DATE__DAY: "dzień",
            DATE__DAY_PLURAL: "dni",
            DATE__HOUR: "godzin",
            DATE__MINUTE: "minut",
            DATE__SECOND: "sekund",
            DATE__LESS_THAN_SECOND: "mniej niż sekunda",
            // --------------------------------------------------------------
            // dialog
            DIALOG__ERROR_TITLE: "Błąd",
            DIALOG__SUCCESS_TITLE: "Sukces",
            DIALOG__EMTPY_SEARCH_CRITERIA: "Kryteria wyszukiwania są puste.",
            DIALOG__ITEM_SAVED: "Zapisano pole.",
            DIALOG__ITEM_UPDATED: "Zakutalizowano pole.",
            DIALOG__EMPTY_RESULTS: "Brak wyników.",
            // --------------------------------------------------------------
            // preconditions
            PRECONDITIONS__EMPTY_SEARCH_QUERY: "Zapytanie nie może być puste",
            // --------------------------------------------------------------
            // login
            // --------------------------------------------------------------
            LOGIN__PLEASE_LOGIN: "Zaloguj się do serwisu",
            LOGIN__EMAIL_ADDRESS: "Adres e-mail",
            LOGIN__PASSWORD: "Hasło",
            LOGIN__REMEMBER_ME: "Zapamiętaj mnie",
            LOGIN__LOGIN: "Zaloguj",
            LOGIN__FORGOT_PASSWORD: "Nie pamiętasz hasła?",
            LOGIN__RESET_PASSWORD: "Wprowadź nowe hasło",
            LOGIN__FORGOT_PASSWORD_MESSAGE: "Wprowadź swój email poniżej - wyślemy na niego link do strony przez która będzie można zresetować hasło",
            LOGIN__FORGOT_PASSWORD_CONFIRMATION: "Wysłano wiadomość na podany adres email.",
            LOGIN__SEND: "Wyślij",
            LOGIN__SET: "Ustaw",
            LOGIN__INVALID_EMAIL: "Nieprawidłowy adres email",
            // --------------------------------------------------------------
            // reset password
            RESET_PASSWORD_TOKEN__VALID: "Prawidłowy token",
            RESET_PASSWORD_TOKEN__INVALID: "Nieprawidłowy token",
            RESET_PASSWORD_TOKEN__EXPIRED: "Wygaśnięty token",
            RESET_PASSWORD_TOKEN__ERROR: "Wystąpił bład w trakcie sprawdzania tokenu",
            RESET_PASSWORD__COMPLETED: "Twoje hasło zostało zmienione",
            RESET_PASSWORD__ERROR: "Wystąpił bład podczas próby zmiany hasła",
            // --------------------------------------------------------------
            // menu
            // --------------------------------------------------------------
            SIDEBAR_TITLE__AUTHORIZATION_TAGS: "Znaczniki autoryzacyjne",
            SIDEBAR_TITLE__CHARGE_BOX_ACTIVITIES: "Aktywność ładowarek",
            SIDEBAR_TITLE__CHARGEBOX_AUTHORIZATION: "Autoryzacja",
            SIDEBAR_TITLE__BOOT_NOTIFICATION: "Notyfikacja uruchomienia",
            SIDEBAR_TITLE__DATA_TRANSFER: "Transfer danych",
            SIDEBAR_TITLE__DIAGNOSTICS_NOTIFICATION: "Notyfikacja diagnostyczna",
            SIDEBAR_TITLE__FIRMWARE_NOTIFICATION: "Notyfikacja oprogramowania",
            SIDEBAR_TITLE__HEARTBEAT: "Notyfikacja",
            SIDEBAR_TITLE__METER_VALUES: "Dane pomiarowe",
            SIDEBAR_TITLE__STATUS_NOTIFICATION: "Notyfikacja statusu",
            SIDEBAR_TITLE__CHARGING_TRANSACTION: "Transakcja ładowania",
            SIDEBAR_TITLE__CHARGEBOXES: "Punkty​ ​ Ładowania",
            SIDEBAR_TITLE__CHARGEBOXES_ALL: "WSZYSTKIE",
            SIDEBAR_TITLE__CHARGEBOXES_ERROR: "BŁĄD",
            SIDEBAR_TITLE__CHARGEBOXES_CHARGING: "AKTYWNE",
            SIDEBAR_TITLE__CHARGEBOXES_ONLINE: "GOTOWE",
            SIDEBAR_TITLE__CHARGEBOXES_WARNING: "OSTRZEŻENIE",
            SIDEBAR_TITLE__CHARGEBOXES_OFFLINE: "WYŁĄCZONE",
            SIDEBAR_TITLE__IMPORT_DATA: "Importuj dane",
            SIDEBAR_TITLE__IMPORT_REGISTRATION_DATA: "Importuj dane rejestracyjne",
            SIDEBAR_TITLE__METER_VALUES_CURRENT: "Trwające",
            SIDEBAR_TITLE__METER_VALUES_ALL: "Wszystkie",
            SIDEBAR_TITLE__REGISTRATION: "Rejestracja",
            SIDEBAR_TITLE__REGISTRATION_CHARGEBOX: "Ładowarka",
            SIDEBAR_TITLE__REGISTRATION_AUTHORIZATION_TAG: "Znacznik autoryzacyjny",
            SIDEBAR_TITLE__ROLES: "Role",
            SIDEBAR_TITLE__REGISTRATION_ROLE: "Rola",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS: "Historia transakcji",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS_CURRENT: "Trwające",
            SIDEBAR_TITLE__CHARGING_TRANSACTIONS_ALL: "Wszystkie",
            SIDEBAR_TITLE__USERS: "Użytkownicy",
            SIDEBAR_TITLE__REGISTRATION_USER: "Użytkownik",
            SIDEBAR_TITLE__VEHICLE: "Pojazdy",
            SIDEBAR_TITLE__CHARGEBOX_DETAILS: "Szczegóły ładowarki",
            SIDEBAR_TITLE__MAP: "Mapa",
            SIDEBAR_TITLE__CHARGEBOX_STATE_ACTIVITIES: "Godziny aktywności punktu ładowania",
//            SIDEBAR_TITLE__CHARGEBOX_TRANSACTIONS: "Punkt ładowania: sesje ładowarnia",
            SIDEBAR_TITLE__CHARGEBOX_ALERTS: "Punkt ładowania: alerty",
            SIDEBAR_TITLE__CHARGEBOX_TRANSACTIONS: "Transakcje historyczne",
            SIDEBAR_TITLE__USERACTIVITY: "Aktywność użytkowników",
            // --------------------------------------------------------------
            // dashboard
            DASHBOARD__CHARGE_BOXES_LIST__CHARGE_POINT_NAME: "Nazwa ładowarki",
            DASHBOARD__CHARGE_BOXES_LIST__SERIAL_NUMBER: "Numer seryjny",
            DASHBOARD__CHARGE_BOXES_LIST__LAST_ACTIVITY: "Ostatnia aktywność",
            DASHBOARD__CHARGE_BOXES_LIST__LAST_CHARGING: "Ostatnie ładowanie",
            DASHBOARD__CHARGE_BOXES_LIST__IP_ADDRESS: "IP",
            DASHBOARD__CHARGE_BOXES_LIST__ERROR: "BŁĄD",
            DASHBOARD__CHARGE_BOXES_LIST__CHARGING:	"AKTYWNE",
            DASHBOARD__CHARGE_BOXES_LIST__WARNING: "OSTRZEŻENIE",
            DASHBOARD__CHARGE_BOXES_LIST__ONLINE: "GOTOWE",
            DASHBOARD__CHARGE_BOXES_LIST__OFFLINE: "WYŁĄCZONE",
            DASHBOARD_CHARGEBOX_QUANTITY: "Ilość ładowarek",
            DASHBOARD_TOTAL_POWER: "Moc [kW]",
            DASHBOARD_POWER: "Moc",
            DASHBOARD_LAST_ACTIVITY: "Ostatnia aktywność",
            DASHBOARD_LAST_CHARGING: "Ostatnie ładowanie",
            DASHBOARD_LAST_ERROR: "Ostatni błąd",
            DASHBOARD_LAST_WARNING: "Ostatnie ostrzeżenie",
            DASHBOARD_IP: "IP",
            DASHBOARD_SOC: "SOC [%]",
            DASHBOARD_VEHICLE: "Pojazd",
            DASHBOARD_FROM_WHEN: "Od kiedy",
            // authorization tagshttp://192.168.14.107/#/transaction/list
            AUTHORIZATION_TAG_LIST__TITLE: "Znaczniki autoryzacyjne",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__PARENT_ID_TOKEN: "ID nadrzędnego tokenu",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__ID_TOKEN: "Token identyfikacyjny",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__STATUS: "Status",
            AUTHORIZATION_TAG_LIST__SEARCH_FORM__EXPIRY_DATE: "Data wygaśnięcia",
            AUTHORIZATION_TAG_LIST__TABLE__PARENT_ID_TOKEN: "ID nadrzędnego tokenu",
            AUTHORIZATION_TAG_LIST__TABLE__ID_TOKEN: "Token identyfikacyjny",
            AUTHORIZATION_TAG_LIST__TABLE__STATUS: "Status",
            AUTHORIZATION_TAG_LIST__TABLE__EXPIRY_DATE: "Data wygaśnięcia",
            AUTHORIZATION_TAG_DETAILS__TITLE: "Szczegóły znacznika autoryzacyjnego",
            AUTHORIZATION_TAG_EDIT__TITLE: "Edycja znacznika autoryzacyjnego",
            AUTHORIZATION_TAG_DETAILS__PARENT_ID_TOKEN: "ID nadrzędnego tokenu",
            AUTHORIZATION_TAG_DETAILS__ID_TOKEN: "Token identyfikacyjny",
            AUTHORIZATION_TAG_DETAILS__STATUS: "Status",
            AUTHORIZATION_TAG_DETAILS__EXPIRY_DATE: "Data wygaśnięcia",
            AUTHORIZATION_TAG_REGISTER__TITLE: "Zarejestruj znacznik autoryzacyjny",
            // chargeboxes
            CHARGE_BOXES_ALL_LIST__TITLE: "Ładowarki",
            CHARGE_BOXES_CHARGING_LIST__TITLE: "Ładujące ładowarki",
            CHARGE_BOXES_ERROR_LIST__TITLE: "Ładowarki z błedem",
            CHARGE_BOXES_OFFLINE_LIST__TITLE: "Wyłączone ładowarki",
            CHARGE_BOXES_ONLINE_LIST__TITLE: "Włączone ładowarki",
            CHARGE_BOXES_SEARCH_FORM__INPUT_NAME: "Nazwa ładowarki",
            CHARGE_BOXES_SEARCH_FORM__INPUT_CHARGE_BOX_IDENTITY: "Identyfikator",
            CHARGE_BOXES_SEARCH_FORM__INPUT_CHARGE_BOX_SERIAL_NUMBER: "Numer seryjny",
            CHARGE_BOXES_SEARCH_FORM__INPUT_IP_ADDRESS: "Adres IP",
            CHARGE_BOXES_TABLE__CHARGE_POINT_NAME: "Nazwa ładowarki",
            CHARGE_BOXES_TABLE__CHARGE_BOX_IDENTITY: "Identyfikator",
            CHARGE_BOXES_TABLE__CHARGE_BOX_SERIAL_NUMBER: "Numer seryjny",
            CHARGE_BOXES_TABLE__IP_ADDRESS: "Adres IP",
            CHARGE_BOXES_TABLE__PROTOCOL: "Protokół",
            CHARGE_BOXES_TABLE__LAST_ACTIVITY: "Ostania aktywność",
            CHARGE_BOXES_TABLE__CHARGE_POINT_STATUS: "Status ładowarki",
            CHARGE_BOX_EDIT__TITLE: "Edycja punktu ładowania",
            CHARGE_BOX_EDIT__IDENTITY: "Identyfikator",
            CHARGE_BOX_EDIT__SN: "S/N",
            CHARGE_BOX_EDIT__GPS: "Pozycja GPS",
            CHARGE_BOX_EDIT__MAX_POWER: "Maksymalna moc",
            CHARGE_BOX_EDIT__GROUP: "Grupa",
            CHARGE_BOX_EDIT__ACTIVE: "Aktywny",
            CHARGE_BOX_EDIT__ADDED_DATE_TIME: 'Data dodania',
            CHARGE_BOX_EDIT__LAST_ACTIVITY_TIME: 'Czas ostatniej aktywności',
            CHARGE_BOX_EDIT__LAST_ACTIVITY: 'Ostatnia aktywność',
            CHARGE_BOX_EDIT__LAST_CHARGING: 'Ostatnie ładowanie',
            CHARGE_BOX_EDIT__CHARGE_BOX_STATUS: 'Status ładowarki',
            CHARGE_BOX_EDIT__NAME: 'Nazwa',
            CHARGE_BOX_EDIT__IP_ADDRESS: 'Adres IP',
            CHARGE_BOX_EDIT__OCPP_PROTOCOL_VERSION: 'Wersja protokołu OCPP',
            CHARGE_BOX_EDIT__CHARGE_BOX_IDENTITY: 'Identyfikator kontrolera ładowania',
            CHARGE_BOX_EDIT__CHARGE_POINT_VENDOR: 'Sprzedawca',
            CHARGE_BOX_EDIT__CHARGE_POINT_MODEL: 'Model',
            CHARGE_BOX_EDIT__CHARGE_POINT_SERIAL_NUMBER: 'Numer seryjny punktu ładowania',
            CHARGE_BOX_EDIT__CHARGE_BOX_SERIAL_NUMBER: 'Numer seryjny kontrolera',
            CHARGE_BOX_EDIT__FIRMWARE_VERSION: 'Wersja firmware',
            CHARGE_BOX_EDIT__ICCID: 'iccid',
            CHARGE_BOX_EDIT__IMSI: 'imsi',
            CHARGE_BOX_EDIT__METER_TYPE: 'Typ licznika',
            CHARGE_BOX_EDIT__METER_SERIAL_NUMBER: 'Numer seryjny licznika',
            CHARGE_BOX_EDIT__SOAP_SERVICES_ENDPOINT_URL: 'soapServicesEndpointUrl',
            CHARGE_BOX_EDIT__ADDRESS: 'Adres',
            CHARGE_BOX_EDIT__LATITUDE: 'Szerokość geograficzna',
            CHARGE_BOX_EDIT__LONGTITUDE: 'Długość geograficzna',
            CHARGE_BOX_EDIT__MAX_FACTORY_POWER: "Max moc fabryczna [kW]",
            CHARGE_BOX_VIEW__TITLE: "Szczegóły punktu ładowania",
            CHARGE_BOX_VIEW__CHARGE_BOX: "Kontroler ładowania",
            CHARGE_BOX_VIEW__ADDED_DATE_TIME: "Data dodania",
            CHARGE_BOX_VIEW__NAME: "Nazwa",
            CHARGE_BOX_VIEW__IP_ADDRESS: "Adres IP",
            CHARGE_BOX_VIEW__OCPP_PROTOCOL_VERSION: "Wersja protokołu OCPP",
            CHARGE_BOX_VIEW__CHARGE_BOX_IDENTITY: "Identyfikator ładowarki",
            CHARGE_BOX_VIEW__CHARGE_POINT_VENDOR: "Sprzedawca",
            CHARGE_BOX_VIEW__CHARGE_POINT_MODEL: "Model",
            CHARGE_BOX_VIEW__CHARGE_POINT_SERIAL_NUMBER: "Numer seryjny punktu ładowania",
            CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER: "Numer seryjny ładowarki",
            CHARGE_BOX_VIEW__FIRMWARE_VERSION: "Wersja firmware",
            CHARGE_BOX_VIEW__ICCID: "Iccid",
            CHARGE_BOX_VIEW__IMSI: "Imsi",
            CHARGE_BOX_VIEW__METER_TYPE: "Typ pomiaru",
            CHARGE_BOX_VIEW__METER_SERIAL_NUMBER: "Numer seryjny pomiaru",
            CHARGE_BOX_VIEW__SOAP_SERVICES_ENDPOINT_URL: "Url usługi SOAP",
            CHARGE_BOX_VIEW__LAST_ACTIVITY_TIME: "Data ostatniej aktywności",
            CHARGE_BOX_VIEW__LAST_ACTIVITY: "Ostatnia aktywność",
            CHARGE_BOX_VIEW__LAST_CHARGING_TIME: "Ostatnie ładowanie",
            CHARGE_BOX_VIEW__CHARGEBOX_STATUS: "Status ładowarki",
            COMMONS__REMOTE_START_TRANSACTION: "Zdalny start ładowania",
            COMMONS__REMOTE_STOP_TRANSACTION: "Zdalny stop ładowania",
            REMOTE_STOP_TRANSACTION__TRANSACTION_ID: "Id transakcji",
            CHARGE_BOX_VIEW__SHOW_HISTORIC_SESSIONS: "Historyczne sesje",
            CHARGE_BOX_VIEW__SHOW_HISTORIC_ALERTS: "Historyczne alerty",
            CHARGE_BOX_VIEW__SHOW_ON_MAP: "Pokaż na mapie",
            CHARGE_BOX_VIEW__MAX_POWER: "Maksymalna moc fabryczna [kW]",
            CHARGE_BOX_VIEW__SET_POWER: "Moc ustawiona [kW]",
            CHARGE_BOX_VIEW__PRODUCT_GROUPS: "Grupy ładowarek",
            CHARGE_BOX_VIEW__OTHER_INFORMATIONS: "Pozostałe informacje",
            CHARGE_BOX_VIEW__CHARGING_DETAILS: "Szczegóły ładowania",
            CHARGE_BOX_VIEW__CHARGING_START: "Początek",
            CHARGE_BOX_VIEW__CHARGING_END: "Koniec",
            CHARGE_BOX_VIEW__CHARGING_DURATION: "Czas trwania",
            CHARGE_BOX_VIEW__CHARGING_SOCKET: "Gniazdo",
            CHARGE_BOX_VIEW__CHARGING_STATE: "Stan",
            CHARGE_BOX_VIEW__CHARGING_CONSUMED_ENERGY: "Pobrana energia [kWh]",
            CHARGE_BOX_VIEW__CHARGING_DEVOTED_ENERGY: "Oddana energia ",
            CHARGE_BOX_VIEW__CHARGING_VEHICLE: "Pojazd",
            CHARGE_BOX_VIEW__ACTIVITY_HOURS: "Godziny aktywności",
            CHARGE_BOX_VIEW__CHARGING_TIME: "Czas ładowania",
            CHARGE_BOX_VIEW__ONLINE_TIME: "Czas gotowości",
            CHARGE_BOX_VIEW__LAST_FAIL: "Ostatni błąd",
            CHARGE_BOX_VIEW__SOC_AT_BEGIN: "SOC(p) [%]",
            CHARGE_BOX_VIEW__SOC_CURRENT: "SOC(b) [%]",
            CHARGE_BOX_VIEW__SOC_END: "SOC(k) [%]",
            CHARGE_BOX_VIEW__SOC_DELTA: "SOC(Δ) [%]",
            CHARGE_BOX_VIEW__DISTANCE: "Dystans",
            CHARGE_BOX_VIEW__TOTAL_CONSUMED_ENERGY: "Sumaryczna energia pobrana [kWh]",
            CHARGE_BOX_VIEW__LAST_WARNING: "Ostatnie ostrzeżenie",
            CHARGE_BOX_VIEW__EXPECTED_TIME: "Przewidywany czas",
            CHARGE_BOX_VIEW__MAX_FACTORY_POWER: "Maksymalna moc fabryczna [kW]",
            CHARGE_BOX_VIEW__MAX_POWER_SET: "Ustawiona maksymalna moc [kW]",
            CHARGE_BOX__CHANGE_CONFIGURATION: "Zmiana konfiguracji",
            CHANGE_CONFIGURATION__KEY: "Klucz",
            CHANGE_CONFIGURATION__VALUE: "Wartość",
            CHARGE_BOX__HISTORIC_TRANSACTIONS: "Transakcje historyczne",
            CHARGE_BOX_STATUS__ONLINE: "Włączona",
            CHARGE_BOX_STATUS__ERROR: "Błąd",
            CHARGE_BOX_STATUS__CHARGING: "Ładowanie",
            CHARGE_BOX_STATUS__READY: "Gotowa",
            CHARGE_BOX_STATUS__OFFLINE: "Wyłączona",
            CHARGE_BOX_VIEW__SHOW_CONFIGURATION: "Pokaż konfiguracje",

            // transactions
            TRANSACTIONS_LIST__TITLE: "Transakcje",
            TRANSACTIONS_SEARCH_FORM__START_TIMESTAMP: "Od",
            TRANSACTIONS_SEARCH_FORM__STOP_TIMESTAMP: "Do",
            TRANSACTIONS_SEARCH_FORM__CHARGE_BOX_IDENTITY: "Ładowarka",
            TRANSACTIONS_SEARCH_FORM__VEHICLE_NAME: "Pojazd",
            TRANSACTIONS_SEARCH_FORM__TRANSACTION_ID: "ID Transakcji",
            TRANSACTIONS_TABLE__TRANSACTION_ID: "ID Transakcji",
            TRANSACTIONS_TABLE__ID: "Identyfikator",
            TRANSACTIONS_TABLE__START_TIMESTAMP: "Rozpoczęcie",
            TRANSACTIONS_TABLE__STOP_TIMESTAMP: "Koniec",
            TRANSACTIONS_TABLE__CHARGING_TIME: "Czas ładowania",
            TRANSACTIONS_TABLE__ENERGY: "Energia",
            TRANSACTIONS_TABLE__ENERGY_IN: "Energia pobrana",
            TRANSACTIONS_TABLE__ENERGY_OUT: "Energia oddana",
            TRANSACTIONS_TABLE__CHARGE_BOX_Name: "Nazwa",
            TRANSACTIONS_TABLE__CHARGE_BOX_IDENTITY: "Identyfikator ładowarki",
            TRANSACTIONS_TABLE__CHARGE_BOX_SERIAL: "Numer seryjny",
            TRANSACTIONS_TABLE__SOC_START: "SOC(p) [%]",
            TRANSACTIONS_TABLE__SOC_END: "SOC(k) [%]",
            TRANSACTIONS_TABLE__SOCKET: "Gniazdo",
            TRANSACTIONS_TABLE__VEHICLE: "Pojazd",
            TRANSACTIONS_TABLE__EOC_REASON: "Powód zakończenia",
            TRANSACTION_DETAILS__TITLE: "Szczegóły transakcji",
            TRANSACTION_DETAILS__TRANSACTION_ID: "Id transakcji",
            TRANSACTION_DETAILS__CONNECTOR_ID: "Numer gniazda",
            TRANSACTION_DETAILS__ID_TAG: "idTag",
            TRANSACTION_DETAILS__RESERVATION_ID: "Id rezerwacji",
            TRANSACTION_DETAILS__START_TIMESTAMP: "Rozpoczęcie",
            TRANSACTION_DETAILS__STOP_TIMESTAMP: "Koniec",
            TRANSACTION_DETAILS__STOP_REASON: "Powód zatrzymania",
            TRANSACTION_DETAILS__ENERGY: "Energia",
            TRANSACTION_DETAILS__DURATION: "Czas trwania",
            TRANSACTION_DETAILS__META_DATA: "Meta dane",
            TRANSACTION_DETAILS__METER_VALUES: "Dane pomiarowe",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__TIMESTAMP: "Data pomiaru",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__VALUE: "Wartość",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__READING_CONTEXT: "Kontekst",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__VALUE_FORMAT: "Format",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__MEASURAND: "Miernik",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__LOCATION: "Lokacja",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__MEASURE_OF_UNIT: "Miara jednostki",
            TRANSACTION_DETAILS_METER_VALUES_TABLE__PHASE: "Faza",
            TRANSACTION_DETAILS__METER_VALUES_CHART_TITLE: "Wykres",
            // meter values
            METER_VALUES_LIST__TITLE: "Dane pomiarowe",
            METER_VALUES_CURRENT_LIST__TITLE: "Trwające pomiary",
            METER_VALUES_SEARCH_FORM__CHARGE_BOX_IDENTITY: "Ładowarka",
            METER_VALUES_SEARCH_FORM__CONNECTOR_ID: "Gniazdo",
            METER_VALUES_SEARCH_FORM__TRANSACTION_ID: "Id transakcji",
            METER_VALUES_TABLE__TIMESTAMP: "Data pomiaru",
            METER_VALUES_TABLE__CHARGEBOX: "Ladowarka",
            METER_VALUES_TABLE__TRANSACTION: "Transakcja",
            METER_VALUES_TABLE__CONNECTOR: "Gniazdo",
            METER_VALUES_TABLE__VALUE: "Wartość",
            METER_VALUES_TABLE__READING_CONTEXT: "Kontekst",
            METER_VALUES_TABLE__VALUE_FORMAT: "Format",
            METER_VALUES_TABLE__MEASURAND: "Miernik",
            METER_VALUES_TABLE__LOCATION: "Lokacja",
            METER_VALUES_TABLE__MEASURE_OF_UNIT: "Miara jednostki",
            METER_VALUES_TABLE__PHASE: "Faza",
            METER_VALUES_TABLE__VIEW: "Wyświetl",
            METER_VALUES_DIALOG__TITLE: "Szczegóły pomiaru",
            METER_VALUES_DIALOG__META_DATA: "Dane pomiarowe",
            METER_VALUES_DIALOG__CHARGEBOX: "Ładowarka",
            METER_VALUES_DIALOG__CONNECTOR_ID: "Gniazdo",
            METER_VALUES_DIALOG__TRANSACTION_ID: "Id transakcji",
            METER_VALUES_DIALOG__TIMESTAMP: "Data",
            // registration chargebox
            REGISTRATION_CHARGE_BOX__TITLE: "Rejestracja ładowarki",
            REGISTRATION_CHARGE_BOX__REGISTRATION_SUCCESS: "Zarejestrowano ładowarke.",
            REGISTRATION_CHARGE_BOX__IDENTITY: "Identyfikator",
            REGISTRATION_CHARGE_BOX__SOAP_ENDPOINT_PATH: "Ścieżka dostępu SOAP",
            REGISTRATION_CHARGE_BOX__PROTOCOL: "Protokół",
            // current transactions
            CURRENT_TRANSACTIONS_LIST__TITLE: "Trwające ładowania",
            // import data
            IMPORT_REGISTRATION_DATA__TITLE: "Import danych rejestracji",
            IMPORT_REGISTRATION_DATA__SUCCESSFULLY_IMPORTED: "Zaimportowano dane rejestracji",
            IMPORT_REGISTRATION_DATA__CONTENT_TO_IMPORT: "Zawartość do zaimportowania",
            IMPORT_REGISTRATION_DATA__IMPORT: "Importuj",
            // chargeBox configuration
            SIDEBAR_TITLE__CHARGEBOX_CONFIGURATION: 'Konfiguracje ładowarek',
            CHARGEBOX_CONFIGURATION_LIST__TITLE: 'Konfiguracje ładowarek',
            CHARGEBOX_CONFIGURATION__TABLE__CHARGEBOX_IDENTITY: "Identyfikator ładowarki",
            CHARGEBOX_CONFIGURATION__TABLE__REQUEST_TIME: "Data żądania",
            CHARGEBOX_CONFIGURATION__TABLE__RESPONSE_STATUS: "Status odpowiedzi",
            CHARGEBOX_CONFIGURATION__TABLE__LIST_VERSIOON: "Lista",
            CHARGEBOX_CONFIGURATION__TABLE__CLEAR_CACHE_STATUS: 'Status',
            CHARGEBOX_DETAILS__MISSING_CONFIGURATION_TITLE: "Konfiguracja ładowarki",
            CHARGEBOX_DETAILS__MISSING_CONFIGURATION_MESSAGE: "Konfiguracja ładowarki nie została wczytana, sprawdź czy ładowarka była chociaż raz dostępna online.",
            // chargeBox activity
            CHARGEBOX_ACTIVITY_LIST__TITLE: 'Aktywność ładowarek',
            CHARGEBOX_ACTIVITY__TABLE__CHARGEBOX_IDENTITY: 'Identyfikator ładowarki',
            CHARGEBOX_ACTIVITY__TABLE__ACTIVITY_TYPE: 'Typ aktywności',
            CHARGEBOX_ACTIVITY__TABLE__REQUEST_TIME: 'Data żadania',
            CHARGEBOX_ACTIVITY__TABLE__RESPONSE_STATUS: 'Status odpowiedzi',
            CHARGEBOX_ACTIVITY_SEARCH_FORM__FROM_DATETIME: "Od",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__TO_DATETIME: "Do",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__TYPE: "Typ",
            CHARGEBOX_ACTIVITY_SEARCH_FORM__CHARGE_BOX_IDENTITY: "Identifyikator ładowarki",
            // chargeBox activities
            CHARGEBOX_AUTHORIZATIONS_LIST__TITLE: 'Autoryzacje ładowarki',
            CHARGEBOX_BOOT_NOTIFICATION_LIST__TITLE: 'Notyfikacje uruchomienia',
            CHARGEBOX_DATA_TRANSFER_LIST__TITLE: 'Transfery danych',
            CHARGEBOX_DIAGNOSTICS_LIST__TITLE: 'Listy diagnostyczne',
            CHARGEBOX_FIRMWARE_NOTIFICATION_LIST__TITLE: 'Status oprogramowania',
            CHARGEBOX_HEARTBEAT_LIST__TITLE: 'Impulsy',
            CHARGEBOX_METER_VALUES_LIST__TITLE: 'Dane pomiarowe',
            CHARGEBOX_STATUS_NOTIFICATION_LIST__TITLE: 'Notyfikacje statusu',
            CHARGEBOX_TRANSACTION_LIST__TITLE: 'Transakcje historyczne',
            CHARGE_BOX__START_TRANSACTION: 'Start transakcji',
            CHARGE_BOX__STOP_TRANSACTION: 'Stop transakcji',
            REMOTE_START_TRANSACTION__CONNECTOR_ID: "ConnectorId",
            REMOTE_START_TRANSACTION__ID_TAG: "IdTag",
            // chargeBox register
            CHARGE_BOX_REGISTER__TITLE: 'Rejestracja ładowarki',
            // roles
            ROLES_LIST__TITLE: "Lista roli",
            ROLE_TABLE__NAME: 'Nazwa roli',
            // users
            USER_LIST__TITLE: 'Lista użytkowników',
            USERS_TABLE__IDENTITY: 'Identyfikator',
            USERS_TABLE__EMAIL: 'Email',
            USERS_TABLE__FIRST_NAME: 'Imię',
            USERS_TABLE__LAST_NAME: 'Nazwisko',
            USERS_TABLE__PHONE: 'Telefon',
            USERS_TABLE__ENABLED: 'Włączony',
            USERS_TABLE__ROLES: 'Role',
            USERS_TABLE__ADDED_DATE_TIME: 'Data dodania',
            USERS_TABLE__PASSWORD: "Hasło",
            USERS_TABLE__CONFIRM_PASSWORD: "Potwierdź hasło",
            USERS_TABLE__ROLE: "Role",
            USERS_TABLE__PASSWORD_CONFIRM: "Potwierdzenie hasła",
            USER_REGISTER__TITLE: 'Rejestracja użytkownika',
            USERS_SEARCH_FORM__EMAIL: "E-mail",
            USERS_SEARCH_FORM__FIRST_NAME: "Imię",
            USERS_SEARCH_FOR__LAST_NAME: "Nazwisko",
            USERS_SEARCH_FORM__FROM_DATETIME: "Data dodania od",
            USERS_SEARCH_FORM__TO_DATETIME: "Data dodania do",
            // role list
            ROLE_EDIT__TITLE: "Edycja roli",
            ROLE_LIST__TITLE: "Lista ról",
            ROLE_REGISTER__TITLE: "Rejestracja roli",
            // local list version
            SIDEBAR_TITLE__LOCAL_LIST_VERSION: "Wersje lokalnych list",
            // clear cache
            SIDEBAR_TITLE__CLEAR_CACHE: 'Wyczyść schowek',
            CHARGEBOX_CLEAR_CACHE_LIST__TITLE: 'Żadania wyczyszczenia schowka',
            // chargebox activity
            CHARGE_BOX_ACTIVITY_DETAILS__TITLE: "Aktywność",
            SIDEBAR_TITLE__CHARGEBOX_ACTIVITY: 'Aktywność',
            CHARGEBOX_ACTIVITY_VIEW__TITLE: 'Aktywność ładowarki',
            // update firmware
            SIDEBAR_TITLE__UPDATE_FIRMWARE: 'Oprogramowanie',
            UPDATE_FIRMWARE_LIST__TITLE: 'Lista zapytań akutalizacji oprogramowania',
            // unlock connector
            SIDEBAR_TITLE__UNLOCK_CONNECTOR: 'Odblokuj wtyk',
            UNLOCK_CONNECTOR_LIST__TITLE: 'Żadania odblokowania wtyku',
            // reset
            RESET_LIST__TITLE: 'Lista resetów',
            SIDEBAR_TITLE__RESET: "Reset",
            RESET__TABLE__RESET_TYPE: 'Typ resetu',
            // reservation
            SIDEBAR_TITLE__CANCEL_RESERVATION: "Anulowania rezerwacji",
            CANCEL_RESERVATION__TITLE: 'Lista anulowanych rezerwacji',
            // change availability
            SIDEBAR_TITLE__CHANGE_AVAILABILITY: "Zmiany dostępności",
            CHANGE_AVAILABILITY_LIST__TITLE: 'Zapytania zmiany dostępności',
            // change configuration
            SIDEBAR_TITLE__CHANGE_CONFIGURATION: "Zmiany konfiguracji",
            CHANGE_CONFIGURATION_LIST__TITLE: 'Lista zapytań konfiguracyjnych',
            // diagnostics
            SIDEBAR_TITLE__DIAGNOSTICS: "Diagnostyka",
            GET_DIAGNOSTICS_LIST__TITLE: 'Lista zapytań diagnostycznych',
            // remote start transaction
            SIDEBAR_TITLE__REMOTE_START_TRANSACTION: "Zdalny start transakcji",
            REMOTE_START_TRANSACTION_LIST__TITLE: 'Lista zdalnych rozpoczęć',
            // remote stop transaction
            SIDEBAR_TITLE__REMOTE_STOP_TRANSACTION: "Zdalny stop transakcji",
            REMOTE_STOP_TRANSACTION_LIST__TITLE: 'Lista zdalnych zatrzymań',
            // reserve now
            SIDEBAR_TITLE__RESERVE_NOW: "Rezerwacje",
            RESERVE_NOW_LIST__TITLE: 'Lista rezerwacji',
            // send local list
            SIDEBAR_TITLE__SEND_LOCAL_LIST: "Listy autoryzacyjne",
            // data transfer
            DATA_TRANSFER_LIST__TITLE: 'Zapytania transferu danych',
            SEND_LOCAL_LIST_LIST__TITLE: 'Zapytania o liste',
            ADVANCED_SEARCH: 'Zaawansowane wyszukiwanie:',
            ADVANCED_SEARCH_FIELDS: 'Pola dostępne w zapytaniu:',
            // alerts
            SIDEBAR_TITLE__ALERTS_HISTORY: "Historia alertów",
            SIDEBAR_TITLE__ALERTS: "Historia alertów",
            ALERT_HISTORY_LIST__TITLE: "Historia alertów",
            ALERT_LIST__TITLE: "Alerty",
            ALERT_REGISTER__TITLE: "Dodaj definicję alertu",
            ALERTS_LIST__TRIGGER_METHOD: "Akcja",
            ALERTS_LIST__ALERT_TIME: "Data wystąpienia",
            ALERTS_LIST__CHARGE_BOX_IDENTITY: "Identyfikator ładowarki",
            ALERT_VIEW__TITLE: "Szczegóły alertu",
            ALERT_VIEW__ALERT_TIME: "Data wystąpienia",
            ALERT_VIEW__TRIGGER_METHOD: "Akcja",
            ALERT_VIEW__CONDITION: "Warunek",
            ALERT_VIEW__NOTIFICATION_TYPE: "Typ powiadomienia",
            ALERT_VIEW__RECEIVERS: "Odbiorcy",
            ALERT_VIEW__STATUS: "Status",
            ALERT_VIEW__ERROR_CODE: "Kod błędu",
            ALERT_VIEW__VENDOR_ERROR_CODE: "Kod błędu dostawcy",
            ALERT_VIEW__SUBJECT: "Temat",
            ALERT_VIEW__CONTENT: "Treść",
            // administration
            SIDEBAR_TITLE__ADMINISTRATION: "Administracja",
            SIDEBAR_TITLE__ADMINISTRATION_CHARGEBOXES: "Zarządzanie punktami ładowania",
            SIDEBAR_TITLE__ADMINISTRATION_CHARGEBOXES_GROUPS: "Zarządzanie grupami punktów ładowania",
            SIDEBAR_TITLE__ADMINISTRATION_ALERTS: "Zarządanie alertami",
            SIDEBAR_TITLE__ADMINISTRATION_OPERATORS: "Zarządanie kontami operatorów",
            ADMINISTRATION_CHARGE_BOXES_LIST__TITLE: "Punkty ładowania",
            ADMINISTRATION_CHARGE_BOXES_LIST__NAME: "Nazwa punktu ładowania",
            ADMINISTRATION_CHARGE_BOXES_LIST__IDENTITY: "Identyfikator",
            ADMINISTRATION_CHARGE_BOXES_LIST__SERIAL_NUMBER: "Numer seryjny",
            ADMINISTRATION_CHARGE_BOXES_LIST__IP_ADDRESS: "Adres IP",
            ADMINISTRATION_CHARGE_BOXES_LIST__LAST_ACTIVITY: "Ostatnia aktywność",
            ADMINISTRATION_CHARGE_BOXES_LIST__STATUS: "Status",
            ADMINISTRATION_ALERTS_LIST__NAME: "Nazwa alertu",
            ADMINISTRATION_ALERTS_LIST__EVENT: "Zdarzenie",
            ADMINISTRATION_ALERTS_LIST__CHARGE_BOX: "Punkt ładowania",
            ADMINISTRATION_ALERTS_LIST__RECEIVERS: "Odbiorcy",
            ADMINISTRATION_ALERTS_LIST__ACTIVE: "Aktywny",
            // accounts
            SIDEBAR_TITLE__ACCOUNTS: "Konta",
            // chargebox configuration
            CHARGE_BOX_CONFIGURATION__TITLE: "Konfiguracja ładowarki",
            CHARGE_BOX_CONFIGURATION_LIST__TITLE: "Konfiguracja",
            // chargebox group
            SIDEBAR_TITLE__CHARGEBOX_GROUPS: "Grupy ładowarek",
            CHARGE_BOX_GROUP_LIST__TITLE: "Grupy ładowarek",
            CHARGE_BOX_GROUP_EDIT__NAME: "Nazwa grupy",
            CHARGE_BOX_GROUP_EDIT__CHARGE_POINTS: "Punkty ładowania",
            CHARGE_BOX_GROUP_EDIT__MAXIMUM_CONNECTOR_POWER: "Maksymalna moc przyłącza",
            CHARGE_BOX_GROUP_EDIT__DESCRIPTION: "Opis",
            CHARGE_BOX_GROUP_TABLE__NAME: "Nazwa grupy ładowarek",
            CHARGE_BOX_GROUP_TABLE__ACTIVE: "Aktywna",
            CHARGE_BOX_GROUP_TABLE__CHARGER_COUNT: "Ilość ładowarek",
            CHARGE_BOX_GROUP_TABLE__SUMMARY_POWER: "Łączna moc",
            CHARGE_BOX_GROUP_TABLE__EDIT_POWER: "Edycja mocy",
            CHARGE_BOX_GROUP_TABLE__EDIT_GROUP: "Edycja grupy",
            CHARGE_BOX_GROUP_EDIT__TITLE: "Edytuj grupe ładowarek",
            CHARGE_BOX_GROUP_REGISTER__TITLE: "Rejestruj grupę ładowarek",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOXES: "Ładowarki",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX: "Ładowarka",
            CHARGE_BOX_GROUP_EDIT__CHARGE_BOX_PRIORITY: "Priorytet",
            CHARGE_BOX_GROUP_SEARCH__NAME: "Nazwa",
            CHARGE_BOX_GROUP_DETAILS__TITLE: "Szczegóły grupy ładowarek",
            CHARGE_BOX_GROUP_VIEW__NAME: "Nazwa",
            CHARGE_BOX_GROUP_VIEW__DESCRIPTION: "Opis",
            CHARGE_BOX_GROUP_VIEW__CHARGE_BOXES: "Ładowarki",
            BUTTON_SEARCH: 'Szukaj',
            // map
            SIDEBAR_TITLE__CHARGE_BOX_MAP: "Mapa",
            CHARGE_BOX_MAP__TITLE: "Mapa",
            // developer
            SIDEBAR_TITLE__DEVELOPER: "Developer",
            // REPORTS
            SIDEBAR_TITLE__REPORTS: "Raporty",
            REPORTS_LIST__TITLE: "Raporty",
            REPORTS_CHARGEBOXES_LIST__TITLE: "Punkty ładowań",
            REPORTS_CHARGEBOXES__CHARGEBOX_IDENTIFIER: "Identifyikator ładowarki",
            REPORTS_CHARGEBOXES__CHARGEBOX_NAME: "Nazwa ładowarki",
            REPORTS_CHARGEBOXES__CHARGING_TIME: "Łączny czas ładowania",
            REPORTS_CHARGEBOXES__CHARGING_QUANTITY: "Ilość ładowań",
            REPORTS_CHARGEBOXES__AVERAGE_CHARGING_ENERGY: "Średnia energia na ładowanie [kWh]",
            REPORTS_CHARGEBOXES__COSUMED_ENERGY: "Pobrana energia [kWh]",
            REPORTS_CHARGEBOXES__VEHICLE_IDENTITY: "Identyfikator pojazdu",
            REPORTS_CHARGEBOXES__VEHICLE_NAME: "Nazwa pojazdu",
            REPORTS_VEHCILES_VEHICLES_LIST__TITLE: "Pojazdy",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX: "Punkty ładowania - dane",
            SIDEBAR_TITLE__REPORTS_VEHICLE_USAGE: "Zużycie​ ​ energii​ ​ na​ ​ pojazd",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX_USAGE: "Zużycie​ ​ energii​ ​ na​ ​ punkt ładowania",
            SIDEBAR_TITLE__REPORTS_CHARGEBOX_HOURS: "Punkty ładowania - godziny​ ​ pracy",
            REPORTS__IDENTITY: "Identyfikator",
            REPORTS__NAME: "Nazwa",
            REPORTS__DESCRIPTION: "Opis",
            REPORTS__DEFINITION: "Definicja",
            REPORT_DEFINITION_SEARCH_FORM__IDENTITY: "Identyfikator",
            REPORT_DEFINITION_SEARCH_FORM__NAME: "Nazwa",
            REPORT__TYPE: "Typ",
            REPORT__ITEMS: "Elementy",
            REPORT__INTERVAL: "Okres",
            REPORT__DETAILS: "Szczegółowy",
            REPORT__START_DATE: "Data początkowa",
            REPORT__END_DATE: "Data końcowa",
            XLSX_REPORT_CHARGE_BOX: "ładowarki.xlsx",
            XLSX_REPORT_CHARGE_BOX_GROUP: "grupa_ładowarek.xlsx",
            XLSX_CONSUMED_ENERGY_REPORT_VEHICLE: "pojazdy_pobrana_energia.xlsx",
            XLSX_HISTORY_TRANSACTIONS: "historia_transakcji.xlsx",
            XLSX_REPORT_VEHICLE: "pojazdy.xlsx",
            XLSX_HISTORY_ALERT: "historia_alertów.xlsx",
            XLSX_REPORT_CHARGE_BOX_CONSUMED_ENERGY: "ładowarki_pobrana_energia.xlsx",
            XLSX_REPORT_CHARGE_BOX_GROUP_CONSUMED_ENERGY: "grupa_ładowarek_pobrana_energia.xlsx",
            XLSX_REPORT_VEHICLE_CONSUMED_ENERGY: "pojazdy_pobrana_energia.xlsx",
            XLSX_REPORT_AUTHORIZATION_ID_TAG: "znaczniki_autoryzacyjne.xlsx",
            XLSX_REPORT_ALERT_DEFINITION: "definicje_alertów.xlsx",
            XLSX_REPORT_TEMPLATE: "szablon_raportu.xlsx",


            // ALERTS
            ALERT_DEFINITION__HIDDEN: 'Usunięty',
            ALERT_DEFINITION__TRIGGER_METHOD: "Akcja",
            ALERT_DEFINITION__EXPRESSION: "Wyrażenie",
            ALERT_DEFINITION__NOTIFICATION_TYPE: "Typ powiadomienia",
            ALERT_DEFINITION__NOTIFICATION_SUBJECT_TEMPLATE: "Szablon tytułu powiadomienia",
            ALERT_DEFINITION__NOTIFICATION_CONTENT_TEMPLATE: "Szablon treści powiadomienia",
            ALERT_DEFINITION__NOTIFICATION_RECEIVERS: "Odbiorcy",
            ALERT_DEFINITION_SEARCH_FORM__TRIGGER_METHOD: "Akcja",
            ALERT_DEFINITION_SEARCH_FORM__NOTIFICATION_METHOD: "Typ powiadomienia",
            ALERT_DEFINITION_SEARCH_FORM__RECEIVER: "Odbiorca",
            ALERT_SEARCH_FORM__FROM_DATETIME: "Od",
            ALERT_SEARCH_FORM__TO_DATETIME: "Do",
            ALERT_SEARCH_FORM__TRIGGER_METHOD: "Akcja",
            ALERTS_LIST__TITLE: "Alerty",
            // VEHICLE
            ADMINISTRATION_VEHICLE_LIST__TITLE: "Lista pojazdów",
            VEHICLE_TABLE__IDENTITY: "Identyfikator",
            VEHICLE_TABLE__SIDE_NUMBER: "Number boczny",
          	VEHICLE_TABLE__NAME: "Nazwa",
            VEHICLE_TABLE__BATTERY_CAPACITY: "Pojemność baterii [kWh]",
            VEHICLE_SEARCH_FORM__INPUT_IDENTITY: "Identyfikator",
            VEHICLE_SEARCH_FORM__INPUT_NAME: "Nazwa",
            VEHICLE__IDENTITY: "Identyfikator",
            VEHICLE__NAME: "Nazwa",
            VEHICLE__BATTERY_CAPACITY: "Pojemność baterii [kWh]",
            VEHICLE_EDIT__TITLE: "Edycja pojazdu",
            VEHICLE_REGISTER__TITLE: "Rejestracja pojazdu",
            VEHICLE_LIST__TITLE: "Pojazdy",
            VEHICLE_VIEW__IDENTITY: "Identyfikator",
            VEHICLE_VIEW__NAME: "Nazwa",
            VEHICLE_VIEW__BATTERY_CAPACITY: "Pojemność baterii [kWh]",
            VEHICLE_VIEW__TITLE: "Szczegóły pojazdu",
            CHARGEOBOX_DETAILS__MAX_POWER_CANOT_BE_HIGHER_THAN_FABRIC_POWER: "Moc ustawiona nie może być wyższa niż moc fabryczna.",
            // USERACTIVITY

            USERACTIVITY_SEARCH_FORM__USERNAME: "Użytkownik",
            USERACTIVITY_SEARCH_FORM__CHANGED_OBJECT: "Rodzaj obiektu",
            USERACTIVITY_SEARCH_FORM__CHANGED_OBJECT_NAME: "Nazwa obiektu",
            ADMINISTRATION_USERACTIVITY_LIST__TITLE: "Lista zmian",
            USERACTIVITY__CHANGED_TIMESTAMP: "Data zmiany",
            USERACTIVITY__CHANGED_OBJECT: "Rodzaj obiektu",
            USERACTIVITY__CHANGED_OBJECT_NAME: "Nazwa obiektu",
            USERACTIVITY__CHANGED_PARAMETER: "Parametr",
            USERACTIVITY__CHANGED_SUB_PARAMETER: "Podobiekt",
            USERACTIVITY__OLD_VALUE: "Stara wartosc",
            USERACTIVITY__NEW_VALUE: "Nowa wartosc",
            USERACTIVITY__USERNAME: "Uzytkownik",
            USERACTIVITY__TYPE: "Typ",
        });
        $translateProvider.translations('de', {
            TITLE: 'Hallo',
            FOO: 'Dies ist ein Paragraph.',
            BUTTON_LANG_EN: 'englisch',
            BUTTON_LANG_DE: 'deutsch'
        });
        $translateProvider.preferredLanguage('pl');
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.utils', [
   'ui.router'
  ])

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.administration', ['BlurAdmin.coreview', 'BlurAdmin.resourceserver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('Administration', {
          url: '/administration',
          templateUrl: 'app/_core_template/content_wrapper.htm',
          title: 'SIDEBAR_TITLE__ADMINISTRATION',
          permission: 'ChargeBox::registerItem',
          sidebarMeta: {
            order: 900,
          },
        })
        /** Chargeboxes */
        .state('Administration.ChargeBox', {
            url: '/chargebox',
            templateUrl: 'app/administration/chargebox/view/chargebox_list.html',
            controller: 'ChargeBoxAdministrationCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOXES',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 100,
            },
        }).state('Administration.ChargeBoxEdit', {
            url: '/chargebox/edit/:databaseId',
            templateUrl: 'app/administration/chargebox/view/chargebox_edit.html',
            controller: 'ChargeBoxAdministrationItemCtrl',
            title: 'CHARGE_BOX_EDIT__TITLE',
            breadcrumbs: 'Dashboard;Administration.ChargeBox;',
        }).state('Administration.ChargeBoxRegister', {
            url: '/chargebox/register',
            templateUrl: 'app/administration/chargebox/view/chargebox_register.html',
            controller: 'ChargeBoxAdministrationItemCtrl',
            title: 'CHARGE_BOX_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.ChargeBox;',
        })
        /** Vehicle */
        .state('Administration.Vehicle', {
            url: '/vehicle',
            templateUrl: 'app/administration/vehicle/view/vehicle_list.html',
            controller: 'VehicleAdministrationCtrl',
            title: 'SIDEBAR_TITLE__VEHICLE',
            permission: 'Vehicle::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 200,
            },
        }).state('Administration.VehicleEdit', {
            url: '/vehicle/edit/:databaseId',
            templateUrl: 'app/administration/vehicle/view/vehicle_edit.html',
            controller: 'VehicleAdministrationItemCtrl',
            title: 'VEHICLE_EDIT__TITLE',
            breadcrumbs: 'Dashboard;Administration.Vehicle;',
        }).state('Administration.VehicleRegister', {
            url: '/vehicle/register',
            templateUrl: 'app/administration/vehicle/view/vehicle_register.html',
            controller: 'VehicleAdministrationItemCtrl',
            title: 'VEHICLE_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.Vehicle;',
        })
        /** UserActivity */
        .state('Administration.UserActivity', {
            url: '/useractivity',
            templateUrl: 'app/administration/useractivity/view/useractivity_list.html',
            controller: 'UserActivityAdministrationCtrl',
            title: 'SIDEBAR_TITLE__USERACTIVITY',
            permission: 'Privileges::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 900,
            },
        })
        .state('Administration.UserActivityDetails', {
            url: '/useractivity/:databaseId',
            templateUrl: 'app/administration/useractivity/view/useractivity_details.html',
            permission: 'Privileges::readList',
            controller: 'UserActivityAdministrationItemCtrl',
            title: 'SIDEBAR_TITLE__USERACTIVITY',
            breadcrumbs: 'Dashboard;Administration.UserActivity;',
        })
        /** Chargebox groups */
        .state('Administration.ChargeBoxGroup', {
            url: '/chargeboxgroup',
            templateUrl: 'app/administration/chargeboxgroup/view/chargeboxgroup_list.html',
            controller: 'ChargeBoxGroupAdministrationCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_GROUPS',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 300,
            },
          }).state('Administration.ChargeBoxGroupEdit', {
              url: '/chargeboxgroup/edit/:databaseId',
              templateUrl: 'app/administration/chargeboxgroup/view/chargeboxgroup_edit.html',
              controller: 'ChargeBoxGroupAdministrationItemCtrl',
              title: 'CHARGE_BOX_GROUP_EDIT__TITLE',
              breadcrumbs: 'Dashboard;Administration.ChargeBoxGroup;',
          }).state('Administration.ChargeBoxGroupRegister', {
              url: '/chargeboxgroup/register',
              templateUrl: 'app/administration/chargeboxgroup/view/chargeboxgroup_register.html',
              controller: 'ChargeBoxGroupAdministrationItemCtrl',
              title: 'CHARGE_BOX_GROUP_REGISTER__TITLE',
              breadcrumbs: 'Dashboard;Administration.ChargeBoxGroup;',
          })
        /** Authorization tags */
        .state('Administration.AuthorizationTags', {
            url: '/authorizationtags',
            templateUrl: 'app/administration/authorizationtags/template/authorizationtags.html',
            title: 'SIDEBAR_TITLE__AUTHORIZATION_TAGS',
            controller: 'AuthorizationTagsCtrl',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 400,
            },
        }).state('Administration.AuthorizationTagRegister', {
            url: '/authorizationtags/register',
            templateUrl: 'app/administration/authorizationtags/template/authorizationtag_register.html',
            controller: 'AuthorizationTagItemCtrl',
            title: 'AUTHORIZATION_TAG_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.AuthorizationTags;',
        }).state('Administration.AuthorizationTagEdit', {
            url: '/authorizationtags/edit/:databaseId',
            templateUrl: 'app/administration/authorizationtags/template/authorizationtag_edit.html',
            controller: 'AuthorizationTagItemCtrl',
            title: 'AUTHORIZATION_TAG_EDIT__TITLE',
            breadcrumbs: 'Dashboard;Administration.AuthorizationTags;',
        })
        /** Alerts */
        .state('Administration.Alert', {
            url: '/alert',
            templateUrl: 'app/administration/alert/view/alert_list.html',
            controller: 'AlertAdministrationCtrl',
            title: 'SIDEBAR_TITLE__ALERTS_DEFINITIONS',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 500,
            },
        }).state('Administration.AlertEdit', {
            url: '/alert/edit/:databaseId',
            templateUrl: 'app/administration/alert/view/alert_edit.html',
            controller: 'AlertAdministrationItemCtrl',
            title: 'ALERT_EDIT__TITLE',
            breadcrumbs: 'Dashboard;Administration.Alert;',
        }).state('Administration.AlertRegister', {
            url: '/alert/register',
            templateUrl: 'app/administration/alert/view/alert_register.html',
            controller: 'AlertAdministrationItemCtrl',
            title: 'ALERT_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.Alert;',
        })
        /** Accounts */
        .state('Administration.Account', {
            url: '/account',
            templateUrl: 'app/administration/account/view/user_list.html',
            controller: 'UserAdministrationCtrl',
            title: 'SIDEBAR_TITLE__ACCOUNTS',
            permission: 'Privileges::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 700,
            },
        }).state('Administration.AccountUserEdit', {
            url: '/account/edit/:databaseId',
            templateUrl: 'app/administration/account/view/user_edit.html',
            controller: 'UserItemAdministrationCtrl',
            title: 'USER_EDIT__TITLE',
            permission: 'Privileges::readList',
            breadcrumbs: 'Dashboard;Administration.Account;',
        }).state('Administration.AccountUserRegister', {
            url: '/account/register',
            templateUrl: 'app/administration/account/view/user_register.html',
            controller: 'UserItemAdministrationCtrl',
            permission: 'Privileges::readList',
            title: 'USER_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.Account;',
        })
        /** Roles */
        .state('Administration.Role', {
            url: '/role',
            templateUrl: 'app/administration/role/view/role_list.html',
            controller: 'RoleAdministrationCtrl',
            title: 'SIDEBAR_TITLE__ROLES',
            permission: 'Privileges::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 800,
            },
        }).state('Administration.RoleEdit', {
            url: '/role/edit/:databaseId',
            templateUrl: 'app/administration/role/view/role_edit.html',
            controller: 'RoleItemAdministrationCtrl',
            title: 'ROLE_EDIT__TITLE',
            permission: 'Privileges::readList',
            breadcrumbs: 'Dashboard;Administration.Role;',
        }).state('Administration.RoleRegister', {
            url: '/role/register',
            templateUrl: 'app/administration/role/view/role_register.html',
            controller: 'RoleItemAdministrationCtrl',
            permission: 'Privileges::readList',
            title: 'ROLE_REGISTER__TITLE',
            breadcrumbs: 'Dashboard;Administration.Role;',
        });
  };

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.alerts', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
        .state('Alerts', {
          abstract: true,
          url: '/alerts',
          templateUrl: 'app/_core_template/content_wrapper.htm',
          title: 'SIDEBAR_TITLE__ALERTS',
          permission: 'Alert::readList',
          sidebarMeta: {
            order: 200,
          },
        }).state('Alerts.All', {
            url: '/list',
            templateUrl: 'app/alerts/template/alert_list.html',
            title: 'SIDEBAR_TITLE__ALERTS',
            breadcrumbs: 'Dashboard;',
            controller: 'AlertCtrl',
            permission: 'Alert::readList',
            sidebarMeta: {
              order: 200,
            },
        }).state('Alerts.Details', {
            url: '/details/:databaseId',
            templateUrl: 'app/alerts/template/alert_details.html',
            controller: 'AlertItemCtrl',
            permission: 'Alert::readDetails',
            title: 'ALERT_DETAILS__TITLE',
            breadcrumbs: 'Dashboard;Alerts.All'
        });
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.authorization', [
   'ui.router',
   'BlurAdmin.utils',
   'BlurAdmin.config',
   'BlurAdmin.resourceserver',
   'BlurAdmin.metadata'
  ])
  .run(runAtStart)
  .config(routeConfig);

  function runAtStart($rootScope, $state, $location, AuthorizationFactory) {
      $rootScope.$on('$stateChangeStart', function(event, next, current) {
          if (next.name != 'login' && next.name != 'forgotPassword' && next.name != 'resetPassword') {
              if (AuthorizationFactory.accessTokenContext.accessToken == undefined) {
                  event.preventDefault();
                  $state.go('login');
              }
          }
      });
  }

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
	    url: '/',
	    templateUrl: 'app/authorization/view/login.html',
	    controller: 'AuthorizationController'
	  }).state('resetPassword', {
        url: '/resetPassword?id&token',
        templateUrl: 'app/authorization/view/resetPassword.html',
        controller: 'ResetPasswordController'
    })
    .state('forgotPassword', {
        url: '/forgotPassword',
        templateUrl: 'app/authorization/view/forgotPassword.html',
        controller: 'ForgotPasswordController'
    })
    .state('missingPermissions', {
        url: '/missingPermissions',
        templateUrl: 'app/authorization/view/missingPermissions.html',
        controller: 'ForgotPasswordController'
    });
    $urlRouterProvider.otherwise('/');
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.chargebox', ['BlurAdmin.coreview', 'BlurAdmin.resourceserver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ChargeBox', {
          url: '/chargebox',
          templateUrl: 'app/_core_template/content_wrapper.htm',
          title: 'SIDEBAR_TITLE__CHARGEBOXES',
          permission: 'ChargeBox::readList',
          sidebarMeta: {
            order: 100,
          },
        })
        /** ChargeBox details */
        .state('ChargeBox.Details', {
            url: '/:state/:databaseId/',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_details.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxesItemCtrl',
            title: 'CHARGE_BOX_DETAILS__TITLE',
            breadcrumbs: 'Dashboard;ChargeBox.All',
        })
        /** ChargeBox historic transactions */
        .state('ChargeBox.Transactions', {
            url: '/:state/:databaseId/transactions',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_transactions.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxTransactionsCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_TRANSACTIONS',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        /** ChargeBox historic alerts */
        .state('ChargeBox.Alerts', {
            url: '/:state/:databaseId/alerts',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_alerts.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxAlertsCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_ALERTS',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        /** ChargeBox activity hours */
        .state('ChargeBox.ActivityHours', {
            url: '/:state/:databaseId/activity_hours',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_activity_hours.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxesActivityHoursCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_STATE_ACTIVITIES',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        .state('ChargeBox.ChargingSchedule', {
            url: '/:state/:databaseId/charging_schedule',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_charging_schedule.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxesChargingScheduleCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_GET_CHARGING_SCHEDULE',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        .state('ChargeBox.ChargingProfiles', {
            url: '/:state/:databaseId/charging_profiles',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_charging_profiles.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxesChargingProfilesCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_SENDED_CHARGING_PROFILES',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        .state('ChargeBox.SetChargingProfile', {
            url: '/:state/:databaseId/charging_profiles/set',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_set_charging_profiles.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxesSetChargingProfilesCtrl',
            title: 'SIDEBAR_TITLE__CHARGEBOX_SEND_CHARGING_PROFILE',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        /** ChargeBox configuration */
        .state('ChargeBox.Configuration', {
            url: '/:state/:databaseId/configuration',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_configuration.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxConfigurationCtrl',
            title: 'CHARGE_BOX_CONFIGURATION__TITLE',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        /** ChargeBox diagnosics */
        .state('ChargeBox.Diagnostics', {
            url: '/:state/:databaseId/diagnostics',
            templateUrl: 'app/chargebox/chargeboxes/view/chargebox_diagnostics.html',
            permission: 'ChargeBox::readDetails',
            controller: 'ChargeBoxDiagnosticsCtrl',
            title: 'CHARGE_BOX_DIAGNOSTICS__TITLE',
            breadcrumbs: 'Dashboard;ChargeBox.All;ChargeBox.Details;',
        })
        // =====================================================================
        // ChargeBoxes all
        // =====================================================================
        .state('ChargeBox.All', {
            url: '/all',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_ALL',
            controller: 'ChargeBoxesCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 100,
            },
        })
        // =====================================================================
        // ChargeBoxes error
        // =====================================================================
        .state('ChargeBox.Error', {
            url: '/error',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_ERROR',
            controller: 'ChargeBoxesErrorCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 200,
            },
        })
        // =====================================================================
        // ChargeBoxes Warning
        // =====================================================================
        .state('ChargeBox.Warning', {
            url: '/warning',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_WARNING',
            controller: 'ChargeBoxesWarningCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 300,
            },
        })
        // =====================================================================
        // ChargeBoxes charging
        // =====================================================================
        .state('ChargeBox.Charging', {
            url: '/charging',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_CHARGING',
            controller: 'ChargeBoxesChargingCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 400,
            },
        })
        // =====================================================================
        // ChargeBoxes online
        // =====================================================================
        .state('ChargeBox.Online', {
            url: '/online',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_ONLINE',
            controller: 'ChargeBoxesOnlineCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 500,
            },
        })
        // =====================================================================
        // ChargeBoxes offline
        // =====================================================================
        .state('ChargeBox.Offline', {
            url: '/offline',
            templateUrl: 'app/chargebox/chargeboxes/view/chargeboxes.html',
            title: 'SIDEBAR_TITLE__CHARGEBOXES_OFFLINE',
            controller: 'ChargeBoxesOfflineCtrl',
            permission: 'ChargeBox::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 600,
            },
        });
  };

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.chargeboxgroup', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('ChargeboxGroup', {
                abstract: true,
                url: '/chargeboxgroup',
                templateUrl: 'app/_core_template/content_wrapper.htm',
                title: 'SIDEBAR_TITLE__CHARGEBOX_GROUPS',
                permission: 'ChargeBoxGroup::readList',
                sidebarMeta: {
                  order: 700,
                },
            }).state('ChargeboxGroup.All', {
                url: '/list',
                templateUrl: 'app/chargeboxgroup/view/chargeboxgroup_list.html',
                title: 'SIDEBAR_TITLE__CHARGEBOX_GROUPS',
                breadcrumbs: 'Dashboard;',
                controller: 'ChargeBoxGroupCtrl',
                permission: 'ChargeBoxGroup::readList',
                sidebarMeta: {
                  order: 200,
                },
            }).state('ChargeboxGroup.Details', {
                url: '/details/:databaseId',
                templateUrl: 'app/chargeboxgroup/view/chargeboxgroup_details.html',
                controller: 'ChargeBoxGroupItemCtrl',
                title: 'CHARGE_BOX_GROUP_DETAILS__TITLE',
                breadcrumbs: 'Dashboard;ChargeboxGroup.All'
            });
          }

        })();

(function() {
    'use strict';

    angular.module('BlurAdmin.chargingprofiles', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('ChargingProfiles', {
              abstract: true,
              url: '/chargingprofiles',
              templateUrl: 'app/_core_template/content_wrapper.htm',
              title: 'SIDEBAR_TITLE__CHARGING_PROFILES',
              permission: 'ChargeBox::readList',
              sidebarMeta: {
                order: 1100,
              },
            }).state('ChargingProfiles.All', {
                url: '/list',
                templateUrl: 'app/chargingprofiles/template/chargingprofiles_list.html',
                title: 'SIDEBAR_TITLE__CHARGING_PROFILES',
                breadcrumbs: 'Dashboard;',
                controller: 'ChargingProfilesCtrl',
                permission: 'ChargeBox::readList',
                sidebarMeta: {
                  order: 200,
                },
            }).state('ChargingProfiles.ChargingProfilesEdit', {
                url: '/chargebox/edit/:databaseId',
                templateUrl: 'app/chargingprofiles/template/chargingprofiles_edit.html',
                controller: 'ChargingProfilesItemCtrl',
                title: 'CHARGING_PROFILE__EDIT',
                breadcrumbs: 'Dashboard;ChargingProfiles.All;'
            }).state('ChargingProfiles.ChargingProfilesRegister', {
                url: '/chargebox/register',
                templateUrl: 'app/chargingprofiles/template/chargingprofiles_register.html',
                controller: 'ChargingProfilesItemCtrl',
                title: 'CHARGING_PROFILE__REGISTER',
                breadcrumbs: 'Dashboard;ChargingProfiles.All;'
            });
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.dashboard', ['BlurAdmin.coreview', 'BlurAdmin.resourceserver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('Dashboard', {
          url: '/dashboard',
          templateUrl: 'app/dashboard/template/dashboard_template.html',
          title: 'Dashboard',
          controller: 'DashboardController',
          permission: 'ChargeBoxGroup::readList',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  };

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.developer', ['BlurAdmin.coreview', 'BlurAdmin.resourceserver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('Developer', {
          url: '/developer',
          title: 'SIDEBAR_TITLE__DEVELOPER',
          templateUrl: 'app/_core_template/content_wrapper.htm',
          permission: 'ChargeBoxActivity::readList'
        })
        /** Chargebox activity */
        .state('Developer.ChargeBoxActivity', {
            url: '/chargeboxactivity',
            templateUrl: 'app/developer/chargeboxactivity/template/chargeboxactivity.html',
            title: 'SIDEBAR_TITLE__CHARGEBOX_ACTIVITY',
            controller: 'ChargeBoxActivityCtrl',
            permission: 'ChargeBoxActivity::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 100,
            },
        }).state('Developer.ChargeBoxActivityDetails', {
            url: '/chargeboxactivity/details/:databaseId',
            templateUrl: 'app/developer/chargeboxactivity/template/chargeboxactivity_view.html',
            permission: 'ChargeBoxActivity::readDetails',
            controller: 'ChargeBoxActivityItemCtrl',
            title: 'CHARGE_BOX_ACTIVITY_DETAILS__TITLE',
            breadcrumbs: 'Dashboard;Developer.ChargeBoxActivity;',
        })
        /** Vehicle distance */
        .state('Developer.VehicleDistance', {
            url: '/vehicledistance',
            templateUrl: 'app/developer/vehicledistance/template/vehicledistance.html',
            title: 'SIDEBAR_TITLE__VEHICLE_DISTANCE',
            controller: 'VehicleDistanceCtrl',
            permission: 'ChargeBoxActivity::readList',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 100,
            },
        }).state('Developer.VehicleDistanceDetails', {
            url: '/vehicledistance/details/:databaseId',
            templateUrl: 'app/developer/vehicledistance/template/vehicledistance_view.html',
            permission: 'ChargeBoxActivity::readDetails',
            controller: 'VehicleDistanceItemCtrl',
            title: 'VEHICLE_DISTANCE_DETAILS__TITLE',
            breadcrumbs: 'Dashboard;Developer.VehicleDistance;',
        })
        /** Import data */
        .state('Developer.ImportData', {
            url: '/importdata',
            templateUrl: 'app/developer/importdata/template/registration.html',
            title: 'SIDEBAR_TITLE__IMPORT_DATA',
            controller: 'ImportdataCtrl',
            breadcrumbs: 'Dashboard;',
            sidebarMeta: {
              order: 200,
            },
        });
  };

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.map', ['BlurAdmin.coreview', 'BlurAdmin.resourceserver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('Map', {
          abstract: true,
          url: '/map',
          templateUrl: 'app/_core_template/content_wrapper.htm',
          title: 'SIDEBAR_TITLE__MAP',
          permission: 'ChargeBox::readList',
          sidebarMeta: {
            order: 500,
          },
        }).state('Map.ChargeBox', {
            url: '/chargebox',
            templateUrl: 'app/map/chargeboxes/template/chargeboxes.html',
            title: 'MAP_CHARGE_BOX__TITLE',
            breadcrumbs: 'Dashboard;',
            controller: 'ChargeBoxesMapCtrl',
            permission: 'ChargeBox::readList',
            sidebarMeta: {
              order: 200,
            },
        });
  };

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.reports', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
              .state('Report', {
                url: '/report',
                templateUrl: 'app/_core_template/content_wrapper.htm',
                title: 'SIDEBAR_TITLE__REPORTS',
                permission: 'ReportChargeBox::readList',
                sidebarMeta: {
                  order: 800,
                },
              }).state('Report.ChargeBoxConsumedEnergy', {
                url: '/chargebox/consumed-energy',
                templateUrl: 'app/reports/view/chargebox_consumed_energy.html',
                title: 'SIDEBAR_TITLE__CHARGE_BOX_ENERGY',
                controller: 'ChargeBoxConsumedEnergyReportCtrl',
                permission: 'ReportChargeBox::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 100,
                },
            }).state('Report.ChargeBoxGroupConsumedEnergy', {
                url: '/chargeboxgroup/consumed-energy',
                templateUrl: 'app/reports/view/chargeboxgroup_consumed_energy.html',
                title: 'SIDEBAR_TITLE__CHARGE_BOX_GROUP_ENERGY',
                controller: 'ChargeBoxGroupConsumedEnergyReportCtrl',
                permission: 'ReportChargeBox::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 200,
                },
            }).state('Report.VehicleConsumedEnergy', {
                url: '/vehicle/consumed-energy',
                templateUrl: 'app/reports/view/vehicle_consumed_energy.html',
                title: 'SIDEBAR_TITLE__VEHICLE_ENERGY',
                controller: 'VehicleConsumedEnergyReportCtrl',
                permission: 'ReportChargeBox::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 300,
                },
            }).state('Report.TransactionsReport', {
                url: '/transaction/export',
                templateUrl: 'app/reports/view/transactions_report.html',
                title: 'SIDEBAR_TITLE__TRANSACTIONS_EXPORT',
                controller: 'TransactionsReportCtrl',
                permission: 'ReportChargeBox::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 400,
                },
            }).state('Report.ReportTemplates', {
                url: '/report/templates',
                templateUrl: 'app/reports/view/report_templates.html',
                title: 'SIDEBAR_TITLE__REPORT_TEMPLATES_DEMO',
                controller: 'ReportTemplatesCtrl',
                permission: 'ReportChargeBox::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 500,
                },
            }).state('Report.ReportTemplatesEdit', {
                url: '/report/templates/edit/:databaseId',
                templateUrl: 'app/reports/view/report_templates_edit.html',
                controller: 'ReportTemplatesItemCtrl',
                title: 'REPORT_TEMPLATES_EDIT__TITLE',
                breadcrumbs: 'Dashboard;Report.ReportTemplates;',
            }).state('Report.ReportTemplatesRegister', {
                url: '/report/templates/register',
                templateUrl: 'app/reports/view/report_templates_register.html',
                controller: 'ReportTemplatesItemCtrl',
                title: 'REPORT_TEMPLATES_NEW__TITLE',
                breadcrumbs: 'Dashboard;Report.ReportTemplates;',
            }).state('Report.ReportTemplatesDetails', {
                url: '/report/templates/details/:databaseId',
                templateUrl: 'app/reports/view/report_templates_details.html',
                controller: 'ReportTemplatesDetailsCtrl',
                title: 'REPORT_TEMPLATES_DETAILS__TITLE',
                breadcrumbs: 'Dashboard;Report.ReportTemplates;',
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.transactions', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
              .state('Transaction', {
                abstract: true,
                url: '/transaction',
                templateUrl: 'app/_core_template/content_wrapper.htm',
                title: 'SIDEBAR_TITLE__CHARGING_TRANSACTIONS',
                permission: 'ChargingTransaction::readList',
                sidebarMeta: {
                  order: 200,
                },
              })
            .state('Transaction.List', {
                url: '/list',
                templateUrl: 'app/transactions/view/transactions.html',
                title: 'SIDEBAR_TITLE__CHARGING_TRANSACTIONS',
                controller: 'TransactionsCtrl',
                permission: 'ChargingTransaction::readList',
                breadcrumbs: 'Dashboard;',
                sidebarMeta: {
                  order: 200,
                },
            }).state('Transaction.Details', {
                url: '/details/:databaseId',
                templateUrl: 'app/transactions/view/details.html',
                permission: 'ChargingTransaction::readDetails',
                controller: 'TransactionItemCtrl',
                title: 'CHARGING_TRANSACTION_DETAILS__TITLE',
                breadcrumbs: 'Dashboard;Transaction.List;',
            });
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.userprofile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('UserProfile', {
          abstract: true,
          url: '/user',
          templateUrl: 'app/_core_template/content_wrapper.htm',
        })
        .state('UserProfile.Details', {
          url: '/profile',
          templateUrl: 'app/userprofile/template/profile.html',
          controller: 'UserProfileController',
          title: 'SIDEBAR_TITLE__USER_PROFILE',
        });
  }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.vehicle', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('Vehicle', {
              abstract: true,
              url: '/vehicle',
              templateUrl: 'app/_core_template/content_wrapper.htm',
              title: 'SIDEBAR_TITLE__VEHICLE',
              permission: 'Vehicle::readList',
              sidebarMeta: {
                order: 200,
              },
            }).state('Vehicle.All', {
                url: '/list',
                templateUrl: 'app/vehicle/template/vehicle_list.html',
                title: 'SIDEBAR_TITLE__VEHICLE',
                breadcrumbs: 'Dashboard;',
                controller: 'VehicleCtrl',
                permission: 'Vehicle::readList',
                sidebarMeta: {
                  order: 200,
                },
            }).state('Vehicle.Details', {
                url: '/details/:databaseId',
                templateUrl: 'app/vehicle/template/vehicle_details.html',
                controller: 'VehicleItemCtrl',
                title: 'VEHICLE_VIEW__TITLE',
                breadcrumbs: 'Dashboard;Vehicle.All'
            });
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

var app = angular.module('BlurAdmin', [
  'ngAnimate',
  'ngSanitize',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ui.select',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'pascalprecht.translate',
  'ngCookies',
  'ngFileSaver',
  'angular-loading-bar',

  'BlurAdmin.coreview',
  'BlurAdmin.resourceserver',
  'BlurAdmin.dashboard',
  'BlurAdmin.theme',
  'BlurAdmin.translations',
  'BlurAdmin.metadata',
  'BlurAdmin.authorization',
  'BlurAdmin.utils',
  'BlurAdmin.config',
  'BlurAdmin.administration',
  'BlurAdmin.developer',
  'BlurAdmin.chargebox',
  'BlurAdmin.chargeboxgroup',
  'BlurAdmin.transactions',
  'BlurAdmin.vehicle',
  'BlurAdmin.alerts',
  'BlurAdmin.reports',
  'BlurAdmin.userprofile',
  'BlurAdmin.map',
  'BlurAdmin.chargingprofiles'
])
.config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
}])
.run(runAtStart);

function runAtStart($rootScope, $window, $http, $translate, AuthorizationService, AuthorizationFactory, ConfigFactory,
       CookieUtils, InteractionsUtils, ErrorUtils) {
  // init costs
  $rootScope.labelColors = {
    'ERROR': "#a94442",
    'WARNING': "#8a6d3b",
    'CHARGING': "#00bc16",
  }
  $rootScope.httpRequests = $http.pendingRequests;
  // discover environment paths
  var environmentPathPromise = $http({
      method: 'GET',
      url: ConfigFactory.proxyServicePath + '/config'
  });
  $rootScope.isAuthorized = AuthorizationService.isAuthorized;
  $rootScope.userAuthorized = AuthorizationService.isAuthorized();
  // register global methods
  $rootScope.logout = AuthorizationService.logout;
  if(!$rootScope.userAuthorized) {
    environmentPathPromise.then(
        function(answer) {
            setAppContext($translate, $rootScope, ConfigFactory, CookieUtils, answer);
        },
        function(error) {
            ErrorUtils.handleDefaultError(error);
        }
    );
    return
  }
  environmentPathPromise.then(
      function(answer) {
          setAppContext($translate, $rootScope, ConfigFactory, CookieUtils, answer);
          // handle authorized user
          AuthorizationService.handleAuthorizedUser(false);
      },
      function(error) {
          ErrorUtils.handleDefaultError(error);
      }
  );
}

function setAppContext(translate, rootScope, ConfigFactory, CookieUtils, answer) {
  ConfigFactory.setPath('/eko-oauth', '/eko');
  ConfigFactory.setViewSettings(answer.data['settings']);
  // set language
  var language = CookieUtils.getCookieValue("ocpp_app_language");
  if(language == undefined) {
    if(answer.data['settings'] != undefined) {
      language = answer.data['settings'].language;
    }
  }
  translate.use(language);
  rootScope.appLanguage = language;
  // logo
  rootScope.appLogo = answer.data['settings'].logo;
  if(rootScope.appLogo == undefined) {
    rootScope.appLogo = "http://sm.ekoenergetyka.com.pl/themes/sm/img/logo.png";
  }
}

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.config');

    module.factory('ConfigFactory', ['$location', function( $location, CookieUtils) {

        var proxyServicePath = "/proxy";
        var environmentPaths = {};
        var viewSettings = {};
        return {
            proxyServicePath : proxyServicePath,
            environmentPaths: environmentPaths,
            viewSettings: viewSettings,
            setPath: setPath,
            setViewSettings: setViewSettings
        }

        function setPath(configAuthServicePath, configResourcesServicePath) {
          environmentPaths.authServicePath = configAuthServicePath;
          environmentPaths.resourcesServicePath = configResourcesServicePath;
        }

        function setViewSettings(viewSettingsData) {
          if(viewSettingsData != undefined) {
            for(var key in viewSettingsData) {
              viewSettings[key] = viewSettingsData[key];
            }
          }
        }

    }])
})();

(function(){
    'use strict';

    angular.module('BlurAdmin.coreview')
        .controller('DatePickerPopupCtrl', DatePickerPopupCtrl);

    /** @ngInject */
    function DatePickerPopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();

angular.module('BlurAdmin.coreview')
    .directive('tableInfiniteScroll', ['$timeout', 'cfpLoadingBar', function (timeout, cfpLoadingBar) {
        return{
            require: 'stTable',
            link: function (scope, element, attr, ctrl) {
                var container = angular.element(element.parent());
                var tableState = ctrl.tableState();
                var pagination = tableState.pagination;
                var promise = undefined;
                element.bind("DOMMouseScroll mousewheel onmousewheel", function(event){
                  tableState.userAction = true;
                  var maxScrollTop = container[0].scrollHeight - container.outerHeight();
                  var event = window.event || event;
                  var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
                  var scrollTop = container[0].scrollTop;
                  // scroll top
                  if(delta > 0) {
                    // do nothing
                  }
                  // scroll down
                  else {
                    if(scrollTop >= maxScrollTop) {
                      // avoid multiple pagination requests
                      if (promise != undefined) {
                          timeout.cancel(promise);
                      }
                      // progress bar start
                      cfpLoadingBar.start();
                      // start promise
                      promise = timeout(function () {
                        ctrl.slice(pagination.start + 1, 0);
                        promise = undefined;
                      }, 50);
                    }
                  }
                });
            }

        };
    }]);

(function(){
    'use strict';

    angular.module('BlurAdmin.coreview')
        .controller('TimePickerPopupCtrl', TimePickerPopupCtrl);

    /** @ngInject */
    function TimePickerPopupCtrl($scope) {

      $scope.hstep = 1;
      $scope.mstep = 15;

      $scope.options = {
        hstep: [1, 2, 3],
        mstep: [1, 5, 10, 15, 25, 30]
      };

      $scope.ismeridian = false;

      $scope.update = function() {
        var d = new Date();
        d.setHours( 14 );
        d.setMinutes( 0 );
        $scope.mytime = d;
      };

      $scope.clear = function() {
        $scope.mytime = null;
      };

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.coreview')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.metadata');

    module.factory('MetadataFactory', function() {
        var metadataContext = {};
        return {
            metadataContext: metadataContext,
            updateMetadataContext: function(medataDataContextData) {
                metadataContext.authorizationStatuses = medataDataContextData.authorizationStatuses;
                metadataContext.chargeBoxAvailabilityTypes = medataDataContextData.chargeBoxAvailabilityTypes;
                metadataContext.chargeBoxConfigurationKnownFields = medataDataContextData.chargeBoxConfigurationKnownFields;
                metadataContext.chargeBoxResetTypes = medataDataContextData.chargeBoxResetTypes;
                metadataContext.chargeBoxAuthorizationListUpdateType = medataDataContextData.chargeBoxAuthorizationListUpdateType;
                metadataContext.ocppProtocolVersions = medataDataContextData.ocppProtocolVersions;
                metadataContext.configuration = medataDataContextData.configuration;
                metadataContext.numberSearchOperators = medataDataContextData.numberSearchOperators;
                metadataContext.measurementTypes = medataDataContextData.measurementTypes;
                metadataContext.chargingProfilePurposeType = medataDataContextData.chargingProfilePurposeType;
                metadataContext.chargingProfileKindType = medataDataContextData.chargingProfileKindType;
                metadataContext.recurrencyKindType = medataDataContextData.recurrencyKindType;
                metadataContext.chargingRateUnitType = medataDataContextData.chargingRateUnitType;
                metadataContext.chargeBoxStates = medataDataContextData.chargeBoxStates;
                metadataContext.communicationProtocols = medataDataContextData.communicationProtocols;
            }
        }
    })
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.metadata');

    module.service('MetadataService', [
      'HttpUtils',
      'ConfigFactory',
      'MetadataFactory',
      function(HttpUtils, ConfigFactory, MetadataFactory) {

        this.getMetadata = function() {
            var promise =  HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, 'rest/client/metadata');
            return promise.then(
                function(response) {
                    MetadataFactory.updateMetadataContext(response.data);
                    return response.data;
                }
            );
        }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');
    module.service('ResourceServerDataService', [
        '$translate',
        'HttpUtils',
        'ConfigFactory',
        'ArrayUtils',
        'DateUtils',
        'PaginationUtils',
        'InteractionsUtils',
        function($translate, HttpUtils, ConfigFactory, ArrayUtils, DateUtils, PaginationUtils, InteractionsUtils) {
            // ==================================================================
            // request
            // ==================================================================
            this.sendRequestData = function(viewStorage, restPath, itemIdentity, requestData, itemPreSaveAction) {
                if (itemPreSaveAction != undefined) {
                    itemPreSaveAction(requestData);
                }
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, restPath + '/' + itemIdentity, requestData);
                return promise.then(
                    function(answer) {
                        viewStorage.response = answer.data;
                    }
                );
            }

            this.rawSendRequestData = function(restPath, requestData) {
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, restPath, requestData);
                return promise.then(
                    function(answer) {
                        return answer;
                    }
                );
            }

            this.initNewRequestDataItem = function(viewStorage, restPath, loadItemPostConstruct) {
                var promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath);
                viewStorage.itemData = undefined;
                return promise.then(
                    function(answer) {
                        var itemData = answer.data;
                        if (loadItemPostConstruct != undefined) {
                            loadItemPostConstruct(itemData);
                            viewStorage.itemData = itemData;
                        }
                        else {
                            viewStorage.itemData = itemData;
                        }
                    }
                );
            }

            this.importXLSXReport = function(pRestPath, criteria, viewFactory, sortProperty, sortDirection) {
                var searchCriteria = criteria;
                ArrayUtils.removeSearchCriteriaEmptyCriteria(searchCriteria);
                if (viewFactory.searchCriteriaPostContruct != undefined) {
                  criteria = viewFactory.searchCriteriaPostContruct(searchCriteria);
                }
                HttpUtils.prepareHttpXLSXPost(ConfigFactory.environmentPaths.resourcesServicePath, pRestPath, criteria, sortProperty, sortDirection);
            }

            // ==================================================================
            // csv
            // ==================================================================
            this.downloadFile = function(restPath, viewContext, request, content, extension) {
              var promise = undefined;
              if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                  promise = HttpUtils.prepareHttpPutFile(ConfigFactory.environmentPaths.authServicePath, restPath, undefined, request, content);
              }
              else {
                  promise = HttpUtils.prepareHttpPutFile(ConfigFactory.environmentPaths.resourcesServicePath, restPath, undefined, request, content);
              }
              return promise.then(
                  function(answer) {
                      var blob = undefined;
                      if(extension == 'csv') {
                        blob = new Blob([answer.data],{type: "text/csv;charset=utf-8;"});
                      } else if(extension == 'zip'){
                        blob = new Blob([answer.data],{type: "application/zip;"});
                      }
                      if (navigator.msSaveBlob) { // IE 10+
                          navigator.msSaveBlob(blob, $translate.instant(viewIdentity) + '_' + DateUtils.getCurrentTimestamp() +'_export.' + extension)
                      } else {
                          var link = document.createElement("a");
                          if (link.download !== undefined) { // feature detection
                              // Browsers that support HTML5 download attribute
                              var url = URL.createObjectURL(blob);
                              link.setAttribute("href", url);
                              link.setAttribute("download", $translate.instant(viewContext.identity) + '_' + DateUtils.getCurrentTimestamp() +'_export.' + extension);
                              link.style = "visibility:hidden";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                          }
                      }
                  }
              );
            }
            // ==================================================================
            // Edit, update
            // ==================================================================
            this.initNewItem = function(viewContext, viewStorage, restPath, loadItemPostConstruct) {
                // reset current item
                viewStorage.itemData = undefined;
                // init promise
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath + '/new');
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath + '/new');
                }
                // handle promise
                return promise.then(
                    function(answer) {
                        viewStorage.itemData = answer.data;
                        if (loadItemPostConstruct != undefined) {
                            loadItemPostConstruct(viewStorage.itemData);
                        }
                    }
                );
            }
            this.loadEditableItemData = function(viewContext, viewStorage, restPath, loadEditableItemPostConstruct) {
                // reset current item
                viewStorage.itemData = undefined;
                // init promise
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath);
                }
                // handle promise
                return promise.then(
                    function(answer) {
                        viewStorage.itemData = answer.data;
                        if (loadEditableItemPostConstruct != undefined) {
                            loadEditableItemPostConstruct(viewStorage.itemData);
                        }
                    }
                );
            }
            this.saveItem = function(viewContext, viewStorage, restPath, item, redirectState, itemPreSaveAction) {
                if (itemPreSaveAction != undefined) {
                    itemPreSaveAction(item);
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.authServicePath, restPath, item);
                }
                else {
                    promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, restPath, item);
                }
                return promise.then(
                    function(answer) {
                        if (redirectState != undefined) {
                            InteractionsUtils.changeView(redirectState);
                        }
                        InteractionsUtils.openInfoDialog($translate.instant('DIALOG__SUCCESS_TITLE'), $translate.instant('DIALOG__ITEM_SAVED'));
                    }
                );
            }
            this.updateItem = function(viewContext, viewStorage, restPath, item, redirectState, itemPreSaveAction) {
                if (itemPreSaveAction != undefined) {
                    itemPreSaveAction(item);
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.authServicePath, restPath, item);
                }
                else {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.resourcesServicePath, restPath, item);
                }
                return promise.then(
                    function(answer) {
                        if (redirectState != undefined) {
                            InteractionsUtils.changeView(redirectState);
                        }
                        InteractionsUtils.openInfoDialog($translate.instant('DIALOG__SUCCESS_TITLE'), $translate.instant('DIALOG__ITEM_UPDATED'));
                    }
                );
            }

            // ==================================================================
            // Raw data
            // ==================================================================

            this.rawLoadDataWithoutPagination = function(viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction) {
              var sortQuery = undefined;
              if(sortProperty == undefined || sortProperty == '') {
                sortQuery = '?sort=id,desc';
              } else {
                sortQuery = '?sort=' + sortProperty + ',' + sortDirection;
              }
              var promise = undefined;
              if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                  promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath + sortQuery);
              }
              else {
                  promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath + sortQuery);
              }
              return promise.then(
                  function(answer) {
                      var itemsData = answer.data;
                      if(viewStorage != undefined) {
                        var oldItemsData = viewStorage.itemsData;
                        if (postAction != undefined) {
                            postAction(itemsData, oldItemsData, viewStorage, answer.data);
                        }
                      }
                      return itemsData;
                  }
              );
            }

            this.rawLoadSingleItemData = function(viewContext, restPath, loadItemPostConstruct) {
                // init promise
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath);
                }
                // handle promise
                return promise.then(
                    function(answer) {
                        var itemData = answer.data;
                        if (loadItemPostConstruct != undefined) {
                            loadItemPostConstruct(itemData);
                        }
                        return itemData;
                    }
                );
            }

            this.rawSearchData = function(rawSearchCriteria, viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction, viewFactory) {
                var searchCriteria = rawSearchCriteria;
                ArrayUtils.removeSearchCriteriaEmptyCriteria(searchCriteria);
                if(viewFactory.searchCriteriaPostContruct != undefined) {
                  searchCriteria = viewFactory.searchCriteriaPostContruct(searchCriteria);
                }
                var sortQuery = undefined;
                if(sortProperty == undefined || sortProperty == '') {
                  sortQuery = '?sort=id,desc';
                } else {
                  sortQuery = '?sort=' + sortProperty + ',' + sortDirection;
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.authServicePath, restPath + "/search" + sortQuery, searchCriteria);
                }
                else {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.resourcesServicePath, restPath + '/search' + sortQuery, searchCriteria);
                }
                return promise.then(
                    function(answer) {
                      var itemsData = answer.data;
                      var oldItemsData = viewStorage.itemsData;
                      if (postAction != undefined) {
                          postAction(itemsData, oldItemsData, viewStorage, answer.data);
                      }
                      return itemsData;
                    }
                );
            }

            // ==================================================================
            // Data with pagination
            // ==================================================================
            this.loadDataWithPagination = function(viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction, initTableDataAction, viewMetadataPostAction) {
                // load view metadata
                if (viewContext.viewMetadataRestPath != undefined) {
                    var viewMetadataPromise = initViewMetadataPromise(viewContext, viewStorage, viewContext.viewMetadataRestPath);
                    return viewMetadataPromise.then(
                        function(answer) {
                            viewStorage.viewMetadata = answer;
                            if(viewMetadataPostAction != undefined) {
                              viewStorage.viewMetadata = viewMetadataPostAction(answer);
                            }
                        }
                    ).then(
                        function() {
                            return handleItemsPaginatedData(viewContext, sortProperty, sortDirection, viewStorage, restPath, postAction, initTableDataAction);
                        }
                    );
                }
                else {
                    return handleItemsPaginatedData(viewContext, sortProperty, sortDirection, viewStorage, restPath, postAction, initTableDataAction);
                }
            }
            this.searchDataWithPagination = function(rawSearchCriteria, viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction, initTableDataAction, viewMetadataPostAction, viewFactory) {
                var searchCriteria = rawSearchCriteria;
                ArrayUtils.removeSearchCriteriaEmptyCriteria(searchCriteria);
                if(viewFactory.searchCriteriaPostContruct != undefined) {
                  searchCriteria = viewFactory.searchCriteriaPostContruct(searchCriteria);
                }
                var paginationQuery = 'page=' + viewStorage.pageNumber + '&size=' + viewStorage.itemsQuantity;
                if(sortProperty == undefined || sortProperty == '') {
                  paginationQuery = paginationQuery + '&sort=id,desc';
                } else {
                  paginationQuery = paginationQuery + '&sort=' + sortProperty + ',' + sortDirection;
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.authServicePath, restPath + '/search?' + paginationQuery, searchCriteria);
                }
                else {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.resourcesServicePath, restPath + '/search?' + paginationQuery, searchCriteria);
                }
                if (viewContext.viewMetadataRestPath != undefined) {
                    var viewMetadataPromise = initViewMetadataPromise(viewContext, viewStorage, viewContext.viewMetadataRestPath);
                    return viewMetadataPromise.then(
                        function(answer) {
                            viewStorage.viewMetadata = answer;
                            if(viewMetadataPostAction != undefined) {
                              viewStorage.viewMetadata = viewMetadataPostAction(answer);
                            }
                        }
                    ).then(
                        function() {
                          return promise.then(
                              function(answer) {
                                  doHandleItemsPaginatedData(answer, viewStorage, postAction, initTableDataAction);
                              }
                          );
                        }
                    );
                } else {
                  return promise.then(
                      function(answer) {
                          doHandleItemsPaginatedData(answer, viewStorage, postAction, initTableDataAction);
                      }
                  );
                }
            }

            function handleItemsPaginatedData(viewContext, sortProperty, sortDirection, viewStorage, restPath, postAction, initTableDataAction) {
                var paginationQuery = 'page=' + viewStorage.pageNumber + '&size=' + viewStorage.itemsQuantity;
                if(sortProperty == undefined || sortProperty == '') {
                  paginationQuery = paginationQuery + '&sort=id,desc';
                } else {
                  paginationQuery = paginationQuery + '&sort=' + sortProperty + ',' + sortDirection;
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath, paginationQuery);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath, paginationQuery);
                }
                return promise.then(
                    function(answer) {
                        doHandleItemsPaginatedData(answer, viewStorage, postAction, initTableDataAction);
                    }
                );
            }

            function doHandleItemsPaginatedData(answer, viewStorage, postAction, initTableDataAction) {
                var oldItemsData = viewStorage.itemsData;
                viewStorage.itemsData = answer.data.content;
                if (postAction != undefined) {
                    postAction(viewStorage.itemsData, oldItemsData, viewStorage, answer.data);
                }
                if (initTableDataAction != undefined) {
                    viewStorage.itemsData = initTableDataAction(viewStorage.itemsData);
                }
            }

            // ==================================================================
            // Data without pagination
            // ==================================================================
            this.loadDataWithoutPagination = function(viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction, initTableDataAction, viewMetadataPostAction) {
                // load view metadata
                if (viewContext.viewMetadataRestPath != undefined) {
                    var viewMetadataPromise = initViewMetadataPromise(viewContext, viewStorage, viewContext.viewMetadataRestPath);
                    return viewMetadataPromise.then(
                        function(answer) {
                            viewStorage.viewMetadata = answer;
                            if(viewMetadataPostAction != undefined) {
                              viewStorage.viewMetadata = viewMetadataPostAction(answer);
                            }
                        }
                    ).then(
                        function() {
                            return handleItemsWithoutPaginatedData(viewContext, viewStorage, sortProperty, sortDirection, restPath, postAction, initTableDataAction);
                        }
                    );
                }
                else {
                    return handleItemsWithoutPaginatedData(viewContext, viewStorage, sortProperty, sortDirection, restPath, postAction, initTableDataAction);
                }
            }

            this.searchDataWithoutPagination = function(rawSearchCriteria, viewStorage, sortProperty, sortDirection, viewContext, restPath, postAction, initTableDataAction, viewMetadataPostAction, viewFactory) {
                var searchCriteria = rawSearchCriteria;
                ArrayUtils.removeSearchCriteriaEmptyCriteria(searchCriteria);
                if(viewFactory.searchCriteriaPostContruct != undefined) {
                  searchCriteria = viewFactory.searchCriteriaPostContruct(searchCriteria);
                }
                var sortQuery = undefined;
                if(sortProperty == undefined || sortProperty == '') {
                  sortQuery = '?sort=id,desc';
                } else {
                  sortQuery = '?sort=' + sortProperty + ',' + sortDirection;
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.authServicePath, restPath + '/search?' + sortQuery, searchCriteria);
                }
                else {
                    promise = HttpUtils.prepareHttpPut(ConfigFactory.environmentPaths.resourcesServicePath, restPath + '/search?' + sortQuery, searchCriteria);
                }
                // load view metadata
                if (viewContext.viewMetadataRestPath != undefined) {
                    var viewMetadataPromise = initViewMetadataPromise(viewContext, viewStorage, viewContext.viewMetadataRestPath);
                    return viewMetadataPromise.then(
                        function(answer) {
                            viewStorage.viewMetadata = answer;
                            if(viewMetadataPostAction != undefined) {
                              viewStorage.viewMetadata = viewMetadataPostAction(answer);
                            }
                        }
                    ).then(
                        function() {
                          return promise.then(
                              function(answer) {
                                  doHandleItemsData(answer, viewStorage, postAction, initTableDataAction);
                              }
                          );
                        }
                    );
                }
                else {
                  return promise.then(
                      function(answer) {
                          doHandleItemsData(answer, viewStorage, postAction, initTableDataAction);
                      }
                  );
                }

            }

            function handleItemsWithoutPaginatedData(viewContext, viewStorage, sortProperty, sortDirection, restPath, postAction, initTableDataAction) {
                var sortQuery = undefined;
                if(sortProperty == undefined || sortProperty == '') {
                  sortQuery = '?sort=id,desc';
                } else {
                  sortQuery = '?sort=' + sortProperty + ',' + sortDirection;
                }
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath + sortQuery);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath + sortQuery);
                }
                return promise.then(
                    function(answer) {
                      doHandleItemsData(answer, viewStorage, postAction, initTableDataAction);
                    }
                );
            }

            function doHandleItemsData(answer, viewStorage, postAction, initTableDataAction) {
              var oldItemsData = viewStorage.itemsData;
              viewStorage.itemsData = answer.data;
              if (postAction != undefined) {
                  postAction(viewStorage.itemsData, oldItemsData, viewStorage, answer.data);
              }
              if (initTableDataAction != undefined) {
                  viewStorage.itemsData = initTableDataAction(viewStorage.itemsData);
              }
            }
            // ==================================================================
            // Single item data
            // ==================================================================
            this.loadSingleItemData = function(viewStorage, viewContext, restPath, loadItemPostConstruct) {
                // init promise
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath);
                }
                // handle promise
                return promise.then(
                    function(answer) {
                        var itemData = answer.data;
                        if (loadItemPostConstruct != undefined) {
                            loadItemPostConstruct(itemData);
                        }
                        viewStorage.itemData = itemData;
                    }
                );
            }

            this.loadViewMetadataPromise = function(viewContext, viewStorage, restPath) {
              return initViewMetadataPromise(viewContext, viewStorage, restPath);
            }
            // ==================================================================
            // View metadata
            // ==================================================================
            function initViewMetadataPromise(viewContext, viewStorage, restPath) {
                var promise = undefined;
                if (viewContext.dataSource != undefined && viewContext.dataSource == 'Auth') {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, restPath);
                }
                else {
                    promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, restPath);
                }
                return promise.then(
                    function(answer) {
                        return answer.data;
                    }
                );
            }
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('ArrayUtils', [function() {

        this.indexOf = function(array, value) {
          if(array == undefined || value == undefined) {
            return -1;
          }
          for(var index = 0; index < array.length; index++) {
            var arrayItem = array[index];
            if(arrayItem == value) {
              return index;
            }
          }
          return -1;
        }

        this.checkIfDictionaryIsEmpty = function(dictionary) {
          if(dictionary == undefined) {
            return true;
          }
          for(var key in dictionary) {
            return false;
          }
          return true;
        }

        this.removeSearchCriteriaEmptyCriteria = function(searchCriteria) {
          // collect entries
          var searchEntriesToRemove = [];
          for(var key in searchCriteria) {
            var searchEntry = searchCriteria[key];
            if(searchEntry != undefined) {
              if(searchEntry.length == 0) {
                searchEntriesToRemove.push(key);
              } else {
                // collect indexes
                var indexToRemove = [];
                for(var index = 0; index < searchEntry.length; index++) {
                  var searchValue = searchEntry[index];
                  if(searchValue == undefined || searchValue.length == 0) {
                    indexToRemove.push(index);
                  }
                }
                // remove
                for(var index = 0; index < indexToRemove.length; index++) {
                  searchEntry.splice(index, 1);
                }
              }
            }
          }
          // remove
          for(var index = 0; index < searchEntriesToRemove.length; index++) {
            delete searchCriteria[searchEntriesToRemove[index]];
          }
        }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('ChargeBoxUtils', ['$translate', '$sce', 'layoutPaths', 'DateUtils', 'StringUtils', function($translate, $sce, layoutPaths, DateUtils, StringUtils) {

      var stateIcons = initStateIcons();

      this.getStateIcons = function() {
        return stateIcons;
      }

      this.initChargeBoxIcon = function(state) {
          if (state == 'ERROR') {
              return stateIcons['ERROR'];
          } else if (state == 'CHARGING') {
              return stateIcons['CHARGING'];
          } else if (state == 'WARNING') {
              return stateIcons['WARNING'];
          } else if (state == 'ONLINE') {
              return stateIcons['ONLINE'];
          }
          // default offline
          return stateIcons['OFFLINE'];
      }

      this.initChargeBoxRepeatedIcon = function(state) {
        if(state == 'ERROR') {
            return stateIcons['ERROR_REPEATED'];
        } else if(state == 'WARNING') {
          return stateIcons['WARNING_REPEATED'];
        } else if (state == 'CHARGING') {
            return stateIcons['CHARGING'];
        } else if (state == 'ONLINE') {
            return stateIcons['ONLINE'];
        }
        // default offline
        return stateIcons['OFFLINE'];
      }


      this.initChargeBoxTooltipData = function(chargeBox) {
          if(chargeBox.actualState.chargeBoxStatus == 'CHARGING') {
              return $sce.trustAsHtml(doInitChargingChargeBoxTooltipData(chargeBox, false));
          }
          return $sce.trustAsHtml(doInitChargeBoxTooltipData(chargeBox, false));
      }

      this.initChargeBoxTooltipHtmlData = function(chargeBox) {
        if(chargeBox.actualState.chargeBoxStatus == 'CHARGING') {
          return doInitChargingChargeBoxTooltipData(chargeBox, true);
        }
        return doInitChargeBoxTooltipData(chargeBox, true);
      }

      function doInitChargingChargeBoxTooltipData(chargeBox, showDetailsUrl) {
        var content = "<table>" +
              // name
        '<tr><td colspan="2">' + chargeBox.actualConfiguration.name +'</td><td></td></tr>' +
              // power
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_POWER') +':</td><td align="left">' +  chargeBox.actualState.lastPowerActiveImportOutlet + 'kW / ' + chargeBox.actualConfiguration.maxPowerSet + 'kW [' + chargeBox.totalUsedPowerPercent + '%]</td></tr>' +
              // factory power
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_FACTORY_POWER') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualConfiguration.maxFactoryPower) + ' [kW]</td></tr>' +
              // last activity time -->
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_ACTIVITY') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastActivityTime) + '</td></tr>' +
              // last charging time
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_CHARGING') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastChargingTime) + '</td></tr>' +
              // last error
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_ERROR') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastErrorTime) + '</td></tr>' +
              // last warning
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_WARNING') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastWarningTime) + '</td></tr>' +
              // IP
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_IP') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualConfiguration.ipAddress) + '</td></tr>' +
              // vehicle
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_VEHICLE') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualState.lastChargingVehicleName) + '</td></tr>' +
              // SOC
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_SOCb') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualState.lastChargingVehicleSoc) + '</td></tr>' +
              // to end
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_TIME_TO_CHARGING_END') +':</td><td align="left">' +  DateUtils.millisecondsToStrTimeInterval(chargeBox.actualState.remainingTimeToFullSoC) + '</td></tr>';
              // nav to detaills
              if(showDetailsUrl) {
                content = content + '<tr><td align="left" colspan="2"><a href="' + chargeBox.detailsUrl + '">' + $translate.instant('COMMONS_SHOW_DETAILS') +'</a></td></tr>';
              }
              content = content + '</table>';
          return content;
      }

      function doInitChargeBoxTooltipData(chargeBox, showDetailsUrl) {
        var content = "<table>" +
              // name
        '<tr><td colspan="2">' + chargeBox.actualConfiguration.name +'</td><td></td></tr>' +
              // power
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_POWER') +':</td><td align="left">' +  chargeBox.actualState.lastPowerActiveImportOutlet + 'kW / ' + chargeBox.actualConfiguration.maxPowerSet + 'kW [' + chargeBox.totalUsedPowerPercent + '%]</td></tr>' +
              // factory power
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_FACTORY_POWER') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualConfiguration.maxFactoryPower) + '[kW]</td></tr>' +
              // last activity time -->
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_ACTIVITY') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastActivityTime) + '</td></tr>' +
              // last charging time
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_CHARGING') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastChargingTime) + '</td></tr>' +
              // last error
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_ERROR') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastErrorTime) + '</td></tr>' +
              // last warning
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_LAST_WARNING') +':</td><td align="left">' +  DateUtils.formatDate(chargeBox.actualState.lastWarningTime) + '</td></tr>' +
              // IP
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_IP') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualConfiguration.ipAddress) + '</td></tr>' +
              // vehicle
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_VEHICLE') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualState.lastChargingVehicleName) + '</td></tr>' +
              // SOC
              '<tr><td align="right" style="padding-right: 10px;">' + $translate.instant('DASHBOARD_SOCk') +':</td><td align="left">' +  StringUtils.standarizeValue(chargeBox.actualState.lastChargingVehicleSoc) + '</td></tr>';
              if(showDetailsUrl) {
                // nav to detaills
                content = content + '<tr><td align="left" colspan="2"><a href="' + chargeBox.detailsUrl + '">' + $translate.instant('COMMONS_SHOW_DETAILS') +'</a></td></tr>';
              }
              content = content + '</table>';
          return content;
      }

      function initStateIcons() {
        var stateIcons = {};
        // error
        stateIcons['ERROR'] = layoutPaths.images.chargePoints + 'charging-point-error.png';
        stateIcons['ERROR_REPEATED'] = layoutPaths.images.chargePoints + 'charging-point-error_repeated.png';
        // charging
        stateIcons['CHARGING'] = layoutPaths.images.chargePoints + 'charging-point-charging.png';
        // warning
        stateIcons['WARNING'] = layoutPaths.images.chargePoints + 'charging-point-warning.png';
        stateIcons['WARNING_REPEATED'] = layoutPaths.images.chargePoints + 'charging-point-warning_repeated.png';
        // online
        stateIcons['ONLINE'] = layoutPaths.images.chargePoints + 'charging-point-online.png';
        // offline
        stateIcons['OFFLINE'] = layoutPaths.images.chargePoints + 'charging-point-offline.png';
        return stateIcons;
      }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('ChartUtils', ['DateUtils', 'StringUtils', '$timeout', '$translate', 'layoutPaths', function(DateUtils, StringUtils, $timeout, $translate, layoutPaths) {

          var chargeBoxStates = {
            'OFFLINE': 0,
            'CHARGING': 3,
            'ONLINE': 1,
            'ERROR': 2,
          }

          var chargeBoxStatesWithoutError = {
            'OFFLINE': 0,
            'CHARGING': 2,
            'ONLINE': 1,
          }

          this.getChart = function(id) {
            var allCharts = AmCharts.charts;
            for (var i = 0; i < allCharts.length; i++) {
                if (id == allCharts[i].div.id) {
                    return allCharts[i];
                }
            }
            return undefined;
          }

          this.destroyCharts = function(charts) {
            for(var chartIdentity in charts) {
              charts[chartIdentity].destroy();
            }
          }

          this.clearCharts = function(chartsMetadata, charts) {
            for (var visibleChartIndex = 0; visibleChartIndex < chartsMetadata.length; visibleChartIndex++) {
              var visibleChart = chartsMetadata[visibleChartIndex];
              var chart = charts[visibleChart.label];
              if(chart != undefined) {
                // clear chart
                while(chart.dataProvider.length > 0) {
                  chart.dataProvider.shift();
                }
                chart.validateData();
              }
            }
          }

          this.initCharts = function(visibleCharts, charts, chartData, prefixedChartsGraphColors, valueGuides, nameFragments, valueUnitLabel, labelFunction) {
            return $timeout(function() {
                for(var visibleChartIndex = 0; visibleChartIndex < visibleCharts.length; visibleChartIndex++) {
                  var chartMetaData = visibleCharts[visibleChartIndex];
                  var chartIdentity = chartMetaData.label;
                  var chartDataProvider = chartData[chartMetaData.label];
                  var valueUnit = undefined;
                  if(valueUnitLabel != undefined ) {
                    valueUnit = $translate.instant(valueUnitLabel);
                  } else {
                    valueUnit = ' [' + getValueUnit(chartDataProvider[0]) + ']';
                  }
                  var fileName = undefined;
                  if(nameFragments != undefined) {
                    fileName = $translate.instant("COMMONS__" + chartIdentity);
                    for(var fragmentIndex = 0; fragmentIndex < nameFragments.length; fragmentIndex++) {
                      fileName = fileName + "__" + nameFragments[fragmentIndex];
                    }
                  } else {
                    fileName = $translate.instant(chartIdentity);
                  }
                  // init value axes
                  var valueAxes = undefined;
                  if(valueGuides != undefined && valueGuides[chartIdentity] != undefined) {
                    valueAxes = [{
                        "axisColor": "#FF6600",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "left",
                        "guides": valueGuides[chartIdentity],
                        "unit": valueUnit
                    }];
                  } else {
                    if(labelFunction != undefined) {
                      valueAxes = [{
                          "axisColor": "#FF6600",
                          "axisThickness": 2,
                          "axisAlpha": 1,
                          "position": "left",
                          "labelFunction": labelFunction
                      }];
                    } else {
                      valueAxes = [{
                          "axisColor": "#FF6600",
                          "axisThickness": 2,
                          "axisAlpha": 1,
                          "position": "left",
                          "unit": valueUnit
                      }];
                    }
                  }
                  if(chartMetaData.values_prefix != undefined) {
                    charts[chartMetaData.label] = AmCharts.makeChart(chartMetaData.label, {
                          "numberFormatter": {
                              "precision": -1,
                              "decimalSeparator": ".",
                              "thousandsSeparator": ""
                          },
                          "values_prefix": chartMetaData.values_prefix,
                          "type": "serial",
                          "theme": "light",
                          "legend": {
                              "useGraphSettings": true
                          },
                          "dataProvider": chartDataProvider,
                          "valueAxes": valueAxes,
                          "graphs": [],
                          "chartScrollbar": {},
                          "chartCursor": {
                              "cursorPosition": "mouse"
                          },
                          "categoryField": "date",
                          "categoryAxis": {
                            gridAlpha: 0,
                            autoGridCount: true,
                            autoWrap: true,
                            minHorizontalGap: 100,
                            gridPosition: "start",
                            equalSpacing: false,
                            parseDates: false,
                            minPeriod: "fff",
                            startOnAxis: true,
                            axisColor: "#dcdcdc",
                            axisThickness: 1,
                            showLastLabel: true
                          },
                          "export": {
                              "enabled": true,
                              "position": "bottom-right",
                              "fileName": fileName,
                              menu: [{
                                  class: "export-main",
                                  label: "Export CSV",
                                  click: function() {
                                      this.toCSV({}, function(data) {
                                          this.download(data, "text/plain", this.config.fileName + ".csv");
                                      });
                                  }
                              }]
                          },
                          "pathToImages": layoutPaths.images.amChart
                      });
                      // register graphs
                      var graphsByValueIdentity = chartMetaData.graphsByValueIdentity;
                      if(graphsByValueIdentity != undefined) {
                        var graphIndex = 0;
                        for(var graphDataIdentity in graphsByValueIdentity) {
                          var graph = new AmCharts.AmGraph();
                          graph.lineColor = prefixedChartsGraphColors[graphIndex],
                          graph.bullet = "round",
                          graph.bulletBorderThickness = 1,
                          graph.hideBulletsCount = 20,
                          graph.title = graphDataIdentity,
                          graph.valueField = graphDataIdentity;
                          graph.fillAlphas = 0;
                          charts[chartMetaData.label].addGraph(graph);
                          graphIndex = graphIndex + 1;
                        }
                      }
                  } else {
                    var visibleChart = cloneChartData(chartMetaData);
                    charts[visibleChart.label] = AmCharts.makeChart(visibleChart.label, {
                          "numberFormatter": {
                              "precision": -1,
                              "decimalSeparator": ".",
                              "thousandsSeparator": ""
                          },
                          "type": "serial",
                          "theme": "light",
                          "legend": {
                              "useGraphSettings": true
                          },
                          "dataProvider": chartDataProvider,
                          "valueAxes": valueAxes,
                          "graphs": visibleChart.graphs,
                          "chartScrollbar": {},
                          "chartCursor": {
                              "cursorPosition": "mouse"
                          },
                          "categoryField": "date",
                          "categoryAxis": {
                              gridAlpha: 0,
                              autoGridCount: true,
                              autoWrap: true,
                              minHorizontalGap: 100,
                              gridPosition: "start",
                              equalSpacing: false,
                              parseDates: false,
                              minPeriod: "fff",
                              startOnAxis: true,
                              axisColor: "#dcdcdc",
                              axisThickness: 1,
                              showLastLabel: true
                          },
                          "export": {
                              "enabled": true,
                              "position": "bottom-right",
                              "fileName": fileName,
                              menu: [{
                                  class: "export-main",
                                  label: "Export CSV",
                                  click: function() {
                                      this.toCSV({}, function(data) {
                                          this.download(data, "text/plain", this.config.fileName + ".csv");
                                      });
                                  }
                              }]
                          },
                          "pathToImages": layoutPaths.images.amChart
                      });
                  }
                }
            });
          }

          this.generateActivityHoursChartData = function(chargeBoxStatesData, disableError) {
            if(disableError) {
              var chartDataArray = [];
              for (var index = 0; index < chargeBoxStatesData.length; index++) {
                var chargeBoxStatesDataEntry = chargeBoxStatesData[index];
                // start time
                var chartDataStartEntry = {
                  'value': chargeBoxStatesWithoutError[chargeBoxStatesDataEntry.chargeBoxStatus],
                  'date': DateUtils.formatDate(chargeBoxStatesDataEntry.startTime),
                };
                chartDataArray.push(chartDataStartEntry);
                // end time
                if(chargeBoxStatesDataEntry.stopTime != undefined) {
                  var chartDataEndEntry = {
                    'value': chargeBoxStatesWithoutError[chargeBoxStatesDataEntry.chargeBoxStatus],
                    'date': DateUtils.formatDate(chargeBoxStatesDataEntry.stopTime),
                  };
                  chartDataArray.push(chartDataEndEntry);
                }
              }
              return chartDataArray;
            }
            var chartDataArray = [];
            for (var index = 0; index < chargeBoxStatesData.length; index++) {
              var chargeBoxStatesDataEntry = chargeBoxStatesData[index];
              // start time
              var chartDataStartEntry = {
                'value': chargeBoxStates[chargeBoxStatesDataEntry.chargeBoxStatus],
                'date': DateUtils.formatDate(chargeBoxStatesDataEntry.startTime),
              };
              chartDataArray.push(chartDataStartEntry);
              // end time
              if(chargeBoxStatesDataEntry.stopTime != undefined) {
                var chartDataEndEntry = {
                  'value': chargeBoxStates[chargeBoxStatesDataEntry.chargeBoxStatus],
                  'date': DateUtils.formatDate(chargeBoxStatesDataEntry.stopTime),
                };
                chartDataArray.push(chartDataEndEntry);
              }
            }
            return chartDataArray;
          }

          this.generateChargingProfilesCharts = function(chargeBoxChargingProfiles) {
            var chartDataArray = [ {
                "category": "Module #1",
                "segments": [ {
                  "start": "2016-01-01",
                  "end": "2016-01-14",
                  "color": "#b9783f",
                  "task": "Gathering requirements"
                }, {
                  "start": "2016-01-16",
                  "end": "2016-01-27",
                  "task": "Producing specifications"
                }, {
                  "start": "2016-02-05",
                  "end": "2016-04-18",
                  "task": "Development"
                }, {
                  "start": "2016-04-18",
                  "end": "2016-04-30",
                  "task": "Testing and QA"
                } ]
              }, {
                "category": "Module #2",
                "segments": [ {
                  "start": "2016-01-08",
                  "end": "2016-01-10",
                  "color": "#cc4748",
                  "task": "Gathering requirements"
                }, {
                  "start": "2016-01-12",
                  "end": "2016-01-15",
                  "task": "Producing specifications"
                }, {
                  "start": "2016-01-16",
                  "end": "2016-02-05",
                  "task": "Development"
                }, {
                  "start": "2016-02-10",
                  "end": "2016-02-18",
                  "task": "Testing and QA"
                } ]
              }, {
                "category": "Module #3",
                "segments": [ {
                  "start": "2016-01-02",
                  "end": "2016-01-08",
                  "color": "#cd82ad",
                  "task": "Gathering requirements"
                }, {
                  "start": "2016-01-08",
                  "end": "2016-01-16",
                  "task": "Producing specifications"
                }, {
                  "start": "2016-01-19",
                  "end": "2016-03-01",
                  "task": "Development"
                }, {
                  "start": "2016-03-12",
                  "end": "2016-04-05",
                  "task": "Testing and QA"
                } ]
              }, {
                "category": "Module #4",
                "segments": [ {
                  "start": "2016-01-01",
                  "end": "2016-01-19",
                  "color": "#2f4074",
                  "task": "Gathering requirements"
                }, {
                  "start": "2016-01-19",
                  "end": "2016-02-03",
                  "task": "Producing specifications"
                }, {
                  "start": "2016-03-20",
                  "end": "2016-04-25",
                  "task": "Development"
                }, {
                  "start": "2016-04-27",
                  "end": "2016-05-15",
                  "task": "Testing and QA"
                } ]
              }, {
                "category": "Module #5",
                "segments": [ {
                  "start": "2016-01-01",
                  "end": "2016-01-12",
                  "color": "#448e4d",
                  "task": "Gathering requirements"
                }, {
                  "start": "2016-01-12",
                  "end": "2016-01-19",
                  "task": "Producing specifications"
                }, {
                  "start": "2016-01-19",
                  "end": "2016-03-01",
                  "task": "Development"
                }, {
                  "start": "2016-03-08",
                  "end": "2016-03-30",
                  "task": "Testing and QA"
                } ]
              } ];
          }

          this.generateChartData = function(visibleCharts, itemDataMeterValues, convertTo) {
            var chartDataByLabel = {};
            var powerUnitTemp;
            var updateTitle = false;
            var powerUnit;
            var energyOutletUnit;
            var energyInletUnit;
            var setEnergyOutTitle = false;
            var setEnergyInTitle = false;
            for (var visibleChartIndex = 0; visibleChartIndex < visibleCharts.length; visibleChartIndex++) {
                var chart = visibleCharts[visibleChartIndex];
                
                if(chart.values_prefix != undefined) {
                  if(chart.graphsByValueIdentity == undefined) {
                    chart.graphsByValueIdentity = {};
                  }
                  var chartData = {};
                  if (itemDataMeterValues != undefined && itemDataMeterValues.length > 0) {
                      // iterate over meter values
                      for (var meterValuesIndex = 0; meterValuesIndex < itemDataMeterValues.length; meterValuesIndex++) {
                          var meterValues = itemDataMeterValues[meterValuesIndex];
                          var chartDataEntry = {};
                          var chartDataEntryEmpty = true;
                          if (meterValues.meterValueItems != undefined && meterValues.meterValueItems.length > 0) {
                              // iterate over meter value items
                              for (var meterValueItemIndex = 0; meterValueItemIndex < meterValues.meterValueItems.length; meterValueItemIndex++) { 
                                var meterValueItem = meterValues.meterValueItems[meterValueItemIndex];
                                  // check if starts with prefix
                                  if(meterValueItem.measurand.indexOf(chart.values_prefix) == 0) {
                                    var valueIdentity = meterValueItem.measurand + '__' + meterValueItem.location;
                                    chartDataEntry[valueIdentity] = meterValueItem.meterValue;
                                    chartDataEntry[valueIdentity + "__unit"] = meterValueItem.measureOfUnit;
                                    chartDataEntryEmpty = false;
                                    // register graph
                                    chart.graphsByValueIdentity[valueIdentity] = true;
                                  }
                              }
                          }
                          // check if chart data entry is not empty
                          if (!chartDataEntryEmpty) {
                              var timestamp = DateUtils.formatDate(meterValues.meterValueTimestamp);
                              var archivedChartDataEntry = chartData[timestamp];
                              if(archivedChartDataEntry != undefined) {
                                for(var chartDataEntryKey in chartDataEntry) {
                                  archivedChartDataEntry[chartDataEntryKey] = chartDataEntry[chartDataEntryKey];
                                }
                              } else {
                                var timestamp = DateUtils.formatDate(meterValues.meterValueTimestamp);
                                chartDataEntry['date'] = timestamp;
                                chartData[timestamp] = chartDataEntry;
                              }
                          }
                      }
                  }
                } else {
                    var chartData = {};
                    var convert = convertTo;
                    powerUnit = convert;
                    if (itemDataMeterValues != undefined && itemDataMeterValues.length > 0) {
                        // iterate over meter values
                        for (var meterValuesIndex = 0; meterValuesIndex < itemDataMeterValues.length; meterValuesIndex++) {
                            var meterValues = itemDataMeterValues[meterValuesIndex];
                            var chartDataEntry = {};
                            var chartDataEntryEmpty = true;
                            if (meterValues.meterValueItems != undefined && meterValues.meterValueItems.length > 0) {
                                // iterate over meter value items
                                for (var meterValueItemIndex = 0; meterValueItemIndex < meterValues.meterValueItems.length; meterValueItemIndex++) {
                                    var meterValueItem = meterValues.meterValueItems[meterValueItemIndex];
                                    // iterate over chart types
                                    for (var chartGraphIndex = 0; chartGraphIndex < chart.graphs.length; chartGraphIndex++) {
                                        var chartGraph = chart.graphs[chartGraphIndex];
                                        var valueIdentity = meterValueItem.measurand + '__' + meterValueItem.location;
                                        if (chartGraph.measurand == meterValueItem.measurand && chartGraph.location == meterValueItem.location) {
                                          if (chartGraph.measurand == "ENERGY_ACTIVE_IMPORT_REGISTER") {
                                            if (meterValueItem.location == "INLET") {
                                                energyInletUnit = meterValueItem.measureOfUnit;
                                                setEnergyInTitle = true;
                                            } else {
                                                energyOutletUnit = meterValueItem.measureOfUnit;
                                                setEnergyOutTitle = true;
                                            }
                                          }
                                          var valueIdentity = meterValueItem.measurand + '__' + meterValueItem.location;
                                          if (convert == undefined || meterValueItem.measureOfUnit != "W") {
                                            chartDataEntry[valueIdentity] = meterValueItem.meterValue;
                                            chartDataEntry[valueIdentity + "__unit"] = meterValueItem.measureOfUnit;
                                          } else {
                                            if (convert == "kW") {
                                              chartDataEntry[valueIdentity] = convertTokW(meterValueItem.meterValue);
                                              chartDataEntry[valueIdentity + "__unit"] = "kW";
                                              powerUnit = "kW";
                                              updateTitle = true;
                                            } else {
                                              chartDataEntry[valueIdentity] = meterValueItem.meterValue;
                                              chartDataEntry[valueIdentity + "__unit"] = meterValueItem.measureOfUnit;
                                              powerUnit = "W";
                                            }
                                          }
                                          chartDataEntryEmpty = false;
                                        }
                                    }                            
                                }
                            }
                            if (!chartDataEntryEmpty) {
                                var timestamp = DateUtils.formatDate(meterValues.meterValueTimestamp);
                                var archivedChartDataEntry = chartData[timestamp];
                                if(archivedChartDataEntry != undefined) {
                                  for(var chartDataEntryKey in chartDataEntry) {
                                    archivedChartDataEntry[chartDataEntryKey] = chartDataEntry[chartDataEntryKey];
                                  }
                                } else {
                                  var timestamp = DateUtils.formatDate(meterValues.meterValueTimestamp);
                                  chartDataEntry['date'] = timestamp;
                                  chartData[timestamp] = chartDataEntry;
                                }
                            }
                        }
                    }
                }
                 if (setEnergyInTitle) {
                    setTitle(chart.graphs, energyInletUnit);
                    setEnergyInTitle = false;
                }
                if (setEnergyOutTitle) {
                    setTitle(chart.graphs, energyOutletUnit);
                    setEnergyOutTitle = false;
                }

                if (powerUnitTemp == undefined) {
                    setTitle(chart.graphs, powerUnit);
                    powerUnitTemp = powerUnit;
                }
                if (updateTitle) {
                    setTitle(chart.graphs, powerUnit);
                    updateTitle = false;
                }

                var chartDataArray = [];
                for(var chartDataKey in chartData) {
                  chartDataArray.push(chartData[chartDataKey]);
                }
                chartData.creationTime = new Date().getTime();
                chartDataByLabel[chart.label] = chartDataArray;
            }
            return chartDataByLabel;
        }


           function setTitle(chart, unit) {
            for (var item = 0; item < chart.length; item ++) {
                if ("POWER_ACTIVE_IMPORT" == chart[item].measurand) {
                    var powerTitle;
                    if ("INLET" == chart[item].location) {
                        powerTitle = $translate.instant('COMMONS__INLET_POWER_ACTIVE_IMPORT');
                    } else {
                        powerTitle = $translate.instant('COMMONS__OUTLET_POWER_ACTIVE_IMPORT');
                    }
                    chart[item].title = "";
                    chart[item].title = powerTitle + " [" + unit + "]";
                }
                if ("ENERGY_ACTIVE_IMPORT_REGISTER" == chart[item].measurand) {
                    var energyTitle;
                    if ("INLET" == chart[item].location) {
                        energyTitle = $translate.instant('COMMONS__INLET_ENERGY_ACTIVE_IMPORT_REGISTER');
                    } else {
                        energyTitle = $translate.instant('COMMONS__OUTLET_ENERGY_ACTIVE_IMPORT_REGISTER');
                    }
                    chart[item].title = "";
                    chart[item].title = energyTitle + " [" + unit + "]";
                }
              }
           }

          function convertTokW(powerValues) {
            var value = 0;
            if (powerValues != 0) {
              var value = Math.round((powerValues / 1000)*100)/100;
            }
            return value;
          }

          function getValueUnit(valueItem) {
            for(var key in valueItem) {
              if(key.lastIndexOf('_unit') == key.length - 5) {
                return $translate.instant(valueItem[key]);
              }
            }
            return '';
          }

          function cloneChartData(chart) {
            var clonedGraphs = [];
            for(var index = 0; index < chart.graphs.length; index++) {
              var graph = chart.graphs[index];
              var clonedGraph = {};
              for(var key in graph) {
                clonedGraph[key] = graph[key];
              }
              clonedGraphs.push(clonedGraph);
            }
            return {
              "label": chart.label,
              "graphs": clonedGraphs,
            }
          }
    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('CookieUtils', ['$cookies', function($cookies) {

      this.setCookieValue = function(name, value, expDays) {
          var date = new Date();
          date.setTime(+date + (expDays * 86400000)); //24 * 60 * 60 * 1000
          $cookies.put(name, value, {
              expires: date.toGMTString()
          });
      }

      this.removeCookieValue = function(name) {
          $cookies.remove(name);
      }

      this.getCookieValue = function(identity) {
          var cookieValue = $cookies.get(identity);
          if (cookieValue != undefined) {
              return cookieValue;
          }
          return undefined;
      }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('DateUtils', ['$translate', function($translate) {

        var suffixAfterDictionary = initSuffixAfterDictionary();

        var H_6 = 1000 * 60 * 60 * 6;
        var H_24 = 1000 * 60 * 60 * 24;
        var D_10 = 1000 * 60 * 60 * 24 * 10;
        var D_30 = 1000 * 60 * 60 * 24 * 30;
        var M_6 = 1000 * 60 * 60 * 24 * 182;
        var M_12 = 1000 * 60 * 60 * 24 * 365;

        this.dateFormat = 'yyyy-MM-dd HH:mm:ss';

        this.getCurrentTimestamp = function() {
          return new Date().getTime();
        }

        this.getTimePeriodInMs = function(timePeriodLabel) {
          if(timePeriodLabel == undefined) {
            return undefined;
          }
          if(timePeriodLabel == 'H_6') {
            return H_6;
          }
          if(timePeriodLabel == 'H_24') {
            return H_24;
          }
          if(timePeriodLabel == 'D_10') {
            return D_10;
          }
          if(timePeriodLabel == 'D_30') {
            return D_30;
          }
          if(timePeriodLabel == 'M_6') {
            return M_6;
          }
          if(timePeriodLabel == 'M_12') {
            return M_12;
          }
        }

        this.formatDate = function(dateTime) {
            if (dateTime == undefined) {
                return "---";
            }
            var date = new Date(dateTime);
            return getDateValue(date.getDate()) + '/' + getDateValue(date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + getDateValue(date.getHours()) + ':' + getDateValue(date.getMinutes()) + ":" + getDateValue(date.getSeconds());
        }

        this.getJsonOutputDate = function(date) {
            var year = date.getFullYear();
            var month = getDateValue(date.getMonth() + 1);
            var day = getDateValue(date.getDate());
            var hours = getDateValue(date.getHours());
            var minutes = getDateValue(date.getMinutes());
            var seconds = getDateValue(date.getSeconds());
            return year + "-" + month + '-' + day + 'T' + hours + ":" + minutes + ":" + seconds + '+00:00';
        }

        this.displayOnlyTime = function(dateTime) {
          if (dateTime == undefined) {
              return "---";
          }
          var date = new Date(dateTime);
          return getDateValue(date.getHours()) + ':' + getDateValue(date.getMinutes()) + ":" + getDateValue(date.getSeconds());
        }

        this.getFormattedTimestamp = function() {
          var date = new Date();
          return getDateValue(date.getFullYear()) + getDateValue(date.getMonth() + 1) + getDateValue(date.getDate()) + getDateValue(date.getHours()) + getDateValue(date.getMinutes()) + getDateValue(date.getSeconds());
        }

        this.millisecondsToStrTimeInterval = function(milliseconds) {
          if(milliseconds == undefined) {
            return '---';
          }
          var minutes = Math.floor(milliseconds / 60000);
          var seconds = ((milliseconds % 60000) / 1000).toFixed(0);
          return minutes + " min " + (seconds < 10 ? '0' : '') + seconds + " s";
        }

        function numberEnding(number, suffixAfterDictionary) {
          if(suffixAfterDictionary == undefined) {
            return '';
          }
          var suffix = suffixAfterDictionary[number];
          if(suffix == undefined) {
            return '';
          }
          return suffix;
        }

        this.secondsToStrTimeInterval = function(milliseconds) {
          if(milliseconds == undefined) {
            return '---';
          }
          var minutes = Math.floor(milliseconds / 60);
          var seconds = (milliseconds % 60).toFixed(0);
          return minutes + " min " + (seconds < 10 ? '0' : '') + seconds + " s";
        }

        function numberEnding(number, suffixAfterDictionary) {
          if(suffixAfterDictionary == undefined) {
            return '';
          }
          var suffix = suffixAfterDictionary[number];
          if(suffix == undefined) {
            return '';
          }
          return suffix;
        }

        function initSuffixAfterDictionary() {
          var suffixAfterDictionary = {};
          suffixAfterDictionary['pl'] = initPlSuffixAfterDictionary();
          return suffixAfterDictionary;
        }

        function initPlSuffixAfterDictionary() {
          var suffixAfterDictionary = {};
          // 0
          suffixAfterDictionary[1] = 'a';
          suffixAfterDictionary[2] = 'y';
          suffixAfterDictionary[3] = 'y';
          suffixAfterDictionary[4] = 'y';
          // 20
          suffixAfterDictionary[22] = 'a';
          suffixAfterDictionary[23] = 'y';
          suffixAfterDictionary[24] = 'y';
          // 30
          suffixAfterDictionary[32] = 'a';
          suffixAfterDictionary[33] = 'y';
          suffixAfterDictionary[34] = 'y';
          // 40
          suffixAfterDictionary[42] = 'a';
          suffixAfterDictionary[43] = 'y';
          suffixAfterDictionary[44] = 'y';
          // 50
          suffixAfterDictionary[52] = 'a';
          suffixAfterDictionary[53] = 'y';
          suffixAfterDictionary[54] = 'y';
          // return
          return suffixAfterDictionary;
        }

        function getDateValue(value) {
            if (value < 10) {
                return addLeadingZerosToDate(value);
            }
            return value;
        }

        function addLeadingZerosToDate(num, size) {
            var s = "0" + num;
            return s.substr(s.length - size);
        }


    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('ErrorUtils', ['$translate', 'ArrayUtils', 'CookieUtils', 'InteractionsUtils', function($translate, ArrayUtils, CookieUtils, InteractionsUtils) {

      this.handleDefaultError = function(error) {
        var errorCode = getErrorCode(error);
        InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant(errorCode));

        // handle error
        // if(error.data != undefined && error.data.error_description != undefined) {
        //   InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), error.data.error_description);
        // return;
        //} else if(error.data != undefined && error.data.message != undefined) {
        //  InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), error.data.message);
        //  return;
        // }
        // InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), "Authorization failed");
      }

      this.handleError = function(error, errorArray) {
        if(error.status == 401) {
          // remove user token
          CookieUtils.removeCookieValue('access_token');
          // nav to login page
          InteractionsUtils.changeView('login');
          return;
        }
        var errorCode = getErrorCode(error);
        if(errorArray.length == 0) {
          errorArray.push(errorCode);
          InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant(errorCode), errorCode, errorArray);
        } else {
          // check if contains
          if(ArrayUtils.indexOf(errorArray, errorCode) == -1) {
            errorArray.push(errorCode);
            InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant(errorCode), errorCode, errorArray);
          }
        }
      }

        function getErrorCode(error) {
          if(error.data != undefined && error.data.message != undefined) {
            return error.data.message;
          } else if(error.data != undefined) {
            if(error.data.error != undefined ) {
              return error.data.error;
            }
            return error.data;
          } else if(error.status == -1) {
            return "ERROR_CONNECTION_REFUSED";
          } else if(error.status == 500 ) {
            return "ERROR_FAILED_TO_LOAD_RESOURCES";
          } else if(error.message != undefined) {
            return error.message;
          }
        }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');
    module.service('HttpUtils', ['$q', '$http', '$translate', 'AuthorizationFactory', 'InteractionsUtils', function($q, $http, $translate, AuthorizationFactory, InteractionsUtils) {
        this.prepareHttpGet = function(serverPath, apiPath, query) {
            if (query != undefined) {
                var url = undefined;
                if (apiPath.indexOf('?') == -1) {
                  url = serverPath + "/" + apiPath + "?" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                } else {
                  url = serverPath + "/" + apiPath + "&" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                }
                return $http({
                    method: 'GET',
                    url: url,
                    headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
                });
            }
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
              url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            } else {
              url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }

            return $http({
                method: 'GET',
                url: url,
                // disable cache
                headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
            });
        }
        this.prepareHttpPost = function(serverPath, apiPath, requestData) {
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            else {
                url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            return $http({
                method: 'POST',
                url: url,
                data: requestData,
                headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
            });
        }
        this.prepareHttpPut = function(serverPath, apiPath, requestData) {
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            else {
                url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            return $http({
                method: 'PUT',
                url: url,
                data: requestData,
                headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
            });
        }

         this.prepareHttpXLSXPost = function(serverPath, apiPath, dataRequest, pSortProperty, pSortDirection) {
             var file = setFileName(apiPath);
             var url = undefined;
             var self = this;
             var deferred = $q.defer();

             if (pSortProperty == undefined) {
                pSortProperty = 'id'
                pSortDirection = 'DESC';
             }
             dataRequest["sort"] = [pSortProperty, pSortDirection];

             if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
             } else {
                url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
             }

             $http.post(url, dataRequest, { responseType: "blob" }).then(
                function (response){
                   saveAs(response.data, file)
                   deferred.resolve(file);
                 }, function (response) {
                   deferred.reject("Error when saving the file");
                 });
         }

        function setFileName(partPath) {
            var path = partPath;

            var file = "Report.xlsx";
            if (path.includes("rest/chargebox/status/CHARGING/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargebox/status/ONLINE/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargebox/status/OFFLINE/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargebox/status/ERROR/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargebox/status/WARNING/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargingtransaction/xlsx-generate")) {
                file = $translate.instant('XLSX_HISTORY_TRANSACTIONS');
            }
            if (path.includes("rest/vehicle/xlsx-generate")) {
                 file = $translate.instant('XLSX_REPORT_VEHICLE');
            }
            if (path.includes("rest/alert/xlsx-generate")) {
                file = $translate.instant('XLSX_HISTORY_ALERT');
            }
            if (path.includes("rest/chargeboxgroup/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX_GROUP');
            }
            if (path.includes("rest/report/chargebox/consumed-energy/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX_CONSUMED_ENERGY');
            }
            if (path.includes("rest/report/chargeboxgroup/consumed-energy/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX_GROUP_CONSUMED_ENERGY');
            }
            if (path.includes("rest/report/vehicle/consumed-energy/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_VEHICLE_CONSUMED_ENERGY');
            }
            if (path.includes("rest/chargebox/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX');
            }
            if (path.includes("rest/chargeboxgroup/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_CHARGE_BOX_GROUP');
            }
            if (path.includes("rest/authorizationidtag/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_AUTHORIZATION_ID_TAG');
            }
            if (path.includes("rest/alertdefinition/xlsx-generate")) {
                file = $translate.instant('XLSX_REPORT_ALERT_DEFINITION');
            }
            if (path.includes("rest/report_template")) {
                file = $translate.instant('XLSX_REPORT_TEMPLATE');
            }
            return file;
        }

        this.prepareHttpGetCsv = function(serverPath, apiPath, query) {
            var headers = {
                Accept: 'text/csv',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            };
            if (query != undefined) {
                var url = undefined;
                if (apiPath.indexOf('?') == -1) {
                    url = serverPath + "/" + apiPath + "?" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                }
                else {
                    url = serverPath + "/" + apiPath + "&" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                }
                return $http({
                    method: 'GET',
                    headers: headers,
                    url: url,
                });
            }
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            else {
                url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            return $http({
                method: 'GET',
                headers: headers,
                url: url,
            });
        }
        this.prepareHttpPutFile = function(serverPath, apiPath, query, requestData, content) {
            if (query != undefined) {
                var url = undefined;
                if (apiPath.indexOf('?') == -1) {
                    url = serverPath + "/" + apiPath + "?" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                }
                else {
                    url = serverPath + "/" + apiPath + "&" + query + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
                }
                return $http({
                    method: 'PUT',
                    url: url,
                    data: requestData,
                    headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
                });
            }
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            else {
                url = serverPath + "/" + apiPath + '&access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            return $http({
                method: 'PUT',
                url: url,
                data: requestData,
                responseType: 'arraybuffer',
                headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
            });
        }
        this.prepareHttpPostOctetStream = function(serverPath, apiPath, requestData) {
            var url = undefined;
            if (apiPath.indexOf('?') == -1) {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            else {
                url = serverPath + "/" + apiPath + '?access_token=' + AuthorizationFactory.accessTokenContext.accessToken;
            }
            return $http({
                method: 'POST',
                url: url,
                responseType: 'arraybuffer',
                data: requestData,
                headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}
            });
        }
    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');
    module.service('InteractionsUtils', ['$state', '$uibModal', '$uibModalStack', 'ArrayUtils', function($state, $uibModal, $uibModalStack, ArrayUtils) {
        // =====================================================================
        // dialogs
        // =====================================================================
        this.openWarningDialog = function(title, message, error, displayedErrors) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/theme/components/modals/warning.html',
                backdrop: false,
                controller: function($scope, $uibModalInstance) {
                    $scope.title = title;
                    $scope.message = message;
                    $scope.cancel = function() {
                        if(displayedErrors != undefined) {
                          var indexOfError = ArrayUtils.indexOf(displayedErrors, error);
                          displayedErrors.splice(indexOfError, 1);
                        }
                        $uibModalInstance.close();
                        $uibModalInstance.dismiss('cancel');
                        return false;
                    }
                }
            });
        };
        this.openInfoDialog = function(title, message) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/theme/components/modals/info.html',
                backdrop: false,
                controller: function($scope, $uibModalInstance) {
                    $scope.title = title;
                    $scope.message = message;
                    $scope.cancel = function() {
                        $uibModalInstance.close();
                        return false;
                    }
                    $scope.confirm = function() {
                        $uibModalInstance.close();
                        return true;
                    }
                }
            });
        };
        this.openCustomDialog = function(template, size) {
            var self = this;
            $uibModal.open({
                animation: true,
                templateUrl: template,
                size: size,
                backdrop: false,
            });
        }
        this.openDialog = function(title, template, size, itemData) {
            var self = this;
            $uibModal.open({
                animation: true,
                templateUrl: template,
                size: size,
                backdrop: false,
                controller: function($scope, $uibModalInstance) {
                    $scope.formatDate = self.formatDate;
                    $scope.title = title;
                    $scope.itemData = itemData;
                    $scope.cancel = function() {
                        $uibModalInstance.close();
                        return false;
                    }
                    $scope.confirm = function() {
                        $uibModalInstance.close();
                        return true;
                    }
                }
            });
        }
        // =====================================================================
        // snackbar
        // =====================================================================
        this.showSnackbar = function(message, timout) {
          // try to close dialog
          var snackbarTop = $uibModalStack.getTop();
          if(snackbarTop != undefined) {
            $uibModalStack.dismiss(top.key);
          }
          // Get the snackbar DIV
          var snackbarElement = document.getElementById("snackbar");
          snackbarElement.innerHTML = message;
          // Add the "show" class to DIV
          snackbarElement.className = "show";
          // After 3 seconds, remove the show class from DIV
          setTimeout(function(){
            snackbarElement.className = snackbarElement.className.replace("show", ""); }
          , timout);
        }
        // =====================================================================
        // navigation
        // =====================================================================
        this.changeView = function(routerState, postCallback, preCallback, params) {
            if (preCallback != undefined) {
                if (preCallback()) {
                    doChangeView(routerState, postCallback, params);
                }
                return;
            }
            doChangeView(routerState, postCallback, params);
        }

        function doChangeView(routerState, callback, params) {
            // change router state
            if (params == undefined) {
                $state.go(routerState);
            }
            else {
                $state.go(routerState, params);
            }
            // callback
            if (callback != undefined) {
                callback();
            }
        }
    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');
    module.service('PaginationUtils', [function() {

      this.getPaginationArray = function(currentPage, totalPages) {
          var current = currentPage,
              lastPage = totalPages,
              delta = 2,
              left = current - delta,
              right = current + delta + 1,
              range = [],
              outputRange = [],
              l;
          if (right > totalPages) {
              left = left - (right - totalPages);
          } else if (left < 0) {
              right = right + (left * -1);
          }
          for (var i = 0; i < lastPage; i++) {
              if (i >= left && i < right) {
                  range.push(i);
              }
          }
          for (var index = 0; index < range.length; index++) {
              var i = range[index];
              if (l) {
                  if (i - l === 2) {
                      outputRange.push(l);
                  }
              }
              outputRange.push(i);
              l = i;
          }
          return outputRange;
      }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('PreconditionsUtils', ['$translate', 'InteractionsUtils', function($translate, InteractionsUtils) {

        this.checkArgument = function(expression, message, component, functionName) {
            if (!expression) {
                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), message);
                throw message;
            }
        }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.directive('autoComplete', function($timeout) {
      return function(scope, iElement, iAttrs) {
            iElement.autocomplete({
                source: scope[iAttrs.uiItems],
                select: function() {
                    $timeout(function() {
                      iElement.trigger('input');
                    }, 0);
                }
            });
          };
    });

    module.service('StringUtils', ['$sce', function($sce) {

        this.getRandomColor = function(){
          var c = '';
          while (c.length < 7) {
            c += (Math.random()).toString(16).substr(-6).substr(-1)
          }
          return '#'+c;
        }

        this.replaceNewLineCharWithBrTag = function(value) {
            if (value != undefined) {
                return $sce.trustAsHtml(value.replace(/(\n)+/g, '<br />'));
            }
            return value;
        }

        this.replaceAll = function(str, find, replace) {
            return str.replace(new RegExp(find, 'g'), replace);
        }

        this.isNullOrEmpty = function(stringValue) {
            if (stringValue == undefined || stringValue.length === 0) {
                return true;
            }
            return false;
        }
        this.formatXml = function(xml) {
            var reg = /(>)(<)(\/*)/g;
            var wsexp = / *(.*) +\n/g;
            var contexp = /(<.+>)(.+\n)/g;
            xml = xml.replace(reg, '$1\n$2$3').replace(wsexp, '$1\n').replace(contexp, '$1\n$2');
            var pad = 0;
            var formatted = '';
            var lines = xml.split('\n');
            var indent = 0;
            var lastType = 'other';
            // 4 types of tags - single, closing, opening, other (text, doctype, comment) - 4*4 = 16 transitions
            var transitions = {
                'single->single': 0,
                'single->closing': -1,
                'single->opening': 0,
                'single->other': 0,
                'closing->single': 0,
                'closing->closing': -1,
                'closing->opening': 0,
                'closing->other': 0,
                'opening->single': 1,
                'opening->closing': 0,
                'opening->opening': 1,
                'opening->other': 1,
                'other->single': 0,
                'other->closing': -1,
                'other->opening': 0,
                'other->other': 0
            };
            for (var i = 0; i < lines.length; i++) {
                var ln = lines[i];
                var single = Boolean(ln.match(/<.+\/>/)); // is this line a single tag? ex. <br />
                var closing = Boolean(ln.match(/<\/.+>/)); // is this a closing tag? ex. </a>
                var opening = Boolean(ln.match(/<[^!].*>/)); // is this even a tag (that's not <!something>)
                var type = single ? 'single' : closing ? 'closing' : opening ? 'opening' : 'other';
                var fromTo = lastType + '->' + type;
                lastType = type;
                var padding = '';
                indent += transitions[fromTo];
                for (var j = 0; j < indent; j++) {
                    padding += '    ';
                }
                formatted += padding + ln + '\n';
            }
            return { rows: lines.length, content: formatted };
        }

        this.standarizeValue = function(value) {
          if(value == undefined) {
            return '------';
          }
          return value;
        }

        function createShiftArr(step) {
            var space = '';
            if (isNaN(parseInt(step))) // argument is string
                space = step;
            else // argument is integer
                for (var i = 0; i < step; i++) space += ' ';
            var shift = ['\n']; // array of shifts
            for (var ix = 0; ix < 100; ix++) shift.push(shift[ix] + space);
            return shift;
        }


    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.utils');

    module.service('ViewUtils', ['$translate', 'MetadataFactory', 'ConfigFactory', 'StringUtils', 'DateUtils', function($translate, MetadataFactory, ConfigFactory, StringUtils, DateUtils) {

      this.getViewReloadInterval = function(viewFactory) {
        var viewSettings = ConfigFactory.viewSettings;
        if(viewSettings != undefined) {
          // get settings for current view
          var reloadInterval = ConfigFactory.viewSettings[viewFactory.viewContext.identity + '.reloadInterval'];
          if(reloadInterval != undefined) {
            return reloadInterval;
          }
          // get general config
          reloadInterval = viewSettings['reloadInterval'];
          if(reloadInterval != undefined) {
            return reloadInterval;
          }
        }
        return viewFactory.viewContext.dataSynchronizationInterval;
      }

      this.translateType = function(type) {
          return $translate.instant('USER_ACTIVITY_' + type.toUpperCase());
      }

      this.translateParameter = function(changedParameter) {
          var prefix = "";
          switch (changedParameter) {
            case "Name":
            case "Identity":
            case "Privileges":
            case "Active":
            case "active":
              prefix = "COMMONS__"
              break;
            case "CommunicationProtocol":
            case "Latitude":
            case "Longtitude":
            case "OcppProtocolVersion":
            case "MaxFactoryPower":
            case "ChargePointVendor":
            case "Address":
              prefix = "CHARGE_BOX_EDIT__";
              break;
            case "BatteryCapacity":
            case "SideNumber":
              prefix = "VEHICLE_TABLE__";
              break;
            case "ParentIdToken":
            case "Status":
            case "ExpiryDate":
              prefix = "AUTHORIZATION_TAG_DETAILS__";
              break;
            case "Description":
            case "Power":
            case "ChargeBox":
            case "ChargeBoxPriority":
              prefix = "CHARGE_BOX_GROUP_EDIT__";
              break;
            case "NotificationType":
            case "TriggerMethod":
            case "Hidden":
            case "Expression":
              prefix = "ALERT_DEFINITION__"
              break;
            case "Receivers":
            case "SubjectTemplate":
            case "ContentTemplate":
              prefix = "ALERT_DEFINITION__NOTIFICATION_"
              break;
            case "email":
            case "roles":
            case "phone":
            case "password":
            case "passwordConfirm":
            case "lastName":
            case "firstName":
              prefix = "USERS_TABLE__"
              break;
            case "StackLevel":
            case "ChargingProfilePurpose":
            case "ChargingProfileKind":
            case "ProfilePurpose":
            case "RecurrencyKind":
            case "ValidFrom":
            case "ValidTo":
            case "ChargingSchedulePeriod":
            case "StartSchedule":
            case "MinChargingRate":
            case "ChargingRateUnit":
            case "Duration":
            case "StartPeriod":
            case "Limit":
            case "NumberOfPhases":
              prefix = "CHARGING_PROFILE__"
              break;
            case 'ChargingProfile':
              prefix = "CHARGE_BOX__SET_"
              break;
          }
          var parsedParameter = changedParameter.replace(/\.?([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "").toUpperCase();
          return parsedParameter == "" ? parsedParameter : $translate.instant(prefix + parsedParameter);

      }

      this.saveDataAsCsv = function(itemsData, reportType, metaData, viewIdentity, tableColumns, extension) {
        var csv
        if (reportType) {
          csv = convertDataToCsv(tableColumns, itemsData, metaData);
        } else {
          csv = convertSummaryDataToCSV(tableColumns, itemsData, metaData);
        }
        
        var fileExtension = extension;
        if(fileExtension == undefined) {
          fileExtension = "csv";
        }
        var blob = undefined;
        if(fileExtension == 'txt') {
          blob = new Blob([csv],{type: "text/plain;charset=utf-8;"});
        } else {
          blob = new Blob([csv],{type: "text/csv;charset=utf-8;"});
        }

        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, $translate.instant(viewIdentity) + '_' + DateUtils.getCurrentTimestamp() +'_export.' + fileExtension)
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", $translate.instant(viewIdentity) + '_' + DateUtils.getCurrentTimestamp() +'_export.' + fileExtension);
                link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
      }

      function initTableContent(itemsData, tableColumns) {
        // init data
        var tableRows = [];
        for(var index = 0; index < itemsData.length; index++) {
          var item = itemsData[index];
          var itemDisplayedData = [];
          for(var columnIndex = 0; columnIndex < tableColumns.length; columnIndex++) {
            var propertyValue = tableColumns[columnIndex].property(item);
            if(propertyValue == undefined) {
              itemDisplayedData[columnIndex] = "'---'";
            } else {
              var propertyValueFormatter = tableColumns[columnIndex].formatter;
              // property formatter
              if(propertyValueFormatter != undefined) {
                itemDisplayedData[columnIndex] = propertyValueFormatter(propertyValue);
              } else {
                itemDisplayedData[columnIndex] = propertyValue;
              }
              // property type
              var propertyValueType = tableColumns[columnIndex].propertyType;
              if(propertyValueType == 'String') {
                itemDisplayedData[columnIndex] = "'" + itemDisplayedData[columnIndex] + "'";
              } else if(propertyValueType == 'FormattedDate') {
                itemDisplayedData[columnIndex] = "'" + itemDisplayedData[columnIndex] + "'";
              } else if(propertyValueType == 'FormattedTimeDuration') {
                itemDisplayedData[columnIndex] = "'" + itemDisplayedData[columnIndex] + "'";
              }
            }
          }
          tableRows[index] = itemDisplayedData;
        }
        return tableRows;
      }

      function convertSummaryDataToCSV(tableColumns, tableData, metaData) {
        var columnDelimiter = ';';
        var lineDelimiter = '\n';
        var valueWrapper = "\"";
        var keys = tableColumns;
        var tabData = tableData;
          var data = [];
          data[0] = tabData.totalChargingTime;
          data[1] = tabData.totalChargingQuantity;
          data[2] = tabData.averageChargingConsumedEnergy;
          data[3] = tabData.totalChargingConsumedEnergy;
          data[4] = tabData.averageChargingReturnedEnergy;
          data[5] = tabData.totalChargingReturnedEnergy;
        // collect result
        var result = '';
        // init metadata
        var serializedMetaData = JSON.stringify(metaData);
        // check if serializedMetaData is empty
        if(serializedMetaData != "{}") {
          serializedMetaData = StringUtils.replaceAll(serializedMetaData, ',', ' ::: ');
          result = result + serializedMetaData;
          result = result + lineDelimiter;
          result = result + lineDelimiter;
        }
        // init header
        for(var index = 0; index < keys.length; index++) {
          if(index + 1 == keys.length) {
            result = result + wrapCsvValue(valueWrapper, keys[index].identity);
          } else {
            result = result + wrapCsvValue(valueWrapper, keys[index].identity) + columnDelimiter;
          }
        }
        result = result + lineDelimiter;
        // init content
        for(var columnIndex = 0; columnIndex < tableColumns.length; columnIndex++) {
          if(columnIndex + 1 == tableColumns.length) {
            var propertyValue = data[columnIndex];
            if(propertyValue == undefined) {
              result = result + wrapCsvValue(valueWrapper, "---");
            } else {
              var propertyValueFormatter = tableColumns[columnIndex].formatter;
              // property formatter
              if(propertyValueFormatter != undefined) {
                result = result + wrapCsvValue(valueWrapper, propertyValueFormatter(propertyValue));
              } else {
                result = result + wrapCsvValue(valueWrapper, propertyValue);
              }
            }
          } else {
            var propertyValue = data[columnIndex];
            if(propertyValue == undefined) {
              result = result + wrapCsvValue(valueWrapper, "---") + columnDelimiter;
            } else {
              var propertyValueFormatter = tableColumns[columnIndex].formatter;
              // property formatter
              if(propertyValueFormatter != undefined) {
                result = result + wrapCsvValue(valueWrapper, propertyValueFormatter(propertyValue)) + columnDelimiter;
              } else {
                result = result + wrapCsvValue(valueWrapper, propertyValue) + columnDelimiter;
              }
            }
          }
        }
        result = result + lineDelimiter;
        return result;

      }

      function convertDataToCsv(tableColumns, tableData, metaData) {
        var columnDelimiter = ';';
        var lineDelimiter = '\n';
        var valueWrapper = "\"";
        var keys = tableColumns;
        var data = tableData;
        // collect result
        var result = '';
        // init metadata
        var serializedMetaData = JSON.stringify(metaData);
        // check if serializedMetaData is empty
        if(serializedMetaData != "{}") {
          serializedMetaData = StringUtils.replaceAll(serializedMetaData, ',', ' ::: ');
          result = result + serializedMetaData;
          result = result + lineDelimiter;
          result = result + lineDelimiter;
        }
        // init header
        for(var index = 0; index < keys.length; index++) {
          if(index + 1 == keys.length) {
            result = result + wrapCsvValue(valueWrapper, keys[index].identity);
          } else {
            result = result + wrapCsvValue(valueWrapper, keys[index].identity) + columnDelimiter;
          }
        }
        result = result + lineDelimiter;
        // init content
        for(var index = 0; index < data.length; index++) {
          var item = data[index];
          for(var columnIndex = 0; columnIndex < tableColumns.length; columnIndex++) {
            if(columnIndex + 1 == tableColumns.length) {
              var propertyValue = tableColumns[columnIndex].property(item);
              if(propertyValue == undefined) {
                result = result + wrapCsvValue(valueWrapper, "---");
              } else {
                var propertyValueFormatter = tableColumns[columnIndex].formatter;
                // property formatter
                if(propertyValueFormatter != undefined) {
                  result = result + wrapCsvValue(valueWrapper, propertyValueFormatter(propertyValue));
                } else {
                  result = result + wrapCsvValue(valueWrapper, propertyValue);
                }
              }
            } else {
              var propertyValue = tableColumns[columnIndex].property(item);
              if(propertyValue == undefined) {
                result = result + wrapCsvValue(valueWrapper, "---") + columnDelimiter;
              } else {
                var propertyValueFormatter = tableColumns[columnIndex].formatter;
                // property formatter
                if(propertyValueFormatter != undefined) {
                  result = result + wrapCsvValue(valueWrapper, propertyValueFormatter(propertyValue)) + columnDelimiter;
                } else {
                  result = result + wrapCsvValue(valueWrapper, propertyValue) + columnDelimiter;
                }
              }
            }
          }
          result = result + lineDelimiter;
        }
        return result;
      }

      function wrapCsvValue(valueWrapper, value) {
        return valueWrapper + value + valueWrapper;
      }

    }]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.alerts');
    module.controller('AlertCtrl', ['$controller', '$scope', 'AlertsFactory',
        function($controller, $scope, AlertsFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: AlertsFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(AlertsFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.alerts');
    module.controller('AlertItemCtrl', [
        '$controller',
        '$scope',
        '$stateParams',
        '$state',
        'cfpLoadingBar',
        'PreconditionsUtils',
        'ResourceServerDataService',
        'ErrorUtils',
        'AlertsFactory',
        function($controller, $scope, $stateParams, $state, cfpLoadingBar, PreconditionsUtils, ResourceServerDataService, ErrorUtils, AlertsFactory) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: AlertsFactory
            });

            var errors = [];

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(AlertsFactory.restPath + '/' + $stateParams.databaseId);

            $scope.deleteAlertItem = function(alertData) {
              PreconditionsUtils.checkArgument(alertData != undefined, "alertData argument cannot be undefined", 'Core.ItemViewController', 'save');
              PreconditionsUtils.checkArgument(alertData.id != undefined, "alertData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
              // set hidden
              alertData.hidden = true;
              // invoke promise
              var updateDataPromise = ResourceServerDataService.updateItem(AlertsFactory.viewContext, $scope, AlertsFactory.restPath + '/hide', alertData, AlertsFactory.mainState, AlertsFactory.itemPreSaveAction);
              // progress bar ============
              cfpLoadingBar.start();
              // =========================
              updateDataPromise.then(
                  function(data) {
                      // progress bar ============
                      cfpLoadingBar.complete();
                      // =========================
                      // nav to details page
                      $state.go(AlertsFactory.viewContext.mainState);
                  },
                  function(error) {
                      // progress bar ============
                      cfpLoadingBar.complete();
                      // =========================
                      ErrorUtils.handleError(error, errors);
                  }
              );
            }
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.authorization');
    module.controller('AuthorizationController', ['$rootScope', '$scope', '$translate', '$http', 'MetadataFactory', 'ConfigFactory', 'MetadataService', 'AuthorizationFactory', 'AuthorizationService', 'InteractionsUtils', 'ErrorUtils', function($rootScope, $scope, $translate, $http, MetadataFactory, ConfigFactory, MetadataService, AuthorizationFactory, AuthorizationService, InteractionsUtils, ErrorUtils) {
        this.login = function(authorizationData) {
            var requestData = {
                username: authorizationData.username,
                password: authorizationData.password,
            };
            var promise = $http({
                method: 'POST',
                url: ConfigFactory.proxyServicePath + '/authorize',
                data: requestData
            });
            // start promise
            promise.then(
                function(response) {
                    AuthorizationService.storeAccessToken(response.data, authorizationData.rememberMe);
                },
                function(error) {
                    ErrorUtils.handleDefaultError(error);
                    return Promise.reject(error);
                }
            ).then(
                function() {
                    // discover environment paths
                    var environmentPathPromise = $http({
                        method: 'GET',
                        url: ConfigFactory.proxyServicePath + '/config'
                    });
                    environmentPathPromise.then(
                        function(answer) {
                            ConfigFactory.setPath('/eko-oauth', '/eko');
                            // nav to dashboard when authorized
                            if (AuthorizationService.isAuthorized()) {
                                AuthorizationService.handleAuthorizedUser(true);
                            }
                            else {
                                // display message
                                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), "Authorization failed");
                                return;
                            }
                        },
                        function(error) {
                            ErrorUtils.handleDefaultError(error);
                        }
                    );
                }
            );
        }
        // register methods
        $scope.login = this.login;
    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.authorization');

    module.factory('AuthorizationFactory', ['CookieUtils', 'ConfigFactory', function(CookieUtils, ConfigFactory) {
        var accessTokenContext = initAccessToken();
        // user context
        var permissions = {
          'authorizationId.edit': true
        }
        var userContext = {};
        return {
            accessTokenContext: accessTokenContext,
            userContext: userContext,
            updateAccessToken: function(accessTokenData) {
                accessTokenContext.accessToken = accessTokenData.access_token;
                accessTokenContext.tokenType = accessTokenData.token_type;
                accessTokenContext.expiresIn = accessTokenData.expires_in;
                accessTokenContext.scope = accessTokenData.scope;
            },
            clearAccessToken: function() {
                accessTokenContext.accessToken = undefined;
                accessTokenContext.tokenType = undefined;
                accessTokenContext.expiresIn = undefined;
                accessTokenContext.scope = undefined;
            },
            updateUserContext: function(userData) {
              userContext.email = userData.email;
              userContext.firstName = userData.firstName;
              userContext.lastName = userData.lastName;
              userContext.phone = userData.phone;
              userContext.roles = userData.roles;
            },
            updateUserPermissions: function(permissionsData) {
              userContext.permission = initPermissions(permissionsData);
            },
            clearUserContext: function() {
              userContext.email = undefined;
              userContext.firstName = undefined;
              userContext.lastName = undefined;
              userContext.phone = undefined;
              userContext.roles = undefined;
              userContext.permissions = undefined;
            }
        }

        function initPermissions(privileges) {
           var permissions = {};
           for(var index = 0; index < privileges.length; index++) {
             var privilege = privileges[index];
             permissions[privilege] = true;
           }
           return permissions;
       }

        function initAccessToken() {
          accessTokenContext = {};
          var accessToken = CookieUtils.getCookieValue('access_token');
          if(accessToken != undefined) {
            accessTokenContext.accessToken = accessToken;
          }
          return accessTokenContext;
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.authorization');

    module.service('AuthorizationService', [
      '$rootScope',
      '$http',
      '$translate',
      'AuthorizationFactory',
      'MetadataFactory',
      'MetadataService',
      'CookieUtils',
      'HttpUtils',
      'ConfigFactory',
      'InteractionsUtils',
      'ErrorUtils',
      function($rootScope, $http, $translate, AuthorizationFactory, MetadataFactory, MetadataService, CookieUtils, HttpUtils, ConfigFactory, InteractionsUtils, ErrorUtils) {

        this.logout = function() {
            removeAccessToken();
            InteractionsUtils.changeView('login');
        }

      this.handleAuthorizedUser = function(redirectToDashboard) {
          var self = this;
          self.getUserProfile()
            .then(function(firstResult) {
              $rootScope.userContext = AuthorizationFactory.userContext;
              return self.getUserPermissions();
            }, function(firstException) {
              if(firstException != undefined && firstException.data != undefined && firstException.data.message != undefined) {
                  InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), firstException.data.message);
                  return undefined;
              }
              InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), "Get user profile failed.");
              // redirect to login screen
              InteractionsUtils.changeView('login');
              // stop promise
              return undefined;
            })
            .then(function(secondResult) {
              if(secondResult == undefined) {
                return undefined;
              }
              $rootScope.userContext = AuthorizationFactory.userContext;
              return MetadataService.getMetadata();
            }, function(secondException) {
              if(secondException != undefined && secondException.data != undefined && secondException.data.message != undefined) {
                  InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), secondException.data.message);
                  return undefined;
              }
              if(secondException.status == -1) {
                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'),$translate.instant('ERROR_CONNECTION_REFUSED'));
                return undefined;
              }
              InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('ERROR_FAILED_TO_LOAD_OAUTH'));
              return undefined;
            })
            .then(function(thirdResult) {
              if(thirdResult == undefined) {
                return undefined;
              }
              $rootScope.metadata = MetadataFactory.metadataContext;
              // redirect to dashboard
              if(redirectToDashboard) {
                InteractionsUtils.changeView('Dashboard');
              }
            }, function(thirdException) {
              if(thirdException != undefined && thirdException.data != undefined && thirdException.data.message != undefined) {
                  InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), thirdException.data.message);
                  return undefined;
              }
              InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('ERROR_FAILED_TO_LOAD_METADATA'));
            });
      }

        this.getUserProfile = function(username) {
          var promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.authServicePath, 'rest/user/profile');
          return promise.then(
            function(response) {
              AuthorizationFactory.updateUserContext(response.data);
              return response.data;
            }
          );
        }

        this.getUserPermissions = function() {
          var promise = HttpUtils.prepareHttpGet(ConfigFactory.environmentPaths.resourcesServicePath, 'rest/privilege/user');
          return promise.then(
            function(response) {
              AuthorizationFactory.updateUserPermissions(response.data);
              return response.data;
            }
          );
        }

        this.isAuthorized = function() {
            return AuthorizationFactory.accessTokenContext.accessToken != undefined;
        }

        function removeAccessToken() {
            AuthorizationFactory.clearAccessToken();
            CookieUtils.removeCookieValue('access_token');
            AuthorizationFactory.clearUserContext();
        }

        this.storeAccessToken = function(accessTokenData, rememberMe) {
            // store
            AuthorizationFactory.updateAccessToken(accessTokenData);
            // check if save in cookies
            if(rememberMe) {
              CookieUtils.setCookieValue('access_token', accessTokenData.access_token, 7);
            } else {
              CookieUtils.removeCookieValue('access_token');
            }
        }

    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.authorization');
    module.controller('ForgotPasswordController', ['$rootScope', '$scope', '$translate', '$http', 'MetadataService', 'AuthorizationFactory', 'AuthorizationService', 'InteractionsUtils', 'ConfigFactory', function($rootScope, $scope, $translate, $http, MetadataService, AuthorizationFactory, AuthorizationService, InteractionsUtils, ConfigFactory) {
        $scope.restore = function(authorizationData) {
            if(authorizationData != undefined) {
                if(authorizationData.username != undefined) {
                    if(ConfigFactory.environmentPaths.authServicePath != undefined) {
                        var url = ConfigFactory.environmentPaths.authServicePath + '/open/user/resetPassword?email=' + authorizationData.username;
                        var headers = {
                            Accept: 'text/plain'
                        };
                        var promise = $http({
                            method: 'POST',
                            headers: headers,
                            url: encodeURI(url),
                            transformResponse: function(response)
                            {
                                return response;
                            }
                        });
                        promise.then(function(response) {
                            if(response.data != 'RESET_PASSWORD_EMAIL__VALID') {
                                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("LOGIN__INVALID_EMAIL"));
                            } else {
                                InteractionsUtils.changeView('login', InteractionsUtils.openInfoDialog($translate.instant('DIALOG__SUCCESS_TITLE'), $translate.instant('LOGIN__FORGOT_PASSWORD_CONFIRMATION')));
                            }
                            return;
                        }, function(reason) {
                            if(reason.status === 200)
                                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("LOGIN__INVALID_EMAIL"));
                            else
                                InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('ERROR_CONNECTION_REFUSED'));
                            return;
                        });
                    } else {
                      // discover environment paths
                        var environmentPathPromise = $http({
                            method: 'GET',
                            url: ConfigFactory.proxyServicePath + '/config'
                        });
                        environmentPathPromise.then(
                            function(answer) {
                                ConfigFactory.setPath('/eko-oauth', '/eko');
                            },
                            function(error) {
                                ErrorUtils.handleDefaultError(error);
                                return Promise.reject(error);
                            }
                        ).then(function() {
                                var url = ConfigFactory.environmentPaths.authServicePath + '/open/user/resetPassword?email=' + authorizationData.username;
                                var promise = $http({
                                    method: 'POST',
                                    url: encodeURI(url),
                                    transformResponse: function(response)
                                    {
                                        return response;
                                    }
                                });
                                promise.then(function(response) {
                                    if(response.data != 'RESET_PASSWORD_EMAIL__VALID') {
                                        if(response.status === 200)
                                            InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("LOGIN__INVALID_EMAIL"));
                                        else
                                            InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('ERROR_CONNECTION_REFUSED'));
                                    } else {
                                        InteractionsUtils.changeView('login', InteractionsUtils.openInfoDialog($translate.instant('DIALOG__SUCCESS_TITLE'), $translate.instant('LOGIN__FORGOT_PASSWORD_CONFIRMATION')));
                                    }
                                    return;
                                }, function(reason) {
                                    if(reason.status === 200)
                                        InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("LOGIN__INVALID_EMAIL"));
                                    else
                                        InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('ERROR_CONNECTION_REFUSED'));
                                    return;
                                });
                        });
                    }
                }
            }
        }
    }]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.authorization');
    module.controller('ResetPasswordController', ['$rootScope', '$scope', '$stateParams', '$translate', '$http', 'AuthorizationFactory', 'AuthorizationService', 'InteractionsUtils', 'HttpUtils', 'ConfigFactory', function($rootScope, $scope, $stateParams, $translate, $http, AuthorizationFactory, AuthorizationService, InteractionsUtils, HttpUtils, ConfigFactory) {
        initCheckToken();
        var valid = false;
        var token = $stateParams.token;
        var uid = $stateParams.id;

        function initCheckToken() {
            var token = $stateParams.token;
            var uid = $stateParams.id;
            if(ConfigFactory.environmentPaths.authServicePath != undefined) {
              var url = ConfigFactory.environmentPaths.authServicePath + '/open/user/validateToken?uid=' + uid + '&token=' + token;
              var headers = {
                  Accept: 'text/plain'
              };
              var promise = $http({
                  method: 'GET',
                  headers: headers,
                  url: url,
              });
              promise.then(function(response) {
                  if(response.data != 'RESET_PASSWORD_TOKEN__VALID') {
                      if((response.data == 'RESET_PASSWORD_TOKEN__INVALID') || (response.data == 'RESET_PASSWORD_TOKEN__EXPIRED')) {
                          InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant(response.data)));
                      } else {
                          InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("RESET_PASSWORD_TOKEN__ERROR")));
                      }
                  }
              }, function(reason) {
                  InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("RESET_PASSWORD_TOKEN__ERROR")));
              });
              return undefined;
            } else {
              // discover environment paths
              var environmentPathPromise = $http({
                  method: 'GET',
                  url: ConfigFactory.proxyServicePath + '/config'
              });
              environmentPathPromise.then(
                function(answer) {
                  ConfigFactory.setPath('/eko-oauth', '/eko');
                },
                function(error) {
                  ErrorUtils.handleDefaultError(error);
                  return Promise.reject(error);
                }
              ).then(
                function() {
                  var url = ConfigFactory.environmentPaths.authServicePath + '/open/user/validateToken?uid=' + uid + '&token=' + token;
                  var headers = {
                      Accept: 'text/plain'
                  };
                  var promise = $http({
                      method: 'GET',
                      headers: headers,
                      url: url,
                  });
                  promise.then(function(response) {
                      if(response.data != 'RESET_PASSWORD_TOKEN__VALID') {
                          if((response.data == 'RESET_PASSWORD_TOKEN__INVALID') || (response.data == 'RESET_PASSWORD_TOKEN__EXPIRED')) {
                              InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant(response.data)));
                          } else {
                              InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("RESET_PASSWORD_TOKEN__ERROR")));
                          }
                      }
                  }, function(reason) {
                      InteractionsUtils.changeView('login', InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("RESET_PASSWORD_TOKEN__ERROR")));
                  });
                  return undefined;
                }
              );
            }
        }
        this.changePassword = function(authorizationData) {
            if(authorizationData != undefined) {
                if(authorizationData.password != undefined) {
                    token = $stateParams.token;
                    uid = $stateParams.id;
                    var url = ConfigFactory.environmentPaths.authServicePath + '/open/user/changePassword?uid=' + uid + '&token=' + token + '&newPassword=' + authorizationData.password;
                    var promise = $http({
                        method: 'POST',
                        url: encodeURI(url),
                    });
                    return promise.then(
                        function(response) {
                            InteractionsUtils.changeView('login', InteractionsUtils.openInfoDialog($translate.instant('DIALOG__SUCCESS_TITLE'), 'Password changed correctly'));
                        },
                        function(error) {
                            InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant("RESET_PASSWORD__ERROR"));
                        }
                    );
                }
            }
        }
        $scope.changePassword = this.changePassword;

    }]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargeboxgroup');

    module.controller('ChargeBoxGroupCtrl', ['$controller', '$scope', 'ChargeBoxGroupFactory',
        function($controller, $scope, ChargeBoxGroupFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxGroupFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxGroupFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargeboxgroup');
    module.controller('ChargeBoxGroupItemCtrl', [
        '$controller',
        '$scope',
        '$stateParams',
        'ChargeBoxGroupFactory',
        function($controller, $scope, $stateParams, ChargeBoxGroupFactory) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: ChargeBoxGroupFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxGroupFactory.restPath + '/' + $stateParams.databaseId);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargingprofiles');

    module.controller('ChargingProfilesCtrl', ['$controller', '$scope', 'ChargingProfilesFactory',
        function($controller, $scope, ChargingProfilesFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargingProfilesFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargingProfilesFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargingprofiles');
    module.controller('ChargingProfilesItemCtrl', [
        '$controller',
        '$scope',
        'ChargingProfilesFactory',
        function($controller, $scope, ChargingProfilesFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: ChargingProfilesFactory
            });

            $scope.addSchedulePeriod = function() {
              if($scope.itemData.chargingSchedule.chargingSchedulePeriod == undefined) {
                $scope.itemData.chargingSchedule.chargingSchedulePeriod = [];
              }
              $scope.itemData.chargingSchedule.chargingSchedulePeriod.push({
                'startPeriod': 0,
                'limit': 1000,
                'numberPhases': 3
              });
            }

            $scope.removeSchedulePeriod = function(index) {
              $scope.itemData.chargingSchedule.chargingSchedulePeriod.splice(index, 1);
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.dashboard');

    module.controller('DashboardController', [
      '$controller',
      '$scope',
      'DashboardFactory',
      'ConfigFactory',
      'CookieUtils',
      'InteractionsUtils',
      'ArrayUtils',
      'DateUtils',
      function($controller, $scope, DashboardFactory, ConfigFactory, CookieUtils, InteractionsUtils, ArrayUtils, DateUtils) {
           $controller('Core.ListDisabledPaginationController',
           { $scope: $scope,
             ViewFactory: DashboardFactory
           });

           // overrided parent methods
           $scope.initStartAdditions = initStartAdditions;

            // register user action functions
            $scope.expandChargeBoxGroup = expandChargeBoxGroup;
            $scope.hideChargeBoxGroup = hideChargeBoxGroup;
            $scope.navToChargeBoxDetails = navToChargeBoxDetails;
            $scope.millisecondsToStrTimeInterval = DateUtils.millisecondsToStrTimeInterval;
            $scope.displayCommunicationProtocol = ConfigFactory.viewSettings['display.dashboard.chargebox_communication_protocol'];
            if ($scope.displayCommunicationProtocol == undefined) {
              $scope.displayCommunicationProtocol = false;
            }
            // consts
            var dashboardCookieId = 'dashboard_expanded_groups';

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(DashboardFactory.viewContext.restPath);

            // =====================================================================
            // Implementation
            // =====================================================================

            function initStartAdditions() {
                var expandedGroups = CookieUtils.getCookieValue('dashboard_expanded_groups');
                if (expandedGroups == undefined || expandedGroups.length == 0) {
                    return;
                }
                for (var index = 0; index < $scope.itemsData.length; index++) {
                    var groupData = $scope.itemsData[index];
                    if(expandedGroups.indexOf(groupData.chargeBoxGroupName) != -1) {
                      groupData.expanded = true;
                    }
                }
            }

            function expandChargeBoxGroup(groupSummary) {
               groupSummary.expanded = true;
               // cookie support
               var expandedGroups = CookieUtils.getCookieValue(dashboardCookieId);
               if(expandedGroups == undefined || expandedGroups.length == 0) {
                 CookieUtils.setCookieValue(dashboardCookieId, JSON.stringify([groupSummary.chargeBoxGroupName]), 7);
                 return;
               }
               expandedGroups = expandedGroups + groupSummary.chargeBoxGroupName + ";";
               CookieUtils.setCookieValue(dashboardCookieId, expandedGroups, 7);
             }

             function hideChargeBoxGroup(groupSummary) {
               groupSummary.expanded = false;
               // cookie support
               var expandedGroups = CookieUtils.getCookieValue(dashboardCookieId);
               if(expandedGroups == undefined || expandedGroups.length == 0) {
                 return;
               }
               expandedGroups = expandedGroups.replace(groupSummary.chargeBoxGroupName, '');
               CookieUtils.setCookieValue(dashboardCookieId, expandedGroups, 7);
             }

             function navToChargeBoxDetails(status, databaseId) {
               if(status == 'ERROR') {
                 InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, { 'state': 'ERROR', 'databaseId': databaseId});
               } else if(status == 'CHARGING') {
                 InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, { 'state': 'CHARGING', 'databaseId': databaseId});
               } else if(status == 'WARNING') {
                 InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, { 'state': 'WARNING', 'databaseId': databaseId});
               } else if(status == 'ONLINE') {
                 InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, { 'state': 'ONLINE', 'databaseId': databaseId});
               } else if(status == 'OFFLINE') {
                 InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, { 'state': 'OFFLINE', 'databaseId': databaseId});
               }
             }

        }]);

})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('ChargeBoxConsumedEnergyReportCtrl', ['$controller', '$scope', 'ChargeBoxConsumedEnergyReportFactory',
        function($controller, $scope, ChargeBoxConsumedEnergyReportFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxConsumedEnergyReportFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxConsumedEnergyReportFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('ChargeBoxGroupConsumedEnergyReportCtrl', ['$controller', '$scope', 'ChargeBoxGroupConsumedEnergyReportFactory',
        function($controller, $scope, ChargeBoxGroupConsumedEnergyReportFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxGroupConsumedEnergyReportFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxGroupConsumedEnergyReportFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('ReportTemplatesCtrl', ['$controller', '$scope', '$rootScope', '$translate', 'InteractionsUtils', 'CookieUtils', 'ResourceServerDataService', 'ReportTemplatesFactory',
        function($controller, $scope, $rootScope, $translate, InteractionsUtils, CookieUtils, ResourceServerDataService, ReportTemplatesFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ReportTemplatesFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ReportTemplatesFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('ReportTemplatesDetailsCtrl', ['$controller', '$scope', '$stateParams', 'ReportTemplatesDetailsFactory',
        function($controller, $scope, $stateParams, ReportTemplatesDetailsFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ReportTemplatesDetailsFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ReportTemplatesDetailsFactory.viewContext.restPath + '/' + $stateParams.databaseId);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.reports');
    module.controller('ReportTemplatesItemCtrl', [
        '$controller',
        '$scope',
        'ReportTemplatesFactory',
        function($controller, $scope, ReportTemplatesFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: ReportTemplatesFactory
            });

            var availableVehiclesCopy = undefined;
            var availableChargeBoxesCopy = undefined;
            var reportElementsCopy = undefined;

            $scope.addAll = addAll;
            $scope.addSelected = addSelected;
            $scope.removeSelected = removeSelected;
            $scope.deselectAll = deselectAll;
            $scope.selectListItem = selectListItem;
            $scope.clearElements = clearElements;

            $scope.initStartAdditions = function() {
              if($scope.itemData.reportElementsArray == undefined) {
                $scope.itemData.reportElementsArray = [];
              }
              if($scope.itemData.vehicles == undefined) {
                $scope.itemData.vehicles = [];
              }
              if($scope.itemData.chargeBoxes == undefined) {
                $scope.itemData.chargeBoxes = [];
              }
              if($scope.itemData.reportElements != undefined) {
                $scope.itemData.reportElementsArray = $scope.itemData.reportElements.split(', ');
              }
              availableVehiclesCopy = [];
              for(var index = 0; index < $scope.itemData.vehicles.length; index++) {
                availableVehiclesCopy[index] = $scope.itemData.vehicles[index];
              }
              availableChargeBoxesCopy = [];
              for(var index = 0; index < $scope.itemData.chargeBoxes.length; index++) {
                availableChargeBoxesCopy[index] = $scope.itemData.chargeBoxes[index];
              }
              reportElementsCopy = [];
              for(var index = 0; index < $scope.itemData.reportElementsArray.length; index++) {
                reportElementsCopy[index] = $scope.itemData.reportElementsArray[index];
              }
              if($scope.itemData.reportType != undefined && $scope.itemData.reportType == 'Vehicles') {
                var indexToRemove = [];
                for(var index = 0; index < $scope.itemData.reportElementsArray.length; index++) {
                  for(var vehicleIndex = 0; vehicleIndex < $scope.itemData.vehicles.length; vehicleIndex++) {
                    if($scope.itemData.reportElementsArray[index] == $scope.itemData.vehicles[vehicleIndex]) {
                      indexToRemove.push(vehicleIndex);
                      break;
                    }
                  }
                }
                var numberToRemove = indexToRemove.length
                for(var toRemoveIndex = 0; toRemoveIndex < indexToRemove.length; toRemoveIndex++) {
                   $scope.itemData.vehicles.splice(indexToRemove[toRemoveIndex], numberToRemove);
                   numberToRemove--;
                }
              } else if($scope.itemData.reportType != undefined && $scope.itemData.reportType == 'ChargeBoxes'){
                var indexToRemove = [];
                for(var index = 0; index < $scope.itemData.reportElementsArray.length; index++) {
                  for(var chargeBoxIndex = 0; chargeBoxIndex < $scope.itemData.chargeBoxes.length; chargeBoxIndex++) {
                    if($scope.itemData.reportElementsArray[index] == $scope.itemData.chargeBoxes[chargeBoxIndex]) {
                      indexToRemove.push(chargeBoxIndex);
                      break;
                    }
                  }
                }
                for(var toRemoveIndex = indexToRemove.length -1; toRemoveIndex >= 0; toRemoveIndex--) {
                   $scope.itemData.chargeBoxes.splice(indexToRemove[toRemoveIndex], 1);
                }
              }
            }

            function clearElements() {
              $scope.itemData.reportElementsArray = [];
            }

            function addAll() {
              if($scope.itemData.reportType == undefined) {
                return;
              }
              $scope.itemData.reportElementsArray = [];
              if($scope.itemData.reportType == 'Vehicles') {
                $scope.itemData.vehicles = [];
                for(var index = 0; index < availableVehiclesCopy.length; index++) {
                  $scope.itemData.reportElementsArray.push(availableVehiclesCopy[index]);
                }
              } else if($scope.itemData.reportType == 'ChargeBoxes') {
                $scope.itemData.chargeBoxes = [];
                for(var index = 0; index < availableChargeBoxesCopy.length; index++) {
                  $scope.itemData.reportElementsArray.push(availableChargeBoxesCopy[index]);
                }
              }
            }

            function deselectAll() {
              if($scope.itemData.reportType == undefined) {
                return;
              }
              
              $scope.itemData.reportElementsArray = [];
              if($scope.itemData.reportType == 'Vehicles') {
                $scope.itemData.vehicles = [];
                for(var index = 0; index < availableVehiclesCopy.length; index++) {
                  $scope.itemData.vehicles.push(availableVehiclesCopy[index]);
                }
              } else if($scope.itemData.reportType == 'ChargeBoxes') {
                $scope.itemData.chargeBoxes = [];
                for(var index = 0; index < availableChargeBoxesCopy.length; index++) {
                  $scope.itemData.chargeBoxes.push(availableChargeBoxesCopy[index]);
                }
              }
            }

            function addSelected() {
              if($scope.itemData.reportType == undefined) {
                return;
              }
              var availableElements = undefined;
              var itemDataAvailableElements = undefined;
              if($scope.itemData.reportType == 'Vehicles') {
                availableElements = document.getElementById('availableVehicles').getElementsByTagName("li");
                itemDataAvailableElements = $scope.itemData.vehicles;
              }
              if($scope.itemData.reportType == 'ChargeBoxes') {
                availableElements = document.getElementById('availableChargeBoxes').getElementsByTagName("li");
                itemDataAvailableElements = $scope.itemData.chargeBoxes;
              }
              var indexToAdd = [];
              for(var index = 0; index < availableElements.length; index++) {
                  var availableElement = availableElements[index];
                  if(availableElement.classList != undefined && availableElement.classList.contains('selectedListItem')) {
                    indexToAdd.push(index);
                  }
              }
              for(var index = 0; index < indexToAdd.length; index++) {
                var elementToAdd = itemDataAvailableElements.splice(indexToAdd[index], 1);
                $scope.itemData.reportElementsArray.unshift(elementToAdd[0]);
              }
            }

            function removeSelected() {
              if($scope.itemData.reportType == undefined) {
                return;
              }
              if($scope.itemData.rolePrivileges == undefined) {
                $scope.itemData.rolePrivileges = [];
              }
              var itemDataAvailableElements = undefined;
              if($scope.itemData.reportType == 'Vehicles') {
                itemDataAvailableElements = $scope.itemData.vehicles;
              }
              if($scope.itemData.reportType == 'ChargeBoxes') {
                itemDataAvailableElements = $scope.itemData.chargeBoxes;
              }
              var availablePrivileges = document.getElementById('selectedElements').getElementsByTagName("li");
              var indexToRemove = [];
              for(var index = 0; index < availablePrivileges.length; index++) {
                  var availableElement = availablePrivileges[index];
                  if(availableElement.classList != undefined && availableElement.classList.contains('selectedListItem')) {
                    indexToRemove.push(index);
                  }
              }
              for(var index = 0; index < indexToRemove.length; index++) {
                var elementsToRemove = $scope.itemData.reportElementsArray.splice(indexToRemove[index], 1);
                itemDataAvailableElements.unshift(elementsToRemove[0]);
              }
            }

            function selectListItem(listIdentity, $event) {
              if($scope.itemData.reportType == undefined) {
                return;
              }
              // check if selected
              if($event.currentTarget.classList != undefined && $event.currentTarget.classList.contains('selectedListItem')) {
                $event.currentTarget.classList.remove('selectedListItem');
                return;
              }
              // find all available elements and remove selectedListItem class
              var listElements = document.getElementById(listIdentity).getElementsByTagName("li");
              for(var index = 0; index < listElements.length; index++) {
                  var element = listElements[index];
                  if(element.classList != undefined && element.classList.contains('selectedListItem')) {
                    element.classList.remove('selectedListItem');
                  }
              }
              // add selection
              $event.currentTarget.classList.add('selectedListItem');
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('TransactionsReportCtrl', ['$controller', '$scope', '$rootScope', '$translate', 'InteractionsUtils', 'CookieUtils', 'ResourceServerDataService', 'ChargingTransactionReportFactory',
        function($controller, $scope, $rootScope, $translate, InteractionsUtils, CookieUtils, ResourceServerDataService, ChargingTransactionReportFactory) { 
            $controller('Core.ListDisabledPaginationController', {
                $scope: $scope,
                ViewFactory: ChargingTransactionReportFactory
            });

            $scope.initStartAdditions = initStartAdditions;

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView();

            $scope.exportData = function() {
              var downloadPromise = ResourceServerDataService.downloadFile(ChargingTransactionReportFactory.viewContext.restPath + 'download/' + $rootScope.appLanguage, ChargingTransactionReportFactory.viewContext, ChargingTransactionReportFactory.searchCriteriaPostContruct($scope.searchCriteriaData), 'application/zip', 'zip');
              downloadPromise.then(
                  function(success) {
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('EXPORT_FILE_WAS_DOWNLOADED'), 5000);
                  },
                  function(error) {
                    // reset search criteria
                    for (var key in $scope.searchCriteriaData) {
                        $scope.searchCriteriaData[key] = undefined;
                    }
                    CookieUtils.setCookieValue(ChargingTransactionReportFactory.viewContext.identity + "_searchCriteria", undefined, 365);
                    // display dialog
                    InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
                  }
              );
            }

            $scope.exportXLSXData = function() {
                var restPath = ChargingTransactionReportFactory.viewContext.restPath + 'summaryreport/' + $rootScope.appLanguage;
                ChargingTransactionReportFactory.searchCriteriaPostContruct($scope.searchCriteriaData);
                ResourceServerDataService.downloadFile(restPath, ChargingTransactionReportFactory.viewContext, ChargingTransactionReportFactory.searchCriteriaPostContruct($scope.searchCriteriaData), "undefined", "zip");
            }

            function initStartAdditions() {
              $scope.searchCriteriaData.vehicleSideNumbers = ['Wszystkie'];
              // load view metadata
              var viewMetadataPromise = ResourceServerDataService.loadViewMetadataPromise(ChargingTransactionReportFactory.viewContext, $scope, ChargingTransactionReportFactory.viewContext.viewMetadataRestPath);
              return viewMetadataPromise.then(
                  function(answer) {
                      $scope.viewMetadata = answer;
                      $scope.viewMetadata.searchFieldsValues.vehicleSideNumbers.unshift('Wszystkie');
                  }
              );
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.reports');

    module.controller('VehicleConsumedEnergyReportCtrl', ['$controller', '$scope', 'VehicleConsumedEnergyReportFactory',
        function($controller, $scope, VehicleConsumedEnergyReportFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: VehicleConsumedEnergyReportFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(VehicleConsumedEnergyReportFactory.viewContext.restPath);
        }
    ]);
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/',
        chargePoints: 'assets/img/charge-point/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    'use strict';
    var module = angular.module('BlurAdmin.transactions');
    module.controller('TransactionItemCtrl', [
       '$controller',
       '$scope',
       '$rootScope',
       '$stateParams',
       '$translate',
       'ConfigFactory',
       'InteractionsUtils',
       'ChartUtils',
       'DateUtils',
       'ResourceServerDataService',
       'TransactionFactory',
        function($controller, $scope, $rootScope, $stateParams, $translate, ConfigFactory, InteractionsUtils, ChartUtils, DateUtils, ResourceServerDataService, TransactionFactory) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: TransactionFactory
            });
            // =====================================================================
            // actions available in view
            // =====================================================================
            $scope.exportTransactionDataCsv = exportTransactionDataCsv;
            $scope.consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
            if ($scope.consumedEnergyUnit == undefined) {
              $scope.consumedEnergyUnit = '[Wh]';
            }
            $scope.displayDetailsConsumedEnergy = ConfigFactory.viewSettings['display.transactions_details.consumed_energy'];
            if ($scope.displayDetailsConsumedEnergy == undefined) {
                $scope.displayDetailsConsumedEnergy = false;
            }
            // =====================================================================
            // override functions
            // =====================================================================
            $scope.initStartAdditions = initStartAdditions;
            $scope.initReloadAdditions = initReloadAdditions;
            // =====================================================================
            // variables available from view
            // =====================================================================
            $scope.displayedCharts = TransactionFactory.viewContext.displayedCharts;
            $scope.transactionData = {};
            // =====================================================================
            // internal state
            // =====================================================================
            var charts = {};
            var chartsZoomData = {};
            var updatingCharts = false;
            var prefixedChartsGraphColors = ["#006600", "#FF6600", "#B0DE09", "#167bc1", "#FCD202"];

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(TransactionFactory.restPath + '/' + $stateParams.databaseId);

            // =====================================================================
            // implementation
            // =====================================================================
            function exportTransactionDataCsv() {
              var downloadPromise = ResourceServerDataService.downloadFile(TransactionFactory.viewContext.restPath + '/download/' + $scope.itemData.transactionId + "/" + $rootScope.appLanguage, TransactionFactory.viewContext, undefined, 'text/csv', 'csv');
              downloadPromise.then(
                  function(success) {
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('EXPORT_FILE_WAS_DOWNLOADED'), 5000);
                  },
                  function(error) {
                    // display dialog
                    InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
                  }
              );
            }

            // =====================================================================
            // additions
            // =====================================================================
            function initStartAdditions() {
            debugger;

                $scope.convert = "W";
                if ($scope.itemData.actualState != null) {
                    for (var meterValue = 0; meterValue < $scope.itemData.actualState.meterValues.length; meterValue++) {
                        for (var item = 0; item < $scope.itemData.actualState.meterValues[meterValue].meterValueItems.length; item++) {
                            if ("MAX_POWER" == $scope.itemData.actualState.meterValues[meterValue].meterValueItems[item].measurand) {
                                if ($scope.itemData.actualState.meterValues[meterValue].meterValueItems[item].meterValue > 0) {
                                    $scope.convert = "kW";
                                    break;
                                }
                            }
                        }
                    }
                }

                // consumed energy
                if($scope.itemData.actualState.consumedEnergy != undefined) {
                  $scope.itemData.actualState.consumedEnergy = Math.round($scope.itemData.actualState.consumedEnergy);
                }
                // returned energy
                if($scope.itemData.actualState.returnedEnergy != undefined) {
                  $scope.itemData.actualState.returnedEnergy = Math.round($scope.itemData.actualState.returnedEnergy);
                }
                // generate charts data
                var chartsData = ChartUtils.generateChartData(TransactionFactory.viewContext.visibleCharts, $scope.itemData.actualState.meterValues, $scope.convert);
                // init charts
                var initChartsPromise = ChartUtils.initCharts(showNotEmptyCharts(chartsData), charts, chartsData, prefixedChartsGraphColors, undefined, [$translate.instant('COMMONS__CHARGE_BOX') + "_" + $scope.itemData['chargeBoxName'], $translate.instant('COMMONS__TRANSACTION') + "_" + $scope.itemData['transactionId']]);
                initChartsPromise.then(
                  function(data) {
                    for(var key in charts) {
                      var chart = charts[key];
                      chart.addListener("zoomed", handleZoom);
                    }
                  }
                );
            }

            function initReloadAdditions() {
              if($scope.itemData.stopTimestamp != undefined) {
                return;
              }
              // consumed energy
              if($scope.itemData.consumedEnergy != undefined) {
                $scope.itemData.consumedEnergy = Math.round($scope.itemData.consumedEnergy);
              }
              // returned energy
              if($scope.itemData.returnedEnergy != undefined) {
                $scope.itemData.returnedEnergy = Math.round($scope.itemData.returnedEnergy);
              }
              updatingCharts = true;
              // generate charts data
              var chartsData = ChartUtils.generateChartData(TransactionFactory.viewContext.visibleCharts, $scope.itemData.actualState.meterValues);
              // clear charts
              ChartUtils.clearCharts(TransactionFactory.viewContext.visibleCharts, charts);
              // update charts
              updateCharts(chartsData);
            }

            function updateCharts(chartsData) {
              var notEmptyCharts = showNotEmptyCharts(chartsData);
              for (var visibleChartIndex = 0; visibleChartIndex < notEmptyCharts.length; visibleChartIndex++) {
                var visibleChart = notEmptyCharts[visibleChartIndex];
                if(chartsData[visibleChart.label] != undefined) {
                  var chart = charts[visibleChart.label];
                  var chartData = chartsData[visibleChart.label];
                  for(var chartDataEntryIndex = 0; chartDataEntryIndex < chartData.length; chartDataEntryIndex++) {
                    chart.dataProvider.push(chartData[chartDataEntryIndex]);
                  }
                  chart.validateData();
                  var chartZoomData = chartsZoomData[visibleChart.label];
                  if(chartZoomData != undefined) {
                    chart.zoomToIndexes(chartZoomData.startIndex, chartZoomData.endIndex);
                  }
                }
              }
              updatingCharts = false;
            }

            function showNotEmptyCharts(chartsData) {
              $scope.displayedCharts = [];
              var notEmptyCharts = [];
              for(var index = 0; index < TransactionFactory.viewContext.visibleCharts.length; index++) {
                var expectedChart = TransactionFactory.viewContext.visibleCharts[index];
                var chartDataEntries = chartsData[expectedChart.label];
                if(chartDataEntries != undefined && chartDataEntries.length > 0) {
                  notEmptyCharts.push(expectedChart);
                  $scope.displayedCharts.push(expectedChart.label);
                }
              }
              return notEmptyCharts;
            }

            function handleZoom(event) {
              if(!updatingCharts) {
                chartsZoomData[event.chart.div.id] = {
                  'startIndex': event.startIndex,
                  'endIndex': event.endIndex
                }
              }
            }

            $scope.$on("$destroy", function() {
                ChartUtils.destroyCharts(charts);
            });

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.transactions');

    module.controller('TransactionsCtrl', ['$controller', '$scope', 'TransactionFactory',
        function($controller, $scope, TransactionFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: TransactionFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(TransactionFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    angular.module('BlurAdmin.userprofile')
        .controller('UserProfileController', ['$rootScope', '$scope', '$window', '$translate', 'CookieUtils', function($rootScope, $scope, $window, $translate, CookieUtils) {

            $scope.changeLanguage = changeLanguage;
            $scope.selectedLanguage = $rootScope.appLanguage;
            $scope.availableLanguages = $translate.getAvailableLanguageKeys();

            function changeLanguage(languageSymbol) {
                // save language to cookies
                CookieUtils.setCookieValue('ocpp_app_language', languageSymbol, 365);
                // reload view
                $window.location.reload();
            }

        }]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.vehicle');

    module.controller('VehicleCtrl', ['$controller', '$scope', 'VehicleFactory',
        function($controller, $scope, VehicleFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: VehicleFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(VehicleFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.vehicle');
    module.controller('VehicleItemCtrl', [
        '$controller',
        '$scope',
        '$stateParams',
        'VehicleFactory',
        function($controller, $scope, $stateParams, VehicleFactory) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: VehicleFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(VehicleFactory.restPath + '/' + $stateParams.databaseId);
        }
    ]);
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.coreview')
        .controller('Core.EditableSingleItemController', [
            '$scope',
            'ViewFactory',
            '$rootScope',
            '$state',
            '$stateParams',
            '$interval',
            'cfpLoadingBar',
            'PreconditionsUtils',
            'InteractionsUtils',
            'ErrorUtils',
            'DateUtils',
            'ResourceServerDataService',
            function($scope, ViewFactory, $rootScope, $state, $stateParams, $interval, cfpLoadingBar, PreconditionsUtils, InteractionsUtils, ErrorUtils, DateUtils, ResourceServerDataService) {
                // register functions available in view
                $scope.startView = startView;
                $scope.formatDate = DateUtils.formatDate;
                $scope.millisecondsToStrTimeInterval = DateUtils.millisecondsToStrTimeInterval;
                $scope.secondsToStrTimeInterval = DateUtils.secondsToStrTimeInterval;
                $scope.changeView = InteractionsUtils.changeView;
                $scope.save = save;
                $scope.reset = reset;
                $scope.cancel = cancel;
                // methods to override
                $scope.initStartAdditions = initStartAdditions;
                $scope.preSaveAction = preSaveAction;
                $scope.editableItemRestPath = ViewFactory.restPath + '/' + $stateParams.databaseId + '/edit';
                // internal state
                var errors = [];

                // invoke at controller start
                $scope.startView();

                function startView() {
                    // check permissions
                    if($rootScope.userContext == undefined || $rootScope.userContext.roles == undefined || $rootScope.userContext.roles.length == 0 || $rootScope.userContext.permission == undefined || $rootScope.userContext.permission.length == 0) {
                      InteractionsUtils.changeView('missingPermissions');
                      return;
                    }
                    // reset
                    $scope.itemData = undefined;
                    // init new item
                    var itemPromise = undefined;
                    if ($stateParams.databaseId == undefined) {
                      itemPromise = ResourceServerDataService.initNewItem(ViewFactory.viewContext, $scope, ViewFactory.restPath, ViewFactory.loadItemPostConstruct);
                    }
                    // init editable item
                    else {
                      itemPromise = ResourceServerDataService.loadEditableItemData(ViewFactory.viewContext, $scope, $scope.editableItemRestPath, ViewFactory.loadEditableItemPostConstruct);
                    }
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    itemPromise.then(
                        function(answer) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            $scope.initStartAdditions($scope.itemData);
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                            return Promise.reject(error);
                        }
                    );
                }

                function initStartAdditions(itemData) {
                  // empty
                }

                function preSaveAction(itemData) {
                  // empty
                }

                function reset() {
                    startView();
                }

                function cancel() {
                  // reset
                  $scope.itemData = undefined;
                  // back to list
                  InteractionsUtils.changeView(ViewFactory.mainState, undefined, undefined, undefined);
                }

                function save(itemData) {
                    PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'save');

                    $scope.preSaveAction(itemData);
                    var itemPromise = undefined;
                    if ($stateParams.databaseId == undefined) {
                        itemPromise = ResourceServerDataService.saveItem(ViewFactory.viewContext, $scope, ViewFactory.restPath, itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                    } else {
                        itemPromise = ResourceServerDataService.updateItem(ViewFactory.viewContext, $scope, ViewFactory.restPath, itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                    }
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    itemPromise.then(
                      function(success) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                      },
                      function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                      }
                    );
                }

            }
        ]);

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.coreview')
        .controller('Core.SendRequestController', [
            '$scope',
            'ViewFactory',
            '$state',
            '$stateParams',
            '$interval',
            'cfpLoadingBar',
            'PreconditionsUtils',
            'InteractionsUtils',
            'ErrorUtils',
            'DateUtils',
            'ResourceServerDataService',
            function($scope, ViewFactory, $state, $stateParams, $interval, cfpLoadingBar, PreconditionsUtils, InteractionsUtils, ErrorUtils, DateUtils, ResourceServerDataService) {

                $scope.initNewItemRestPath = ViewFactory.viewContext.rest16Path  + '/' + $stateParams.databaseId + '/new';
                $scope.sendRequest = sendRequest;
                $scope.itemData = {};
                // methods to override
                $scope.initStartAdditions = initStartAdditions;
                $scope.requestPreconditions = requestPreconditions;
                // internal state
                var errors = [];

                // invoke at controller start
                initItem();

                function initItem() {
                    // reset
                    $scope.itemData = undefined;
                    // init new item
                    var itemDataPromise = ResourceServerDataService.initNewRequestDataItem($scope, $scope.initNewItemRestPath, ViewFactory.loadItemPostConstruct);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    itemDataPromise.then(
                      function(success) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          $scope.initStartAdditions($scope.itemData);
                      },
                      function(error) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          ErrorUtils.handleError(error, errors);
                      }
                    );
                }

                function sendRequest(requestData) {
                    if(!$scope.requestPreconditions()) {
                      return;
                    }
                    // clear previous response
                    $scope.itemData.response = undefined;
                    // send request
                    var requestPromise = ResourceServerDataService.sendRequestData($scope, ViewFactory.viewContext.rest16Path, $stateParams.databaseId, requestData, ViewFactory.itemPreSaveAction);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    requestPromise.then(
                      function(success) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        $scope.actionAfterRequest();
                      },
                      function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                      }
                    );
                }

                $scope.actionAfterRequest = function() {
                  // empty
                }

                function requestPreconditions() {
                  return true;
                }

                function initStartAdditions(itemData) {
                  // empty
                }

            }
        ]);

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.coreview')
        .controller('Core.SingleItemController', [
            '$scope',
            'ViewFactory',
            '$rootScope',
            '$state',
            '$stateParams',
            '$interval',
            'cfpLoadingBar',
            'PreconditionsUtils',
            'InteractionsUtils',
            'ErrorUtils',
            'DateUtils',
            'ViewUtils',
            'ResourceServerDataService',
            function($scope, ViewFactory, $rootScope, $state, $stateParams, $interval, cfpLoadingBar, PreconditionsUtils, InteractionsUtils, ErrorUtils, DateUtils, ViewUtils, ResourceServerDataService) {
                // context
                $scope.viewContext = ViewFactory.viewContext;
                // register functions available in view
                $scope.startView = startView;
                $scope.formatDate = DateUtils.formatDate;
                $scope.millisecondsToStrTimeInterval = DateUtils.millisecondsToStrTimeInterval;
                $scope.secondsToStrTimeInterval = DateUtils.secondsToStrTimeInterval;
                $scope.changeView = InteractionsUtils.changeView;
                $scope.sendRequest = sendRequest;
                $scope.reloadView = reloadView;
                $scope.translateParameter = ViewUtils.translateParameter;
                $scope.translateType = ViewUtils.translateType;

                // methods to override
                $scope.initStartAdditions = initStartAdditions;
                $scope.initReloadAdditions = initReloadAdditions;
                // internal state
                var restPath = undefined;
                var autoReloadDataPromise = undefined;
                var errors = [];

                // view state
                $scope.viewSettings = {
                  reloadData: ViewFactory.viewContext.reloadData
                }

                function startView(restPathValue) {
                    // check permissions
                    if($rootScope.userContext == undefined || $rootScope.userContext.roles == undefined || $rootScope.userContext.roles.length == 0 || $rootScope.userContext.permission == undefined || $rootScope.userContext.permission.length == 0) {
                      InteractionsUtils.changeView('missingPermissions');
                      return;
                    }
                    restPath = restPathValue;
                    // handle start view
                    var loadDataPromise = ResourceServerDataService.loadSingleItemData($scope, ViewFactory.viewContext, restPath, ViewFactory.loadItemPostConstruct);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    loadDataPromise.then(
                        function(answer) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            $scope.initStartAdditions($scope.itemData);
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                            return Promise.reject(error);
                        }
                    ).then(
                        function() {
                            // check if start data synchronization
                            if (ViewFactory.viewContext.reloadItemData != undefined && ViewFactory.viewContext.reloadItemData) {
                                autoReloadDataPromise = $interval(function() {
                                  if($scope.viewSettings.reloadData) {
                                    var dataSynchronizationPromise = ResourceServerDataService.loadSingleItemData($scope, ViewFactory.viewContext, restPath, ViewFactory.loadItemPostConstruct);
                                    // progress bar ============
                                    cfpLoadingBar.start();
                                    // =========================
                                    dataSynchronizationPromise.then(
                                        function(data) {
                                            // progress bar ============
                                            cfpLoadingBar.complete();
                                            // =========================
                                            $scope.initReloadAdditions($scope.itemData);
                                        },
                                        function(error) {
                                            // progress bar ============
                                            cfpLoadingBar.complete();
                                            // =========================
                                            ErrorUtils.handleError(error, errors);
                                        }
                                    );
                                  }
                                }, ViewUtils.getViewReloadInterval(ViewFactory));
                            }
                        }
                    );
                }

                function reloadView() {
                  var loadDataPromise = ResourceServerDataService.loadSingleItemData($scope, ViewFactory.viewContext, restPath, ViewFactory.loadItemPostConstruct);
                  // progress bar ============
                  cfpLoadingBar.start();
                  // =========================
                  loadDataPromise.then(
                      function(answer) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          $scope.initStartAdditions($scope.itemData);
                      },
                      function(error) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          ErrorUtils.handleError(error, errors);
                      }
                  );
                }

                function initStartAdditions(itemData) {
                  // empty
                }

                function initReloadAdditions(itemsData) {
                  // empty
                }

                function sendRequest(requestData) {
                    // clear previous response
                    itemData.response = undefined;
                    // send request
                    var requestPromise = ResourceServerDataService.sendRequestData($scope, ViewFactory.viewContext.rest16Path, $stateParams.databaseId, requestData, ViewFactory.itemPreSaveAction);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    requestPromise.then(
                      function(success) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                      },
                      function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                      }
                    );
                }

                // =====================================================================
                // destroy
                // =====================================================================

                $scope.$on('$destroy', function() {
                    if (autoReloadDataPromise != undefined) {
                        $interval.cancel(autoReloadDataPromise);
                    }
                });

            }
        ]);

})();

(function() {
    'use strict';
    angular.module('BlurAdmin.coreview')
    .controller('Core.ListDisabledPaginationController', [
        '$scope',
        'ViewFactory',
        '$rootScope',
        '$interval',
        '$state',
        '$timeout',
        '$translate',
        'cfpLoadingBar',
        'DateUtils',
        'CookieUtils',
        'ArrayUtils',
        'ErrorUtils',
        'ViewUtils',
        'InteractionsUtils',
        'PreconditionsUtils',
        'ResourceServerDataService',
        function($scope, ViewFactory, $rootScope, $interval, $state, $timeout, $translate, cfpLoadingBar, DateUtils, CookieUtils, ArrayUtils, ErrorUtils, ViewUtils, InteractionsUtils, PreconditionsUtils, ResourceServerDataService) {
            // context
            $scope.viewContext = ViewFactory.viewContext;
            $scope.formatDate = DateUtils.formatDate;
            $scope.millisecondsToStrTimeInterval = DateUtils.millisecondsToStrTimeInterval;
            $scope.secondsToStrTimeInterval = DateUtils.secondsToStrTimeInterval;
            // methods to override
            $scope.initStartAdditions = initStartAdditions;
            $scope.initReloadAdditions = initReloadAdditions;
            // methods available from view
            $scope.startView = startView;
            $scope.reloadData = reloadData;
            $scope.showItemDetails = showItemDetails;
            $scope.downloadCSV = downloadCSV;
            $scope.downloadXLSX = downloadXLSX;
            $scope.showEditView = showEditView;
            $scope.showRegisterNewItem = showRegisterNewItem;
            $scope.activateItem = activateItem;
            $scope.deActivateItem = deActivateItem;
            $scope.setReloadData = setReloadData;
            $scope.setDatePeriod = setDatePeriod;
            $scope.tableAction = tableAction;
            $scope.sortTable = sortTable;
            $scope.sortDefault = sortDefault;
            $scope.validateDate = validateDate;
            // view state
            $scope.viewSettings = undefined;
            // form data
            $scope.searchCriteriaData = {};
            var searchCriteria = undefined;
            // internal state
            var autoReloadDataPromise = undefined;
            var errors = [];

            $scope.tableRowIndexShift = 1;
            var restPath = undefined;

            $scope.datePickerOptions = {
                showWeeks: false,
                language: 'pl'
            };

            // =====================================================================
            // Edit
            // =====================================================================
            function showEditView(databaseId) {
                PreconditionsUtils.checkArgument(databaseId != undefined, "databaseId argument cannot be undefined", 'CoreListViewController', 'showDetails');
                PreconditionsUtils.checkArgument(ViewFactory.viewContext.editViewState != undefined, "ViewFactory.editViewState argument cannot be undefined", 'CoreListViewController', 'showDetails');
                // nav to details page
                $state.go(ViewFactory.viewContext.editViewState, {
                    databaseId: databaseId
                });
            }

            function showRegisterNewItem() {
                PreconditionsUtils.checkArgument(ViewFactory.viewContext.registerViewState != undefined, "ViewFactory not support new items registration", 'CoreListViewController', 'navToRegierNewItem');
                InteractionsUtils.changeView(ViewFactory.viewContext.registerViewState);
            }

            function activateItem(itemData) {
                PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'save');
                // set active
                itemData.active = true;
                PreconditionsUtils.checkArgument(itemData.id != undefined, "itemData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
                // invoke promise
                var updateDataPromise = ResourceServerDataService.updateItem(ViewFactory.viewContext, $scope, restPath + '/activate', itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                updateDataPromise.then(
                    function(data) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                );
            }

            function deActivateItem(itemData) {
                PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'save');
                // set active
                itemData.active = false;
                PreconditionsUtils.checkArgument(itemData.id != undefined, "itemData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
                // invoke promise
                var updateDataPromise = ResourceServerDataService.updateItem(ViewFactory.viewContext, $scope, restPath + '/activate', itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                updateDataPromise.then(
                    function(data) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        $scope.initReloadAdditions();
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                );
            }

            function tableAction(tableState) {
              console.log("tableAction");
            }

            function validateDate() {
              if($scope.searchCriteriaData.fromTime != undefined && $scope.searchCriteriaData.toTime != undefined) {
                if($scope.searchCriteriaData.toTime.getTime() < $scope.searchCriteriaData.fromTime.getTime()) {
                  $scope.searchCriteriaData.toTime = undefined;
                  InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('PLEASE_CHANGE_TO_TIME_SEARCH_INPUT'));
                }
              }
            }

            // =====================================================================
            // sort
            // =====================================================================

            function sortTable(selectedHeader) {
              // clear all sort
              var tableHeaders = $scope.itemsData.headers;
              for(var index = 0; index < tableHeaders.length; index++) {
                var header = tableHeaders[index];
                if(header.propertyIdentity == selectedHeader.propertyIdentity) {
                  if(selectedHeader.sortDown == undefined || !selectedHeader.sortDown) {
                    selectedHeader.sortDown = true;
                    selectedHeader.sortUp = false;
                    // store in cookies
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_sortHeader", selectedHeader.propertyIdentity + "__asc", 365);
                  } else {
                    selectedHeader.sortDown = false;
                    selectedHeader.sortUp = true;
                    // store in cookies
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_sortHeader", selectedHeader.propertyIdentity + "__desc", 365);
                  }
                } else {
                  header.sortUp = undefined;
                  header.sortDown = undefined;
                }
              }
              // send request
              doReloadData();
            }

            function sortDefault() {
              // remove cookies
              CookieUtils.removeCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
              // send request
              doReloadData();
            }

            // =====================================================================
            // Settings
            // =====================================================================
            function setReloadData() {
                CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_reloadData", $scope.viewSettings.reloadData, 365);
            }
            // =====================================================================
            // Search
            // =====================================================================

            function setDatePeriod(timePeriod) {
              if(timePeriod == undefined) {
                return;
              }
              $scope.searchCriteriaData.toTime = DateUtils.getCurrentTimestamp();
              $scope.searchCriteriaData.toTime = new Date($scope.searchCriteriaData.toTime);
              $scope.searchCriteriaData.fromTime = $scope.searchCriteriaData.toTime - DateUtils.getTimePeriodInMs(timePeriod);
              $scope.searchCriteriaData.fromTime = new Date($scope.searchCriteriaData.fromTime);
            }

            $scope.showSearchCriteria = function() {
                $scope.viewSettings.displaySearchCriteria = !$scope.viewSettings.displaySearchCriteria;
                CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_displaySearchCriteria", $scope.viewSettings.displaySearchCriteria, 365);
                if(!$scope.viewSettings.displaySearchCriteria && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                  // reset search criteria
                  $scope.resetSearchCriteria($scope.searchCriteriaData);
                }
            }
            $scope.openDatePickerPopup = function() {
                $scope.datePickerOpened = true;
            }
            $scope.searchByCriteria = function(searchCriteriaInput) {
                if(searchCriteriaInput == undefined != ArrayUtils.checkIfDictionaryIsEmpty(searchCriteriaInput)) {
                  $scope.resetSearchCriteria(searchCriteriaInput);
                  return;
                }
                // store in cookies
                CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_searchCriteria", JSON.stringify($scope.searchCriteriaData), 365);
                // update scope
                $scope.searchCriteriaData = searchCriteriaInput;
                // get sort header from cookie
                var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                var sortDirection  = undefined;
                if(sortProperty != undefined) {
                  var sortSeparatorIndex = sortProperty.indexOf('__');
                  sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                  sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                }
                // search
                var searchDataPromise = ResourceServerDataService.searchDataWithoutPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                searchDataPromise.then(
                    function(data) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                );
            }
            $scope.resetSearchCriteria = function(searchCriteriaInput) {
                for (var key in searchCriteriaInput) {
                    searchCriteriaInput[key] = undefined;
                }
                CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_searchCriteria", undefined, 365);
                $scope.searchCriteriaData = searchCriteriaInput;
                // restore reload data
                $scope.viewSettings.reloadData = true;
                CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_reloadData", $scope.viewSettings.reloadData, 365);
                // reload data
                doReloadData();
            }
            // =====================================================================
            // Data
            // =====================================================================
            function startView(restPathValue) {
                // check permissions
                if($rootScope.userContext == undefined || $rootScope.userContext.roles == undefined || $rootScope.userContext.roles.length == 0 || $rootScope.userContext.permission == undefined || $rootScope.userContext.permission.length == 0) {
                  InteractionsUtils.changeView('missingPermissions');
                  return;
                }
                // handle start view
                if(restPathValue == undefined) {
                  $scope.initStartAdditions();
                  return;
                }
                restPath = restPathValue;
                // restore state
                $scope.viewSettings = initViewSettings();
                $scope.searchCriteriaData = initSearchCriteria();
                // get sort header from cookie
                var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                var sortDirection  = undefined;
                if(sortProperty != undefined) {
                  var sortSeparatorIndex = sortProperty.indexOf('__');
                  sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                  sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                }
                // load data at start
                var loadDataPromise = undefined;
                if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                    loadDataPromise = ResourceServerDataService.searchDataWithoutPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                } else {
                    loadDataPromise = ResourceServerDataService.loadDataWithoutPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                }
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                loadDataPromise.then(
                    function(data) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        if(sortProperty != undefined) {
                          restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                        }
                        $scope.initStartAdditions();
                    },
                    function(error) {
                        // wrong search criteria format
                        if(error.data != undefined && error.data.message != undefined && error.data.message.indexOf("JSON parse error:") == 0) {
                          // reset search criteria
                          $scope.resetSearchCriteria($scope.searchCriteriaData);
                          startView(restPath);
                          return;
                        }
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                        return Promise.reject(error);
                    }
                ).then(
                    function() {
                        // check if start data synchronization
                            autoReloadDataPromise = $interval(function() {
                                if ($scope.viewSettings.reloadData != undefined && $scope.viewSettings.reloadData) {
                                if ($scope.viewSettings.reloadData) {
                                    // get sort header from cookie
                                    var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                                    var sortDirection  = undefined;
                                    if(sortProperty != undefined) {
                                      var sortSeparatorIndex = sortProperty.indexOf('__');
                                      sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                                      sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                                    }
                                    // load data at start
                                    var dataSynchronizationPromise = undefined;
                                    if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                                        dataSynchronizationPromise = ResourceServerDataService.searchDataWithoutPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                                    } else {
                                        dataSynchronizationPromise = ResourceServerDataService.loadDataWithoutPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                                    }
                                    // progress bar ============
                                    cfpLoadingBar.start();
                                    // =========================
                                    dataSynchronizationPromise.then(
                                        function(data) {
                                            // progress bar ============
                                            cfpLoadingBar.complete();
                                            // =========================
                                            if(sortProperty != undefined) {
                                              restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                                            }
                                            $scope.initReloadAdditions()
                                        },
                                        function(error) {
                                            // progress bar ============
                                            cfpLoadingBar.complete();
                                            // =========================
                                            ErrorUtils.handleError(error, errors);
                                        }
                                    );
                                }
                              }
                            }, ViewUtils.getViewReloadInterval(ViewFactory));
                    }
                );
            }

            function restoreTableSortProperty(headers, sortProperty, direction) {
              for(var index = 0; index < headers.length; index++) {
                var header = headers[index];
                if(header.propertyIdentity == sortProperty) {
                  if(direction == 'desc') {
                    header.sortUp = true;
                  } else {
                    header.sortDown = true;
                  }
                  return;
                }
              }
            }

            function showItemDetails(databaseId) {
                PreconditionsUtils.checkArgument(databaseId != undefined, "databaseId argument cannot be undefined", 'CoreListViewController', 'showDetails');
                // nav to details page
                $state.go(ViewFactory.viewContext.detailsViewState, {
                    databaseId: databaseId
                });
            }

            function downloadXLSX() {
               var criteria = {};
               var url = "";
               url =  restPath + "/xlsx-generate/" + $rootScope.appLanguage;
               if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                   criteria = $scope.searchCriteriaData;
               }
               var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
               var sortDirection  = undefined;
               if(sortProperty != undefined) {
                   var sortSeparatorIndex = sortProperty.indexOf('__');
                   sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                   sortProperty = sortProperty.substring(0, sortSeparatorIndex);
               }
               ResourceServerDataService.importXLSXReport(url, criteria, ViewFactory, sortProperty, sortDirection);
            }

            function downloadCSV(extension) {
              // get sort header from cookie
              var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
              var sortDirection  = undefined;
              if(sortProperty != undefined) {
                var sortSeparatorIndex = sortProperty.indexOf('__');
                sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                sortProperty = sortProperty.substring(0, sortSeparatorIndex);
              }
              if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                var loadDataPromise = ResourceServerDataService.rawSearchData($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, undefined, ViewFactory);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                loadDataPromise.then(
                    function(itemsData) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        if(ViewFactory.exportCsvPreAction != undefined) {
                          itemsData = ViewFactory.exportCsvPreAction(itemsData);
                        }
                        ViewUtils.saveDataAsCsv(itemsData, {
                          searchCriteria: $scope.searchCriteriaData,
                          sortProperty: sortProperty,
                          sortDirection: sortDirection
                        }, ViewFactory.viewContext.identity, ViewFactory.initTableDataAction().headers, extension);
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                )
              } else {
                var loadDataPromise = ResourceServerDataService.rawLoadDataWithoutPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, undefined, ViewFactory.viewMetaDataPostAction);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                loadDataPromise.then(
                    function(itemsData) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        if(ViewFactory.exportCsvPreAction != undefined) {
                          itemsData = ViewFactory.exportCsvPreAction(itemsData);
                        }
                        ViewUtils.saveDataAsCsv(itemsData, {
                          searchCriteria: undefined,
                          sortProperty: sortProperty,
                          sortDirection: sortDirection
                        }, ViewFactory.viewContext.identity, ViewFactory.initTableDataAction().headers, extension);
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                )
              }
            }

            function reloadData() {
                doReloadData();
            }

            function doReloadData() {
                // get sort header from cookie
                var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                var sortDirection  = undefined;
                if(sortProperty != undefined) {
                  var sortSeparatorIndex = sortProperty.indexOf('__');
                  sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                  sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                }
                var dataSynchronizationPromise = undefined;
                if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                    dataSynchronizationPromise = ResourceServerDataService.searchDataWithoutPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                }
                else {
                    dataSynchronizationPromise = ResourceServerDataService.loadDataWithoutPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                }
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                dataSynchronizationPromise.then(
                    function(data) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                      if(sortProperty != undefined) {
                        restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                      }
                      $scope.initReloadAdditions();
                      // Get the snackbar DIV
                      var snackbarElement = document.getElementById("snackbar");
                      snackbarElement.innerHTML = $translate.instant('COMMONS_DATA__WAS_LOADED');
                      // Add the "show" class to DIV
                      snackbarElement.className = "show";
                      // After 3 seconds, remove the show class from DIV
                      setTimeout(function(){ snackbarElement.className = snackbarElement.className.replace("show", ""); }, 3000);
                    },
                    function(error) {
                        // progress bar ============
                        cfpLoadingBar.complete();
                        // =========================
                        ErrorUtils.handleError(error, errors);
                    }
                );
            }

            function initViewSettings() {
                var reloadData = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_reloadData");
                if (reloadData == undefined) {
                    reloadData = ViewFactory.viewContext.reloadData;
                } else {
                  reloadData = (reloadData == 'true');
                }
                var displaySearchCriteria = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_displaySearchCriteria");
                if (displaySearchCriteria == undefined) {
                    displaySearchCriteria = false;
                } else {
                  displaySearchCriteria = (displaySearchCriteria == 'true');
                }
                return {
                    reloadData: reloadData,
                    displaySearchCriteria: displaySearchCriteria
                }
            }

            function initSearchCriteria() {
                var searchCriteria = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_searchCriteria");
                if (searchCriteria == undefined) {
                    return {};
                }
                var searchCriteria = JSON.parse(searchCriteria);
                // check from time
                if(searchCriteria.fromTime != undefined && searchCriteria.fromTime.length > 0) {
                  searchCriteria.fromTime = new Date(searchCriteria.fromTime);
                }
                // check to time
                if(searchCriteria.toTime != undefined && searchCriteria.toTime.length > 0) {
                  searchCriteria.toTime = new Date(searchCriteria.toTime);
                }
                // check timestamp
                if(searchCriteria.timestamp != undefined && searchCriteria.timestamp.length > 0) {
                  searchCriteria.timestamp = new Date(searchCriteria.timestamp);
                }
                // check expiry date operator
                if(searchCriteria.expiryDateOperator != undefined && searchCriteria.expiryDateOperator.length > 0) {
                  searchCriteria.expiryDateOperator = searchCriteria.expiryDateOperator;
                }
                return searchCriteria;
            }

            // =====================================================================
            // functions to override
            // =====================================================================

            function initStartAdditions() {
              // empty
            }

            function initReloadAdditions() {
              // empty
            }

            // =====================================================================
            // destroy
            // =====================================================================
            $scope.$on('$destroy', function() {
                if (autoReloadDataPromise != undefined) {
                    $interval.cancel(autoReloadDataPromise);
                }
            });
        }
    ]);
})();

(function() {
    'use strict';
    angular.module('BlurAdmin.coreview')
        .controller('Core.ListPaginationController', [
            '$scope',
            'ViewFactory',
            '$rootScope',
            '$interval',
            '$state',
            '$timeout',
            '$translate',
            'cfpLoadingBar',
            'DateUtils',
            'CookieUtils',
            'ArrayUtils',
            'ErrorUtils',
            'ViewUtils',
            'InteractionsUtils',
            'PreconditionsUtils',
            'ResourceServerDataService',
            function($scope, ViewFactory, $rootScope, $interval, $state, $timeout, $translate, cfpLoadingBar, DateUtils, CookieUtils, ArrayUtils, ErrorUtils, ViewUtils, InteractionsUtils, PreconditionsUtils, ResourceServerDataService) {
                // context
                $scope.viewContext = ViewFactory.viewContext;
                $scope.formatDate = DateUtils.formatDate;
                $scope.millisecondsToStrTimeInterval = DateUtils.millisecondsToStrTimeInterval;
                $scope.secondsToStrTimeInterval = DateUtils.secondsToStrTimeInterval;
                // methods to override
                $scope.viewStartAction = function($scope) {};
                $scope.initStartAdditions = initStartAdditions;
                $scope.initReloadAdditions = initReloadAdditions;
                // methods available from view
                $scope.startView = startView;
                $scope.reloadData = reloadData;
                $scope.showItemDetails = showItemDetails;
                $scope.downloadCSV = downloadCSV;
                $scope.downloadXLSX = downloadXLSX;
                $scope.changePage = changePage;
                $scope.itemsPerPage = itemsPerPage;
                $scope.showEditView = showEditView;
                $scope.showRegisterNewItem = showRegisterNewItem;
                $scope.activateItem = activateItem;
                $scope.deActivateItem = deActivateItem;
                $scope.setReloadData = setReloadData;
                $scope.setDatePeriod = setDatePeriod;
                $scope.tableAction = tableAction;
                $scope.sortTable = sortTable;
                $scope.sortDefault = sortDefault;
                $scope.validateDate = validateDate;
                // view state
                $scope.pageNumber = 0;
                $scope.viewSettings = undefined;
                $scope.itemsQuantity = ViewFactory.viewContext.itemsQuantity;
                // form data
                $scope.searchCriteriaData = {};
                // internal state
                var autoReloadDataPromise = undefined;
                var errors = [];
                var restPath = undefined;
                var cachedTableState = undefined;

                $scope.tableRowIndexShift = 1;

                $scope.datePickerOptions = {
                    showWeeks: false,
                    language: 'pl'
                };

                // =====================================================================
                // Edit
                // =====================================================================
                function showEditView(databaseId) {
                    PreconditionsUtils.checkArgument(databaseId != undefined, "databaseId argument cannot be undefined", 'CoreListViewController', 'showDetails');
                    PreconditionsUtils.checkArgument(ViewFactory.viewContext.editViewState != undefined, "ViewFactory.editViewState argument cannot be undefined", 'CoreListViewController', 'showDetails');
                    // nav to details page
                    $state.go(ViewFactory.viewContext.editViewState, {
                        databaseId: databaseId
                    });
                }

                function showRegisterNewItem() {
                    PreconditionsUtils.checkArgument(ViewFactory.viewContext.registerViewState != undefined, "ViewFactory not support new items registration", 'CoreListViewController', 'navToRegierNewItem');
                    InteractionsUtils.changeView(ViewFactory.viewContext.registerViewState);
                }

                function activateItem(itemData) {
                    PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'save');
                    // set active
                    itemData.active = true;
                    PreconditionsUtils.checkArgument(itemData.id != undefined, "itemData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
                    // invoke promise
                    var updateDataPromise = ResourceServerDataService.updateItem(ViewFactory.viewContext, $scope, ViewFactory.restPath + '/activate', itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    updateDataPromise.then(
                        function(data) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    );
                }

                function deActivateItem(itemData) {
                    PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'save');
                    // set active
                    itemData.active = false;
                    PreconditionsUtils.checkArgument(itemData.id != undefined, "itemData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
                    // invoke promise
                    var updateDataPromise = ResourceServerDataService.updateItem(ViewFactory.viewContext, $scope, ViewFactory.restPath + '/activate', itemData, ViewFactory.mainState, ViewFactory.itemPreSaveAction);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    updateDataPromise.then(
                        function(data) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    );
                }

                // =====================================================================
                // sort
                // =====================================================================

                function sortTable(selectedHeader) {
                  // clear all sort
                  var tableHeaders = $scope.itemsData.headers;
                  for(var index = 0; index < tableHeaders.length; index++) {
                    var header = tableHeaders[index];
                    if(header.propertyIdentity == selectedHeader.propertyIdentity) {
                      if(selectedHeader.sortDown == undefined || !selectedHeader.sortDown) {
                        selectedHeader.sortDown = true;
                        selectedHeader.sortUp = false;
                        // store in cookies
                        CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_sortHeader", selectedHeader.propertyIdentity + "__asc", 365);
                      } else {
                        selectedHeader.sortDown = false;
                        selectedHeader.sortUp = true;
                        // store in cookies
                        CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_sortHeader", selectedHeader.propertyIdentity + "__desc", 365);
                      }
                    } else {
                      header.sortUp = undefined;
                      header.sortDown = undefined;
                    }
                  }
                  // switch page to 0
                  $scope.pageNumber = 0;
                  // reload and replace table data
                  // progress bar ============
                  cfpLoadingBar.start();
                  reloadAndReplaceData();
                  // progress bar ============
                  cfpLoadingBar.complete();
                }

                function sortDefault() {
                  // remove cookies
                  CookieUtils.removeCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                  // send request
                  // switch page to 0
                  $scope.pageNumber = 0;
                  // reload and replace table data
                  // progress bar ============
                  cfpLoadingBar.start();
                  reloadAndReplaceData();
                  // progress bar ============
                  cfpLoadingBar.complete();
                }

                // =====================================================================
                // Pagination
                // =====================================================================

                function validateDate() {
                  if($scope.searchCriteriaData.fromTime != undefined && $scope.searchCriteriaData.toTime != undefined) {
                    if($scope.searchCriteriaData.toTime.getTime() < $scope.searchCriteriaData.fromTime.getTime()) {
                      $scope.searchCriteriaData.toTime = undefined;
                      InteractionsUtils.openWarningDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('PLEASE_CHANGE_TO_TIME_SEARCH_INPUT'));
                    }
                  }
                }

                function itemsPerPage(itemsQuantity) {
                    PreconditionsUtils.checkArgument(itemsQuantity != undefined, "itemsQuantity argument cannot be undefined", 'CoreListViewController', 'itemsPerPage');
                    // set items quantity
                    $scope.itemsQuantity = itemsQuantity;
                    // store in cookies
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_displayedItemsQuantity", itemsQuantity, 365);
                    // change page to first
                    $scope.pageNumber = 0;
                    $scope.tableRowIndexShift = 1 + ($scope.pageNumber * $scope.itemsQuantity);
                    // reload data
                    doReloadData();
                }

                function changePage(pageNumber) {
                    PreconditionsUtils.checkArgument(pageNumber != undefined, "pageNumber argument cannot be undefined", 'CoreListViewController', 'changePage');
                    $scope.pageNumber = pageNumber;
                    if ($scope.pageNumber != 0) {
                        // stop data reload
                        $scope.viewContext.reloadData = false;
                    }
                    else {
                        // start data reload
                        $scope.viewContext.reloadData = true;
                    }
                    $scope.tableRowIndexShift = 1 + ($scope.pageNumber * $scope.itemsQuantity);
                    // reload data
                    doReloadData();
                }

                // =====================================================================
                // Settings
                // =====================================================================
                function setReloadData() {
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_reloadData", $scope.viewSettings.reloadData, 365);
                    if($scope.viewSettings.reloadData) {
                      // reset table state
                      cachedTableState.pagination.start = 0;
                      // reload and replace table data
                      // progress bar ============
                      cfpLoadingBar.start();
                      reloadAndReplaceData();
                      // progress bar ============
                      cfpLoadingBar.complete();
                      // scroll to top
                      var tableContainer = angular.element(document.getElementById('infiniteTableContainer'));
                      tableContainer[0].scrollTop = 0;
                    }
                }
                // =====================================================================
                // Search
                // =====================================================================

                function setDatePeriod(timePeriod) {
                  if(timePeriod == undefined) {
                    return;
                  }
                  $scope.searchCriteriaData.toTime = DateUtils.getCurrentTimestamp();
                  $scope.searchCriteriaData.toTime = new Date($scope.searchCriteriaData.toTime);
                  $scope.searchCriteriaData.fromTime = $scope.searchCriteriaData.toTime - DateUtils.getTimePeriodInMs(timePeriod);
                  $scope.searchCriteriaData.fromTime = new Date($scope.searchCriteriaData.fromTime);
                }

                $scope.showSearchCriteria = function() {
                    $scope.viewSettings.displaySearchCriteria = !$scope.viewSettings.displaySearchCriteria;
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_displaySearchCriteria", $scope.viewSettings.displaySearchCriteria, 365);
                    if(!$scope.viewSettings.displaySearchCriteria && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                      // reset search criteria
                      $scope.resetSearchCriteria($scope.searchCriteriaData);
                    }
                }
                $scope.openDatePickerPopup = function() {
                    $scope.datePickerOpened = true;
                }
                $scope.searchByCriteria = function(searchCriteriaInput) {
                    if(searchCriteriaInput == undefined != ArrayUtils.checkIfDictionaryIsEmpty(searchCriteriaInput)) {
                      $scope.resetSearchCriteria(searchCriteriaInput);
                      return;
                    }
                    // store in cookies
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_searchCriteria", JSON.stringify($scope.searchCriteriaData), 365);
                    // update scope
                    $scope.searchCriteriaData = searchCriteriaInput;
                    $scope.pageNumber = 0;
                    // get sort header from cookie
                    var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                    var sortDirection  = undefined;
                    if(sortProperty != undefined) {
                      var sortSeparatorIndex = sortProperty.indexOf('__');
                      sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                      sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                    }
                    // search
                    var searchDataPromise = ResourceServerDataService.searchDataWithPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    searchDataPromise.then(
                        function(data) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    );
                }
                $scope.resetSearchCriteria = function(searchCriteriaInput) {
                    for (var key in searchCriteriaInput) {
                        searchCriteriaInput[key] = undefined;
                    }
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_searchCriteria", undefined, 365);
                    $scope.searchCriteriaData = searchCriteriaInput;
                    // restore reload data
                    $scope.viewSettings.reloadData = true;
                    CookieUtils.setCookieValue(ViewFactory.viewContext.identity + "_reloadData", $scope.viewSettings.reloadData, 365);
                    // switch page to 0
                    $scope.pageNumber = 0;
                    // reload and replace table data
                    // progress bar ============
                    cfpLoadingBar.start();
                    reloadAndReplaceData();
                    // progress bar ============
                    cfpLoadingBar.complete();
                }
                // =====================================================================
                // Data
                // =====================================================================
                function tableAction(tableState) {
                    cachedTableState = tableState;
                    if(tableState.userAction) {
                      $scope.viewSettings.reloadData = false;
                      $scope.pageNumber = tableState.pagination.start;
                      // reload data
                      doReloadData(tableState);
                    }
                }

                function startView(restPathValue) {
                    // check permissions
                    if($rootScope.userContext == undefined || $rootScope.userContext.roles == undefined || $rootScope.userContext.roles.length == 0 || $rootScope.userContext.permission == undefined || $rootScope.userContext.permission.length == 0) {
                      InteractionsUtils.changeView('missingPermissions');
                      return;
                    }
                    // handle start view
                    if(restPathValue == undefined) {
                      $scope.initStartAdditions();
                      return;
                    }
                    restPath = restPathValue;
                    // restore state
                    $scope.viewSettings = initViewSettings();
                    $scope.searchCriteriaData = initSearchCriteria();
                    // get sort header from cookie
                    var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                    var sortDirection  = undefined;
                    if(sortProperty != undefined) {
                      var sortSeparatorIndex = sortProperty.indexOf('__');
                      sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                      sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                    }
                    // load data at start
                    var loadDataPromise = undefined;
                    if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                        loadDataPromise = ResourceServerDataService.searchDataWithPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                    } else {
                        loadDataPromise = ResourceServerDataService.loadDataWithPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                    }
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    loadDataPromise.then(
                        function(data) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            // invoke action after first data load
                            $scope.viewStartAction($scope);
                            if(sortProperty != undefined) {
                              restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                            }
                            // set table container height - required for scroll
                            var screenHeight = screen.height;
                            if(screenHeight != undefined) {
                              var tableContainerHeight = Math.round(screenHeight * 0.7);
                              setTableContainerHeight("" + tableContainerHeight + "px");
                            }
                            $scope.initStartAdditions();
                        },
                        function(error) {
                            // wrong search criteria format
                            if(error.data != undefined && error.data.message != undefined && error.data.message.indexOf("JSON parse error:") == 0) {
                              // reset search criteria
                              $scope.resetSearchCriteria($scope.searchCriteriaData);
                              startView(restPath);
                              return;
                            }
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                            return Promise.reject(error);
                        }
                    ).then(
                        function() {
                            autoReloadDataPromise = $interval(function() {
                              // check if start data synchronization
                              if ($scope.viewSettings.reloadData != undefined && $scope.viewSettings.reloadData) {
                                if ($scope.viewSettings.reloadData) {
                                  reloadAndReplaceData();
                                }
                              }
                            }, ViewUtils.getViewReloadInterval(ViewFactory));
                        }
                    );
                }

                function reloadAndReplaceData() {
                  // get sort header from cookie
                  var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                  var sortDirection  = undefined;
                  if(sortProperty != undefined) {
                    var sortSeparatorIndex = sortProperty.indexOf('__');
                    sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                    sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                  }
                  // load data at start
                  var dataSynchronizationPromise = undefined;
                  if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                      dataSynchronizationPromise = ResourceServerDataService.searchDataWithPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                  } else {
                      dataSynchronizationPromise = ResourceServerDataService.loadDataWithPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                  }
                  // progress bar ============
                  cfpLoadingBar.start();
                  // =========================
                  dataSynchronizationPromise.then(
                      function(data) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          if(sortProperty != undefined) {
                            restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                          }
                      },
                      function(error) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          ErrorUtils.handleError(error, errors);
                      }
                  );
                }

                function restoreTableSortProperty(headers, sortProperty, direction) {
                  for(var index = 0; index < headers.length; index++) {
                    var header = headers[index];
                    if(header.propertyIdentity == sortProperty) {
                      if(direction == 'desc') {
                        header.sortUp = true;
                      } else {
                        header.sortDown = true;
                      }
                      return;
                    }
                  }
                }

                function showItemDetails(databaseId) {
                    PreconditionsUtils.checkArgument(databaseId != undefined, "databaseId argument cannot be undefined", 'CoreListViewController', 'showDetails');
                    // nav to details page
                    $state.go(ViewFactory.viewContext.detailsViewState, {
                        databaseId: databaseId
                    });
                }

                function downloadXLSX() {
                    var criteria = {};
                    var url = "";
                    url =  restPath + "/xlsx-generate/" + $rootScope.appLanguage;
                    if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                        criteria = $scope.searchCriteriaData;
                    }
                    var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                    var sortDirection  = undefined;
                    if(sortProperty != undefined) {
                        var sortSeparatorIndex = sortProperty.indexOf('__');
                        sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                        sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                    }
                    ResourceServerDataService.importXLSXReport(url, criteria, ViewFactory, sortProperty, sortDirection);
                }

                function downloadCSV(extension) {
                  // get sort header from cookie
                  var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                  var sortDirection  = undefined;
                  if(sortProperty != undefined) {
                    var sortSeparatorIndex = sortProperty.indexOf('__');
                    sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                    sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                  }
                  if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                    var loadDataPromise = ResourceServerDataService.rawSearchData($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, undefined, ViewFactory);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    loadDataPromise.then(
                        function(itemsData) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            var headers = [];
                            var isDetailsReport;
                            if (ViewFactory.viewContext.identity == "ConsumedEnergyReportTemplateList" && (itemsData.reportTemplate.reportDetailed == false)) {
                              headers = getSummaryTableDataActionHeaders();
                              isDetailsReport = false;
                            } else {
                              headers = ViewFactory.initTableDataAction().headers;
                              isDetailsReport = true;
                            }
                            // =========================
                            if(ViewFactory.exportCsvPreAction != undefined) {
                              itemsData = ViewFactory.exportCsvPreAction(itemsData);
                            }
                            ViewUtils.saveDataAsCsv(itemsData, isDetailsReport, {
                              searchCriteria: $scope.searchCriteriaData,
                              sortProperty: sortProperty,
                              sortDirection: sortDirection
                            }, ViewFactory.viewContext.identity, ViewFactory.initTableDataAction().headers, extension);
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    )
                  } else {
                    var loadDataPromise = ResourceServerDataService.rawLoadDataWithoutPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, undefined, ViewFactory.viewMetaDataPostAction);
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    loadDataPromise.then(
                        function(itemsData) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            var headers = [];
                            var isDetailsReport;
                            if (ViewFactory.viewContext.identity == "ConsumedEnergyReportTemplateList" && (itemsData.reportTemplate.reportDetailed == false)) {
                              headers = getSummaryTableDataActionHeaders();
                              isDetailsReport = false;
                            } else {
                              headers = ViewFactory.initTableDataAction().headers;
                              isDetailsReport = true;
                            }
                            if(ViewFactory.exportCsvPreAction != undefined) {
                              itemsData = ViewFactory.exportCsvPreAction(itemsData);
                            }
                            ViewUtils.saveDataAsCsv(itemsData, isDetailsReport, {
                              searchCriteria: undefined,
                              sortProperty: sortProperty,
                              sortDirection: sortDirection
                            }, ViewFactory.viewContext.identity, headers, extension);
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    )
                  }
                }

                function getSummaryTableDataActionHeaders() {
                  return ViewFactory.initSummaryTableDataAction().headers
                }

                function reloadData() {
                  // switch page to 0
                  $scope.pageNumber = 0;
                  // reload and replace table data
                  // progress bar ============
                  cfpLoadingBar.start();
                  reloadAndReplaceData();
                  // progress bar ============
                  cfpLoadingBar.complete();
                }

                function doReloadData(tableState) {
                    var oldItemsData = $scope.itemsData;
                    // get sort header from cookie
                    var sortProperty = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_sortHeader");
                    var sortDirection  = undefined;
                    if(sortProperty != undefined) {
                      var sortSeparatorIndex = sortProperty.indexOf('__');
                      sortDirection = sortProperty.substring(sortSeparatorIndex + 2);
                      sortProperty = sortProperty.substring(0, sortSeparatorIndex);
                    }
                    var dataSynchronizationPromise = undefined;
                    if($scope.searchCriteriaData != undefined && !ArrayUtils.checkIfDictionaryIsEmpty($scope.searchCriteriaData)) {
                        dataSynchronizationPromise = ResourceServerDataService.searchDataWithPagination($scope.searchCriteriaData, $scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction, ViewFactory);
                    } else {
                        dataSynchronizationPromise = ResourceServerDataService.loadDataWithPagination($scope, sortProperty, sortDirection, ViewFactory.viewContext, restPath, ViewFactory.loadDataPostAction, ViewFactory.initTableDataAction, ViewFactory.viewMetaDataPostAction);
                    }
                    // progress bar ============
                    cfpLoadingBar.start();
                    // =========================
                    dataSynchronizationPromise.then(
                        function(data) {
                          // progress bar ============
                          cfpLoadingBar.complete();
                          // =========================
                          if(sortProperty != undefined) {
                            restoreTableSortProperty($scope.itemsData.headers, sortProperty, sortDirection);
                          }
                          if(tableState != undefined && $scope.itemsData.rows.length == 0) {
                            $scope.itemsData = oldItemsData;
                            tableState.pagination.start = tableState.pagination.start - 1;
                            $scope.pageNumber = tableState.pagination.start;
                            InteractionsUtils.openInfoDialog(
                              $translate.instant('TableNoMoreElementsTitle'),
                              $translate.instant('TableNoMoreElementsDescription'));
                          } else {
                            // merge
                            var rows = oldItemsData.rows.concat($scope.itemsData.rows);
                            $scope.itemsData.rows = rows;
                            // Get the snackbar DIV
                            var snackbarElement = document.getElementById("snackbar");
                            snackbarElement.innerHTML = $translate.instant('COMMONS_DATA__WAS_LOADED');
                            // Add the "show" class to DIV
                            snackbarElement.className = "show";
                            // After 3 seconds, remove the show class from DIV
                            setTimeout(function(){ snackbarElement.className = snackbarElement.className.replace("show", ""); }, 3000);
                          }
                        },
                        function(error) {
                            // progress bar ============
                            cfpLoadingBar.complete();
                            // =========================
                            ErrorUtils.handleError(error, errors);
                        }
                    );
                }

                function initViewSettings() {
                    var reloadData = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_reloadData");
                    if (reloadData == undefined) {
                        reloadData = ViewFactory.viewContext.reloadData;
                    } else {
                      reloadData = (reloadData == 'true');
                    }
                    var displaySearchCriteria = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_displaySearchCriteria");
                    if (displaySearchCriteria == undefined) {
                        displaySearchCriteria = false;
                    } else {
                      displaySearchCriteria = (displaySearchCriteria == 'true');
                    }
                    return {
                        reloadData: reloadData,
                        displaySearchCriteria: displaySearchCriteria
                    }
                }

                function initSearchCriteria() {
                    var searchCriteria = CookieUtils.getCookieValue(ViewFactory.viewContext.identity + "_searchCriteria");
                    if (searchCriteria == undefined) {
                        return {};
                    }
                    var searchCriteria = JSON.parse(searchCriteria);
                    // check from time
                    if(searchCriteria.fromTime != undefined && searchCriteria.fromTime.length > 0) {
                      searchCriteria.fromTime = new Date(searchCriteria.fromTime);
                    }
                    // check to time
                    if(searchCriteria.toTime != undefined && searchCriteria.toTime.length > 0) {
                      searchCriteria.toTime = new Date(searchCriteria.toTime);
                    }
                    // check timestamp
                    if(searchCriteria.timestamp != undefined && searchCriteria.timestamp.length > 0) {
                      searchCriteria.timestamp = new Date(searchCriteria.timestamp);
                    }
                    // check expiry date operator
                    if(searchCriteria.expiryDateOperator != undefined && searchCriteria.expiryDateOperator.length > 0) {
                      searchCriteria.expiryDateOperator = searchCriteria.expiryDateOperator;
                    }
                    return searchCriteria;
                }

                function setTableContainerHeight(height) {
                  // set table container height
                  var contentContainer = angular.element(document.getElementById('infiniteTableContainer'));
                  if(contentContainer != undefined && contentContainer.length > 0) {
                    contentContainer[0].style.height = height;
                  }
                }

                // =====================================================================
                // destroy
                // =====================================================================
                $scope.$on('$destroy', function() {
                    if (autoReloadDataPromise != undefined) {
                        $interval.cancel(autoReloadDataPromise);
                    }
                });
            }
        ]);

        // =====================================================================
        // functions to override
        // =====================================================================

        function initStartAdditions() {
          // empty
        }

        function initReloadAdditions() {
          // empty
        }
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('AlertAdministrationFactory', ['$translate', function($translate) {
        // rest api paths
        var restPath = 'rest/alertdefinition';
        var viewMetadataRestPath = 'rest/alertdefinition/view/metadata';
        // route states
        var mainState = 'Administration.Alert';
        // permissions
        var permissions = {
          details: 'AlertDefinition::readDetails',
          register: 'AlertDefinition::registerItem',
          update: 'AlertDefinition::updateItem',
        }
        // view context
        var viewContext = {
          identity: 'AlertAdministrationList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.AlertRegister",
          editViewState: "Administration.AlertEdit",
          itemDetailsIdentifier: 'identity',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            mainState: mainState,
            viewContext: viewContext,
            initTableDataAction: initTableDataAction
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // triggerMethod
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // notificationType
            { identity: $translate.instant('ALERT_DEFINITION__NOTIFICATION_TYPE'),
              propertyIdentity: 'notificationType',
              propertyType: 'String',
              property: function(item) {
              return item.notificationType;
            }},
            // receivers
            { identity: $translate.instant('ALERT_DEFINITION__NOTIFICATION_RECEIVERS'),
              propertyIdentity: 'receivers',
              propertyType: 'String',
              property: function(item) {
              return item.receivers;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('AuthorizationTagFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
        // rest api paths
        var restPath = 'rest/authorizationidtag';
        var viewMetadataRestPath = 'rest/authorizationidtag/view/metadata';
        // route states
        var mainState = 'Administration.AuthorizationTags';
        // permissions
        var permissions = {
          details: 'AuthorizationIdTag::readDetails',
          update: 'AuthorizationIdTag::updateItem',
          register: 'AuthorizationIdTag::registerItem'
        }
        // view context
        var viewContext = {
          identity: 'AuthorizationTagAdministrationList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          editViewState: "Administration.AuthorizationTagEdit",
          registerViewState: "Administration.AuthorizationTagRegister",
          itemDetailsIdentifier: 'idToken',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            itemPreSaveAction: itemPreSaveAction,
            loadEditableItemPostConstruct: loadEditableItemPostConstruct,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction
        }

        function itemPreSaveAction(itemData) {
          if(itemData.expiryDate.getTime) {
            itemData.expiryDate = itemData.expiryDate.getTime();
          }
        }

        function loadEditableItemPostConstruct(itemData) {
          if(itemData.expiryDate != undefined) {
            itemData.expiryDate = new Date(itemData.expiryDate);
          }
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'timestamp') {
              if(searchCriteria.timestamp != undefined) {
                var values = [];
                if(searchCriteria.timestamp.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['timestamp'] = values;
              }
            } else if(key == 'expiryDateOperator') {
              var values = [];
              values.push(searchCriteria[key]);
              outputSearchCriteria['expiryDateOperator'] = values;
            } else if(key == 'status'){
              var values = [];
              values.push(searchCriteria['status']);
              outputSearchCriteria['status'] = values;
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // parentIdToken
            { identity: $translate.instant('AUTHORIZATION_TAG_LIST__TABLE__PARENT_ID_TOKEN'),
              propertyIdentity: 'parent_id_token',
              propertyType: 'String',
              property: function(item) {
              return item.parentIdToken;
            }},
            // idToken
            { identity: $translate.instant('AUTHORIZATION_TAG_LIST__TABLE__ID_TOKEN'),
              propertyIdentity: 'id_token',
              propertyType: 'String',
              property: function(item) {
              return item.idToken;
            }},
            // status
            { identity: $translate.instant('AUTHORIZATION_TAG_LIST__TABLE__STATUS'),
              propertyIdentity: 'status',
              propertyType: 'String',
              property: function(item) {
              return item.status;
            }},
            // status
            { identity: $translate.instant('AUTHORIZATION_TAG_LIST__TABLE__EXPIRY_DATE'),
              propertyIdentity: 'expiry_date',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.expiryDate;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxAdministrationFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
        // rest api paths
        var restPath = 'rest/chargebox';
        var restPathActiveAndInactive = 'rest/chargebox/all';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        // route states
        var mainState = 'Administration.ChargeBox';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
          update: 'ChargeBox::updateItem',
          register: 'ChargeBox::registerItem'
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxAdministrationList',
          restPath: restPath,
          restPathActiveAndInactive: restPathActiveAndInactive,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.ChargeBoxRegister",
          editViewState: "Administration.ChargeBoxEdit",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            loadItemPostConstruct: loadItemPostConstruct,
            initTableDataAction: initTableDataAction,
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // communication protocol
            { identity: $translate.instant('CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL'),
              propertyIdentity: 'communicationProtocol',
              propertyType: 'String',
              property: function(item) {
              return item.communicationProtocol;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxGroupAdministrationFactory', ['$translate', 'ArrayUtils', function($translate, ArrayUtils) {
        // rest api paths
        var restPath = 'rest/chargeboxgroup';
        var viewMetadataRestPath = 'rest/chargeboxgroup/view/metadata';
        // route states
        var mainState = 'Administration.ChargeBoxGroup';
        // permissions
        var permissions = {
          details: 'ChargeBoxGroup::readDetails',
          update: 'ChargeBoxGroup::updateItem',
          register: 'ChargeBoxGroup::registerItem'
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxGroupAdministrationList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.ChargeBoxGroupRegister",
          editViewState: "Administration.ChargeBoxGroupEdit",
          itemDetailsIdentifier: 'name',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction,
            loadEditableItemPostConstruct: loadEditableItemPostConstruct
        }

        function loadEditableItemPostConstruct(itemData) {
          if(itemData.chargeBoxes != undefined && itemData.chargeBoxes.length != 0) {
            // remove assigned chargeBoxes from available chargeBoxes
            var cleanedAvailableChargeBoxes = [];
            for(var index = 0; index < itemData.availableChargeBoxes.length; index++) {
              var chargeBox =  itemData.availableChargeBoxes[index];
              if(ArrayUtils.indexOf(itemData.chargeBoxes, chargeBox) == -1) {
                cleanedAvailableChargeBoxes.push(chargeBox);
              }
            }
            itemData.availableChargeBoxes = cleanedAvailableChargeBoxes;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RoleAdministrationFactory', ['$translate' ,'ResourceServerDataService', function($translate, ResourceServerDataService) {
        // rest api paths
        var restPath = 'rest/role';
        var viewMetadataRestPath = 'rest/role/view/metadata';
        // route states
        var mainState = 'Administration.Role';
        // permissions
        var permissions = {
          details: 'Privileges::readDetails',
          update: 'Privileges::updateItem',
          register: 'Privileges::registerItem'
        }
        // view context
        var viewContext = {
          identity: 'RoleAdministrationList',
          restPath: restPath,
          dataSource: 'Auth',
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.RoleRegister",
          editViewState: "Administration.RoleEdit",
          itemDetailsIdentifier: 'name',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            mainState: mainState,
            viewContext: viewContext,
            initTableDataAction: initTableDataAction,
            itemPreSaveAction: itemPreSaveAction
        }

        function itemPreSaveAction(itemData) {
            var itemPromise = ResourceServerDataService.rawSendRequestData('rest/privilege/handleUserRequest', itemData);
            itemPromise.then(
              function(success) {
              },
              function(error) {
                ErrorUtils.handleError(error, errors);
              }
            );
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RolePermissionsAdministrationFactory', function() {
        // rest api paths
        var restPath = 'rest/privilege';
        // route states
        var mainState = 'Administration.Role';
        // view context
        var viewContext = {
          identity: 'RolePermissionsAdministrationList',
          restPath: restPath,
          itemDetailsIdentifier: 'name'
        };
        var permissions = {
          details: 'Privileges::readDetails',
          update: 'Privileges::updateItem',
          register: 'Privileges::registerItem'
        }
        return {
            restPath: restPath,
            mainState: mainState,
            permission: permissions,
            viewContext: viewContext
        }

    })
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('UserActivityAdministrationFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var restPath = 'rest/useractivity';
        var viewMetadataRestPath = 'rest/useractivity/view/metadata';
        // route states
        var mainState = 'Administration.UserActivity';
        // permissions
        var permissions = {
          details: 'Vehicle::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'UserActivityAdministrationList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          detailsViewState: "Administration.UserActivityDetails",
          itemDetailsIdentifier: 'id',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction
        }
        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // battery capacity
            { identity: $translate.instant('USERACTIVITY__CHANGED_TIMESTAMP'),
              propertyIdentity: 'changeTimestamp',
              propertyType: 'Long',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.changeTimestamp;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__CHANGED_OBJECT'),
              propertyIdentity: 'changedObject',
              propertyType: 'String',
              formatter: ViewUtils.translateType,
              property: function(item) {
              return item.changedObject;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__CHANGED_OBJECT_NAME'),
              propertyIdentity: 'changedObjectName',
              propertyType: 'String',
              property: function(item) {
              return item.changedObjectName;
            }},
            // soc
            { identity: $translate.instant('USERACTIVITY__CHANGED_PARAMETER'),
              propertyIdentity: 'changedParameter',
              propertyType: 'String',
              formatter: ViewUtils.translateParameter,
              property: function(item) {
              return item.changedParameter;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__CHANGED_SUB_PARAMETER'),
              propertyIdentity: 'changedSubParameter',
              propertyType: 'String',
              property: function(item) {
              return item.changedSubParameter;
            }},
            { identity: $translate.instant('USERACTIVITY__OLD_VALUE'),
              propertyIdentity: 'oldValue',
              propertyType: 'String',
              display: false,
              property: function(item) {
              return item.oldValue;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__NEW_VALUE'),
              propertyIdentity: 'newValue',
              propertyType: 'String',
              display: false,
              property: function(item) {
              return item.newValue;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__USERNAME'),
              propertyIdentity: 'username',
              propertyType: 'String',
              property: function(item) {
              return item.username;
            }},
            // identity
            { identity: $translate.instant('USERACTIVITY__TYPE'),
              propertyIdentity: 'type',
              propertyType: 'String',
              property: function(item) {
              return item.type;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('UserAdministrationFactory', ['$translate', 'ResourceServerDataService', 'UserActivityAdministrationFactory', 'DateUtils', function($translate, ResourceServerDataService, UserActivityAdministrationFactory, DateUtils) {
        // rest api paths
        var restPath = 'rest/user';
        var viewMetadataRestPath = 'rest/user/view/metadata';
        // route states
        var mainState = 'Administration.Account';
        // permissions
        var permissions = {
          details: 'Privileges::readDetails',
          update: 'Privileges::updateItem',
          register: 'Privileges::registerItem'
        }
        var currentValues = undefined;
        var oldValue = undefined;
        // view context
        var viewContext = {
          identity: 'UserAdministrationList',
          restPath: restPath,
          dataSource: 'Auth',
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.AccountUserRegister",
          editViewState: "Administration.AccountUserEdit",
          itemDetailsIdentifier: 'email',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
          currentValues: currentValues,
            oldValue: oldValue
        };
        return {
            restPath: restPath,
            mainState: mainState,
            viewContext: viewContext,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            itemPreSaveAction: itemPreSaveAction,
            loadEditableItemPostConstruct: loadEditableItemPostConstruct,
            currentValues: currentValues,
            oldValue: oldValue
        }

        function itemPreSaveAction(itemData) {
            if(typeof itemData.id == 'undefined') {
                itemData.old = oldValue;
            } else {
                for(var index = 0; index < currentValues.length; index++) {
                    if(itemData.id == currentValues[index].id){
                        var simpleObject = {};
                        for (var prop in currentValues[index] ){
                            if (!itemData.hasOwnProperty(prop)){
                                continue;
                            }
                            simpleObject[prop] = currentValues[index][prop];
                        }
                        itemData.old = simpleObject;
                    }
                }
            }
            var itemPromise = ResourceServerDataService.rawSendRequestData(UserActivityAdministrationFactory.restPath + '/handleUserRequest', itemData);
            itemPromise.then(
              function(success) {
                if (typeof(itemData.old) !== 'undefined') {
                    oldValue = itemData.old
                }
              },
              function(error) {
                ErrorUtils.handleError(error, errors);
              }
            );
        }

        function loadEditableItemPostConstruct(itemData) {
            var simpleObject = {};
            for (var prop in itemData) {
                if (!itemData.hasOwnProperty(prop)){
                    continue;
                }
                if (typeof(itemData[prop]) == 'object' && itemData[prop] != null ) {
                    var simpleObject2 = [];
                    for(var prop2 in itemData[prop] ){
                        simpleObject2.push(itemData[prop][prop2]);
                    }
                    simpleObject[prop] = simpleObject2;
                    continue;
                }
                if (typeof(itemData[prop]) == 'function') {
                    continue;
                }
                simpleObject[prop] = itemData[prop];
            }
            oldValue = JSON.stringify(simpleObject);
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          oldValue = undefined;
          for(var key in searchCriteria) {
            if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('USERS_TABLE__EMAIL'),
              propertyIdentity: 'email',
              propertyType: 'String',
              property: function(item) {
              return item.email;
            }},
            // identity
            { identity: $translate.instant('USERS_TABLE__FIRST_NAME'),
              propertyIdentity: 'first_name',
              propertyType: 'String',
              property: function(item) {
              return item.firstName;
            }},
            // battery capacity
            { identity: $translate.instant('USERS_TABLE__LAST_NAME'),
              propertyIdentity: 'last_name',
              propertyType: 'String',
              property: function(item) {
              return item.lastName;
            }},
            // soc
            { identity: $translate.instant('USERS_TABLE__PHONE'),
              propertyIdentity: 'phone',
              propertyType: 'String',
              property: function(item) {
              return item.phone;
            }},
            // soc
            { identity: $translate.instant('USERS_TABLE__ROLES'),
              propertyIdentity: 'roles',
              propertyType: 'String',
              property: function(item) {
              return item.roles;
            }},
            // soc
            { identity: $translate.instant('USERS_TABLE__ADDED_DATE_TIME'),
              propertyIdentity: 'added_date_time',
              propertyType: 'String',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.addedDateTime;
            }},
          ];
          oldValue = undefined;
          currentValues = itemsData;
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('VehicleAdministrationFactory', ['$translate', function($translate) {
        // rest api paths
        var restPath = 'rest/vehicle';
        var viewMetadataRestPath = 'rest/vehicle/view/metadata';
        // route states
        var mainState = 'Administration.Vehicle';
        // permissions
        var permissions = {
          details: 'Vehicle::readDetails',
          update: 'Vehicle::updateItem',
          register: 'Vehicle::registerItem'
        }
        // view context
        var viewContext = {
          identity: 'VehicleAdministrationList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "Administration.VehicleRegister",
          editViewState: "Administration.VehicleEdit",
          itemDetailsIdentifier: 'identity',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('VEHICLE_TABLE__SIDE_NUMBER'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.actualConfiguration.sideNumber;
            }},
            // identity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'identity',
              propertyType: 'String',
              property: function(item) {
              return item.identity;
            }},
            // battery capacity
            { identity: $translate.instant('COMMONS__BATTERY_CAPACITY'),
              propertyIdentity: 'batteryCapacity',
              propertyType: 'Long',
              property: function(item) {
              return item.actualConfiguration.batteryCapacity;
            }},
            // soc
            { identity: $translate.instant('COMMONS__SOC'),
              propertyIdentity: 'soc',
              propertyType: 'Double',
              property: function(item) {
              return item.actualState.soc;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('AlertsFactory', ['DateUtils', '$translate', function(DateUtils, $translate) {
      var restPath = 'rest/alert';
      var viewMetadataRestPath = 'rest/alert/view/metadata';
      var mainState = 'Alerts.All';
      // permissions
      var permissions = {
        details: 'Alert::readDetails',
        register: 'Alert::registerItem',
        update: 'Alert::updateItem',
      }
      // view context
      var viewContext = {
        identity: 'AlertList',
        mainState: mainState,
        restPath: restPath,
        loadMetadata: true,
        permission: permissions,
        viewMetadataRestPath: viewMetadataRestPath,
        reloadData: true,
        itemsQuantity: 50,
        detailsViewState: "Alerts.Details",
        itemDetailsIdentifier: 'id',
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
          initTableDataAction: initTableDataAction
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }

      function initTableDataAction(itemsData) {
        // init columns
        var tableColumns = [
          // archived
          { identity: $translate.instant('ALERTS_LIST__ARCHIVED'),
            propertyIdentity: 'archived',
            propertyType: 'String',
            icon: true,
            property: function(item) {
              if(item.archived) {
                return 'none';
              }
              return 'envelope';
          }},
          // triggerMethod
          { identity: $translate.instant('ALERTS_LIST__TRIGGER_METHOD'),
            propertyIdentity: 'trigger_method',
            propertyType: 'String',
            property: function(item) {
            return item.triggerMethod;
          }},
          // alert time
          { identity: $translate.instant('ALERTS_LIST__ALERT_TIME'),
            propertyIdentity: 'alert_time',
            propertyType: 'FormattedDate',
            formatter: DateUtils.formatDate,
            property: function(item) {
            return item.alertTime;
          }},
          // chargeBoxIdentity
          { identity: $translate.instant('ALERTS_LIST__CHARGE_BOX_IDENTITY'),
            propertyIdentity: 'charge_box_identity',
            propertyType: 'String',
            property: function(item) {
            return item.chargeBoxIdentity;
          }},
          // status
          { identity: $translate.instant('COMMONS__STATUS'),
            propertyIdentity: 'status',
            propertyType: 'String',
            property: function(item) {
            return item.status;
          }},
          // error code
          { identity: $translate.instant('ALERT_VIEW__ERROR_CODE'),
            propertyIdentity: 'error_code',
            propertyType: 'String',
            property: function(item) {
            return item.errorCode;
          }},
          // vendor error code
          { identity: $translate.instant('ALERT_VIEW__VENDOR_ERROR_CODE'),
            propertyIdentity: 'vendor_error_code',
            propertyType: 'String',
            property: function(item) {
            return item.vendorErrorCode;
          }},
        ];
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxAlertsFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var restPath = 'rest/chargebox';
        var viewMetadataRestPath = 'rest/alert/view/metadata';
        // route states
        var mainState = 'ChargeBox.All';
        // permissions
        var permissions = {
          details: 'Alert::readDetails',
          register: 'Alert::registerItem',
          update: 'Alert::updateItem',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxAlerts',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          permission: permissions,
          reloadData: true,
          detailsViewState: "Alerts.Details",
          itemDetailsIdentifier: 'id',
          itemsQuantity: 50,
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction,
            searchCriteriaPostContruct: searchCriteriaPostContruct
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // triggerMethod
            { identity: $translate.instant('ALERTS_LIST__TRIGGER_METHOD'),
              propertyIdentity: 'trigger_method',
              propertyType: 'String',
              property: function(item) {
              return item.triggerMethod;
            }},
            // alert time
            { identity: $translate.instant('ALERTS_LIST__ALERT_TIME'),
              propertyIdentity: 'alert_time',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.alertTime;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('ALERTS_LIST__CHARGE_BOX_IDENTITY'),
              propertyIdentity: 'charge_box_identity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // status
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'status',
              propertyType: 'String',
              property: function(item) {
              return item.status;
            }},
            // error code
            { identity: $translate.instant('ALERT_VIEW__ERROR_CODE'),
              propertyIdentity: 'error_code',
              propertyType: 'String',
              property: function(item) {
              return item.errorCode;
            }},
            // vendor error code
            { identity: $translate.instant('ALERT_VIEW__VENDOR_ERROR_CODE'),
              propertyIdentity: 'vendor_error_code',
              propertyType: 'String',
              property: function(item) {
              return item.vendorErrorCode;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxConfigurationFactory', ['$stateParams', function($stateParams) {
        // rest api paths
        var restPath = 'rest/chargebox/actual_configuration';
        // permissions
        var permissions = {
          details: 'ChargeBoxState::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesConfiguration',
          restPath: restPath,
          itemDetailsIdentifier: 'chargeBoxIdentity',
        };
        return {
            restPath: restPath,
            viewContext: viewContext
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxTransactionsFactory', ['$translate', 'DateUtils', 'ViewUtils', 'ConfigFactory', function($translate, DateUtils, ViewUtils, ConfigFactory) {
        // rest api paths
        var restPath = 'rest/chargebox';
        var viewMetadataRestPath = 'rest/chargingtransaction/view/metadata';
        // route states
        var mainState = 'ChargeBox.All';
        // permissions
        var permissions = {
          details: 'ChargingTransaction::readDetails'
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxTransactions',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          permission: permissions,
          reloadData: true,
          detailsViewState: "Transaction.Details",
          itemDetailsIdentifier: 'transactionId',
          itemsQuantity: 50,
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction,
            searchCriteriaPostContruct: searchCriteriaPostContruct
        }

        function initTableDataAction(itemsData) {
          // init columns
          var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
          if (consumedEnergyUnit == undefined) {
              consumedEnergyUnit = '[Wh]';
          }
          var tableColumns = [
            // transactionId
            { identity: $translate.instant('TRANSACTIONS_TABLE__TRANSACTION_ID'),
              propertyIdentity: 'transaction_id',
              propertyType: 'Long',
              property: function(item) {
              return item.transactionId;
            }},
            // startTimestamp
            { identity: $translate.instant('TRANSACTIONS_TABLE__START_TIMESTAMP'),
              propertyIdentity: 'start_timestamp',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.startTimestamp;
            }},
            // stopTimestamp
            { identity: $translate.instant('TRANSACTIONS_TABLE__STOP_TIMESTAMP'),
              propertyIdentity: 'stop_timestamp',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.stopTimestamp;
            }},
            // duration
            { identity: $translate.instant('TRANSACTIONS_TABLE__CHARGING_TIME'),
              propertyIdentity: 'duration',
              propertyType: 'FormattedTimeDuration',
              formatter: DateUtils.millisecondsToStrTimeInterval,
              property: function(item) {
              return item.duration;
            }},
            // energy
            { identity: $translate.instant('COMMONS__RETURNED_ENERGY') + consumedEnergyUnit,
              propertyIdentity: 'returned_energy',
              propertyType: 'Long',
              property: function(item) {
              return item.returnedEnergy != undefined ? Math.round(item.returnedEnergy) : "---";
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('TRANSACTIONS_TABLE__CHARGE_BOX_IDENTITY'),
              propertyIdentity: 'charge_box_identity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // vehicleId
            { identity: $translate.instant('TRANSACTIONS_TABLE__VEHICLE'),
              propertyIdentity: 'vehicle_name',
              propertyType: 'String',
              property: function(item) {
              return item.vehicleName;
            }},
            // stopReason
            { identity: $translate.instant('TRANSACTIONS_TABLE__EOC_REASON'),
              propertyIdentity: 'stop_reason',
              propertyType: 'String',
              property: function(item) {
              return item.stopReason;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'transaction_id') {
              if(searchCriteria.transaction_id != undefined) {
                var values = [];
                values.push(searchCriteria.transaction_id);
                outputSearchCriteria['transaction_id'] = values;
              }
            } else if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesActivityHoursFactory', ['$translate', function($translate) {
        // rest api paths
        var restPath = 'rest/chargebox/state';
        // permissions
        var permissions = {
          details: 'ChargeBoxState::readDetails',
        }
        // charts
        var displayedCharts = ['ActivityHours'];
        var visibleCharts = [
          // other
          {
            "label": 'ActivityHours',
            "graphs": [{
                        "lineColor": "#006600",
                        "bullet": "round",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 10,
                        "title": $translate.instant('COMMONS__STATE'),
                        "valueField": "value",
                        "fillAlphas": 0,
                        "type": "step",
            }]
          }
        ];
        // view context
        var viewContext = {
          identity: 'ChargeBoxActivityHoursList',
          restPath: restPath,
          itemDetailsIdentifier: 'chargeBoxIdentity',
          displayedCharts: displayedCharts,
          visibleCharts: visibleCharts,
          reloadData: true,
          dataSynchronizationInterval: 5000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            searchCriteriaPostContruct: searchCriteriaPostContruct
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesChargingFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var coreRestPath = 'rest/chargebox';
        var restPath = coreRestPath + '/status/CHARGING';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.Charging';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesChargingList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
              outputSearchCriteria[key] = searchCriteria[key];
          }
          outputSearchCriteria['chargeBoxStatus'] = ['CHARGING'];
          return outputSearchCriteria;
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesChargingProfilesFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
        // rest api paths
        var restPath = 'rest/chargebox/chargingprofile/';
        // permissions
        var permissions = {
          details: 'ChargeBoxState::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxActivityHoursList',
          restPath: restPath,
          itemDetailsIdentifier: 'chargeBoxIdentity',
          reloadData: true,
          dataSynchronizationInterval: 5000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            initTableDataAction: initTableDataAction
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // profile id
            { identity: $translate.instant('PROFILE_ID'),
              propertyIdentity: 'profile_id',
              propertyType: 'String',
              property: function(item) {
              return item.id;
            }},
            // transaction_id
            { identity: $translate.instant('TRANSACTION_ID'),
              propertyIdentity: 'transaction_id',
              propertyType: 'String',
              property: function(item) {
              return item.transactionId;
            }},
            // stack_level
            { identity: $translate.instant('STACK_LEVEL'),
              propertyIdentity: 'stack_level',
              propertyType: 'String',
              property: function(item) {
              return item.stackLevel;
            }},
            // purpose
            { identity: $translate.instant('PROFILE_PURPOSE'),
              propertyIdentity: 'charging_profile_purpose',
              propertyType: 'String',
              property: function(item) {
              return item.chargingProfilePurpose;
            }},
            // kind
            {
              identity: $translate.instant('PROFILE_KIND'),
              propertyIdentity: 'charging_profile_kind',
              propertyType: 'String',
              property: function(item) {
              return item.chargingProfileKind;
            }},
            // RecurrencyKindType
            { identity: $translate.instant('RECURRENCY_KIND'),
              propertyIdentity: 'recurrency_kind',
              propertyType: 'String',
              property: function(item) {
              return item.recurrencyKind;
            }},
            // from
            {
              identity: $translate.instant('FROM'),
              propertyIdentity: 'valid_from',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.validFrom;
            }},
            // to
            {
              identity: $translate.instant('TO'),
              propertyIdentity: 'valid_to',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.validTo;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesErrorFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var coreRestPath = 'rest/chargebox';
        var restPath = coreRestPath + '/status/ERROR';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.Error';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesErrorList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
              outputSearchCriteria[key] = searchCriteria[key];
          }
          outputSearchCriteria['chargeBoxStatus'] = ['ERROR'];
          return outputSearchCriteria;
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var restPath = 'rest/chargebox';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.All';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.chargeBoxGroups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              groups = groups + ", " + chargeBoxGroups[index];
            }
            itemData.chargeBox.groups = groups.substring(2);
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // communication protocol
            { identity: $translate.instant('CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL'),
              propertyIdentity: 'communicationProtocol',
              propertyType: 'String',
              property: function(item) {
              return item.communicationProtocol;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesOfflineFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var coreRestPath = 'rest/chargebox';
        var restPath = coreRestPath + '/status/OFFLINE';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.Offline';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesOfflineList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
              outputSearchCriteria[key] = searchCriteria[key];
          }
          outputSearchCriteria['chargeBoxStatus'] = ['OFFLINE'];
          return outputSearchCriteria;
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // communication protocol
            { identity: $translate.instant('CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL'),
              propertyIdentity: 'communicationProtocol',
              propertyType: 'String',
              property: function(item) {
              return item.communicationProtocol;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesOnlineFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var coreRestPath = 'rest/chargebox';
        var restPath = coreRestPath + '/status/ONLINE';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.Online';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesOnlineList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
              outputSearchCriteria[key] = searchCriteria[key];
          }
          outputSearchCriteria['chargeBoxStatus'] = ['ONLINE'];
          return outputSearchCriteria;
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // communication protocol
            { identity: $translate.instant('CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL'),
              propertyIdentity: 'communicationProtocol',
              propertyType: 'String',
              property: function(item) {
              return item.communicationProtocol;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxesWarningFactory', ['$translate', 'DateUtils', 'ViewUtils', function($translate, DateUtils, ViewUtils) {
        // rest api paths
        var coreRestPath = 'rest/chargebox';
        var restPath = coreRestPath + '/status/WARNING';
        var viewMetadataRestPath = 'rest/chargebox/view/metadata';
        var chargeBoxMeasurmentDataRestPath = 'rest/measurmentdata/chargebox';
        // route states
        var mainState = 'ChargeBox.Warning';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }  // view context
        var viewContext = {
          identity: 'ChargeBoxesWarningList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          chargeBoxStartTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/start_transaction.html',
          chargeBoxStopTransactionDialogTemplate: 'app/chargebox/chargeboxes/dialog/stop_transaction.html',
          setMaxPowerDialogTemplate: 'app/chargebox/chargeboxes/dialog/set_max_power.html',
          changeConfigurationDialogTemplate: 'app/chargebox/chargeboxes/dialog/change_configuration.html',
          chargeBoxResetDialogTemplate: 'app/chargebox/chargeboxes/dialog/reset.html',
          permission: permissions,
          reloadData: true,
          reloadItemData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            chargeBoxMeasurmentDataRestPath: chargeBoxMeasurmentDataRestPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
              outputSearchCriteria[key] = searchCriteria[key];
          }
          outputSearchCriteria['chargeBoxStatus'] = ['WARNING'];
          return outputSearchCriteria;
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxGroups = itemData.groups;
          if(chargeBoxGroups == undefined || chargeBoxGroups.length == 0) {
            itemData.chargeBox.groups = $translate.instant('without_group');
          } else {
            var groups = '';
            for(var index = 0; index < chargeBoxGroups.length; index++) {
              var chargeBoxGroup = chargeBoxGroups[index];
              groups = groups + ", " + chargeBoxGroup.name;
            }
            itemData.chargeBox.groups = groups;
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item.name;
            }},
            // chargeBoxIdentity
            { identity: $translate.instant('COMMONS__IDENTITY'),
              propertyIdentity: 'chargeBoxIdentity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // chargeBoxSerialNumber
            { identity: $translate.instant('CHARGE_BOX__CHARGE_BOX_SERIAL_NUMBER'),
              propertyIdentity: 'chargeBoxSerialNumber',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxSerialNumber;
            }},
            // communication protocol
            { identity: $translate.instant('CHARGE_BOX_EDIT__COMMUNICATION_PROTOCOL'),
              propertyIdentity: 'communicationProtocol',
              propertyType: 'String',
              property: function(item) {
              return item.communicationProtocol;
            }},
            // ipAddress
            { identity: $translate.instant('COMMONS__IP_ADDRESS'),
              propertyIdentity: 'ipAddress',
              propertyType: 'String',
              property: function(item) {
              return item.ipAddress;
            }},
            // lastActivityTime
            {
              identity: $translate.instant('COMMONS__LAST_ACTIVITY_TIME'),
              propertyIdentity: 'lastActivityTime',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.lastActivityTime;
            }},
            // chargeBoxStatus
            { identity: $translate.instant('COMMONS__STATUS'),
              propertyIdentity: 'chargeBoxStatus',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxGroupFactory', ['$translate', '$state', function($translate, $state) {
        // rest api paths
        var restPath = 'rest/chargeboxgroup';
        var viewMetadataRestPath = 'rest/chargeboxgroup/view/metadata';
        // route states
        var mainState = 'ChargeboxGroup.All';
        // permissions
        var permissions = {
          details: 'ChargeBoxGroup::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesGroupList',
          restPath: restPath,
          loadMetadata: true,
          viewMetadataRestPath: viewMetadataRestPath,
          permission: permissions,
          reloadData: true,
          itemsQuantity: 50,
          detailsViewState: "ChargeboxGroup.Details",
          itemDetailsIdentifier: 'name',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            loadItemPostConstruct: loadItemPostConstruct,
            initTableDataAction: initTableDataAction
        }

        function loadItemPostConstruct(itemData) {
          var chargeBoxes = itemData.chargeBoxes;
          if(loadItemPostConstruct == undefined || loadItemPostConstruct.length == 0) {
            return;
          }
          for(var index = 0; index < chargeBoxes.length; index++) {
            var chargeBox = chargeBoxes[index];
            chargeBox.showDetailsUrl = $state.href('ChargeBox.Details', {state: 'all', databaseId: chargeBox.chargeBoxIdentity}, {absolute: true});
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { identity: $translate.instant('COMMONS__NAME'),
              propertyIdentity: 'name',
              propertyType: 'String',
              property: function(item) {
              return item['name'];
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargingProfilesFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
        // rest api paths
        var restPath = 'rest/chargingprofile';
        var viewMetadataRestPath = 'rest/chargingprofile/view/metadata';
        // route states
        var mainState = 'ChargingProfiles.All';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
          update: 'ChargeBox::readDetails',
          register: 'ChargeBox::readDetails'
        }
        // view context
        var viewContext = {
          identity: 'ChargingProfilesList',
          restPath: restPath,
          loadMetadata: false,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          registerViewState: "ChargingProfiles.ChargingProfilesRegister",
          editViewState: "ChargingProfiles.ChargingProfilesEdit",
          itemDetailsIdentifier: 'identity',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            itemPreSaveAction: itemPreSaveAction,
            viewContext: viewContext,
            mainState: mainState,
            initTableDataAction: initTableDataAction,
        }

        function itemPreSaveAction(itemData) {
          if(itemData.validFrom != undefined && itemData.validFrom.getTime) {
            itemData.validFrom = itemData.validFrom.getTime();
          }
          if(itemData.validTo != undefined && itemData.validTo.getTime) {
            itemData.validTo = itemData.validTo.getTime();
          }
          if(itemData.chargingSchedule != undefined && itemData.chargingSchedule.startSchedule != undefined && itemData.chargingSchedule.startSchedule.getTime) {
            itemData.chargingSchedule.startSchedule = itemData.chargingSchedule.startSchedule.getTime();
          }
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // profile id
            { identity: $translate.instant('PROFILE_ID'),
              propertyIdentity: 'identity',
              propertyType: 'String',
              property: function(item) {
              return item.identity;
            }},
            // stack_level
            { identity: $translate.instant('STACK_LEVEL'),
              propertyIdentity: 'stack_level',
              propertyType: 'String',
              property: function(item) {
              return item.stackLevel;
            }},
            // purpose
            { identity: $translate.instant('PROFILE_PURPOSE'),
              propertyIdentity: 'charging_profile_purpose',
              propertyType: 'String',
              property: function(item) {
              return item.chargingProfilePurpose;
            }},
            // kind
            {
              identity: $translate.instant('PROFILE_KIND'),
              propertyIdentity: 'charging_profile_kind',
              propertyType: 'String',
              property: function(item) {
              return item.chargingProfileKind;
            }},
            // RecurrencyKindType
            { identity: $translate.instant('RECURRENCY_KIND'),
              propertyIdentity: 'recurrency_kind',
              propertyType: 'String',
              property: function(item) {
              return item.recurrencyKind;
            }},
            // from
            {
              identity: $translate.instant('FROM'),
              propertyIdentity: 'valid_from',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.validFrom;
            }},
            // to
            {
              identity: $translate.instant('TO'),
              propertyIdentity: 'valid_to',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.validTo;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');
    module.factory('DashboardFactory', ['$sce', '$translate', 'DateUtils', 'ChargeBoxUtils', 'layoutPaths', 'CookieUtils', 'ArrayUtils', function($sce, $translate, DateUtils, ChargeBoxUtils, layoutPaths, CookieUtils, ArrayUtils) {
        // rest api paths
        var restPath = 'rest/chargeboxgroup/summary';
        // permissions
        var permissions = {
            // empty
        }
        // view context
        var viewContext = {
            identity: 'dashboard',
            restPath: restPath,
            permission: permissions,
            reloadData: true,
            itemDetailsIdentifier: 'id',
            dataSynchronizationInterval: 1000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            loadDataPostAction: loadDataPostAction
        }

        function loadDataPostAction(itemsData, oldItemsData) {
            if (oldItemsData != undefined) {
                // search for expanded groups
                var expandedGroups = [];
                for (var index = 0; index < oldItemsData.length; index++) {
                    var group = oldItemsData[index];
                    if (group.expanded) {
                        expandedGroups.push(group.chargeBoxGroupName);
                    }
                }
                // init groups data
                initGroups(itemsData);
                // set expanded groups
                for (var index = 0; index < expandedGroups.length; index++) {
                    var groupByIdentity = findGroupByName(itemsData, expandedGroups[index]);
                    if (groupByIdentity != undefined) {
                        groupByIdentity.expanded = true;
                    }
                }
                return;
            }
            initGroups(itemsData);
        }

        function initGroups(itemsData) {
            for (var groupIndex = 0; groupIndex < itemsData.length; groupIndex++) {
                var group = itemsData[groupIndex];
                group.totalSetPower = Math.round(group.totalSetPower * 100) / 100;
                if (group.chargeBoxGroupName == 'orphan charge boxes') {
                    group.displayName = $translate.instant('orphan charge boxes');
                }
                else {
                    group.displayName = group.chargeBoxGroupName;
                }
                if(group.totalDevicesPower != 0) {
                  group.totalUsedPowerPercent = parseFloat((group.totalSetPower / group.totalDevicesPower) * 100).toFixed(2);
                } else {
                  group.totalUsedPowerPercent = 0;
                }

                var stateEntries = {};
                for (var state in group.chargeBoxQuantityByState) {
                    var stateChargeBoxes = group.chargeBoxQuantityByState[state];
                    for (var chargeBoxIndex = 0; chargeBoxIndex < stateChargeBoxes.length; chargeBoxIndex++) {
                        var chargeBox = stateChargeBoxes[chargeBoxIndex];
                        if (chargeBox.actualState.powerUnitImportOutlet == "W") {
                          chargeBox.actualState.lastPowerActiveImportOutlet = Math.round((chargeBox.actualState.lastPowerActiveImportOutlet / 1000) * 100) / 100;
                        }
                        if(chargeBox.actualConfiguration.maxPowerSet != 0) {
                          chargeBox.totalUsedPowerPercent = parseFloat((chargeBox.actualState.lastPowerActiveImportOutlet / chargeBox.actualConfiguration.maxPowerSet) * 100).toFixed(2);
                        } else {
                          chargeBox.totalUsedPowerPercent = "0.00";
                        }
                        chargeBox.icon = ChargeBoxUtils.initChargeBoxIcon(state);
                        if(chargeBox.actualState.chargeBoxStatus == 'ERROR') {
                          if(chargeBox.actualState.errorStateRepeated) {
                            chargeBox.icon = ChargeBoxUtils.initChargeBoxRepeatedIcon(state);
                          }
                        } else if(chargeBox.actualState.chargeBoxStatus == 'WARNING') {
                          if(chargeBox.actualState.warningStateRepeated) {
                            chargeBox.icon = ChargeBoxUtils.initChargeBoxRepeatedIcon(state);
                          }
                        }
                        chargeBox.tooltipData = ChargeBoxUtils.initChargeBoxTooltipData(chargeBox);
                    }
                    stateEntries[state] = {
                        chargeBoxes: stateChargeBoxes,
                        alertClass: initStateAlertClass(state)
                    };
                }
                group.chargeBoxQuantityByState = stateEntries;
            }
        }

        function findGroupByName(groups, chargeBoxGroupName) {
            for (var index = 0; index < groups.length; index++) {
                var group = groups[index];
                if (group.chargeBoxGroupName == chargeBoxGroupName) {
                    return group;
                }
            }
            return undefined;
        }

        function initStateAlertClass(state) {
            if (state == 'ERROR') {
                return 'alert-danger';
            }
            else if (state == 'CHARGING') {
                return 'alert-info';
            }
            else if (state == 'WARNING') {
                return 'alert-warning';
            }
            else if (state == 'ONLINE') {
                return 'alert-success';
            }
            else if (state == 'OFFLINE') {
                return undefined;
            }
            return undefined;
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxActivityFactory', ['$translate', 'StringUtils', 'DateUtils', function($translate, StringUtils, DateUtils) {
        var restPath = 'rest/activities';
        var viewMetadataRestPath = 'rest/activities/view/metadata';
        var mainState = 'Developer.ChargeBoxActivity';
        // permissions
        var permissions = {
          details: 'ChargeBoxActivity::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'ChargeBoxesActivityList',
          restPath: restPath,
          loadMetadata: true,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          detailsViewState: "Developer.ChargeBoxActivityDetails",
          itemDetailsIdentifier: 'id',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            loadItemPostConstruct: loadItemPostConstruct,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction
        }

        function loadItemPostConstruct(itemData) {
          // request
          if(itemData.rawRequest != undefined) {
            var formattedContent = StringUtils.formatXml(itemData.rawRequest);
            itemData.rawRequest = formattedContent.content;
            itemData.rawRequestRows = formattedContent.rows;
          }
          // response
          if(itemData.rawResponse != undefined) {
            var formattedContent = StringUtils.formatXml(itemData.rawResponse);
            itemData.rawResponse = formattedContent.content;
            itemData.rawRequestRows = formattedContent.rows;
          }
        };

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'transaction_id') {
              if(searchCriteria.transaction_id != undefined) {
                var values = [];
                values.push(searchCriteria.transaction_id);
                outputSearchCriteria['transaction_id'] = values;
              }
            } else if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // name
            { width: "20%", identity: $translate.instant('CHARGEBOX_ACTIVITY__TABLE__CHARGEBOX_IDENTITY'),
              propertyIdentity: 'charge_box_identity',
              propertyType: 'String',
              property: function(item) {
              return item.chargeBoxIdentity;
            }},
            // transaction id
            { width: "10%", identity: $translate.instant('CHARGEBOX_ACTIVITY__TABLE__TRANSACTION_ID'),
              propertyIdentity: 'transaction_id',
              propertyType: 'String',
              property: function(item) {
              return item.transactionId;
            }},
            // identity
            { width: "20%", identity: $translate.instant('CHARGEBOX_ACTIVITY__TABLE__ACTIVITY_TYPE'),
              propertyIdentity: 'activity_type',
              propertyType: 'String',
              property: function(item) {
              return item.activityType;
            }},
            // request time
            { width: "20%", identity: $translate.instant('CHARGEBOX_ACTIVITY__TABLE__REQUEST_TIME'),
              propertyIdentity: 'activity_time',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.activityTime;
            }},
            // response status
            { width: "20%", identity: $translate.instant('CHARGEBOX_ACTIVITY__TABLE__RESPONSE_STATUS'),
              propertyIdentity: 'response_status',
              propertyType: 'String',
              property: function(item) {
              return item.responseStatus;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('VehicleDistanceFactory', ['$translate', 'StringUtils', 'DateUtils', function($translate, StringUtils, DateUtils) {
        var restPath = 'rest/vehicle_distance';
        var viewMetadataRestPath = 'rest/vehicle_distance/view/metadata';
        var mainState = 'Developer.VehicleDistance';
        // permissions
        var permissions = {
          details: 'VehicleDistance::readDetails',
        }
        // view context
        var viewContext = {
          identity: 'VehicleDistanceList',
          restPath: restPath,
          loadMetadata: false,
          permission: permissions,
          viewMetadataRestPath: viewMetadataRestPath,
          reloadData: true,
          itemsQuantity: 50,
          detailsViewState: "Developer.VehicleDistanceDetails",
          itemDetailsIdentifier: 'id',
          dataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            searchCriteriaPostContruct: searchCriteriaPostContruct,
            initTableDataAction: initTableDataAction
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // messageId
            { identity: $translate.instant('VEHICLE_DISTANCE__TABLE__MESSAGE_ID'),
              propertyIdentity: 'message_id',
              propertyType: 'String',
              property: function(item) {
              return item.messageId;
            }},
            // vehicleId
            { identity: $translate.instant('VEHICLE_DISTANCE__VEHICLE_ID'),
              propertyIdentity: 'vehicle_id',
              propertyType: 'String',
              property: function(item) {
              return item.vehicleId;
            }},
            // session_id
            { identity: $translate.instant('VEHICLE_DISTANCE__SESSION_ID'),
              propertyIdentity: 'session_id',
              propertyType: 'String',
              property: function(item) {
              return item.sessionId;
            }},
            // distance
            { identity: $translate.instant('VEHICLE_DISTANCE__DISTANCE'),
              propertyIdentity: 'distance',
              propertyType: 'Long',
              property: function(item) {
              return item.distance;
            }},
            // transaction_id
            { identity: $translate.instant('VEHICLE_DISTANCE__TRANSACTION_ID'),
              propertyIdentity: 'transaction_id',
              propertyType: 'Long',
              property: function(item) {
              return item.transactionId;
            }},
            // distanceTimestamp
            { identity: $translate.instant('VEHICLE_DISTANCE__DATE_TIME'),
              propertyIdentity: 'distance_timestamp',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.distanceTimestamp;
            }},
            // data status
            { identity: $translate.instant('VEHICLE_DISTANCE__STATUS'),
              propertyIdentity: 'data_status',
              propertyType: 'String',
              property: function(item) {
              return item.dataStatus;
            }}
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('MapChargeBoxesFactory', ['$state', function($state) {
        // rest api paths
        var restPath = 'rest/chargebox/detailed';
        // route states
        var mainState = 'Map.ChargeBox';
        // permissions
        var permissions = {
          details: 'ChargeBox::readDetails',
        }
        // view context
        var viewContext = {
          identity: "ChargeBoxMap",
          restPath: restPath,
          permission: permissions,
          reloadData: true,
          detailsViewState: "ChargeBox.Details",
          itemDetailsIdentifier: 'chargeBoxIdentity',
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000,
        };
        return {
            restPath: restPath,
            viewContext: viewContext,
            mainState: mainState,
            loadDataPostAction: loadDataPostAction
        }

        function loadDataPostAction(chargeBoxes) {
          if(chargeBoxes == undefined) {
            return;
          }
          for(var index = 0; index < chargeBoxes.length; index++) {
            var chargeBox = chargeBoxes[index];
            chargeBox.detailsUrl = $state.href(viewContext.detailsViewState, { 'state': chargeBox.actualState.chargeBoxStatus, 'databaseId': chargeBox.chargeBoxIdentity }, {absolute: true});
            if(chargeBox.actualConfiguration.maxPowerSet != 0) {
              chargeBox.totalUsedPowerPercent = parseFloat((chargeBox.actualState.lastPowerActiveImportOutlet / chargeBox.actualConfiguration.maxPowerSet) * 100).toFixed(2);
            } else {
              chargeBox.totalUsedPowerPercent = "0.00";
            }
          }

        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteChangeConfigurationRequestFactory', ['$location', function($location) {
        var rest15Path = 'rest/v15/chargebox/configuration/change';
        var rest16Path = 'rest/v16/chargebox/configuration/change';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
            loadItemPostConstruct: loadItemPostConstruct,
        }

        function loadItemPostConstruct(itemData) {
          itemData.key = $location.search()['config_key'];
          itemData.value = $location.search()['config_value'];
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteGetChargingScheduleFactory', ['$location', '$translate', function($location, $translate) {
        var rest16Path = 'rest/v16/chargebox/getcompositeschedule';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
            initTableDataAction: initTableDataAction
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // start period
            { identity: $translate.instant('COMMONS__START_PERIOD'),
              propertyIdentity: 'start_period',
              propertyType: 'String',
              property: function(item) {
              return item.startPeriod;
            }},
            // limit
            { identity: $translate.instant('COMMONS__LIMIT'),
              propertyIdentity: 'limit',
              propertyType: 'String',
              property: function(item) {
              return item.limit;
            }},
            // number phases
            { identity: $translate.instant('CHARGE_BOX__NUMBER_PHASES'),
              propertyIdentity: 'number_phases',
              propertyType: 'String',
              property: function(item) {
              return item.numberPhases;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteGetConfigurationRequestFactory', ['$location', function($location) {
        var rest15Path = 'rest/v15/chargebox/configuration';
        var rest16Path = 'rest/v16/chargebox/configuration';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteGetDiagnosticsRequestFactory', ['$location', '$translate', 'DateUtils', function($location, $translate, DateUtils) {
        var rest15Path = 'rest/v15/chargebox/diagnostics';
        var rest16Path = 'rest/v16/chargebox/diagnostics';
        var restPath = "rest/chargebox/diagnostics";
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          identity: 'RemoteGetDiagnostics',
          restPath: restPath,
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          loadMetadata: false,
          permission: permissions,
          reloadData: true,
          itemDetailsIdentifier: 'id',
          itemsQuantity: 50,
          dataSynchronizationInterval: 5000,
          singleItemdataSynchronizationInterval: 5000,
          displayMessageInterval: 4000
        };
        return {
            restPath: restPath,
            rest15Path: rest15Path,
            rest16Path: rest16Path,
            viewContext: viewContext,
            initTableDataAction: initTableDataAction,
            searchCriteriaPostContruct: searchCriteriaPostContruct
        }

        function searchCriteriaPostContruct(searchCriteria) {
          var outputSearchCriteria = {};
          for(var key in searchCriteria) {
            if(key == 'fromTime') {
              if(searchCriteria.fromTime != undefined) {
                var values = [];
                if(searchCriteria.fromTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
                } else {
                  values.push(searchCriteria[key]);
                }
                outputSearchCriteria['fromTime'] = values;
              }
            } else if(key == 'toTime') {
              if(searchCriteria.toTime != undefined) {
                var values = [];
                if(searchCriteria.toTime.getTime != undefined) {
                    values.push(searchCriteria[key].getTime());
                } else {
                    values.push(searchCriteria[key]);
                }
                outputSearchCriteria['toTime'] = values;
              }
            } else {
              outputSearchCriteria[key] = searchCriteria[key];
            }
          }
          return outputSearchCriteria;
        }

        function initTableDataAction(itemsData) {
          // init columns
          var tableColumns = [
            // triggerMethod
            { identity: $translate.instant('REQUEST_TIME'),
              propertyIdentity: 'request_time',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.requestTime;
            }},
            // alert time
            { identity: $translate.instant('DIAGNOSTICS__LOCATION'),
              propertyIdentity: 'location',
              propertyType: 'String',
              property: function(item) {
              return item.location;
            }},
            // start time
            { identity: $translate.instant('DIAGNOSTICS__START_TIME'),
              propertyIdentity: 'start_time',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.startTime;
            }},
            // stop time
            { identity: $translate.instant('DIAGNOSTICS__STOP_TIME'),
              propertyIdentity: 'stop_time',
              propertyType: 'FormattedDate',
              formatter: DateUtils.formatDate,
              property: function(item) {
              return item.stopTime;
            }},
            // retries
            { identity: $translate.instant('DIAGNOSTICS__RETRIES'),
              propertyIdentity: 'retries',
              propertyType: 'String',
              property: function(item) {
              return item.retries;
            }},
            // retry interval
            { identity: $translate.instant('DIAGNOSTICS__RETRY_INTERVAL'),
              propertyIdentity: 'retry_interval',
              propertyType: 'String',
              property: function(item) {
              return item.retryInterval;
            }},
          ];
          return {
            headers: tableColumns,
            rows: itemsData
          }
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteResetRequestFactory', [function() {
        var rest15Path = 'rest/v15/chargebox/reset';
        var rest16Path = 'rest/v16/chargebox/reset';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteSetChargingProfileRequestFactory', ['$location', function($location) {
        var rest16Path = 'rest/v16/chargebox/chargingprofile';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
            itemPreSaveAction: itemPreSaveAction
        }

        function itemPreSaveAction(itemData) {
          // valid from
          if(itemData.validFrom != undefined && itemData.validFrom.getTime != undefined) {
            itemData.validFrom = itemData.validTrom.getTime();
          }
          // valid to
          if(itemData.validTo != undefined && itemData.validTo.getTime != undefined) {
            itemData.validTo = itemData.validTo.getTime();
          }
          // start schedule
          if(itemData.startSchedule != undefined && itemData.startSchedule.getTime != undefined) {
            itemData.startSchedule = itemData.startSchedule.getTime();
          }
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteSetMaxPowerChargingProfileRequestFactory', ['$location', function($location) {
        var rest16Path = 'rest/v16/chargebox/chargingprofile/maxpower';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext
        }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteStartTransactionRequestFactory', [function() {
        var rest15Path = 'rest/v15/chargebox/chargetransaction/start';
        var rest16Path = 'rest/v16/chargebox/chargetransaction/start';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('RemoteStopTransactionRequestFactory', [function() {
        var rest15Path = 'rest/v15/chargebox/chargetransaction/stop';
        var rest16Path = 'rest/v16/chargebox/chargetransaction/stop';
        // permissions
        var permissions = {

        }
        // view context
        var viewContext = {
          rest15Path: rest15Path,
          rest16Path: rest16Path,
          permission: permissions
        };
        return {
            viewContext: viewContext,
        }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxConsumedEnergyReportFactory', ['$translate', 'DateUtils', 'ConfigFactory', function($translate, DateUtils, ConfigFactory) {
      var restPath = 'rest/report/chargebox/consumed-energy';
      var viewMetadataRestPath = 'rest/report/chargebox/view/metadata';
      var mainState = 'Report.ChargeBoxConsumedEnergy';
      // permissions
      var permissions = {
        details: 'ReportChargeBox::readList'
      }
      
      // view context
      var viewContext = {
        identity: 'ChargeBoxConsumedEnergyReportList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction,
          loadDataPostAction: loadDataPostAction,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
          exportCsvPreAction: exportCsvPreAction
      }

      function loadDataPostAction(itemsData, oldItemsData, viewStorage, rawData) {
          viewStorage.itemsData = rawData.reports.content;
          var summaryData = [];
          summaryData.push(rawData.summaryReport);
          viewStorage.summaryData = initSummaryTableDataAction(summaryData);
      }

      function exportCsvPreAction(itemsData) {
        return itemsData.reports;
      }

      function initSummaryTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy) : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
            tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
           );
        }
        if(displayAverageConsumedEnergy){
            tableColumns.push(
              // totalChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy) : "---";
              }}
           );
        }
        tableColumns.push(
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined && item.averageChargingReturnedEnergy != NaN ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }}
       );
        tableColumns.push(
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined && item.totalChargingReturnedEnergy != NaN ? Math.round(item.totalChargingReturnedEnergy) : "---";
          }}
       );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function initTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [     
          // chargeBoxIdentity
          { identity: $translate.instant('COMMONS__CHARGE_BOX_NAME'),
            propertyIdentity: 'chargeBoxIdentity',
            propertyType: 'String',
            property: function(item) {
            return item.chargeBoxName;
          }},
          { identity: $translate.instant('CHARGE_BOX_VIEW__CONNECTOR'),
            propertyIdentity: 'connectorId',
            propertyType: 'Long',
            property: function(item) {
            return item.connectorId;
          }},
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy) : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
            tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
            );
        }
        if(displayTotalConsumedEnergy){
            tableColumns.push(
              // totalChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy) : "---";
              }}
            );
        }
        tableColumns.push(
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined ? Math.round(item.totalChargingReturnedEnergy) : "---";
          }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'transaction_id') {
            if(searchCriteria.transaction_id != undefined) {
              var values = [];
              values.push(searchCriteria.transaction_id);
              outputSearchCriteria['transaction_id'] = values;
            }
          } else if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargeBoxGroupConsumedEnergyReportFactory', ['$translate', 'DateUtils', 'ConfigFactory', function($translate, DateUtils, ConfigFactory) {
      var restPath = 'rest/report/chargeboxgroup/consumed-energy';
      var viewMetadataRestPath = 'rest/report/chargeboxgroup/view/metadata';
      var mainState = 'Report.ChargeBoxGroupConsumedEnergy';
      // permissions
      var permissions = {
        details: 'ReportChargeBoxGroup::readList'
      }
      // view context
      var viewContext = {
        identity: 'ChargeBoxGroupConsumedEnergyReportList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction,
          loadDataPostAction: loadDataPostAction,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
          exportCsvPreAction: exportCsvPreAction
      }

      function loadDataPostAction(itemsData, oldItemsData, viewStorage, rawData) {
          viewStorage.itemsData = rawData.reports.content;
          var summaryData = [];
          summaryData.push(rawData.summaryReport);
          viewStorage.summaryData = initSummaryTableDataAction(summaryData);
      }

      function exportCsvPreAction(itemsData) {
        return itemsData.reports;
      }

      function initSummaryTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.chargeboxgroup_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.chargeboxgroup_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy) : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
            tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
            );
        }
        if(displayTotalConsumedEnergy){
            tableColumns.push(
              // totalChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy) : "---";
              }}
            );
        }
        tableColumns.push(
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined && item.averageChargingReturnedEnergy != NaN ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined && item.totalChargingReturnedEnergy != NaN ? Math.round(item.totalChargingReturnedEnergy) : "---";
          }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function initTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.chargeboxgroup_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.chargeboxgroup_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [
          // chargeboxGroupName
          { identity: $translate.instant('COMMONS__CHARGE_BOX_GROUP_NAME'),
            propertyIdentity: 'chargeboxGroupName',
            propertyType: 'String',
            property: function(item) {
            return item.chargeboxGroupName;
          }},
          { identity: $translate.instant('CHARGE_BOX_VIEW__CONNECTOR'),
            propertyIdentity: 'connectorId',
            propertyType: 'Long',
            property: function(item) {
            return item.connectorId;
          }},
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy) : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
          tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
          );
        }
        if(displayTotalConsumedEnergy){
            tableColumns.push(
                // totalChargingConsumedEnergy
                { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy) : "---";
                }}
            );
        }
        tableColumns.push(
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined ? Math.round(item.totalChargingReturnedEnergy*100)/100 : "---";
          }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'transaction_id') {
            if(searchCriteria.transaction_id != undefined) {
              var values = [];
              values.push(searchCriteria.transaction_id);
              outputSearchCriteria['transaction_id'] = values;
            }
          } else if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }
    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ChargingTransactionReportFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
      var restPath = 'rest/report/chargingtransaction/';
      var viewMetadataRestPath = 'rest/report/chargingtransaction/view/metadata';
      var mainState = 'Report.TransactionsReport';
      // permissions
      var permissions = {
        details: 'ReportVehicle::readList'
      }
      // view context
      var viewContext = {
        identity: 'TransactionsReportList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
      };
      return {
          restPath: restPath,
          mainState: mainState,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
          viewContext: viewContext
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ReportTemplatesFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
      var restPath = 'rest/report_template';
      var viewMetadataRestPath = 'rest/report_template/view/metadata';
      var mainState = 'Report.ReportTemplates';
      // permissions
      var permissions = {
        details: 'ChargeBox::readDetails',
        update: 'ChargeBox::updateItem',
        register: 'ChargeBox::registerItem'
      }
      // view context
      var viewContext = {
        identity: 'ReportTemplatesList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        registerViewState: "Report.ReportTemplatesRegister",
        editViewState: "Report.ReportTemplatesEdit",
        itemDetailsIdentifier: 'id',
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
        detailsViewState: "Report.ReportTemplatesDetails",
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          itemPreSaveAction: itemPreSaveAction,
          initTableDataAction: initTableDataAction,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
      }

      function itemPreSaveAction(itemData) {
        var reportElementsString = "";
        if(itemData.reportElementsArray != undefined) {
          for(var index = 0; index < itemData.reportElementsArray.length; index++) {
            reportElementsString = reportElementsString + ", " + itemData.reportElementsArray[index];
          }
          itemData.reportElements = reportElementsString.substring(2);
        }
      }

      function initTableDataAction(itemsData) {
        // init columns
        var tableColumns = [
          // name
          { identity: $translate.instant('COMMONS__NAME'),
            propertyIdentity: 'name',
            propertyType: 'String',
            property: function(item) {
            return item.name;
          }},
          // description
          { identity: $translate.instant('COMMONS__DESCRIPTION'),
            propertyIdentity: 'description',
            propertyType: 'String',
            property: function(item) {
            return item.description;
          }},
          // type
          { identity: $translate.instant('COMMONS__TYPE'),
            propertyIdentity: 'reportType',
            propertyType: 'String',
            property: function(item) {
            return $translate.instant(item.reportType);
          }},
          // elements
          { identity: $translate.instant('COMMONS__ELEMENTS'),
            propertyIdentity: 'reportElements',
            propertyType: 'String',
            property: function(item) {
            return item.reportElements;
          }},
          // interval
          { identity: $translate.instant('COMMONS__TIME_INTERVAL'),
            propertyIdentity: 'reportInterval',
            propertyType: 'String',
            property: function(item) {
            return $translate.instant(item.reportInterval);
          }},
          // detailed
          { identity: $translate.instant('COMMONS__DETAILED'),
            propertyIdentity: 'reportDetailed',
            propertyType: 'String',
            property: function(item) {
            return item.reportDetailed == true ? $translate.instant('COMMONS__YES') : $translate.instant('COMMONS__NO');
          }},
        ];
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        return outputSearchCriteria;
      }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('ReportTemplatesDetailsFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
      var restPath = 'rest/report_template/consumed-energy';
      var viewMetadataRestPath = 'rest/report_template/view/metadata';
      var mainState = 'Report.ReportTemplateDetails';
      // permissions
      var permissions = {
        details: 'ReportChargeBox::readList'
      }
      // view context
      var viewContext = {
        identity: 'ConsumedEnergyReportTemplateList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
        itemDetailsIdentifier: 'id',
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction,
          initSummaryTableDataAction: initSummaryTableDataAction,
          loadDataPostAction: loadDataPostAction,
          exportCsvPreAction: exportCsvPreAction
      }

      function loadDataPostAction(itemsData, oldItemsData, viewStorage, rawData) {
          viewStorage.itemsData = rawData.reports;
          viewStorage.templateData = rawData.reportTemplate;
          viewStorage.fromTime = rawData.fromTime;
          viewStorage.toTime = rawData.toTime;
          // var isDetailsReport = viewStorage.templateData.reportDetailed;
          var summaryData = [];
          summaryData.push(rawData.summaryReport);
          viewStorage.summaryData = initSummaryTableDataAction(summaryData);
      }

      function exportCsvPreAction(itemsData) {
        if (itemsData.reportTemplate.reportDetailed) {
          return itemsData.reports;
        }
        return itemsData.summaryReport;
      }

      function initSummaryTableDataAction(itemsData) {
        // init columns
        var tableColumns = [
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return Math.round(item.totalChargingQuantity*100)/100;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy*100)/100 : "---";
          }},
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined && item.averageChargingReturnedEnergy != NaN ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined && item.totalChargingReturnedEnergy != NaN ? Math.round(item.totalChargingReturnedEnergy*100)/100 : "---";
          }},
        ];
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function initTableDataAction(itemsData) {
        var identityProperty = undefined;
        if(itemsData != undefined && itemsData.length > 0) {
          var firstItem = itemsData[0];
          if(firstItem.chargeBoxIdentity != undefined) {
            identityProperty = 'chargeBoxIdentity'
          } else {
            identityProperty = 'vehicleIdentity';
          }
        }
        
        // init columns
        var tableColumns = [
          // chargeBoxIdentity
          { identity: $translate.instant('COMMONS__NAME'),
            propertyIdentity: 'chargeBoxIdentity',
            propertyType: 'String',
            property: function(item) {
            if(item.chargeBoxIdentity != undefined) {
              return item.chargeBoxName;
            } else {
              return item.vehicleName;
            }
          }},
          { identity: $translate.instant('CHARGE_BOX_VIEW__CONNECTOR'),
            propertyIdentity: 'connector_id',
            propertyType: 'Long',
            property: function(item) {
            return item.connectorId;
          }},
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined ? item.totalChargingConsumedEnergy : "---";
          }},
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined ? Math.round(item.totalChargingReturnedEnergy*100)/100: "---";
          }},
        ];
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('VehicleConsumedEnergyReportFactory', ['$translate', 'DateUtils', 'ConfigFactory', function($translate, DateUtils, ConfigFactory) {
      var restPath = 'rest/report/vehicle/consumed-energy';
      var viewMetadataRestPath = 'rest/report/vehicle/view/metadata';
      var mainState = 'Report.VehicleConsumedEnergy';
      // permissions
      var permissions = {
        details: 'ReportVehicle::readList'
      }
      // view context
      var viewContext = {
        identity: 'VehicleConsumedEnergyReportList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        itemsQuantity: 50,
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction,
          loadDataPostAction: loadDataPostAction,
          searchCriteriaPostContruct: searchCriteriaPostContruct,
          exportCsvPreAction: exportCsvPreAction
      }

      function loadDataPostAction(itemsData, oldItemsData, viewStorage, rawData) {
          viewStorage.itemsData = rawData.reports.content;
          var summaryData = [];
          summaryData.push(rawData.summaryReport);
          viewStorage.summaryData = initSummaryTableDataAction(summaryData);
      }

      function exportCsvPreAction(itemsData) {
        return itemsData.reports;
      }

      function initSummaryTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.vehicle_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.vehicle_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy*100)/100 : "---";
          }},
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined && item.averageChargingReturnedEnergy != NaN ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY'),
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined && item.totalChargingReturnedEnergy != NaN ? Math.round(item.totalChargingReturnedEnergy*100)/100 : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
           tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined && item.averageChargingConsumedEnergy != NaN ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
           );
        }
        if(displayTotalConsumedEnergy){
           tableColumns.push(
              // totalChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined && item.totalChargingConsumedEnergy != NaN ? Math.round(item.totalChargingConsumedEnergy) : "---";
              }}
           );
        }
        tableColumns.push(
           // averageChargingReturnedEnergy
           { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
             propertyIdentity: 'averageChargingReturnedEnergy',
             propertyType: 'Long',
             property: function(item) {
             return item.averageChargingReturnedEnergy != undefined && item.averageChargingReturnedEnergy != NaN ? Math.round(item.averageChargingReturnedEnergy) : "---";
           }},
           // totalChargingReturnedEnergy
           { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
             propertyIdentity: 'totalChargingReturnedEnergy',
             propertyType: 'Long',
             property: function(item) {
             return item.totalChargingReturnedEnergy != undefined && item.totalChargingReturnedEnergy != NaN ? Math.round(item.totalChargingReturnedEnergy) : "---";
           }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function initTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
            consumedEnergyUnit = '[Wh]';
        }
        var displayAverageConsumedEnergy = ConfigFactory.viewSettings['display.vehicle_report.average_consumed_energy'];
        if (displayAverageConsumedEnergy == undefined) {
            displayAverageConsumedEnergy = false;
        }
        var displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.vehicle_report.total_consumed_energy'];
        if (displayTotalConsumedEnergy == undefined) {
            displayTotalConsumedEnergy = false;
        }
        var tableColumns = [
          // vehicleName
          { identity: $translate.instant('VEHICLE_TABLE__SIDE_NUMBER'),
            propertyIdentity: 'vehicleName',
            propertyType: 'String',
            property: function(item) {
            return item.vehicleName;
          }},
          { identity: $translate.instant('CHARGE_BOX_VIEW__CONNECTOR'),
            propertyIdentity: 'connectorId',
            propertyType: 'Long',
            property: function(item) {
            return item.connectorId;
          }},
          // totalChargingTime
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TIME'),
            propertyIdentity: 'totalChargingTime',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.totalChargingTime;
          }},
          // totalChargingQuantity
          { identity: $translate.instant('COMMONS__TOTAL_CHARGING_TRANSACTIONS_QUANTITY'),
            propertyIdentity: 'totalChargingQuantity',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingQuantity;
          }},
          // averageChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'averageChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy*100)/100 : "---";
          }},
          // totalChargingConsumedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
            propertyIdentity: 'totalChargingConsumedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy*100)/100 : "---";
          }},
        ];
        if(displayAverageConsumedEnergy){
            tableColumns.push(
              // averageChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'averageChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.averageChargingConsumedEnergy != undefined ? Math.round(item.averageChargingConsumedEnergy) : "---";
              }}
            );
        }
        if(displayTotalConsumedEnergy){
            tableColumns.push(
              // totalChargingConsumedEnergy
              { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_CONSUMED_ENERGY'),
                propertyIdentity: 'totalChargingConsumedEnergy',
                propertyType: 'Long',
                property: function(item) {
                return item.totalChargingConsumedEnergy != undefined ? Math.round(item.totalChargingConsumedEnergy) : "---";
              }}
            );
        }
        tableColumns.push(
          // averageChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__AVERAGE_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'averageChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.averageChargingReturnedEnergy != undefined ? Math.round(item.averageChargingReturnedEnergy*100)/100 : "---";
          }},
          // totalChargingReturnedEnergy
          { identity: $translate.instant('COMMONS__TOTAL_CHARNGING_RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'totalChargingReturnedEnergy',
            propertyType: 'Long',
            property: function(item) {
            return item.totalChargingReturnedEnergy != undefined ? Math.round(item.totalChargingReturnedEnergy*100)/100 : "---";
          }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'transaction_id') {
            if(searchCriteria.transaction_id != undefined) {
              var values = [];
              values.push(searchCriteria.transaction_id);
              outputSearchCriteria['transaction_id'] = values;
            }
          } else if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('TransactionFactory', ['$translate', 'DateUtils', 'ConfigFactory', function($translate, DateUtils, ConfigFactory) {
      var restPath = 'rest/chargingtransaction';
      var viewMetadataRestPath = 'rest/chargingtransaction/view/metadata';
      var mainState = 'Transaction.List';
      // permissions
      var permissions = {
        details: 'ChargingTransaction::readDetails'
      }
      // charts
      var visibleCharts = [
        // power
        {
          "label": 'Power',
          "graphs": [{
              "lineColor": "#006600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__OUTLET_POWER_ACTIVE_IMPORT'),
              "valueField": "POWER_ACTIVE_IMPORT__OUTLET",
              "measurand": "POWER_ACTIVE_IMPORT",
              "location": "OUTLET",
              "fillAlphas": 0
          },
          {
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__INLET_POWER_ACTIVE_IMPORT'),
              "valueField": "POWER_ACTIVE_IMPORT__INLET",
              "measurand": "POWER_ACTIVE_IMPORT",
              "location": "INLET",
              "fillAlphas": 0
          },
          {
              "lineColor": "#ff0000",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__MAX_POWER'),
              "valueField": "MAX_POWER__OUTLET",
              "measurand": "MAX_POWER",
              "location": "OUTLET",
              "fillAlphas": 0
          }]
        },
        // energy
        {
          "label": 'Energy',
          "graphs": [{
              "lineColor": "#006600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__OUTLET_ENERGY_ACTIVE_IMPORT_REGISTER'),
              "valueField": "ENERGY_ACTIVE_IMPORT_REGISTER__OUTLET",
              "measurand": "ENERGY_ACTIVE_IMPORT_REGISTER",
              "location": "OUTLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__INLET_ENERGY_ACTIVE_IMPORT_REGISTER'),
              "valueField": "ENERGY_ACTIVE_IMPORT_REGISTER__INLET",
              "measurand": "ENERGY_ACTIVE_IMPORT_REGISTER",
              "location": "INLET",
              "fillAlphas": 0
          }]
        },
        // Voltage
        {
          "label": 'Voltage',
          "graphs": [{
              "lineColor": "#006600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__IMPORT_VOLTAGE_OUTLET'),
              "valueField": "IMPORT_VOLTAGE__OUTLET",
              "measurand": "IMPORT_VOLTAGE",
              "location": "OUTLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__IMPORT_VOLTAGE_INLET'),
              "valueField": "IMPORT_VOLTAGE__INLET",
              "measurand": "IMPORT_VOLTAGE",
              "location": "INLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#B0DE09",
              "bullet": "triangleUp",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__VOLTAGE_TARGET_OUTLET'),
              "valueField": "targetVoltage__OUTLET",
              "measurand": "targetVoltage",
              "location": "OUTLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#167bc1",
              "bullet": "triangleUp",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__VOLTAGE_PRESENT_INLET'),
              "valueField": "presentVoltage__OUTLET",
              "measurand": "presentVoltage",
              "location": "OUTLET",
              "fillAlphas": 0
          }]
        },
        // current
        {
          "label": 'Current',
          "graphs": [{
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__CURRENT_IMPORT_OUTLET'),
              "valueField": "CURRENT_IMPORT__OUTLET",
              "measurand": "CURRENT_IMPORT",
              "location": 'OUTLET',
              "fillAlphas": 0
          }, {
              "lineColor": "#FCD202",
              "bullet": "square",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__CURRENT_IMPORT_INLET'),
              "valueField": "CURRENT_IMPORT__INLET",
              "measurand": "CURRENT_IMPORT",
              "location": "INLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#B0DE09",
              "bullet": "triangleUp",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__TARGET_CURRENT_OUTLET'),
              "valueField": "targetCurrent__OUTLET",
              "measurand": "targetCurrent",
              "location": "OUTLET",
              "fillAlphas": 0
          }, {
              "lineColor": "#167bc1",
              "bullet": "triangleUp",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__CURRENT_PRESENT_OUTLET'),
              "valueField": "presentCurrent__OUTLET",
              "measurand": "presentCurrent",
              "location": "OUTLET",
              "fillAlphas": 0
          }]
        },
        // soc
        {
          "label": 'Soc',
          "graphs": [{
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__SOC'),
              "valueField": "SO_C__EV",
              "measurand": "SO_C",
              "location": "EV",
              "fillAlphas": 0
          }]
        },
        // temperature
        {
          "label": 'Temperature',
          "values_prefix": "TEMP_",
          "graphs": [{
              "lineColor": "#006600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "fillAlphas": 0
          }]
        },
        // other
        {
          "label": 'Other',
          "graphs": [{
              "lineColor": "#006600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 20,
              "title": $translate.instant('COMMONS__Humidity'),
              "valueField": "Humidity__OUTLET",
              "measurand": "Humidity",
              "location": "OUTLET",
              "fillAlphas": 0
          }]
        }
      ];
      // view context
      var viewContext = {
        identity: 'TransactionList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        reloadItemData: true,
        itemsQuantity: 50,
        detailsViewState: "Transaction.Details",
        itemDetailsIdentifier: 'transactionId',
        visibleCharts: visibleCharts,
        dataSynchronizationInterval: 5000,
        singleItemdataSynchronizationInterval: 5000,
        displayMessageInterval: 4000
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction,
          searchCriteriaPostContruct: searchCriteriaPostContruct
      }

      function initTableDataAction(itemsData) {
        // init columns
        var consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
        if (consumedEnergyUnit == undefined) {
          consumedEnergyUnit = '[Wh]';
        }
        var displayConsumedEnergy = ConfigFactory.viewSettings['display.transactions.consumed_energy'];
        if (displayConsumedEnergy == undefined) {
            displayConsumedEnergy = false;
        }
        var tableColumns = [
          // transactionId
          { identity: $translate.instant('TRANSACTIONS_TABLE__TRANSACTION_ID'),
            propertyIdentity: 'transaction_id',
            propertyType: 'Long',
            property: function(item) {
            return item.transactionId;
          }},
          // charge box name
          { identity: $translate.instant('TRANSACTIONS_TABLE__CHARGE_BOX_NAME'),
            propertyIdentity: 'charge_box_identity',
            propertyType: 'String',
            property: function(item) {
            return item.chargeBoxName;
          }},
          { identity: $translate.instant('CHARGE_BOX_VIEW__CONNECTOR'),
            propertyIdentity: 'connector_id',
            propertyType: 'Long',
            property: function(item) {
            return item.connectorId;
          }},          
          // startTimestamp
          { identity: $translate.instant('TRANSACTIONS_TABLE__START_TIMESTAMP'),
            propertyIdentity: 'start_timestamp',
            propertyType: 'FormattedDate',
            formatter: DateUtils.formatDate,
            property: function(item) {
            return item.startTimestamp;
          }},
          // stopTimestamp
          { identity: $translate.instant('TRANSACTIONS_TABLE__STOP_TIMESTAMP'),
            propertyIdentity: 'stop_timestamp',
            propertyType: 'FormattedDate',
            formatter: DateUtils.formatDate,
            property: function(item) {
            return item.stopTimestamp;
          }},
          // duration
          { identity: $translate.instant('TRANSACTIONS_TABLE__CHARGING_TIME'),
            propertyIdentity: 'duration',
            propertyType: 'FormattedTimeDuration',
            formatter: DateUtils.millisecondsToStrTimeInterval,
            property: function(item) {
            return item.duration;
          }}
        ];
        if(displayConsumedEnergy){
          tableColumns.push(
            // consumed energy
            { identity: $translate.instant('COMMONS__CONSUMED_ENERGY'),
              propertyIdentity: 'consumed_energy',
              propertyType: 'Long',
              property: function(item) {
              return item.consumedEnergy != undefined ? (Math.round(item.consumedEnergy*100)/100) : "---";
            }}
          );
        }
        tableColumns.push(
          // returned energy
          { identity: $translate.instant('COMMONS__RETURNED_ENERGY') + consumedEnergyUnit,
            propertyIdentity: 'returned_energy',
            propertyType: 'Long',
            property: function(item) {
            return item.returnedEnergy != undefined ? (consumedEnergyUnit != '[kWh]' ? Math.round(item.returnedEnergy*100)/100 : (Math.round(item.returnedEnergy / 1000*100)/100)) : "---";
          }},
          // soc p
          { identity: $translate.instant('COMMONS__SOC_AT_BEGIN'),
            propertyIdentity: 'soc_at_begin',
            propertyType: 'Long',
            property: function(item) {
            return item.socAtBegin != undefined ? Math.round(item.socAtBegin) : "---";
          }},
          // soc k
          { identity: $translate.instant('COMMONS__SOC_AT_END'),
            propertyIdentity: 'soc_at_end',
            propertyType: 'Long',
            property: function(item) {
            return item.socAtEnd != undefined ? Math.round(item.socAtEnd) : "---";
          }},
          // soc d
          { identity: $translate.instant('COMMONS__SOC_DELTA'),
              propertyIdentity: 'soc_delta',
              propertyType: 'Long',
              property: function(item) {
              return item.socDelta != undefined ? Math.round(item.socDelta) : "---";
          }},
          // vehicleId
          { identity: $translate.instant('TRANSACTIONS_TABLE__VEHICLE'),
            propertyIdentity: 'vehicle_id',
            propertyType: 'String',
            property: function(item) {
            return item.vehicleName;
          }},
          // stopReason
          { identity: $translate.instant('TRANSACTIONS_TABLE__EOC_REASON'),
            propertyIdentity: 'stop_reason',
            propertyType: 'String',
            formatter: $translate.instant,
            property: function(item) {
            return item.stopReason;
          }}
        );
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

      function searchCriteriaPostContruct(searchCriteria) {
        var outputSearchCriteria = {};
        for(var key in searchCriteria) {
          if(key == 'transaction_id') {
            if(searchCriteria.transaction_id != undefined) {
              var values = [];
              values.push(searchCriteria.transaction_id);
              outputSearchCriteria['transaction_id'] = values;
            }
          } else if(key == 'fromTime') {
            if(searchCriteria.fromTime != undefined) {
              var values = [];
              if(searchCriteria.fromTime.getTime != undefined) {
                values.push(searchCriteria[key].getTime());
              } else {
                values.push(searchCriteria[key]);
              }
              outputSearchCriteria['fromTime'] = values;
            }
          } else if(key == 'toTime') {
            if(searchCriteria.toTime != undefined) {
              var values = [];
              if(searchCriteria.toTime.getTime != undefined) {
                  values.push(searchCriteria[key].getTime());
              } else {
                  values.push(searchCriteria[key]);
              }
              outputSearchCriteria['toTime'] = values;
            }
          } else {
            outputSearchCriteria[key] = searchCriteria[key];
          }
        }
        return outputSearchCriteria;
      }

    }])
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.resourceserver');

    module.factory('VehicleFactory', ['$translate', 'DateUtils', function($translate, DateUtils) {
      var restPath = 'rest/vehicle';
      var viewMetadataRestPath = 'rest/vehicle/view/metadata';
      var mainState = 'Vehicle.All';
      // permissions
      var permissions = {
        details: 'Vehicle::readDetails'
      }
      // view context
      var viewContext = {
        identity: 'VehicleList',
        restPath: restPath,
        loadMetadata: true,
        viewMetadataRestPath: viewMetadataRestPath,
        permission: permissions,
        reloadData: true,
        reloadItemData: true,
        itemsQuantity: 50,
        detailsViewState: "Vehicle.Details",
        itemDetailsIdentifier: 'identity',
        dataSynchronizationInterval: 5000,
        displayMessageInterval: 4000,
      };
      return {
          restPath: restPath,
          mainState: mainState,
          viewContext: viewContext,
          initTableDataAction: initTableDataAction
      }

      function initTableDataAction(itemsData) {
        // init columns
        var tableColumns = [
          // name
          { identity: $translate.instant('VEHICLE_TABLE__SIDE_NUMBER'),
            propertyIdentity: 'name',
            propertyType: 'String',
            property: function(item) {
            return item.actualConfiguration.sideNumber;
          }},
          // identity
          { identity: $translate.instant('COMMONS__IDENTITY'),
            propertyIdentity: 'identity',
            propertyType: 'String',
            property: function(item) {
            return item.identity;
          }},
          // battery capacity
          { identity: $translate.instant('COMMONS__BATTERY_CAPACITY'),
            propertyIdentity: 'batteryCapacity',
            propertyType: 'Long',
            property: function(item) {
            return item.actualConfiguration.batteryCapacity;
          }},
          // soc
          { identity: $translate.instant('COMMONS__SOC'),
            propertyIdentity: 'soc',
            propertyType: 'Double',
            property: function(item) {
            return item.actualState.soc;
          }},
        ];
        return {
          headers: tableColumns,
          rows: itemsData
        }
      }

    }])
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('UserAdministrationCtrl', ['$controller', '$scope', 'UserAdministrationFactory',
        function($controller, $scope, UserAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: UserAdministrationFactory
            });

            $scope.changePassword = false;

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(UserAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('UserItemAdministrationCtrl', [
        '$controller',
        '$scope',
        'PreconditionsUtils',
        'ResourceServerDataService',
        'ErrorUtils',
        'UserAdministrationFactory',
        function($controller, $scope, PreconditionsUtils, ResourceServerDataService, ErrorUtils, UserAdministrationFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: UserAdministrationFactory
            });

            $scope.addAll = addAll;
            $scope.addSelected = addSelected;
            $scope.removeSelected = removeSelected;
            $scope.deselectAll = deselectAll;
            $scope.selectListItem = selectListItem;
            $scope.updatePassword = updatePassword;

            var availableRolesCopy = undefined;
            var selectedRolesCopy = undefined;

            $scope.initStartAdditions = function() {
              if($scope.itemData.roles == undefined) {
                $scope.itemData.roles = [];
              }
              if($scope.itemData.availableRoles == undefined) {
                $scope.itemData.availableRoles = [];
              }
              availableRolesCopy = [];
              for(var index = 0; index < $scope.itemData.availableRoles.length; index++) {
                availableRolesCopy[index] = $scope.itemData.availableRoles[index];
              }
              selectedRolesCopy = [];
              for(var index = 0; index < $scope.itemData.roles.length; index++) {
                selectedRolesCopy[index] = $scope.itemData.roles[index];
              }
              if($scope.itemData.chargeBoxesAndPriorities == undefined) {
                $scope.itemData.chargeBoxesAndPriorities = [];
              }
              if($scope.itemData.chargeBoxesStatus == undefined) {
                $scope.itemData.chargeBoxesStatus = [];
              }
            }

            function updatePassword(itemData) {
               PreconditionsUtils.checkArgument(itemData != undefined, "itemData argument cannot be undefined", 'Core.ItemViewController', 'updatePassword');

               var itemPromise = ResourceServerDataService.updateItem(UserAdministrationFactory.viewContext, $scope, UserAdministrationFactory.restPath + '/password', itemData, UserAdministrationFactory.mainState, UserAdministrationFactory.itemPreSaveAction);
               // progress bar ============
               cfpLoadingBar.start();
               // =========================
               itemPromise.then(
                 function(success) {
                     // progress bar ============
                     cfpLoadingBar.complete();
                     // =========================
                 },
                 function(error) {
                   // progress bar ============
                   cfpLoadingBar.complete();
                   // =========================
                   ErrorUtils.handleError(error, errors);
                 }
               );
           }


            function addAll() {
              $scope.itemData.roles = [];
              $scope.itemData.availableRoles = [];
              // add from selectedRoles
              for(var index = 0; index < selectedRolesCopy.length; index++) {
                $scope.itemData.roles.push(selectedRolesCopy[index]);
              }
              // add from available
              for(var index = 0; index < availableRolesCopy.length; index++) {
                $scope.itemData.roles.push(availableRolesCopy[index]);
              }
            }

            function deselectAll() {
              $scope.itemData.roles = [];
              $scope.itemData.availableRoles = [];
              for(var index = 0; index < availableRolesCopy.length; index++) {
                $scope.itemData.availableRoles.push(availableRolesCopy[index]);
              }
              for(var index = 0; index < selectedRolesCopy.length; index++) {
                $scope.itemData.availableRoles.push(selectedRolesCopy[index]);
              }
            }

            function addSelected() {
              var availableRolesElements = document.getElementById('availableRoles').getElementsByTagName("li");
              var indexToAdd = [];
              for(var index = 0; index < availableRolesElements.length; index++) {
                  var availablePrivilegeElement = availableRolesElements[index];
                  if(availablePrivilegeElement.classList != undefined && availablePrivilegeElement.classList.contains('selectedListItem')) {
                    indexToAdd.push(index);
                  }
              }
              for(var index = 0; index < indexToAdd.length; index++) {
                var privilegeToAdd = $scope.itemData.availableRoles.splice(indexToAdd[index], 1);
                $scope.itemData.roles.unshift(privilegeToAdd[0]);
              }
            }

            function removeSelected() {
              if($scope.itemData.roles == undefined) {
                $scope.itemData.roles = [];
              }
              var availableRoles = document.getElementById('selectedRoles').getElementsByTagName("li");
              var indexToRemove = [];
              for(var index = 0; index < availableRoles.length; index++) {
                  var chargeBoxIdentityElement = availableRoles[index];
                  if(chargeBoxIdentityElement.classList != undefined && chargeBoxIdentityElement.classList.contains('selectedListItem')) {
                    indexToRemove.push(index);
                  }
              }
              for(var index = 0; index < indexToRemove.length; index++) {
                var privilegeToRemove = $scope.itemData.roles.splice(indexToRemove[index], 1);
                $scope.itemData.availableRoles.unshift(privilegeToRemove[0]);
              }
            }

            function selectListItem(listIdentity, $event) {
              // check if selected
              if($event.currentTarget.classList != undefined && $event.currentTarget.classList.contains('selectedListItem')) {
                $event.currentTarget.classList.remove('selectedListItem');
                return;
              }
              // find all available elements and remove selectedListItem class
              var listElements = document.getElementById(listIdentity).getElementsByTagName("li");
              for(var index = 0; index < listElements.length; index++) {
                  var element = listElements[index];
                  if(element.classList != undefined && element.classList.contains('selectedListItem')) {
                    element.classList.remove('selectedListItem');
                  }
              }
              // add selection
              $event.currentTarget.classList.add('selectedListItem');
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('AlertAdministrationCtrl', ['$controller', '$scope', 'AlertAdministrationFactory',
        function($controller, $scope, AlertAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: AlertAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(AlertAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('AlertAdministrationItemCtrl', [
        '$controller',
        '$scope',
        'AlertAdministrationFactory',
        'cfpLoadingBar',
        'PreconditionsUtils',
        'ResourceServerDataService',
        'ErrorUtils',
        function($controller, $scope, AlertAdministrationFactory, cfpLoadingBar, PreconditionsUtils, ResourceServerDataService, ErrorUtils) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: AlertAdministrationFactory
            });

            var errors = [];

            $scope.deleteAlertDefinitionItem = function(alertData) {
              PreconditionsUtils.checkArgument(alertData != undefined, "alertData argument cannot be undefined", 'Core.ItemViewController', 'save');
              PreconditionsUtils.checkArgument(alertData.id != undefined, "alertData.id argument cannot be undefined", 'Core.ItemViewController', 'save');
              // set hidden
              alertData.hidden = true;
              // invoke promise
              var updateDataPromise = ResourceServerDataService.updateItem(AlertAdministrationFactory.viewContext, $scope, AlertAdministrationFactory.restPath + '/hide', alertData, AlertAdministrationFactory.mainState, AlertAdministrationFactory.itemPreSaveAction);
              // progress bar ============
              cfpLoadingBar.start();
              // =========================
              updateDataPromise.then(
                  function(data) {
                      // progress bar ============
                      cfpLoadingBar.complete();
                      // =========================
                      // nav to details page
                      $state.go(AlertAdministrationFactory.viewContext.mainState);
                  },
                  function(error) {
                      // progress bar ============
                      cfpLoadingBar.complete();
                      // =========================
                      ErrorUtils.handleError(error, errors);
                  }
              );
            }
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('AuthorizationTagItemCtrl', [
        '$controller',
        '$scope',
        'AuthorizationTagFactory',
        function($controller, $scope, AuthorizationTagFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: AuthorizationTagFactory
            });
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('AuthorizationTagsCtrl', ['$controller', '$scope', 'AuthorizationTagFactory',
        function($controller, $scope, AuthorizationTagFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: AuthorizationTagFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(AuthorizationTagFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('ChargeBoxAdministrationCtrl', ['$controller', '$scope', 'ChargeBoxAdministrationFactory',
        function($controller, $scope, ChargeBoxAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('ChargeBoxAdministrationItemCtrl', [
        '$controller',
        '$scope',
        'ChargeBoxAdministrationFactory',
        function($controller, $scope, ChargeBoxAdministrationFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: ChargeBoxAdministrationFactory
            });
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('ChargeBoxGroupAdministrationCtrl', ['$controller', '$scope', 'ChargeBoxGroupAdministrationFactory',
        function($controller, $scope, ChargeBoxGroupAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxGroupAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxGroupAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('ChargeBoxGroupAdministrationItemCtrl', [
        '$controller',
        '$scope',
        'ChargeBoxGroupAdministrationFactory',
        'cfpLoadingBar',
        'ArrayUtils',
        'ResourceServerDataService',
        'ErrorUtils',
        function($controller, $scope, ChargeBoxGroupAdministrationFactory, cfpLoadingBar, ArrayUtils, ResourceServerDataService, ErrorUtils) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: ChargeBoxGroupAdministrationFactory
            });

            $scope.addAll = addAll;
            $scope.addSelected = addSelected;
            $scope.removeSelected = removeSelected;
            $scope.deselectAll = deselectAll;
            $scope.selectListItem = selectListItem;
            $scope.simulateChargeBoxGroupAssigments = simulateChargeBoxGroupAssigments;
            $scope.simulationResults = [];
            $scope.dynamicPowerTotal = {};

            var availableChargeBoxesCopy = undefined;
            var chargeBoxesAndPrioritiesCopy = undefined;

            $scope.initStartAdditions = function() {
              availableChargeBoxesCopy = [];
              for(var index = 0; index < $scope.itemData.availableChargeBoxes.length; index++) {
                availableChargeBoxesCopy[index] = $scope.itemData.availableChargeBoxes[index];
              }
              chargeBoxesAndPrioritiesCopy = {};
              for(var key in $scope.itemData.chargeBoxesAndPriorities) {
                chargeBoxesAndPrioritiesCopy[key] = $scope.itemData.chargeBoxesAndPriorities[key];
              }
              if($scope.itemData.chargeBoxesAndPriorities == undefined) {
                $scope.itemData.chargeBoxesAndPriorities = {};
              }
              if($scope.itemData.chargeBoxesStatus == undefined) {
                $scope.itemData.chargeBoxesStatus = {};
              }
              updateDynamicPowerSimulationResults($scope.itemData.dynamicPowerSimulationResult);
            }

            $scope.preSaveAction = function() {
              // update priorities
              for(var index in $scope.simulationResults) {
                var simulationResult = $scope.simulationResults[index];
                $scope.itemData.chargeBoxesAndPriorities[simulationResult.chargeBoxIdentity] = simulationResult.priority;
                $scope.itemData.chargeBoxesStatus[simulationResult.chargeBoxIdentity] = simulationResult.state;
              }
            }

            function simulateChargeBoxGroupAssigments() {
              $scope.preSaveAction($scope.itemData);
              var promise = ResourceServerDataService.rawSendRequestData(ChargeBoxGroupAdministrationFactory.restPath + '/power/simulation', $scope.itemData);
              // progress bar ============
              cfpLoadingBar.start();
              // =========================
              promise.then(
                function(answer) {
                  // progress bar ============
                  cfpLoadingBar.complete();
                  // =========================
                  updateDynamicPowerSimulationResults(answer.data);
                },
                function(error) {
                  // progress bar ============
                  cfpLoadingBar.complete();
                  // =========================
                  ErrorUtils.handleError(error, errors);
                }
              );
            }

            function updateDynamicPowerSimulationResults(simulationData) {
              // clear simulation results
              $scope.simulationResults = [];
              $scope.dynamicPowerTotal.weight = 0;
              $scope.dynamicPowerTotal.percentUse = 0;
              $scope.dynamicPowerTotal.power = 0;
              // collect simulation data
              var chargeBoxesPriority = simulationData.chargeBoxesPriority;
              var chargeBoxesStatus = simulationData.chargeBoxesStatus;
              var chargeBoxesFactoryPower = simulationData.chargeBoxesFactoryPower;
              var chargeBoxesWeight = simulationData.chargeBoxesWeight;
              var chargeBoxesPercentageUse = simulationData.chargeBoxesPercentageUse;
              var chargeBoxesDynamicPower = simulationData.chargeBoxesDynamicPower;
              for(var chargeBoxIdentity in chargeBoxesPriority) {
                var chargeBoxGroupEntryData = {};
                chargeBoxGroupEntryData.chargeBoxIdentity = chargeBoxIdentity;
                chargeBoxGroupEntryData.priority = chargeBoxesPriority[chargeBoxIdentity];
                chargeBoxGroupEntryData.state = chargeBoxesStatus[chargeBoxIdentity];
                if(chargeBoxesFactoryPower != undefined) {
                  chargeBoxGroupEntryData.factoryPower = chargeBoxesFactoryPower[chargeBoxIdentity];
                }
                if(chargeBoxesWeight != undefined) {
                  chargeBoxGroupEntryData.weight = chargeBoxesWeight[chargeBoxIdentity];
                  if(chargeBoxGroupEntryData.weight != undefined) {
                    $scope.dynamicPowerTotal.weight = $scope.dynamicPowerTotal.weight + chargeBoxGroupEntryData.weight;
                  }
                }
                if(chargeBoxesPercentageUse != undefined) {
                  chargeBoxGroupEntryData.percentageUse = chargeBoxesPercentageUse[chargeBoxIdentity];
                  if(chargeBoxGroupEntryData.percentageUse != undefined) {
                    $scope.dynamicPowerTotal.percentUse = $scope.dynamicPowerTotal.percentUse + chargeBoxGroupEntryData.percentageUse;
                  }
                }
                if(chargeBoxesDynamicPower != undefined) {
                  chargeBoxGroupEntryData.dynamicPower = chargeBoxesDynamicPower[chargeBoxIdentity];
                  if(chargeBoxGroupEntryData.dynamicPower != undefined) {
                    $scope.dynamicPowerTotal.power = $scope.dynamicPowerTotal.power + chargeBoxGroupEntryData.dynamicPower;
                  }
                }
                $scope.simulationResults.push(chargeBoxGroupEntryData);
              }
              $scope.dynamicPowerTotal.weight = $scope.dynamicPowerTotal.weight.toFixed(2);
              $scope.dynamicPowerTotal.percentUse = $scope.dynamicPowerTotal.percentUse.toFixed(2);
            }

            function addAll() {
              $scope.itemData.chargeBoxesAndPriorities = {};
              // add from subscribed
              for(var key in chargeBoxesAndPrioritiesCopy) {
                $scope.itemData.chargeBoxesAndPriorities[key] = chargeBoxesAndPrioritiesCopy[key];
                var chargeBoxGroupEntryData = {};
                chargeBoxGroupEntryData.chargeBoxIdentity = key;
                chargeBoxGroupEntryData.priority = 1;
                chargeBoxGroupEntryData.state = "CHARGING";
                $scope.simulationResults.push(chargeBoxGroupEntryData);
              }
              // add from available
              for(var index = 0; index < availableChargeBoxesCopy.length; index++) {
                var entry = availableChargeBoxesCopy[index];
                var chargeBoxPriority = chargeBoxesAndPrioritiesCopy[entry];
                if(chargeBoxPriority != undefined) {
                    $scope.itemData.chargeBoxesAndPriorities[entry] = chargeBoxPriority;
                    $scope.itemData.chargeBoxesStatus[entry] = 'CHARGING';
                    var chargeBoxGroupEntryData = {};
                    chargeBoxGroupEntryData.chargeBoxIdentity = entry;
                    chargeBoxGroupEntryData.priority = 1;
                    chargeBoxGroupEntryData.state = "CHARGING";
                    $scope.simulationResults.push(chargeBoxGroupEntryData);
                } else {
                    $scope.itemData.chargeBoxesAndPriorities[entry] = 1;
                    $scope.itemData.chargeBoxesStatus[entry] = 'CHARGING';
                    var chargeBoxGroupEntryData = {};
                    chargeBoxGroupEntryData.chargeBoxIdentity = entry;
                    chargeBoxGroupEntryData.priority = 1;
                    chargeBoxGroupEntryData.state = "CHARGING";
                    $scope.simulationResults.push(chargeBoxGroupEntryData);
                }
              }
              $scope.itemData.availableChargeBoxes = [];
            }

            function deselectAll() {
              $scope.itemData.chargeBoxesAndPriorities = {};
              $scope.itemData.availableChargeBoxes = [];
              $scope.simulationResults = [];
              var index = 0;
              for(; index < availableChargeBoxesCopy.length; index++) {
                $scope.itemData.availableChargeBoxes[index] = availableChargeBoxesCopy[index];
              }
              for(var key in chargeBoxesAndPrioritiesCopy) {
                $scope.itemData.availableChargeBoxes[index] = key;
                index++;
              }
              $scope.dynamicPowerTotal.weight = 0;
              $scope.dynamicPowerTotal.percentUse = 0;
              $scope.dynamicPowerTotal.power = 0;
            }

            function addSelected() {
              var availableChargeBoxes = document.getElementById('availableChargeBoxes').getElementsByTagName("li");
              var indexToAdd = [];
              for(var index = 0; index < availableChargeBoxes.length; index++) {
                  var chargeBoxIdentityElement = availableChargeBoxes[index];
                  if(chargeBoxIdentityElement.classList != undefined && chargeBoxIdentityElement.classList.contains('selectedListItem')) {
                    indexToAdd.push(index);
                  }
              }
              for(var index = 0; index < indexToAdd.length; index++) {
                var chargeBoxToAdd = $scope.itemData.availableChargeBoxes.splice(indexToAdd[index], 1);
                var chargeBoxPriority = chargeBoxesAndPrioritiesCopy[chargeBoxToAdd[0]];
                if(chargeBoxPriority != undefined) {
                    $scope.itemData.chargeBoxesAndPriorities[chargeBoxToAdd[0]] = chargeBoxPriority;
                    $scope.itemData.chargeBoxesStatus[chargeBoxToAdd[0]] = 'CHARGING';
                    var chargeBoxGroupEntryData = {};
                    chargeBoxGroupEntryData.chargeBoxIdentity = chargeBoxToAdd[0];
                    chargeBoxGroupEntryData.priority = 1;
                    chargeBoxGroupEntryData.state = "CHARGING";
                    $scope.simulationResults.push(chargeBoxGroupEntryData);
                } else {
                    $scope.itemData.chargeBoxesAndPriorities[chargeBoxToAdd[0]] = 1;
                    $scope.itemData.chargeBoxesStatus[chargeBoxToAdd[0]] = 'CHARGING';
                    var chargeBoxGroupEntryData = {};
                    chargeBoxGroupEntryData.chargeBoxIdentity = chargeBoxToAdd[0];
                    chargeBoxGroupEntryData.priority = 1;
                    chargeBoxGroupEntryData.state = "CHARGING";
                    $scope.simulationResults.push(chargeBoxGroupEntryData);
                }
              }
            }

            function removeSelected() {
              var selectedChargeBoxes = document.getElementById('selectedChargeBoxes').getElementsByTagName("li");
              var itemsToRemove = [];
              for(var index = 0; index < selectedChargeBoxes.length; index++) {
                  var chargeBoxIdentityElement = selectedChargeBoxes[index];
                  if(chargeBoxIdentityElement.classList != undefined && chargeBoxIdentityElement.classList.contains('selectedListItem')) {
                    itemsToRemove.push(chargeBoxIdentityElement.textContent.trim());
                  }
              }
              var simulationIndexToRemove = [];
              for(var index = 0; index < itemsToRemove.length; index++) {
                var itemToRemove = itemsToRemove[index];
                delete $scope.itemData.chargeBoxesAndPriorities[itemToRemove];
                for(var simulationResultsIndex = 0; simulationResultsIndex < $scope.simulationResults.length; simulationResultsIndex++) {
                  var simulationResult = $scope.simulationResults[simulationResultsIndex];
                  if(simulationResult.chargeBoxIdentity == itemToRemove) {
                    $scope.simulationResults.splice(simulationResultsIndex, 1);
                    break;
                  }
                }
                var addAtIndex = ArrayUtils.indexOf(availableChargeBoxesCopy, itemsToRemove[index]);
                if(addAtIndex != -1) {
                    $scope.itemData.availableChargeBoxes.splice(addAtIndex, 0, itemToRemove)
                } else {
                  $scope.itemData.availableChargeBoxes.push(itemToRemove);
                }
              }
            }

            function selectListItem(listIdentity, $event) {
              // check if selected
              if($event.currentTarget.classList != undefined && $event.currentTarget.classList.contains('selectedListItem')) {
                $event.currentTarget.classList.remove('selectedListItem');
                return;
              }
              // find all available elements and remove selectedListItem class
              var listElements = document.getElementById(listIdentity).getElementsByTagName("li");
              for(var index = 0; index < listElements.length; index++) {
                  var element = listElements[index];
                  if(element.classList != undefined && element.classList.contains('selectedListItem')) {
                    element.classList.remove('selectedListItem');
                  }
              }
              // add selection
              $event.currentTarget.classList.add('selectedListItem');
            }

            function findChargeBoxAtList(chargeBoxes, selectedChargeBoxIdentity) {
              for(var index = 0; index < chargeBoxes.length; index++) {
                var chargeBoxIdentity = chargeBoxes[index];
                if(chargeBoxIdentity == selectedChargeBoxIdentity) {
                  return index;
                }
              }
              return -1;
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('RoleAdministrationCtrl', ['$controller', '$scope', 'RoleAdministrationFactory',
        function($controller, $scope, RoleAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: RoleAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(RoleAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('RoleItemAdministrationCtrl', [
        '$controller',
        '$scope',
        'RolePermissionsAdministrationFactory',
        function($controller, $scope, RolePermissionsAdministrationFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: RolePermissionsAdministrationFactory
            });

            $scope.addAll = addAll;
            $scope.addSelected = addSelected;
            $scope.removeSelected = removeSelected;
            $scope.deselectAll = deselectAll;
            $scope.selectListItem = selectListItem;

            var availablePrivilegesCopy = undefined;
            var rolePrivilegesCopy = undefined;

            $scope.initStartAdditions = function() {
              if($scope.itemData.rolePrivileges == undefined) {
                $scope.itemData.rolePrivileges = [];
              }
              if($scope.itemData.availablePrivileges == undefined) {
                $scope.itemData.availablePrivileges = [];
              }
              availablePrivilegesCopy = [];
              for(var index = 0; index < $scope.itemData.availablePrivileges.length; index++) {
                availablePrivilegesCopy[index] = $scope.itemData.availablePrivileges[index];
              }
              rolePrivilegesCopy = [];
              for(var index = 0; index < $scope.itemData.rolePrivileges.length; index++) {
                rolePrivilegesCopy[index] = $scope.itemData.rolePrivileges[index];
              }
              if($scope.itemData.chargeBoxesAndPriorities == undefined) {
                $scope.itemData.chargeBoxesAndPriorities = [];
              }
              if($scope.itemData.currrentRoleName == undefined) {
                $scope.itemData.currrentRoleName = $scope.itemData.roleName;
              }
              if($scope.itemData.chargeBoxesStatus == undefined) {
                $scope.itemData.chargeBoxesStatus = [];
              }
            }

            function addAll() {
              $scope.itemData.rolePrivileges = [];
              $scope.itemData.availablePrivileges = [];
              // add from rolePrivileges
              for(var index = 0; index < rolePrivilegesCopy.length; index++) {
                $scope.itemData.rolePrivileges.push(rolePrivilegesCopy[index]);
              }
              // add from available
              for(var index = 0; index < availablePrivilegesCopy.length; index++) {
                $scope.itemData.rolePrivileges.push(availablePrivilegesCopy[index]);
              }
            }

            function deselectAll() {
              $scope.itemData.rolePrivileges = [];
              $scope.itemData.availablePrivileges = [];
              for(var index = 0; index < availablePrivilegesCopy.length; index++) {
                $scope.itemData.availablePrivileges.push(availablePrivilegesCopy[index]);
              }
              for(var index = 0; index < rolePrivilegesCopy.length; index++) {
                $scope.itemData.availablePrivileges.push(rolePrivilegesCopy[index]);
              }
            }

            function addSelected() {
              var availablePrivilegesElements = document.getElementById('availablePrivileges').getElementsByTagName("li");
              var indexToAdd = [];
              for(var index = 0; index < availablePrivilegesElements.length; index++) {
                  var availablePrivilegeElement = availablePrivilegesElements[index];
                  if(availablePrivilegeElement.classList != undefined && availablePrivilegeElement.classList.contains('selectedListItem')) {
                    indexToAdd.push(index);
                  }
              }
              for(var index = 0; index < indexToAdd.length; index++) {
                var privilegeToAdd = $scope.itemData.availablePrivileges.splice(indexToAdd[index], 1);
                $scope.itemData.rolePrivileges.unshift(privilegeToAdd[0]);
              }
            }

            function removeSelected() {
              if($scope.itemData.rolePrivileges == undefined) {
                $scope.itemData.rolePrivileges = [];
              }
              var availablePrivileges = document.getElementById('selectedPrivileges').getElementsByTagName("li");
              var indexToRemove = [];
              for(var index = 0; index < availablePrivileges.length; index++) {
                  var chargeBoxIdentityElement = availablePrivileges[index];
                  if(chargeBoxIdentityElement.classList != undefined && chargeBoxIdentityElement.classList.contains('selectedListItem')) {
                    indexToRemove.push(index);
                  }
              }
              for(var index = 0; index < indexToRemove.length; index++) {
                var privilegeToRemove = $scope.itemData.rolePrivileges.splice(indexToRemove[index], 1);
                $scope.itemData.availablePrivileges.unshift(privilegeToRemove[0]);
              }
            }

            function selectListItem(listIdentity, $event) {
              // check if selected
              if($event.currentTarget.classList != undefined && $event.currentTarget.classList.contains('selectedListItem')) {
                $event.currentTarget.classList.remove('selectedListItem');
                return;
              }
              // find all available elements and remove selectedListItem class
              var listElements = document.getElementById(listIdentity).getElementsByTagName("li");
              for(var index = 0; index < listElements.length; index++) {
                  var element = listElements[index];
                  if(element.classList != undefined && element.classList.contains('selectedListItem')) {
                    element.classList.remove('selectedListItem');
                  }
              }
              // add selection
              $event.currentTarget.classList.add('selectedListItem');
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('UserActivityAdministrationCtrl', ['$controller', '$scope', 'UserActivityAdministrationFactory',
        function($controller, $scope, UserActivityAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: UserActivityAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(UserActivityAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('UserActivityAdministrationItemCtrl', [
        '$controller',
        '$scope',
        '$stateParams',
        'ViewUtils',
        'UserActivityAdministrationFactory',
        function($controller, $scope, $stateParams, ViewUtils, UserActivityAdministrationFactory) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: UserActivityAdministrationFactory,
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(UserActivityAdministrationFactory.restPath + '/' + $stateParams.databaseId);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.administration');

    module.controller('VehicleAdministrationCtrl', ['$controller', '$scope', 'VehicleAdministrationFactory',
        function($controller, $scope, VehicleAdministrationFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: VehicleAdministrationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(VehicleAdministrationFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.administration');
    module.controller('VehicleAdministrationItemCtrl', [
        '$controller',
        '$scope',
        'VehicleAdministrationFactory',
        function($controller, $scope, VehicleAdministrationFactory) { 
            $controller('Core.EditableSingleItemController', {
                $scope: $scope,
                ViewFactory: VehicleAdministrationFactory
            });
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxAlertsCtrl', ['$controller', '$scope', '$stateParams', 'ChargeBoxAlertsFactory',
        function($controller, $scope, $stateParams, ChargeBoxAlertsFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxAlertsFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxAlertsFactory.viewContext.restPath + "/" + $stateParams.databaseId + "/alert");
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxChangeConfigurationCtrl', [
        '$controller',
        '$scope',
        '$rootScope',
        '$location',
        '$translate',
        'InteractionsUtils',
        'RemoteChangeConfigurationRequestFactory',
        function($controller, $scope, $rootScope, $location, $translate, InteractionsUtils, RemoteChangeConfigurationRequestFactory) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteChangeConfigurationRequestFactory
            });

            $scope.actionAfterRequest = function() {
              if($scope.response.configurationStatus != undefined && $scope.response.configurationStatus != 'Rejected') {
                // event
                $rootScope.$emit('configurationChanged');
                // snackbar
                InteractionsUtils.showSnackbar($translate.instant('CONFIGURATION_WAS_CHANGED'), 5000);
              } else {
                // event
                $rootScope.$emit('configurationChanged');
                // display dialog
                InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
              }
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxConfigurationCtrl', [
      '$controller',
      '$scope',
      '$rootScope',
      '$location',
      '$stateParams',
      '$translate',
      'cfpLoadingBar',
      'ConfigFactory',
      'ChargeBoxConfigurationFactory',
      'RemoteGetConfigurationRequestFactory',
      'RemoteGetDiagnosticsRequestFactory',
      'ChargeBoxesFactory',
      'HttpUtils',
      'ErrorUtils',
      'InteractionsUtils',
        function($controller, $scope, $rootScope, $location, $stateParams, $translate, cfpLoadingBar, ConfigFactory, ChargeBoxConfigurationFactory, RemoteGetConfigurationRequestFactory, RemoteGetDiagnosticsRequestFactory, ChargeBoxesFactory, HttpUtils, ErrorUtils, InteractionsUtils) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: ChargeBoxConfigurationFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxConfigurationFactory.restPath + '/' + $stateParams.databaseId);

            // =====================================================================
            // Implementation
            // =====================================================================
            $rootScope.$on('configurationChanged', function(event, args) {
              downloadConfiguration($scope.itemData);
            });

            $scope.showConfigEntryInput = showConfigEntryInput;
            $scope.downloadConfiguration = downloadConfiguration;
            $scope.showInput = {};
            var errors = [];

            function showConfigEntryInput(configKey, configValue) {
              if($scope.itemData.chargeBoxStatus == 'OFFLINE') {
                InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                return;
              }
              $location.search({"config_key": configKey, "config_value": configValue});
              InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.changeConfigurationDialogTemplate, 'md');
            }

            function downloadConfiguration(chargeBoxData) {
              var requestData = {};
              if(chargeBoxData.protocolVersion == 'ocpp1.5') {
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, RemoteGetConfigurationRequestFactory.viewContext.rest15Path + "/" + chargeBoxData.chargeBoxIdentity, requestData);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                promise.then(
                  function(answer) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    $scope.itemData = answer.data;
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('CONFIGURATION_DOWNLOADED'), 5000);
                  },
                  function(error) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    ErrorUtils.handleError(error, errors);
                  }
                );
                return;
              } else if(chargeBoxData.protocolVersion == 'ocpp1.6') {
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, RemoteGetConfigurationRequestFactory.viewContext.rest16Path + "/" + chargeBoxData.chargeBoxIdentity, requestData);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                promise.then(
                  function(answer) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    $scope.itemData = answer.data;
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('CONFIGURATION_DOWNLOADED'), 5000);
                  },
                  function(error) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    ErrorUtils.handleError(error, errors);
                  }
                );
                return;
              }
              InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('MISSING_CHARGE_BOX_PROTOCOL'));
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxDiagnosticsCtrl', [
      '$controller',
      '$scope',
      '$rootScope',
      '$location',
      '$translate',
      '$stateParams',
      'cfpLoadingBar',
      'ConfigFactory',
      'RemoteGetDiagnosticsRequestFactory',
      'ChargeBoxesFactory',
      'HttpUtils',
      'ErrorUtils',
      'InteractionsUtils',
      'DateUtils',
      'ResourceServerDataService',
        function($controller, $scope, $rootScope, $location, $translate, $stateParams, cfpLoadingBar, ConfigFactory, RemoteGetDiagnosticsRequestFactory, ChargeBoxesFactory, HttpUtils, ErrorUtils, InteractionsUtils, DateUtils, ResourceServerDataService) { 
          $controller('Core.ListPaginationController', {
              $scope: $scope,
              ViewFactory: RemoteGetDiagnosticsRequestFactory
          });

          // =====================================================================
          // override functions
          // =====================================================================
          $scope.initStartAdditions = initStartAdditions;
          // =====================================================================
          // variables available from view
          // =====================================================================

          $scope.navToSetChargingProfile = navToSetChargingProfile;
          $scope.navToChargingProfiles = navToChargingProfiles;
          $scope.getDiagnostics = getDiagnostics;
          $scope.requestData = {};

          // =====================================================================
          // internal state
          // =====================================================================
          var charts = {};
          var chartsZoomData = {};
          var prefixedChartsGraphColors = ["#006600", "#FF6600", "#B0DE09", "#167bc1", "#FCD202"];
          var updatingCharts = false;
          var errors = [];

          // =====================================================================
          // Invoke at start
          // =====================================================================
          $scope.startView(RemoteGetDiagnosticsRequestFactory.viewContext.restPath + '/' + $stateParams.databaseId);

          function navToSetChargingProfile() {
            if($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
              InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
              return;
            }
            InteractionsUtils.changeView('ChargeBox.SetChargingProfile', undefined, undefined, {
                'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
            });
          }

          function navToChargingProfiles() {
            InteractionsUtils.changeView('ChargeBox.ChargingProfiles', undefined, undefined, {
                'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
            });
          }

          // =====================================================================
          // additions
          // =====================================================================
          function initStartAdditions() {
              // get chargeBox data
              var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargeBoxesFactory.viewContext, ChargeBoxesFactory.viewContext.restPath + "/"  + $stateParams.databaseId, undefined);
              loadChargeBoxDataPromise.then(
                function(answer) {
                  // empty
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                  return Promise.reject(error);
                }
              );
          }

            function getDiagnostics() {
              if($scope.itemData.chargeBox.actualConfiguration.ocppProtocolVersion == 'ocpp1.5') {
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, RemoteGetDiagnosticsRequestFactory.viewContext.rest15Path + "/" + $stateParams.databaseId, $scope.requestData);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                promise.then(
                  function(answer) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('GET_DIAGNOSTICS_FINISHED'), 5000);
                  },
                  function(error) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    ErrorUtils.handleError(error, errors);
                  }
                );
                return;
              } else if($scope.itemData.chargeBox.actualConfiguration.ocppProtocolVersion == 'ocpp1.6') {
                var startTime = $scope.requestData['startTime'];
                if(startTime != undefined) {
                  // yyyy-MM-dd'T'HH:mm:ss+00:00
                  $scope.requestData['startTime'] = DateUtils.getJsonOutputDate(startTime);
                }
                var stopTime = $scope.requestData['stopTime'];
                if(stopTime != undefined) {
                  // yyyy-MM-dd'T'HH:mm:ss+00:00
                  $scope.requestData['stopTime'] = DateUtils.getJsonOutputDate(stopTime);
                }
                var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, RemoteGetDiagnosticsRequestFactory.viewContext.rest16Path + "/" + $stateParams.databaseId, $scope.requestData);
                // progress bar ============
                cfpLoadingBar.start();
                // =========================
                promise.then(
                  function(answer) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    // snackbar
                    InteractionsUtils.showSnackbar($translate.instant('GET_DIAGNOSTICS_FINISHED'), 5000);
                    // reset request
                    $scope.requestData['location'] = undefined;
                    $scope.requestData['startTime'] = undefined;
                    $scope.requestData['stopTime'] = undefined;
                    $scope.requestData['retry'] = undefined;
                    $scope.requestData['retryInterval'] = undefined;
                  },
                  function(error) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    ErrorUtils.handleError(error, errors);
                    // reset request
                    $scope.requestData['location'] = undefined;
                    $scope.requestData['startTime'] = undefined;
                    $scope.requestData['stopTime'] = undefined;
                    $scope.requestData['retry'] = undefined;
                    $scope.requestData['retryInterval'] = undefined;
                  }
                );
                return;
              }
              InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('MISSING_CHARGE_BOX_PROTOCOL'));
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxResetCtrl', ['$controller', '$rootScope', '$scope', '$translate', 'InteractionsUtils', 'RemoteResetRequestFactory',
        function($controller, $rootScope, $scope, $translate, InteractionsUtils, RemoteResetRequestFactory) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteResetRequestFactory
            });

            $scope.actionAfterRequest = function() {
              if($scope.response.resetStatus != undefined && $scope.response.resetStatus != 'Rejected') {
                // snackbar
                InteractionsUtils.showSnackbar($translate.instant('RESET_ACCEPTED'), 5000);
              } else {
                // display dialog
                InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
              }
            }
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxSetMaxPowerCtrl', [
        '$controller',
        '$scope',
        '$rootScope',
        '$location',
        '$uibModalStack',
        '$translate',
        'InteractionsUtils',
        'RemoteSetMaxPowerChargingProfileRequestFactory',
        function($controller, $scope, $rootScope, $location, $uibModalStack, $translate, InteractionsUtils, RemoteSetMaxPowerChargingProfileRequestFactory) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteSetMaxPowerChargingProfileRequestFactory
            });

            $scope.actionAfterRequest = function() {
              if($scope.response.chargingProfileStatus != undefined && $scope.response.chargingProfileStatus != 'Rejected') {
                // snackbar
                InteractionsUtils.showSnackbar($translate.instant('MAX_POWER_WAS_CHANGED'), 5000);
              } else {
                // display dialog
                InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
              }
            }

        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxStartTransactionCtrl', [
        '$controller',
        '$rootScope',
        '$scope',
        '$translate',
        'InteractionsUtils',
        'RemoteStartTransactionRequestFactory',
        function($controller, $rootScope, $scope, $translate, InteractionsUtils, RemoteStartTransactionRequestFactory) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteStartTransactionRequestFactory
            });

            $scope.actionAfterRequest = function() {
              if($scope.response.startStatus != undefined && $scope.response.startStatus != 'Rejected') {
                // snackbar
                InteractionsUtils.showSnackbar($translate.instant('TRANSACTION_WAS_STARTED'), 5000);
              } else {
                // display dialog
                InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
              }
            }
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxStopTransactionCtrl', [
        '$controller',
        '$rootScope',
        '$scope',
        '$translate',
        'InteractionsUtils',
        'RemoteStopTransactionRequestFactory',
        function($controller, $rootScope, $scope, $translate, InteractionsUtils, RemoteStopTransactionRequestFactory) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteStopTransactionRequestFactory
            });

            $scope.actionAfterRequest = function() {
              if($scope.response.stopStatus != undefined && $scope.response.stopStatus != 'Rejected') {
                // snackbar
                InteractionsUtils.showSnackbar($translate.instant('TRANSACTION_WAS_STOPPED'), 5000);
              } else {
                // display dialog
                InteractionsUtils.openInfoDialog($translate.instant('ERROR'), $translate.instant('REQUEST_WAS_REJECTED'));
              }
            }
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxTransactionsCtrl', ['$controller', '$scope', '$stateParams', 'ChargeBoxTransactionsFactory',
        function($controller, $scope, $stateParams, ChargeBoxTransactionsFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxTransactionsFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxTransactionsFactory.viewContext.restPath + "/" + $stateParams.databaseId + "/chargingtransaction");
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxesActivityHoursCtrl', [
       '$controller',
       '$scope',
       '$stateParams',
       '$translate',
       '$location',
       'InteractionsUtils',
       'ChartUtils',
       'DateUtils',
       'CookieUtils',
       'ConfigFactory',
       'ChargeBoxesActivityHoursFactory',
       'ChargeBoxesFactory',
       'ResourceServerDataService',
        function($controller, $scope, $stateParams, $translate, $location, InteractionsUtils, ChartUtils, DateUtils, CookieUtils, ConfigFactory, ChargeBoxesActivityHoursFactory, ChargeBoxesFactory, ResourceServerDataService) { 
            $controller('Core.ListDisabledPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesActivityHoursFactory
            });

            // =====================================================================
            // override functions
            // =====================================================================
            $scope.initStartAdditions = initStartAdditions;
            $scope.initReloadAdditions = initReloadAdditions;
            $scope.showPowerSetInput = showPowerSetInput;
            $scope.showChargeBoxMap = showChargeBoxMap;
            $scope.showChargeBoxConfiguration = showChargeBoxConfiguration;
            // =====================================================================
            // variables available from view
            // =====================================================================
            $scope.displayedCharts = ChargeBoxesActivityHoursFactory.viewContext.displayedCharts;
            // =====================================================================
            // internal state
            // =====================================================================
            var charts = {};
            var chartsZoomData = {};
            var prefixedChartsGraphColors = ["#006600", "#FF6600", "#B0DE09", "#167bc1", "#FCD202"];
            var updatingCharts = false;

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesActivityHoursFactory.viewContext.restPath + "/" + $stateParams.databaseId);

            // =====================================================================
            // additions
            // =====================================================================
            function initStartAdditions() {
                // get chargeBox data
                var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargeBoxesFactory.viewContext, ChargeBoxesFactory.viewContext.restPath + "/"  + $stateParams.databaseId, undefined);
                loadChargeBoxDataPromise.then(
                  function(answer) {
                    // empty
                  },
                  function(error) {
                    ErrorUtils.handleError(error, errors);
                    return Promise.reject(error);
                  }
                ).then(
                    function() {
                      // init charts
                      var chartsData = undefined;
                      var initChartsPromise = undefined;
                      if(ConfigFactory.viewSettings['disableErrorState']) {
                          chartsData = { ActivityHours: ChartUtils.generateActivityHoursChartData($scope.itemsData, true)};
                          initChartsPromise = ChartUtils.initCharts(ChargeBoxesActivityHoursFactory.viewContext.visibleCharts, charts, chartsData, prefixedChartsGraphColors, undefined, [$translate.instant('COMMONS__CHARGE_BOX') + "_" + $scope.itemData.chargeBox.actualConfiguration['name']], "", chartYAxisLabelFunctionWithoutError);
                      } else {
                          chartsData = { ActivityHours: ChartUtils.generateActivityHoursChartData($scope.itemsData, false)};
                          initChartsPromise = ChartUtils.initCharts(ChargeBoxesActivityHoursFactory.viewContext.visibleCharts, charts, chartsData, prefixedChartsGraphColors, undefined, [$translate.instant('COMMONS__CHARGE_BOX') + "_" + $scope.itemData.chargeBox.actualConfiguration['name']], "", chartYAxisLabelFunction);
                      }
                      initChartsPromise.then(
                          function(data) {
                              for (var key in charts) {
                                  var chart = charts[key];
                                  chart.addListener("zoomed", handleZoom);
                              }
                          }
                      );
                    }
                );
            }

            function initReloadAdditions() {
              updatingCharts = true;
              // generate charts data
              var chartsData = undefined;
              if(ConfigFactory.viewSettings['disableErrorState']) {
                chartsData = { ActivityHours: ChartUtils.generateActivityHoursChartData($scope.itemsData, true)};
              } else {
                chartsData = { ActivityHours: ChartUtils.generateActivityHoursChartData($scope.itemsData, false)};
              }
              // clear charts
              ChartUtils.clearCharts(ChargeBoxesActivityHoursFactory.viewContext.visibleCharts, charts);
              // update charts
              updateCharts(chartsData);
              // get chargeBox data
              var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargeBoxesFactory.viewContext, ChargeBoxesFactory.viewContext.restPath + "/"  + $stateParams.databaseId, undefined);
              loadChargeBoxDataPromise.then(
                function(answer) {
                  // empty
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                }
              );
            }

            function updateCharts(chartsData) {
              for (var visibleChartIndex = 0; visibleChartIndex < ChargeBoxesActivityHoursFactory.viewContext.visibleCharts.length; visibleChartIndex++) {
                var visibleChart = ChargeBoxesActivityHoursFactory.viewContext.visibleCharts[visibleChartIndex];
                if(chartsData[visibleChart.label] != undefined) {
                  var chart = charts[visibleChart.label];
                  var chartData = chartsData[visibleChart.label];
                  for(var chartDataEntryIndex = 0; chartDataEntryIndex < chartData.length; chartDataEntryIndex++) {
                    chart.dataProvider.push(chartData[chartDataEntryIndex]);
                  }
                  chart.validateData();
                  var chartZoomData = chartsZoomData[visibleChart.label];
                  if (chartZoomData != undefined) {
                      chart.zoomToIndexes(chartZoomData.startIndex, chartZoomData.endIndex);
                  }
                }
              }
              updatingCharts = false;
            }

            function handleZoom(event) {
                if (!updatingCharts) {
                    chartsZoomData[event.chart.div.id] = {
                        'startIndex': event.startIndex,
                        'endIndex': event.endIndex
                    }
                }
            }

            function resetChartsZoomData() {
                chartsZoomData = {};
            }

            function chartYAxisLabelFunction(value, valueText, valueAxis) {
              switch (value) {
                case 0:
                  valueText = $translate.instant("OFFLINE_CHART_STATE");
                  break;
                case 1:
                  valueText = $translate.instant("ONLINE_CHART_STATE");
                  break;
                case 2:
                  valueText = $translate.instant("ERROR_CHART_STATE");
                  break;
                case 3:
                  valueText = $translate.instant("CHARGING_CHART_STATE");
                  break;
                default:
                  valueText = "";
              }
              return valueText;
            }

            function chartYAxisLabelFunctionWithoutError(value, valueText, valueAxis) {
              switch (value) {
                case 0:
                  valueText = $translate.instant("OFFLINE_CHART_STATE");
                  break;
                case 1:
                  valueText = $translate.instant("ONLINE_CHART_STATE");
                  break;
                case 2:
                  valueText = $translate.instant("CHARGING_CHART_STATE");
                  break;
                default:
                  valueText = "";
              }
              return valueText;
            }

            function showChargeBoxConfiguration() {
                InteractionsUtils.changeView('ChargeBox.Configuration', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }

            function showChargeBoxMap() {
                InteractionsUtils.changeView('Map.ChargeBox');
            }

            function showPowerSetInput() {
                if ($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
                    InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                    return;
                }
                $location.search({
                    "config_key": 'maxPowerSet',
                    "config_value": $scope.itemData.chargeBox.actualConfiguration.maxPowerSet
                });
                InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.setMaxPowerDialogTemplate, 'md');
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesChargingCtrl', ['$controller', '$scope', 'ChargeBoxesChargingFactory',
        function($controller, $scope, ChargeBoxesChargingFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesChargingFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesChargingFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxesChargingProfilesCtrl', [
       '$controller',
       '$scope',
       '$stateParams',
       '$translate',
       'InteractionsUtils',
       'ChartUtils',
       'DateUtils',
       'CookieUtils',
       'ChargeBoxesChargingProfilesFactory',
       'ChargeBoxesFactory',
       'ResourceServerDataService',
        function($controller, $scope, $stateParams, $translate, InteractionsUtils, ChartUtils, DateUtils, CookieUtils, ChargeBoxesChargingProfilesFactory, ChargeBoxesFactory, ResourceServerDataService) { 
            $controller('Core.ListDisabledPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesChargingProfilesFactory
            });

            // =====================================================================
            // override functions
            // =====================================================================
            $scope.initStartAdditions = initStartAdditions;
            // =====================================================================
            // variables available from view
            // =====================================================================
            $scope.navToSetChargingProfile = navToSetChargingProfile;
            $scope.navToChargingProfiles = navToChargingProfiles;

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesChargingProfilesFactory.viewContext.restPath + $stateParams.databaseId);

            function navToSetChargingProfile() {
              InteractionsUtils.changeView('ChargeBox.SetChargingProfile', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            function navToChargingProfiles() {
              InteractionsUtils.changeView('ChargeBox.ChargingProfiles', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            // =====================================================================
            // additions
            // =====================================================================
            function initStartAdditions() {
                // get chargeBox data
                var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargeBoxesFactory.viewContext, ChargeBoxesFactory.viewContext.restPath + "/"  + $stateParams.databaseId, undefined);
                loadChargeBoxDataPromise.then(
                  function(answer) {
                    // empty
                  },
                  function(error) {
                    ErrorUtils.handleError(error, errors);
                    return Promise.reject(error);
                  }
                );
            }

        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxesChargingScheduleCtrl', [
       '$controller',
       '$scope',
       '$stateParams',
       '$translate',
       'InteractionsUtils',
       'ChartUtils',
       'DateUtils',
       'CookieUtils',
       'RemoteGetChargingScheduleFactory',
       'ChargeBoxesFactory',
       'ResourceServerDataService',
       'ErrorUtils',
        function($controller, $scope, $stateParams, $translate, InteractionsUtils, ChartUtils, DateUtils, CookieUtils, RemoteGetChargingScheduleFactory, ChargeBoxesFactory, ResourceServerDataService, ErrorUtils) { 
            $controller('Core.ListDisabledPaginationController', {
                $scope: $scope,
                ViewFactory: RemoteGetChargingScheduleFactory
            });

            // =====================================================================
            // override functions
            // =====================================================================
            $scope.initStartAdditions = initStartAdditions;
            // =====================================================================
            // variables available from view
            // =====================================================================

            $scope.navToSetChargingProfile = navToSetChargingProfile;
            $scope.navToChargingProfiles = navToChargingProfiles;
            $scope.sendGetChargingScheduleRequest = sendGetChargingScheduleRequest;
            $scope.requestData = {};

            // =====================================================================
            // internal state
            // =====================================================================
            var charts = {};
            var chartsZoomData = {};
            var prefixedChartsGraphColors = ["#006600", "#FF6600", "#B0DE09", "#167bc1", "#FCD202"];
            var updatingCharts = false;
            var errors = [];

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView();

            function navToSetChargingProfile() {
              if($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
                InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                return;
              }
              InteractionsUtils.changeView('ChargeBox.SetChargingProfile', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            function navToChargingProfiles() {
              InteractionsUtils.changeView('ChargeBox.ChargingProfiles', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            // =====================================================================
            // additions
            // =====================================================================
            function initStartAdditions() {
                // get chargeBox data
                var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargeBoxesFactory.viewContext, ChargeBoxesFactory.viewContext.restPath + "/"  + $stateParams.databaseId, undefined);
                loadChargeBoxDataPromise.then(
                  function(answer) {
                    // empty
                  },
                  function(error) {
                    ErrorUtils.handleError(error, errors);
                    return Promise.reject(error);
                  }
                );
            }

            function sendGetChargingScheduleRequest() {
              if($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
                InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                return;
              }
              var getChargingSchedulePromise = ResourceServerDataService.rawSendRequestData(RemoteGetChargingScheduleFactory.viewContext.rest16Path + "/" + $scope.itemData.chargeBox.chargeBoxIdentity, $scope.requestData);
              getChargingSchedulePromise.then(
                function(answer) {
                  if(answer.data.status == 'Rejected') {
                    InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('REQUEST_WAS_REJECTED'));
                    return;
                  }
                  $scope.sendedRequestData = {
                    connectorId: $scope.requestData.connectorId,
                    duration: $scope.requestData.duration,
                    chargingRateUnit: $scope.requestData.chargingRateUnit,
                  }
                  $scope.itemsData = RemoteGetChargingScheduleFactory.initTableDataAction(answer.data.chargingSchedulePeriod);
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                  return Promise.reject(error);
                }
              );
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesCtrl', ['$controller', '$scope', 'ChargeBoxesFactory',
        function($controller, $scope, ChargeBoxesFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesErrorCtrl', ['$controller', '$scope', 'ChargeBoxesErrorFactory',
        function($controller, $scope, ChargeBoxesErrorFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesErrorFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesErrorFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxesItemCtrl', [
        '$controller',
        '$rootScope',
        '$scope',
        '$location',
        '$stateParams',
        '$translate',
        'InteractionsUtils',
        'ChartUtils',
        'ConfigFactory',
        'ChargeBoxesFactory',
        'TransactionFactory',
        'ResourceServerDataService',
        'RemoteGetChargingScheduleFactory',
        'DateUtils',
        'ErrorUtils',
        function($controller, $rootScope, $scope, $location, $stateParams, $translate, InteractionsUtils, ChartUtils, ConfigFactory, ChargeBoxesFactory, TransactionFactory, ResourceServerDataService, RemoteGetChargingScheduleFactory, DateUtils, ErrorUtils) { 
            $controller('Core.SingleItemController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesFactory
            });
            // =====================================================================
            // actions available from view
            // =====================================================================
            $scope.showHistoricSessions = showHistoricSessions;
            $scope.showHistoricAlerts = showHistoricAlerts;
            $scope.remoteStartTransaction = remoteStartTransaction;
            $scope.remoteStopTransaction = remoteStopTransaction;
            $scope.showPowerSetInput = showPowerSetInput;
            $scope.showChargeBoxMap = showChargeBoxMap;
            $scope.showChargingDetails = showChargingDetails;
            $scope.showChargeBoxActivityHours = showChargeBoxActivityHours;
            $scope.showChargeBoxConfiguration = showChargeBoxConfiguration;
            $scope.showChargeBoxDiagnostics = showChargeBoxDiagnostics;
            $scope.showTransactionFromConnector = showTransactionFromConnector;
            $scope.remoteReset = remoteReset;
            $scope.showChargingProfiles = showChargingProfiles;
            $scope.getMaxPowerCompositeSchedule = getMaxPowerCompositeSchedule;
            $scope.formatDate = DateUtils.formatDate;
            $scope.consumedEnergyUnit = ConfigFactory.viewSettings['translations.units.returned_energy'];
            if ($scope.consumedEnergyUnit == undefined) {
              $scope.consumedEnergyUnit = '[Wh]';
            }
            $scope.displayCommunicationProtocol = ConfigFactory.viewSettings['display.chargebox_details.communication_protocol'];
            if ($scope.displayCommunicationProtocol == undefined) {
              $scope.displayCommunicationProtocol = false;
            }
            $scope.displayDistance = ConfigFactory.viewSettings['display.chargebox_details.distance'];
            if ($scope.displayDistance == undefined) {
              $scope.displayDistance = false;
            }
            $scope.displayTotalConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_details.total_consumed_energy'];
            if ($scope.displayTotalConsumedEnergy == undefined) {
              $scope.displayTotalConsumedEnergy = false;
            }
            $scope.displayConsumedEnergy = ConfigFactory.viewSettings['display.chargebox_details.consumed_energy'];
            if ($scope.displayConsumedEnergy == undefined) {
              $scope.displayConsumedEnergy = false;
            }
            // =====================================================================
            // override functions
            // =====================================================================
            $scope.initStartAdditions = initStartAdditions;
            $scope.initReloadAdditions = initReloadAdditions;
            // =====================================================================
            // variables available from view
            // =====================================================================
            $scope.displayedCharts = [];
            $scope.transactionData = {};
            var errors = [];

            // =====================================================================
            // internal state
            // =====================================================================
            var charts = {};
            var chartsZoomData = {};
            var currentTransactionId = undefined;
            var updatingCharts = false;
            var prefixedChartsGraphColors = ["#006600", "#FF6600", "#B0DE09", "#167bc1", "#FCD202"];

            // invoke at controller start
            $scope.startView(ChargeBoxesFactory.restPath  + '/' + $stateParams.databaseId);

            // =====================================================================
            // implementation
            // =====================================================================

            function showTransactionFromConnector(connectorId) {
              InteractionsUtils.changeView('ChargeBox.Details', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'connectorId': connectorId,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            function showHistoricSessions() {
                InteractionsUtils.changeView('ChargeBox.Transactions', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }

            function showHistoricAlerts() {
                InteractionsUtils.changeView('ChargeBox.Alerts', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }

            function remoteStartTransaction() {
                InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.chargeBoxStartTransactionDialogTemplate, 'lg');
            }

            function remoteStopTransaction() {
                InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.chargeBoxStopTransactionDialogTemplate, 'lg');
            }

            function remoteReset() {
                InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.chargeBoxResetDialogTemplate, 'lg');
            }

            function getMaxPowerCompositeSchedule() {
              if($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
                InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                return;
              }
              var loadMaxPowerPromise = ResourceServerDataService.rawLoadSingleItemData(RemoteGetChargingScheduleFactory.viewContext, RemoteGetChargingScheduleFactory.viewContext.rest16Path + "/power/" + $scope.itemData.chargeBox.chargeBoxIdentity, undefined);
              loadMaxPowerPromise.then(
                function(answer) {
                  if(answer.status == 'Rejected') {
                    InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('REQUEST_WAS_REJECTED'));
                    return;
                  }
                  var maxPowerSet = 0;
                  if(answer.chargingSchedulePeriod != undefined) {
                    for(var index = 0; index < answer.chargingSchedulePeriod.length; index++) {
                      var chargingSchedulePeriod = answer.chargingSchedulePeriod[index];
                      if(chargingSchedulePeriod.limit > maxPowerSet) {
                        maxPowerSet = chargingSchedulePeriod.limit;
                      }
                    }
                  }
                  $scope.itemData.chargeBox.actualConfiguration.maxPowerSet = maxPowerSet;

                  // snackbar
                  InteractionsUtils.showSnackbar($translate.instant('MAX_POWER_WAS_CHANGED'), 5000);
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                  return Promise.reject(error);
                }
              );
            }

            function showPowerSetInput() {
                if ($scope.itemData.chargeBox.actualState.chargeBoxStatus == 'OFFLINE') {
                    InteractionsUtils.openInfoDialog($translate.instant('DIALOG__ERROR_TITLE'), $translate.instant('CHARGE_BOX__IS_IN_OFFLINE_STATE'));
                    return;
                }
                $location.search({
                    "config_key": 'maxPowerSet',
                    "config_value": $scope.itemData.chargeBox.actualConfiguration.maxPowerSet
                });
                InteractionsUtils.openCustomDialog(ChargeBoxesFactory.viewContext.setMaxPowerDialogTemplate, 'md');
            }

            function showChargeBoxMap() {
                InteractionsUtils.changeView('Map.ChargeBox');
            }

            function showChargingDetails(transactionId) {
                InteractionsUtils.changeView('transactiondetails', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargingTransaction['id']
                });
            }

            function showChargeBoxActivityHours() {
                InteractionsUtils.changeView('ChargeBox.ActivityHours', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }

            function showChargingProfiles() {
              InteractionsUtils.changeView('ChargeBox.ChargingSchedule', undefined, undefined, {
                  'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                  'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
              });
            }

            function showChargeBoxConfiguration() {
                InteractionsUtils.changeView('ChargeBox.Configuration', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }

            function showChargeBoxDiagnostics() {
                InteractionsUtils.changeView('ChargeBox.Diagnostics', undefined, undefined, {
                    'state': $scope.itemData.chargeBox.actualState.chargeBoxStatus,
                    'databaseId': $scope.itemData.chargeBox[ChargeBoxesFactory.viewContext['itemDetailsIdentifier']]
                });
            }
            // =====================================================================
            // additions
            // =====================================================================
            function initStartAdditions() {
                $scope.convert = "W";
                if ($scope.itemData.chargingTransaction != null) {
                    for (var meterValue = 0; meterValue < $scope.itemData.chargingTransaction.actualState.meterValues.length; meterValue++) {
                        for (var item = 0; item < $scope.itemData.chargingTransaction.actualState.meterValues[meterValue].meterValueItems.length; item++) {
                            if ("MAX_POWER" == $scope.itemData.chargingTransaction.actualState.meterValues[meterValue].meterValueItems[item].measurand) {
                                if ($scope.itemData.chargingTransaction.actualState.meterValues[meterValue].meterValueItems[item].meterValue > 0) {
                                    $scope.convert = "kW";
                                    break;
                                }
                            }
                        }
                    }
                }

                $scope.maxPowerInit = $scope.itemData.chargeBox.actualConfiguration.maxPowerSet;
                if ($scope.maxPowerInit > 0) {
                    $scope.convert = "kW";
                }


                // total consumed energy
                if ($scope.itemData.chargeBox.actualState.totalConsumedEnergy != undefined) {
                    $scope.itemData.chargeBox.actualState.totalConsumedEnergy = Math.round($scope.itemData.chargeBox.actualState.totalConsumedEnergy);
                }
                // check preconditions
                if ($scope.itemData.chargingTransaction == undefined) {
                    return;
                }
                currentTransactionId = $scope.itemData.chargingTransaction.transactionId;
                // consumed energy
                if ($scope.itemData.chargingTransaction.actualState.consumedEnergy != undefined) {
                    $scope.itemData.chargingTransaction.actualState.consumedEnergy = Math.round($scope.itemData.chargingTransaction.actualState.consumedEnergy);
                }
                startCharts();
            }
            
            function initReloadAdditions() {
                var maxPower = $scope.itemData.chargeBox.actualConfiguration.maxPowerSet;
                if (maxPower > 0 && $scope.convert == "W") {
                  updatingCharts = true;
                  $scope.convert = "kW";
                  var chartsData = ChartUtils.generateChartData(TransactionFactory.viewContext.visibleCharts, $scope.itemData.chargingTransaction.actualState.meterValues, $scope.convert);
                  ChartUtils.clearCharts(TransactionFactory.viewContext.visibleCharts, charts);
                  updateCharts(chartsData);
                }
                // total consumed energy
                if ($scope.itemData.chargeBox.actualState.totalConsumedEnergy != undefined) {
                    $scope.itemData.chargeBox.actualState.totalConsumedEnergy = Math.round($scope.itemData.chargeBox.actualState.totalConsumedEnergy);
                }
                // check preconditions
                if ($scope.itemData.chargingTransaction == undefined) {
                    ChartUtils.clearCharts(TransactionFactory.viewContext.visibleCharts, charts);
                    return;
                }
                // consumed energy
                if ($scope.itemData.chargingTransaction.actualState.consumedEnergy != undefined) {
                    $scope.itemData.chargingTransaction.actualState.consumedEnergy = Math.round($scope.itemData.chargingTransaction.actualState.consumedEnergy);
                }
                if (currentTransactionId == undefined || currentTransactionId != $scope.itemData.chargingTransaction.transactionId) {
                    resetChartsZoomData();
                    currentTransactionId = $scope.itemData.chargingTransaction.transactionId;
                    startCharts();
                } else {
                  updatingCharts = true;
                  // generate charts data
                  var chartsData = ChartUtils.generateChartData(TransactionFactory.viewContext.visibleCharts, $scope.itemData.chargingTransaction.actualState.meterValues, $scope.convert);
                  // clear charts
                  ChartUtils.clearCharts(TransactionFactory.viewContext.visibleCharts, charts);
                  // update charts
                  updateCharts(chartsData);
                }
            }

            function startCharts() {
              // generate charts data
              var chartsData = ChartUtils.generateChartData(TransactionFactory.viewContext.visibleCharts, $scope.itemData.chargingTransaction.actualState.meterValues, $scope.convert);
              // init charts
              var valueGuides = {};
              var initChartsPromise = ChartUtils.initCharts(showNotEmptyCharts(chartsData), charts, chartsData, prefixedChartsGraphColors, valueGuides, [$translate.instant('COMMONS__CHARGE_BOX') + "_" + $scope.itemData.chargeBox.actualConfiguration['name'], $translate.instant('COMMONS__TRANSACTION') + "_" +  $scope.itemData.chargingTransaction['transactionId']]);
              initChartsPromise.then(
                  function(data) {
                      for (var key in charts) {
                          var chart = charts[key];
                          chart.addListener("zoomed", handleZoom);
                      }
                  }
              );
            }

            function updateCharts(chartsData) {
                var notEmptyCharts = showNotEmptyCharts(chartsData);
                for (var visibleChartIndex = 0; visibleChartIndex < notEmptyCharts.length; visibleChartIndex++) {
                    var visibleChart = notEmptyCharts[visibleChartIndex];
                    if (chartsData[visibleChart.label] != undefined) {
                        var chart = charts[visibleChart.label];
                        var chartData = chartsData[visibleChart.label];
                        for (var chartDataEntryIndex = 0; chartDataEntryIndex < chartData.length; chartDataEntryIndex++) {
                            chart.dataProvider.push(chartData[chartDataEntryIndex]);
                        }
                        if(chart != undefined) {
                          chart.validateData();
                        }
                        var chartZoomData = chartsZoomData[visibleChart.label];
                        if (chartZoomData != undefined) {
                            chart.zoomToIndexes(chartZoomData.startIndex, chartZoomData.endIndex);
                        }
                    }
                }
                updatingCharts = false;
            }

            function showNotEmptyCharts(chartsData) {
              $scope.displayedCharts = [];
              var notEmptyCharts = [];
              for(var index = 0; index < TransactionFactory.viewContext.visibleCharts.length; index++) {
                var expectedChart = TransactionFactory.viewContext.visibleCharts[index];
                var chartDataEntries = chartsData[expectedChart.label];
                if(chartDataEntries != undefined && chartDataEntries.length > 0) {
                  notEmptyCharts.push(expectedChart);
                  $scope.displayedCharts.push(expectedChart.label);
                }
              }
              return notEmptyCharts;
            }

            function handleZoom(event) {
                if (!updatingCharts) {
                    chartsZoomData[event.chart.div.id] = {
                        'startIndex': event.startIndex,
                        'endIndex': event.endIndex
                    }
                }
            }

            function resetChartsZoomData() {
                chartsZoomData = {};
            }

            $scope.$on("$destroy", function() {
                ChartUtils.destroyCharts(charts);
            });
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesOfflineCtrl', ['$controller', '$scope', 'ChargeBoxesOfflineFactory',
        function($controller, $scope, ChargeBoxesOfflineFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesOfflineFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesOfflineFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesOnlineCtrl', ['$controller', '$scope', 'ChargeBoxesOnlineFactory',
        function($controller, $scope, ChargeBoxesOnlineFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesOnlineFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesOnlineFactory.viewContext.restPath);
        }
    ]);
})();

(function() {
    'use strict';
    var module = angular.module('BlurAdmin.chargebox');
    module.controller('ChargeBoxesSetChargingProfilesCtrl', [
        '$controller',
        '$scope',
        '$rootScope',
        '$location',
        '$uibModalStack',
        '$translate',
        'RemoteSetChargingProfileRequestFactory',
        'ChargingProfilesFactory',
        'ResourceServerDataService',
        'ErrorUtils',
        function($controller, $scope, $rootScope, $location, $uibModalStack, $translate, RemoteSetChargingProfileRequestFactory, ChargingProfilesFactory, ResourceServerDataService, ErrorUtils) { 
            $controller('Core.SendRequestController', {
                $scope: $scope,
                ViewFactory: RemoteSetChargingProfileRequestFactory
            });

            var chargingProfilesData = [];
            var errors = [];

            $scope.cancel = function() {
              // redirect to charging profiles
              var url = $location.url();
              var nextUrl = url.substring(0, url.lastIndexOf("/"));
              console.log(nextUrl);
              $location.path(nextUrl);
            }

            $scope.initStartAdditions = function() {
              // get charging profiles data
              var loadChagingProfilesPromise = ResourceServerDataService.rawLoadDataWithoutPagination($scope, undefined, undefined, ChargingProfilesFactory.viewContext, "rest/chargingprofile/identifiers/" , undefined);
              loadChagingProfilesPromise.then(
                function(answer) {
                  if(answer == undefined) {
                    return;
                  }
                  chargingProfilesData = answer;
                  $scope.chargingProfileIdentifiers = [];
                  for(var index = 0; index < answer.length; index++) {
                    $scope.chargingProfileIdentifiers[index] = answer[index].identity;
                  }
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                  return Promise.reject(error);
                }
              )
            }

            $scope.actionAfterRequest = function() {
              // redirect to charging profiles
              var url = $location.url();
              var nextUrl = url.substring(0, url.lastIndexOf("/"));
              console.log(nextUrl);
              $location.path(nextUrl);
            }

            $scope.loadChargingProfile = function(chargingProfileIdentity) {
              if(chargingProfileIdentity == undefined || chargingProfileIdentity == '') {
                $scope.reset();
                return;
              }
              var chargingProfileData = findChargingProfileDataByIdentity(chargingProfileIdentity);
              if(chargingProfileData == undefined) {
                return;
              }
              // get charging profile data
              var loadChargeBoxDataPromise = ResourceServerDataService.loadSingleItemData($scope, ChargingProfilesFactory.viewContext, ChargingProfilesFactory.viewContext.restPath + "/"  + chargingProfileData.identity, undefined);
              loadChargeBoxDataPromise.then(
                function(answer) {
                  $scope.itemData.chargingProfileIdentity = chargingProfileIdentity;
                },
                function(error) {
                  ErrorUtils.handleError(error, errors);
                  return Promise.reject(error);
                }
              )
            }

            $scope.addSchedulePeriod = function() {
              if($scope.itemData.chargingSchedulePeriod == undefined) {
                $scope.itemData.chargingSchedulePeriod = [];
              }
              $scope.itemData.chargingSchedulePeriod.push({
                'startPeriod': 0,
                'limit': 1000,
                'numberPhases': 3
              });
            }

            $scope.removeSchedulePeriod = function(index) {
              $scope.itemData.chargingSchedulePeriod.splice(index, 1);
            }

            function findChargingProfileDataByIdentity(chargingProfileIdentity) {
              for(var index = 0; index < chargingProfilesData.length; index++) {
                var chargingProfileData = chargingProfilesData[index];
                if(chargingProfileData.identity == chargingProfileIdentity) {
                  return chargingProfileData;
                }
              }
              return undefined;
            }

        }
    ]);
})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.chargebox');

    module.controller('ChargeBoxesWarningCtrl', ['$controller', '$scope', 'ChargeBoxesWarningFactory',
        function($controller, $scope, ChargeBoxesWarningFactory) { 
            $controller('Core.ListPaginationController', {
                $scope: $scope,
                ViewFactory: ChargeBoxesWarningFactory
            });

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(ChargeBoxesWarningFactory.viewContext.restPath);
        }
    ]);
})();


(function () {
  'use strict';

  var module = angular.module('BlurAdmin.developer');

  module.controller('ChargeBoxActivityCtrl', ['$controller', '$scope', 'ChargeBoxActivityFactory',
      function($controller, $scope, ChargeBoxActivityFactory) { 
          $controller('Core.ListPaginationController', {
              $scope: $scope,
              ViewFactory: ChargeBoxActivityFactory
          });

          // =====================================================================
          // Invoke at start
          // =====================================================================
          $scope.startView(ChargeBoxActivityFactory.viewContext.restPath);
      }
  ]);

})();

(function () {
  'use strict';

  var module = angular.module('BlurAdmin.developer');

  module.controller('ChargeBoxActivityItemCtrl', [
     '$controller',
     '$scope',
     '$stateParams',
     'ChargeBoxActivityFactory',
      function($controller, $scope, $stateParams, ChargeBoxActivityFactory) { 
          $controller('Core.SingleItemController', {
              $scope: $scope,
              ViewFactory: ChargeBoxActivityFactory
          });

          // =====================================================================
          // Invoke at start
          // =====================================================================
          $scope.startView(ChargeBoxActivityFactory.restPath + '/' + $stateParams.databaseId);
      }
  ]);

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.administration')
        .controller('ImportdataCtrl', [
          '$scope',
          'cfpLoadingBar',
          'HttpUtils',
          'ErrorUtils',
          'ConfigFactory',
          function($scope, cfpLoadingBar, HttpUtils, ErrorUtils, ConfigFactory) {

        var errors = [];

        $scope.importRegistrationData = function(importDataContent) {
            cfpLoadingBar.start();
            var promise = HttpUtils.prepareHttpPost(ConfigFactory.environmentPaths.resourcesServicePath, 'rest/importdata/registration', importDataContent);
            // progress bar ============
            cfpLoadingBar.start();
            // =========================
            promise.then(
                function(answer) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    $scope.importDataSuccessMessage = answer.data;
                },
                function(error) {
                    // progress bar ============
                    cfpLoadingBar.complete();
                    // =========================
                    ErrorUtils.handleError(error, errors);
                }
            );
        }

        $scope.clearMessage = function() {
            $scope.importDataSuccessMessage = undefined;
        }

    }]);

})();


(function () {
  'use strict';

  var module = angular.module('BlurAdmin.developer');

  module.controller('VehicleDistanceCtrl', ['$controller', '$scope', 'VehicleDistanceFactory',
      function($controller, $scope, VehicleDistanceFactory) { 
          $controller('Core.ListPaginationController', {
              $scope: $scope,
              ViewFactory: VehicleDistanceFactory
          });

          // =====================================================================
          // Invoke at start
          // =====================================================================
          $scope.startView(VehicleDistanceFactory.viewContext.restPath);
      }
  ]);

})();

(function () {
  'use strict';

  var module = angular.module('BlurAdmin.developer');

  module.controller('VehicleDistanceItemCtrl', [
     '$controller',
     '$scope',
     '$stateParams',
     'ChargeBoxActivityFactory',
      function($controller, $scope, $stateParams, VehicleDistanceFactory) { 
          $controller('Core.SingleItemController', {
              $scope: $scope,
              ViewFactory: VehicleDistanceFactory
          });

          // =====================================================================
          // Invoke at start
          // =====================================================================
          $scope.startView(VehicleDistanceFactory.restPath + '/' + $stateParams.databaseId);
      }
  ]);

})();

(function() {
    'use strict';

    var module = angular.module('BlurAdmin.map');

    module.controller('ChargeBoxesMapCtrl', [
      '$controller',
      '$scope',
      '$timeout',
      'MapChargeBoxesFactory',
      'ConfigFactory',
      'ChargeBoxUtils',
        function($controller, $scope, $timeout, MapChargeBoxesFactory, ConfigFactory, ChargeBoxUtils) { 
            $controller('Core.ListDisabledPaginationController', {
                $scope: $scope,
                ViewFactory: MapChargeBoxesFactory
            });

            // overrided parent methods
            $scope.initStartAdditions = initStartAdditions;
            $scope.initReloadAdditions = initReloadAdditions;
            // internal state
            var map = undefined;
            var chargeBoxMapIcons = {};
            var chargeBoxMarkers = {};

            // =====================================================================
            // Invoke at start
            // =====================================================================
            $scope.startView(MapChargeBoxesFactory.viewContext.restPath);

            function initStartAdditions() {
              var startLatitude = ConfigFactory.viewSettings['map.latitude'];
              var startLongtitude = ConfigFactory.viewSettings['map.longtitude'];
              var startZoom = ConfigFactory.viewSettings['map.zoom'];
              // init map
              if(startLatitude != undefined && startLongtitude != undefined && startZoom != undefined) {
                map = L.map(document.getElementById('leaflet-map')).setView([startLatitude, startLongtitude], startZoom);
              } else {
                map = L.map(document.getElementById('leaflet-map'));
              }
              L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              }).addTo(map);
              // register icons
              var chargeBoxIcons = ChargeBoxUtils.getStateIcons();
              for(var state in chargeBoxIcons) {
                chargeBoxMapIcons[state] = L.icon({
                    iconUrl: chargeBoxIcons[state],
                    iconSize: [32, 37], // size of the icon
                    });
              }
              // update markers
              updateMarkers($scope.itemsData);
              // auto zoom
              var bounds = [];
              for(var key in chargeBoxMarkers) {
                var chargeBoxMarker = chargeBoxMarkers[key];
                bounds.push([chargeBoxMarker._latlng.lat, chargeBoxMarker._latlng.lng]);
              }
              if(bounds.length > 0) {
                map.fitBounds(bounds);
              }
            }

            function initReloadAdditions() {
              var markerWithOpenPopup = findMarkerWithOpenPopup();
              if(markerWithOpenPopup != undefined) {
                markerWithOpenPopup.closePopup();
              }
              updateMarkers($scope.itemsData);
              if(markerWithOpenPopup != undefined) {
                markerWithOpenPopup.openPopup();
              }
            }

            function findMarkerWithOpenPopup() {
              for(var key in chargeBoxMarkers) {
                var marker = chargeBoxMarkers[key];
                if(marker._popup._isOpen) {
                  return marker;
                }
              }
              return undefined;
            }

            function updateMarkers(itemsData) {
              for(var index = 0; index < itemsData.length; index++) {
                var chargeBox = itemsData[index];
                if(chargeBox.actualConfiguration.latitude != undefined && chargeBox.actualConfiguration.latitude.length != 0 && chargeBox.actualConfiguration.longtitude != undefined && chargeBox.actualConfiguration.longtitude.length != 0) {
                  // init new marker
                  if(chargeBoxMarkers[chargeBox.chargeBoxIdentity] == undefined) {
                    if(chargeBox.actualConfiguration.latitude != '0' && chargeBox.actualConfiguration.longtitude != '0') {
                      var popupContent = ChargeBoxUtils.initChargeBoxTooltipHtmlData(chargeBox);
                      chargeBoxMarkers[chargeBox.chargeBoxIdentity] =  L.marker([chargeBox.actualConfiguration.latitude, chargeBox.actualConfiguration.longtitude], {icon: chargeBoxMapIcons[chargeBox.actualState.chargeBoxStatus]}).addTo(map)
                            .bindPopup(popupContent);
                    }
                  }
                  // update marker
                  else {
                    var chargeBoxMarker = chargeBoxMarkers[chargeBox.chargeBoxIdentity];
                    if(chargeBoxMarker != undefined) {
                      // update icon
                      chargeBoxMarker.setIcon(chargeBoxMapIcons[chargeBox.actualState.chargeBoxStatus]);
                      // update popup
                      var popupContent = ChargeBoxUtils.initChargeBoxTooltipHtmlData(chargeBox);
                      chargeBoxMarker.bindPopup(popupContent);
                    }
                  }
                }
              }
            }

        }
    ]);
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author pawel.rogos
 * created on 01.04.2017
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('commonsUtil', commonsUtil);

    /** @ngInject */
    function commonsUtil($rootScope, $http, $uibModal, $cookies, $sce, $timeout, $state, $location, $translate) {


        // =====================================================================
        // init root scope
        // =====================================================================

        $rootScope.version = 'version7';
        // date settings

        $rootScope.datePickerOptions = {
            showWeeks: false
        };

        // =====================================================================
        // messages
        // =====================================================================

        this.clearMessage = function(scope) {
            scope.message = undefined;
        }

        // =====================================================================
        // date picker
        // =====================================================================



    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function() {
	'use strict';
	var module = angular.module('BlurAdmin.transactions');
	module.directive('transactionsPreview', ['$interval', 'DateUtils', 'ResourceServerDataService', 'TransactionFactory', function($interval, DateUtils, ResourceServerDataService, TransactionFactory) {
		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			templateUrl: 'app/transactions/transactions_preview/transactions_preview.html',
			scope: {
				src: "="
			},
			controller: function($scope) {
				$scope.formatDate = DateUtils.formatDate;
				// at start
				var loadDataPromise = ResourceServerDataService.rawLoadDataWithoutPagination(undefined, undefined, undefined, TransactionFactory.viewContext, TransactionFactory.viewContext.restPath + '/last', undefined);
				loadDataPromise.then(function(itemsData) {
					$scope.lastChargingTransactions = itemsData;
				}, function(error) {
					// empty
				});
				// reload
				var autoReloadDataPromise = undefined;
				autoReloadDataPromise = $interval(function() {
					var loadDataPromise = ResourceServerDataService.rawLoadDataWithoutPagination(undefined, undefined, undefined, TransactionFactory.viewContext, TransactionFactory.viewContext.restPath + '/last', undefined);
					loadDataPromise.then(function(itemsData) {
						$scope.lastChargingTransactions = itemsData;
					}, function(error) {
						// empty
					});
				}, 5000);
				// =====================================================================
				// destroy
				// =====================================================================
				$scope.$on('$destroy', function() {
					if (autoReloadDataPromise != undefined) {
						$interval.cancel(autoReloadDataPromise);
					}
				});
			}
		}
	}]);
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });
          var menu = [];
          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
            item.abstract ? children.forEach(function(singleChild){
              singleChild.subMenu = null;
              menu.push(singleChild);
            }) : menu.push(item);
          });

          return menu.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  permission: s.permission,
                  abstract: s.abstract,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state, $stateParams) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function(){
            return $state.$current.name
        }, function(newVal, oldVal){
          $scope.activePageTitle = $state.current.title;

          var outputBreadcrumbs = [];
          if($state.current.breadcrumbs != undefined) {
            var breadcrumbsFragments = $state.current.breadcrumbs.split(';');
            var availableStates = $state.get();
            for(var index = 0; index < breadcrumbsFragments.length; index++) {
              var breadcrumbFragment = breadcrumbsFragments[index];
              if(breadcrumbFragment.length != 0) {
                var breadcrumbState = getBreadcrumbsEntry(availableStates, breadcrumbFragment);
                var breadcrumbStateFragments = breadcrumbState.url.split('/');
                var stateParams = {};
                for(var stateFragmentIndex = 0; stateFragmentIndex < breadcrumbStateFragments.length; stateFragmentIndex++) {
                  var fragmentEntry = breadcrumbStateFragments[stateFragmentIndex];
                  if(fragmentEntry[0] == ':') {
                    var fragmentKey = fragmentEntry.slice(1);
                    stateParams[fragmentKey] = $stateParams[fragmentKey];
                  }
                }
                var breadcrumbEntry = {
                  name: breadcrumbState.title,
                  url: $state.href(breadcrumbState.name, stateParams, {absolute: true, inherit: false})
                }
                outputBreadcrumbs.push(breadcrumbEntry);
              }
            }
          }
          $scope.breadcrumbs = outputBreadcrumbs;
        });
      }
    };
  }

  function getBreadcrumbsEntry(availableStates, breadcrumbStateName) {
    for(var index = 0; index < availableStates.length; index++) {
      var state = availableStates[index];
      if(state.name == breadcrumbStateName) {
        return state;
      }
    }
    throw 'State with name ' + breadcrumbStateName + ' was not found.';
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/alerts/template/alert_details.html','<div class="col-md-12" ba-panel="" ba-panel-title="{{ \'ALERT_VIEW__TITLE\' | translate }}" ba-panel-class="with-scroll"><div class="row text-right" style="padding: 0.5em 2em 0.5em 0" ng-if="userContext.permission[\'AlertDefinition::updateItem\']"><label ng-click="deleteAlertItem(itemData.alertEntity)"><span style="cursor: hand; cursor: pointer" class="glyphicon glyphicon-trash" data-toggle="tooltip" title="{{ \'ALERT_VIEW__DELETE\' | translate }}"></span> <span>{{ \'ALERT_VIEW__DELETE\' | translate }}</span></label></div><h4 ng-show="itemData.alertEntity.chargeBoxIdentity != undefined">{{ \'COMMONS__CHARGE_BOX\' | translate }}: {{ itemData.alertEntity.chargeBoxIdentity }}<span ng-show="{{ itemData.alertEntity.name}}">: {{ itemData.alertEntity.name }}</span></h4><p>{{ \'ALERT_VIEW__ALERT_TIME\' | translate }}: {{ formatDate(itemData.alertEntity.alertTime) }}</p><ul><li>{{ \'ALERT_VIEW__TRIGGER_METHOD\' | translate }}: {{ itemData.alertEntity.triggerMethod }}</li><li>{{ \'ALERT_VIEW__CONDITION\' | translate }}: {{ itemData.alertEntity.expression }}</li><li>{{ \'ALERT_VIEW__NOTIFICATION_TYPE\' | translate }}: {{ itemData.notificationEntity.notificationType }}</li><li>{{ \'ALERT_VIEW__RECEIVERS\' | translate }}: {{ itemData.notificationEntity.receiver }}</li><li>{{ \'ALERT_VIEW__STATUS\' | translate }}: {{ itemData.alertEntity[\'status\'] }}</li><li>{{ \'ALERT_VIEW__ERROR_CODE\' | translate }}: {{ itemData.alertEntity[\'errorCode\'] }}</li><li>{{ \'ALERT_VIEW__VENDOR_ERROR_CODE\' | translate }}: {{ itemData.alertEntity[\'vendorErrorCode\'] }}</li></ul><div class="row" ng-show="itemData.notificationEntity != undefined"><div class="col-md-12 form-group"><label for="rawRequest">{{ \'ALERT_VIEW__SUBJECT\' | translate }}</label> <textarea rows="2" ng-model="itemData.notificationEntity.subject" class="form-control" style="height: auto;" id="rawRequest"></textarea></div></div><div class="row" ng-show="itemData.notificationEntity != undefined"><div class="col-md-12 form-group"><label for="rawResponse">{{ \'ALERT_VIEW__CONTENT\' | translate }}</label> <textarea rows="20" ng-model="itemData.notificationEntity.content" class="form-control" style="height: auto;" id="rawResponse"></textarea></div></div></div>');
$templateCache.put('app/alerts/template/alert_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/alerts/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/authorization/view/forgotPassword.html','<div class="wrapper"><form class="form-signin"><h2 class="form-signin-heading">{{ \'LOGIN__FORGOT_PASSWORD\' | translate }}</h2><h5 class="form-signin-heading">{{ \'LOGIN__FORGOT_PASSWORD_MESSAGE\' | translate }}</h5><input type="text" class="form-control" name="username" placeholder="{{ \'LOGIN__EMAIL_ADDRESS\' | translate }}" required="" autofocus="" ng-model="authorizationData.username"> <button ng-click="restore(authorizationData)" class="btn btn-lg btn-primary btn-block">{{ \'LOGIN__SEND\' | translate }}</button></form></div>');
$templateCache.put('app/authorization/view/login.html','<div class="login-wrapper wrapper"><h2 class="form-signin-heading">{{ \'LOGIN__PLEASE_LOGIN\' | translate }}</h2><form class="form-signin"><input type="text" class="form-control" name="username" placeholder="{{ \'LOGIN__EMAIL_ADDRESS\' | translate }}" required="" autofocus="" ng-model="authorizationData.username"> <input type="password" class="form-control" name="password" placeholder="{{ \'LOGIN__PASSWORD\' | translate }}" required="" ng-model="authorizationData.password"> <label class="checkbox"><input type="checkbox" value="remember-me" id="rememberMe" name="rememberMe" ng-model="authorizationData.rememberMe"> {{ \'LOGIN__REMEMBER_ME\' | translate }}</label> <a href="#/forgotPassword">{{ \'LOGIN__FORGOT_PASSWORD\' | translate }}</a> <button ng-click="login(authorizationData)" class="btn btn-lg btn-primary btn-block">{{ \'LOGIN__LOGIN\' | translate }}</button></form></div>');
$templateCache.put('app/authorization/view/missingPermissions.html','{{ \'MISSING_PERMISSIONS\' | translate }}');
$templateCache.put('app/authorization/view/resetPassword.html','<div class="wrapper"><form class="form-signin"><h2 class="form-signin-heading">{{ \'LOGIN__RESET_PASSWORD\' | translate }}</h2><input type="password" class="form-control" name="password" placeholder="{{ \'LOGIN__PASSWORD\' | translate }}" required="" ng-model="authorizationData.password"> <button ng-click="changePassword(authorizationData)" class="btn btn-lg btn-primary btn-block">{{ \'LOGIN__SET\' | translate }}</button></form></div>');
$templateCache.put('app/chargeboxgroup/view/chargeboxgroup_details.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><h4>{{ \'CHARGE_BOX_GROUP_VIEW__NAME\' | translate }}: {{ itemData.name }}</h4><ul><li>{{ \'COMMONS__ADDED_DATE_TIME\' | translate }}: {{ formatDate(itemData.addedDateTime) }}</li><li>{{ \'CHARGE_BOX_GROUP_VIEW__DESCRIPTION\' | translate }}: {{ itemData.description }}</li></ul><h4>{{ \'CHARGE_BOX_GROUP_VIEW__CHARGE_BOXES\' | translate }}</h4><table class="table" st-table="itemData.chargeBoxes"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="name">{{ \'CHARGE_BOXES_TABLE__CHARGE_POINT_NAME\' | translate }}</th><th st-sort="chargeBoxIdentity">{{ \'CHARGE_BOXES_TABLE__CHARGE_BOX_IDENTITY\' | translate }}</th><th st-sort="chargeBoxSerialNumber">{{ \'CHARGE_BOXES_TABLE__CHARGE_BOX_SERIAL_NUMBER\' | translate }}</th><th st-sort="ipAddress">{{ \'CHARGE_BOXES_TABLE__IP_ADDRESS\' | translate }}</th><th st-sort="tableData.getters.lastActivityTime">{{ \'CHARGE_BOXES_TABLE__LAST_ACTIVITY\' | translate }}</th><th st-sort="chargeBoxStatus">{{ \'CHARGE_BOXES_TABLE__CHARGE_POINT_STATUS\' | translate }}</th><th>{{ \'COMMONS__SHOW\' | translate }}</th></tr></thead><tbody><tr ng-repeat="chargeBox in itemData.chargeBoxes"><td class="table-id">{{chargeBox.id}}</td><td>{{ chargeBox[\'chargeBoxIdentity\'] }}</td><td>{{ chargeBox.actualConfiguration[\'name\'] }}</td><td>{{ chargeBox.actualConfiguration[\'chargeBoxSerialNumber\'] }}</td><td>{{ chargeBox.actualConfiguration[\'ipAddress\'] }}</td><td>{{ formatDate(chargeBox.actualState[\'lastActivityTime\']) }}</td><td>{{ chargeBox.actualState[\'chargeBoxStatus\'] }}</td><td><a href="{{ chargeBox.showDetailsUrl }}">{{ \'COMMONS__SHOW_DETAILS\' | translate }}</a></td></tr></tbody></table></div>');
$templateCache.put('app/chargeboxgroup/view/chargeboxgroup_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/chargeboxgroup/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/chargingprofiles/template/chargingprofiles_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/chargingprofiles/components/form.htm\'"></div></div>');
$templateCache.put('app/chargingprofiles/template/chargingprofiles_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/chargingprofiles/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/chargingprofiles/template/chargingprofiles_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/chargingprofiles/components/form.htm\'"></div></div>');
$templateCache.put('app/dashboard/template/dashboard_template.html','<div ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row" ng-include="\'app/dashboard/components/dashboard.htm\'"></div></div></div></div><back-top></back-top></div>');
$templateCache.put('app/reports/view/chargebox_consumed_energy.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/reports/components/chargebox_search_criteria_form.htm\'"></div></div><h3>{{ \'COMMONS__SUMMARY\' | translate }}:</h3><div ng-include="\'app/reports/components/summary_report_table.htm\'"></div><h3 style="margin-top: 40px;">{{ \'COMMONS__CHARGEBOXES\' | translate }}:</h3><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/reports/view/chargeboxgroup_consumed_energy.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/reports/components/chargeboxgroup_search_criteria_form.htm\'"></div></div><h3>{{ \'COMMONS__SUMMARY\' | translate }}:</h3><div ng-include="\'app/reports/components/summary_report_table.htm\'"></div><h3 style="margin-top: 40px;">{{ \'COMMONS__CHARGEBOX_GROUPS\' | translate }}:</h3><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/reports/view/report_templates.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar_for_template_report.htm\'"></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/reports/view/report_templates_details.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><h3>{{ \'COMMONS__TEMPLATE_DATA\' | translate }}:</h3><ul><li>{{ \'REPORTS__NAME\' | translate }}: {{ templateData.name }}</li><li>{{ \'REPORTS__DESCRIPTION\' | translate }}: {{ templateData.description }}</li><li>{{ \'REPORT__TYPE\' | translate }}: {{ templateData.reportType | translate }}</li><li>{{ \'REPORT__ITEMS\' | translate }}: {{ templateData.reportElements }}</li><li>{{ \'REPORT__INTERVAL\' | translate }}: {{ templateData.reportInterval | translate }}</li><li>{{ \'REPORT__DETAILS\' | translate }}: {{ templateData.reportDetailed == true ? \'Tak\' : \'Nie\' }}</li><li ng-if="fromTime != undefined">{{ \'REPORT__START_DATE\' | translate }}: {{ formatDate(fromTime) }}</li><li ng-if="toTime != undefined">{{ \'REPORT__END_DATE\' | translate }}: {{ formatDate(toTime) }}</li></ul><h3>{{ \'COMMONS__SUMMARY\' | translate }}:</h3><div ng-include="\'app/reports/components/summary_report_table.htm\'"></div><div ng-if="templateData.reportDetailed"><h3 ng-if="templateData.reportType == \'ChargeBoxes\'" style="margin-top: 40px;">{{ \'COMMONS__CHARGEBOXES\' | translate }}:</h3><h3 ng-if="templateData.reportType == \'Vehicles\'" style="margin-top: 40px;">{{ \'COMMONS__VEHICLES\' | translate }}:</h3><div ng-include="\'app/_core_view/component/table.htm\'"></div></div></div>');
$templateCache.put('app/reports/view/report_templates_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/reports/components/report_templates_form.htm\'"></div></div>');
$templateCache.put('app/reports/view/report_templates_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/reports/components/report_templates_form.htm\'"></div></div>');
$templateCache.put('app/reports/view/transactions_report.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__START_TIMESTAMP\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.searchCriteriaData.fromTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.searchCriteriaData.fromTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__STOP_TIMESTAMP\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.searchCriteriaData.toTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.searchCriteriaData.toTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row" style="padding-bottom: 1em;"><div class="col-md-3 text-right" style="line-height: 2.5em;"></div><div class="col-md-7"><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'H_6\')">{{ \'COMMONS__PERIOD_6_H\' | translate }}</button></div><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'H_24\')">{{ \'COMMONS__PERIOD_24_H\' | translate }}</button></div><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'D_10\')">{{ \'COMMONS__PERIOD_10_D\' | translate }}</button></div><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'D_30\')">{{ \'COMMONS__PERIOD_30_D\' | translate }}</button></div><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'M_6\')">{{ \'COMMONS__PERIOD_6_M\' | translate }}</button></div><div class="col-md-2" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'M_12\')">{{ \'COMMONS__PERIOD_12_M\' | translate }}</button></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__CHARGE_BOX_IDENTITY\' | translate }}:</span></div><div class="col-md-7"><p><ui-select multiple="" ng-model="$parent.searchCriteriaData.charge_box_name" ng-disabled="false" search-enabled="true" append-to-body="true" theme="bootstrap" class="form-control"><ui-select-match>{{ $item }}</ui-select-match><ui-select-choices repeat="multipleItem in viewMetadata.searchFieldsValues.chargeBoxNames | filter: $select.search">{{ multipleItem }}</ui-select-choices></ui-select></p></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'REPORT_CHARGE_BOX_GROUP__GROUP_NAME\' | translate }}:</span></div><div class="col-md-7"><p><ui-select multiple="" ng-model="$parent.searchCriteriaData.chargeBoxGroupName" ng-disabled="false" search-enabled="true" append-to-body="true" theme="bootstrap" class="form-control"><ui-select-match>{{ $item }}</ui-select-match><ui-select-choices repeat="multipleItem in viewMetadata.searchFieldsValues.chargeBoxGroupIdentifiers | filter: $select.search">{{ multipleItem }}</ui-select-choices></ui-select></p></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__VEHICLE_NAME\' | translate }}:</span></div><div class="col-md-7"><p><ui-select multiple="" ng-model="$parent.searchCriteriaData.vehicleSideNumbers" ng-disabled="false" search-enabled="true" append-to-body="true" theme="bootstrap" class="form-control"><ui-select-match>{{ $item }}</ui-select-match><ui-select-choices repeat="multipleItem in viewMetadata.searchFieldsValues.vehicleSideNumbers | filter: $select.search track by $index">{{ multipleItem }}</ui-select-choices></ui-select></p></div></div><div class="col-md-10 text-right"><button style="width: 8em;" type="submit" class="btn btn-info" ng-click="exportXLSXData()">{{ \'COMMONS__EXPORT_XLSX\' | translate }}</button> <button style="width: 8em;" type="submit" class="btn btn-info" ng-click="exportData(searchCriteriaData)">{{ \'COMMONS__EXPORT_CSV\' | translate }}</button> <button style="width: 8em;" type="submit" class="btn btn-info" ng-click="resetSearchCriteria(searchCriteriaData)">{{ \'COMMONS__RESET\' | translate }}</button></div></form></div>');
$templateCache.put('app/reports/view/vehicle_consumed_energy.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/reports/components/vehicle_search_criteria_form.htm\'"></div></div><h3>{{ \'COMMONS__SUMMARY\' | translate }}:</h3><div ng-include="\'app/reports/components/summary_report_table.htm\'"></div><h3 style="margin-top: 40px;">{{ \'COMMONS__VEHICLES\' | translate }}:</h3><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/transactions/transactions_preview/transactions_preview.html','<div style="padding: 10px;"><table id="lastChargingTransactions" width="100%;"><thead><tr><th>{{ \'TRANSACTIONS_TABLE__STOP_TIMESTAMP\' | translate }}</th><th>{{ \'TRANSACTIONS_TABLE__CHARGE_BOX\' | translate }} / {{ \'TRANSACTIONS_TABLE__VEHICLE\' | translate }}</th><th>{{ \'TRANSACTIONS_TABLE__SOCK\' | translate }}</th></tr></thead><tbody><tr ng-repeat="lastChargingTransaction in lastChargingTransactions"><td style="width: 70px;">{{ formatDate(lastChargingTransaction.stopTimestamp) }}</td><td>{{ lastChargingTransaction.chargeBoxName }}<br>{{ lastChargingTransaction.vehicleName }}</td><td align="center" style="width: 30px;">{{ lastChargingTransaction.socAtEnd}}</td></tr></tbody></table></div>');
$templateCache.put('app/transactions/view/details.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="row"><div class="col-md-6"><div ng-include="\'app/transactions/components/tansaction_details_table.htm\'"></div></div></div><div class="row"><div class="col-md-12" ng-repeat="key in displayedCharts"><h2>{{ \'COMMONS__\' + key | translate }}</h2><div id="{{ key }}" style="width: 100%; height: 300px;"></div></div></div></div>');
$templateCache.put('app/transactions/view/transactions.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/transactions/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/userprofile/template/profile.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'USER_PROFILE__LANGUAGE\' | translate }}:</span></div><div class="col-md-7"><select name="language" ng-model="selectedLanguage" class="form-control" ng-change="changeLanguage(selectedLanguage)"><option ng-repeat="language in availableLanguages" value="{{ language }}">{{ language }}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;">{{ \'USER_PROFILE__USER_DATA\' | translate }}</div><div class="col-md-7"><ul><li>{{ \'USER_PROFILE__EMAIL\' | translate }}: {{ userContext.email }}</li><li>{{ \'USER_PROFILE__FIRST_NAME\' | translate }}: {{ userContext.firstName }}</li><li>{{ \'USER_PROFILE__LAST_NAME\' | translate }}: {{ userContext.lastName }}</li><li>{{ \'USER_PROFILE__PHONE\' | translate }}: {{ userContext.phone }}</li></ul></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;">{{ \'USER_PROFILE__ROLES\' | translate }}</div><div class="col-md-7"><ul><li ng-repeat="role in userContext.roles">{{ role }}</li></ul></div></div></div>');
$templateCache.put('app/vehicle/template/vehicle_details.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><ul><li>{{ \'VEHICLE_VIEW__IDENTITY\' | translate }}: {{ itemData.identity }}</li><li>{{ \'VEHICLE_VIEW__NAME\' | translate }}: {{ itemData.actualConfiguration.sideNumber }}</li><li>{{ \'VEHICLE_VIEW__BATTERY_CAPACITY\' | translate }}: {{ itemData.actualConfiguration.batteryCapacity }}</li></ul></div>');
$templateCache.put('app/vehicle/template/vehicle_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/vehicle/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/account/view/user_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/account/component/edit-form.htm\'"></div></div>');
$templateCache.put('app/administration/account/view/user_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/account/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/account/view/user_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/account/component/register-form.htm\'"></div></div>');
$templateCache.put('app/administration/alert/view/alert_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row text-right" style="padding: 0.5em 2em 0.5em 0" ng-if="userContext.permission[\'AlertDefinition::updateItem\']"><label ng-click="deleteAlertDefinitionItem(itemData)"><span style="cursor: hand; cursor: pointer" class="glyphicon glyphicon-trash" data-toggle="tooltip" title="{{ \'ALERT_VIEW__DELETE\' | translate }}"></span> <span>{{ \'ALERT_VIEW__DELETE\' | translate }}</span></label></div><div ng-include="\'app/administration/alert/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/alert/view/alert_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/alert/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/alert/view/alert_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/alert/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/authorizationtags/template/authorizationtag_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/authorizationtags/components/form.htm\'"></div></div>');
$templateCache.put('app/administration/authorizationtags/template/authorizationtag_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/authorizationtags/components/form.htm\'"></div></div>');
$templateCache.put('app/administration/authorizationtags/template/authorizationtags.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/authorizationtags/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/chargebox/view/chargebox_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/chargebox/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/chargebox/view/chargebox_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/chargebox/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/chargebox/view/chargebox_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/chargebox/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/chargeboxgroup/view/chargeboxgroup_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><h4>{{ itemData.name }}</h4><div ng-include="\'app/administration/chargeboxgroup/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/chargeboxgroup/view/chargeboxgroup_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/chargeboxgroup/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/chargeboxgroup/view/chargeboxgroup_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/chargeboxgroup/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/role/view/role_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/role/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/role/view/role_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/role/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/role/view/role_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/role/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/useractivity/component/useractivity_details_table.html','<table class="table"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="4">{{ \'SIDEBAR_TITLE__USERACTIVITY\' | translate }}</th></tr></thead><tbody><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__CHANGED_TIMESTAMP\' | translate }}:</td><td colspan="2">{{ formatDate(itemData.changeTimestamp) }}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__CHANGED_OBJECT\' | translate }}:</td><td colspan="2">{{ translateType(itemData.changedObject) }}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__CHANGED_OBJECT_NAME\' | translate }}:</td><td colspan="2">{{ itemData.changedObjectName }}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__CHANGED_SUB_PARAMETER\' | translate }}:</td><td colspan="2">{{ itemData.changedSubParameter}}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__CHANGED_PARAMETER\' | translate }}:</td><td colspan="2">{{ translateParameter(itemData.changedParameter) }}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__OLD_VALUE\' | translate }}:</td><td colspan="2">{{ itemData.oldValue}}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__NEW_VALUE\' | translate }}:</td><td colspan="2">{{ itemData.newValue}}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__USERNAME\' | translate }}:</td><td colspan="2">{{ itemData.username}}</td></tr><tr><td style="text-align: left;" colspan="2">{{ \'USERACTIVITY__TYPE\' | translate }}:</td><td colspan="2">{{ itemData.type }}</td></tr></tbody></table>');
$templateCache.put('app/administration/useractivity/view/useractivity_details.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><div ng-include="\'app/administration/useractivity/component/useractivity_details_table.html\'"></div></div></div></div>');
$templateCache.put('app/administration/useractivity/view/useractivity_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/useractivity/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/vehicle/view/vehicle_edit.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/vehicle/component/form.htm\'"></div></div>');
$templateCache.put('app/administration/vehicle/view/vehicle_list.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/administration/vehicle/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/administration/vehicle/view/vehicle_register.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/administration/vehicle/component/form.htm\'"></div></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/change_configuration.html','<div class="modal-content" style="display:table; width: 100%;" ng-controller="ChargeBoxChangeConfigurationCtrl"><div class="modal-header bg-info">{{ \'CHARGE_BOX__CHANGE_CONFIGURATION\' | translate }}</div><div class="modal-body"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHANGE_CONFIGURATION__KEY\' | translate }}:</span></div><div class="col-md-9"><input type="text" class="form-control" id="connectorId" ng-model="itemData.key" disabled=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHANGE_CONFIGURATION__VALUE\' | translate }}:</span></div><div class="col-md-9"><input type="text" class="form-control" id="idTag" ng-model="itemData.value" required=""></div></div><div class="row" ng-show="response != undefined && response.configurationStatus != undefined"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'COMMONS__STATUS\' | translate }}:</span></div><div class="col-md-9" style="line-height: 2.5em;"><span ng-show="isLoading" class="loading-indicator"></span> {{ response.configurationStatus }}</div></div></div><div class="modal-footer"><button style="width:160px;" type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button style="width:160px;" type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/chargebox_charging_profiles.html','<div ui-view=""><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button style="width: 8em;" class="btn btn-info" ng-click="navToSetChargingProfile()">{{ \'CHARGE_BOX__SET_CHARGING_PROFILE\' | translate }}</button></div></div><div class="row"><div class="col-md-12"><div id="chartdiv" style="width: 100%; height: 300px;"></div></div></div><div class="row"><div class="col-md-12"><div ng-include="\'app/_core_view/component/table_disabled_pagination.htm\'"></div></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/reset.html','<div class="modal-content" style="display:table; width: 100%;" ng-controller="ChargeBoxResetCtrl"><div class="modal-header bg-info">{{ \'CHARGE_BOX__STOP_TRANSACTION\' | translate }}</div><div class="modal-body"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGE_BOX__RESET_TYPE\' | translate }}:</span></div><div class="col-md-7"><select name="resetType" ng-model="itemData.type" class="form-control"><option ng-repeat="item in metadata.chargeBoxResetTypes" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'COMMONS__STATUS\' | translate }}:</span></div><div class="col-md-7" style="line-height: 2.5em;">{{ response.startStatus }}</div></div></div><div class="modal-footer"><button ng-show="itemData.message == undefined" type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button ng-show="itemData.message != undefined" type="submit" class="btn btn-info" disabled="">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/set_max_power.html','<div class="modal-content" style="display:table; width: 100%;" ng-controller="ChargeBoxSetMaxPowerCtrl"><form name="set_max_power"><div class="modal-header bg-info">{{ \'CHARGE_BOX__CHANGE_CONFIGURATION\' | translate }}</div><div class="modal-body"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHANGE_CONFIGURATION__VALUE\' | translate }}:</span></div><div class="col-md-9"><input type="text" class="form-control" id="idTag" ng-model="itemData.value" required=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'COMMONS__STATUS\' | translate }}:</span></div><div class="col-md-9" style="line-height: 2.5em;"><span ng-show="isLoading" class="loading-indicator"></span> {{ response.chargingProfileStatus }}</div></div></div><div class="modal-footer"><button ng-disabled="!set_max_power.$valid" style="width:160px;" type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button style="width:160px;" type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></form></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/start_transaction.html','<div class="modal-content" style="display:table; width: 100%;" ng-controller="ChargeBoxStartTransactionCtrl"><div class="modal-header bg-info">{{ \'CHARGE_BOX__START_TRANSACTION\' | translate }}</div><div class="modal-body"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'REMOTE_START_TRANSACTION__CONNECTOR_ID\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="connectorId" ng-model="itemData.connectorId" required=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'REMOTE_START_TRANSACTION__ID_TAG\' | translate }}:</span></div><div class="col-md-7"><p class="input-group"><select name="availableIdTag" ng-model="itemData.idTag" class="form-control" required=""><option ng-repeat="item in itemData.availableIdTags" value="{{ item }}">{{item}}</option></select></p></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'COMMONS__STATUS\' | translate }}:</span></div><div class="col-md-7" style="line-height: 2.5em;">{{ response.startStatus }}</div></div></div><div class="modal-footer"><button type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/chargebox/chargeboxes/dialog/stop_transaction.html','<div class="modal-content" style="display:table; width: 100%;" ng-controller="ChargeBoxStopTransactionCtrl"><div class="modal-header bg-info">{{ \'CHARGE_BOX__STOP_TRANSACTION\' | translate }}</div><div class="modal-body"><div class="row" ng-show="itemData.message != undefined"><div class="col-md-3 text-right" style="line-height: 2.5em;"></div><div class="col-md-7"><span style="color:red;">{{ itemData.message }}</span></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'REMOTE_STOP_TRANSACTION__TRANSACTION_ID\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="transactionId" ng-model="itemData.transactionId"></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND_REQUEST\' | translate }}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_activity_hours.html','<div ui-view=""><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table" style="margin-top: 16px;"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="3">{{ itemData.chargeBox.actualConfiguration.name }} <span class="action underline" style="color: white;" ng-click="showChargeBoxMap()">({{ \'CHARGE_BOX_VIEW__SHOW_ON_MAP\' | translate }}</span>, <span class="action underline" style="color: white;" ng-click="showChargeBoxConfiguration()">{{ \'CHARGE_BOX_VIEW__SHOW_CONFIGURATION\' | translate }})</span></th></tr></thead><tbody><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.chargeBoxSerialNumber }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_EDIT__MAX_FACTORY_POWER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxFactoryPower }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__SET_POWER\' | translate }} <span class="action underline" ng-click="showPowerSetInput()">({{ \'COMMONS__CHANGE\' | translate }})</span></td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxPowerSet }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__PRODUCT_GROUPS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.groups }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_ACTIVITY \' | translate }}:</td><td colspan="2">{{ formatDate(itemData.chargeBox.actualState.lastActivityTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__IP_ADDRESS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.ipAddress }}</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus == \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td>{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td><td>{{ \'CHARGE_BOX_VIEW__EXPECTED_TIME\' | translate }}:</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus != \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td colspan="2">{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGING_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalChargingTime) }}</td><td colspan="2">{{ \'CHARGE_BOX_VIEW__ONLINE_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalOnlineTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_FAIL\' | translate }}:</td><td colspan="2">{{ formatTime(itemData.chargeBox.actualState.lastErrorTime) }}</td></tr></tbody></table></div><div class="col-md-6"><form><div class="row"><div class="col-md-1 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__START_TIMESTAMP\' | translate }}:</span></div><div class="col-md-6" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.searchCriteriaData.fromTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-5" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.searchCriteriaData.fromTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-1 text-right" style="line-height: 2.5em;"><span>{{ \'TRANSACTIONS_SEARCH_FORM__STOP_TIMESTAMP\' | translate }}:</span></div><div class="col-md-6" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.searchCriteriaData.toTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-5" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.searchCriteriaData.toTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row" style="padding-bottom: 1em;"><div class="col-md-1 text-right" style="line-height: 2.5em;"></div><div class="col-md-11" style="line-height: 2.5em;"><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'H_6\')">{{ \'COMMONS__PERIOD_6_H\' | translate }}</button></div><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'H_24\')">{{ \'COMMONS__PERIOD_24_H\' | translate }}</button></div><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'D_10\')">{{ \'COMMONS__PERIOD_10_D\' | translate }}</button></div></div></div><div class="row" style="padding-bottom: 1em;"><div class="col-md-1 text-right" style="line-height: 2.5em;"></div><div class="col-md-11" style="line-height: 2.5em;"><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'D_30\')">{{ \'COMMONS__PERIOD_30_D\' | translate }}</button></div><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'M_6\')">{{ \'COMMONS__PERIOD_6_M\' | translate }}</button></div><div class="col-md-3" style="padding-left: 0;"><button style="width: 100%" class="btn btn-secondary" ng-click="setDatePeriod(\'M_12\')">{{ \'COMMONS__PERIOD_12_M\' | translate }}</button></div></div></div><div class="col-md-10 text-right"><button style="width: 8em;" type="submit" class="btn btn-info" ng-click="searchByCriteria(searchCriteriaData)">{{ \'COMMONS__SHOW\' | translate }}</button> <button style="width: 8em;" type="submit" class="btn btn-info" ng-click="resetSearchCriteria(searchCriteriaData)">{{ \'COMMONS__RESET\' | translate }}</button></div></form></div></div><div class="row"><div class="col-md-12" ng-repeat="key in displayedCharts"><div id="{{ key }}" style="width: 100%; height: 300px;"></div></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_alerts.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/chargebox/chargeboxes/component/alert_search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_charging_profiles.html','<div ui-view=""><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table" style="margin-top: 16px;"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="3">{{ itemData.chargeBox.actualConfiguration.name }} <span class="action underline" style="color: white;" ng-click="showChargeBoxMap()">({{ \'CHARGE_BOX_VIEW__SHOW_ON_MAP\' | translate }}</span>, <span class="action underline" style="color: white;" ng-click="showChargeBoxConfiguration()">{{ \'CHARGE_BOX_VIEW__SHOW_CONFIGURATION\' | translate }})</span></th></tr></thead><tbody><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.chargeBoxSerialNumber }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_EDIT__MAX_FACTORY_POWER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxFactoryPower }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__SET_POWER\' | translate }} <span class="action underline" ng-click="showPowerSetInput()">({{ \'COMMONS__CHANGE\' | translate }})</span></td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxPowerSet }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__PRODUCT_GROUPS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.groups }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_ACTIVITY \' | translate }}:</td><td colspan="2">{{ formatDate(itemData.chargeBox.actualState.lastActivityTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__IP_ADDRESS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.ipAddress }}</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus == \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td>{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td><td>{{ \'CHARGE_BOX_VIEW__EXPECTED_TIME\' | translate }}:</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus != \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td colspan="2">{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGING_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalChargingTime) }}</td><td colspan="2">{{ \'CHARGE_BOX_VIEW__ONLINE_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalOnlineTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_FAIL\' | translate }}:</td><td colspan="2">{{ formatTime(itemData.chargeBox.actualState.lastErrorTime) }}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><div ng-include="\'app/_core_view/component/table_disabled_pagination.htm\'"></div></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_charging_schedule.html','<div ui-view=""><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table" style="margin-top: 16px;"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="3">{{ itemData.chargeBox.actualConfiguration.name }} <span class="action underline" style="color: white;" ng-click="showChargeBoxMap()">({{ \'CHARGE_BOX_VIEW__SHOW_ON_MAP\' | translate }}</span>, <span class="action underline" style="color: white;" ng-click="showChargeBoxConfiguration()">{{ \'CHARGE_BOX_VIEW__SHOW_CONFIGURATION\' | translate }})</span></th></tr></thead><tbody><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.chargeBoxSerialNumber }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_EDIT__MAX_FACTORY_POWER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxFactoryPower }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__SET_POWER\' | translate }} <span class="action underline" ng-click="showPowerSetInput()">({{ \'COMMONS__CHANGE\' | translate }})</span></td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxPowerSet }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__PRODUCT_GROUPS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.groups }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_ACTIVITY \' | translate }}:</td><td colspan="2">{{ formatDate(itemData.chargeBox.actualState.lastActivityTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__IP_ADDRESS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.ipAddress }}</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus == \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td>{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td><td>{{ \'CHARGE_BOX_VIEW__EXPECTED_TIME\' | translate }}:</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus != \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td colspan="2">{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGING_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalChargingTime) }}</td><td colspan="2">{{ \'CHARGE_BOX_VIEW__ONLINE_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalOnlineTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_FAIL\' | translate }}:</td><td colspan="2">{{ formatTime(itemData.chargeBox.actualState.lastErrorTime) }}</td></tr></tbody></table></div><div class="col-md-6"><div class="row"><form name="chargingScheduleForm"><div class="row" style="margin-top: 16px; margin-bottom: 16px; text-align: right; padding-right: 15px;"><div class="col-md-6"><button class="btn btn-info" style="width: 100%;" ng-click="navToChargingProfiles()">{{ \'CHARGE_BOX__ARCHIVED_SET_CHARGING_PROFILE\' | translate }}</button></div><div class="col-md-6"><button class="btn btn-info" style="width: 100%;" ng-click="navToSetChargingProfile()">{{ \'CHARGE_BOX__SET_CHARGING_PROFILE\' | translate }}</button></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__CONNECTOR\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="connector" ng-model="requestData.connectorId"></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__DURATION\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="duration" ng-model="requestData.duration"></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__CHARGING_RATE_UNIT\' | translate }}:</span></div><div class="col-md-7"><select name="chargingRateUnit" ng-model="requestData.chargingRateUnit" class="form-control" required=""><option ng-repeat="item in metadata.chargingRateUnitType" value="{{ item }}">{{item}}</option></select></div></div><div class="row" style="margin-top: 16px; margin-bottom: 16px; text-align: right; padding-right: 15px;"><div class="col-md-12"><button ng-disabled="!chargingScheduleForm.$valid" class="btn btn-info" style="width: 100%;" ng-click="sendGetChargingScheduleRequest()">{{ \'CHARGE_BOX__GET_CHARGING_SCHEDULE\' | translate }}</button></div></div></form></div></div></div><div class="row" ng-if="itemsData != undefined" style="margin-top: 20px;"><div class="col-md-12"><h3>{{ \'RESULTS_FOR\' | translate }}:</h3><ul><li>{{ \'CHARGING_PROFILE__CONNECTOR\' | translate }}: {{ sendedRequestData.connectorId }}</li><li>{{ \'CHARGING_PROFILE__DURATION\' | translate }}: {{ sendedRequestData.duration }}</li><li>{{ \'CHARGING_PROFILE__CHARGING_RATE_UNIT\' | translate }}: {{ sendedRequestData.chargingRateUnit }}</li></ul><div ng-include="\'app/_core_view/component/table_disabled_pagination.htm\'"></div></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_configuration.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row" style="margin-top: 15px; margin-bottom: 15px; text-align: right;"><div class="col-md-12"><span ng-show="isLoading" class="loading-indicator"></span> <button type="submit" class="btn btn-info" ng-disabled="itemData.chargeBoxStatus == \'OFFLINE\'" ng-click="downloadConfiguration(itemData)">{{ \'CHARGE_BOX_CONFIGURATION__DOWNLOAD_CONFIGURATION\' | translate }}</button></div></div><div class="row"><div class="col-md-6"><table class="table"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="3">{{ \'CHARGE_BOX_CONFIGURATION__READ_ONLY\' | translate }}</th></tr></thead><tbody><tr ng-repeat="(key, value) in itemData.readOnlyValues"><td>{{ $index + 1 }}</td><td>{{ key }}</td><td>{{ value }}</td></tr></tbody></table></div><div class="col-md-6"><table class="table"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="4">{{ \'CHARGE_BOX_CONFIGURATION__READ_WRITE\' | translate }}</th></tr></thead><tbody><tr ng-repeat="(key, value) in itemData.readWriteValues"><td width="5%">{{ $index + 1 }}</td><td width="40%">{{ key }}</td><td width="50%"><span style="padding-left: 15px;">{{ value }}</span></td><td class="action" ng-click="showConfigEntryInput(key, value)"><i class="fa fa-cloud-upload" aria-hidden="true"></i></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_details.html','<div class="col-md-12" ba-panel="" ba-panel-title="{{ itemData.chargeBox.actualConfiguration.name }}" ba-panel-class="with-scroll"><div class="row text-right" style="padding: 0.5em 2em 0.5em 0"><label ng-show="viewContext.reloadData != undefined" class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="reloadDataCheckbox" ng-model="viewSettings.reloadData"> <span>{{ \'COMMONS__AUTO_RELOAD\' | translate }}</span></label></div><div class="row"><div class="col-md-2"><button ng-disabled="itemData.chargeBox.actualState.chargeBoxStatus == \'CHARGING\' || itemData.chargeBox.actualState.chargeBoxStatus == \'OFFLINE\'" style="width: 100%;" class="btn btn-info" ng-click="remoteStartTransaction(itemData.chargeBox)">{{ \'COMMONS__REMOTE_START_TRANSACTION\' | translate }}</button></div><div class="col-md-2"><button ng-disabled="itemData.chargeBox.actualState.chargeBoxStatus != \'CHARGING\'" style="width: 100%;" class="btn btn-info" ng-click="remoteStopTransaction(itemData.chargeBox)">{{ \'COMMONS__REMOTE_STOP_TRANSACTION\' | translate }}</button></div><div class="col-md-2"><button ng-disabled="itemData.chargeBox.actualState.chargeBoxStatus == \'OFFLINE\'" style="width: 100%;" class="btn btn-info" ng-click="remoteReset(itemData.chargeBox)">{{ \'COMMONS__REMOTE_RESET\' | translate }}</button></div><div class="col-md-3"><button style="width: 100%;" class="btn btn-info" ng-click="showHistoricSessions(itemData.chargeBox)">{{ \'CHARGE_BOX_VIEW__SHOW_HISTORIC_SESSIONS\' | translate }}</button></div><div class="col-md-3"><button style="width: 100%;" class="btn btn-info" ng-click="showHistoricAlerts(itemData.chargeBox)">{{ \'CHARGE_BOX_VIEW__SHOW_HISTORIC_ALERTS\' | translate }}</button></div></div><div class="row"><div class="col-md-6"><div ng-include="\'app/chargebox/chargeboxes/component/chargebox_details_table.htm\'"></div></div><div class="col-md-6"><div ng-include="\'app/chargebox/chargeboxes/component/chargebox_last_transaction_details_table.htm\'"></div></div></div><div class="row" ng-if="itemData.chargingTransaction != undefined"><div class="col-md-12" ng-repeat="key in displayedCharts"><h2>{{ \'COMMONS__\' + key | translate }}</h2><div id="{{ key }}" style="width: 100%; height: 300px;"></div></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_diagnostics.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div class="row" style="margin-top: 15px; margin-bottom: 15px; text-align: right;"><div class="col-md-12"><span ng-show="isLoading" class="loading-indicator"></span> <button type="submit" class="btn btn-info" ng-disabled="itemData.chargeBoxStatus == \'OFFLINE\'" ng-click="getDiagnostics(itemData)">{{ \'CHARGE_BOX_CONFIGURATION__GET_DIAGNOSTICS\' | translate }}</button></div></div><div class="row"><div class="col-md-6"><table class="table" style="margin-top: 16px;"><thead><tr style="background-color: #c9c9c9; color: white;"><th colspan="3">{{ itemData.chargeBox.actualConfiguration.name }} <span class="action underline" style="color: white;" ng-click="showChargeBoxMap()">({{ \'CHARGE_BOX_VIEW__SHOW_ON_MAP\' | translate }}</span>, <span class="action underline" style="color: white;" ng-click="showChargeBoxConfiguration()">{{ \'CHARGE_BOX_VIEW__SHOW_CONFIGURATION\' | translate }})</span></th></tr></thead><tbody><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGE_BOX_SERIAL_NUMBER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.chargeBoxSerialNumber }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_EDIT__MAX_FACTORY_POWER\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxFactoryPower }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__SET_POWER\' | translate }} <span class="action underline" ng-click="showPowerSetInput()">({{ \'COMMONS__CHANGE\' | translate }})</span></td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.maxPowerSet }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__PRODUCT_GROUPS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.groups }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_ACTIVITY \' | translate }}:</td><td colspan="2">{{ formatDate(itemData.chargeBox.actualState.lastActivityTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__IP_ADDRESS\' | translate }}:</td><td colspan="2">{{ itemData.chargeBox.actualConfiguration.ipAddress }}</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus == \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td>{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td><td>{{ \'CHARGE_BOX_VIEW__EXPECTED_TIME\' | translate }}:</td></tr><tr ng-if="itemData.chargeBox.actualState.chargeBoxStatus != \'CHARGING\'"><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGEBOX_STATUS\' | translate }}:</td><td colspan="2">{{ \'CHARGE_BOX_STATUS__\' + itemData.chargeBox.actualState.chargeBoxStatus | translate }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__CHARGING_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalChargingTime) }}</td><td colspan="2">{{ \'CHARGE_BOX_VIEW__ONLINE_TIME\' | translate }}: {{ millisecondsToStrTimeInterval(itemData.chargeBox.actualState.totalOnlineTime) }}</td></tr><tr><td style="text-align: left;">{{ \'CHARGE_BOX_VIEW__LAST_FAIL\' | translate }}:</td><td colspan="2">{{ formatTime(itemData.chargeBox.actualState.lastErrorTime) }}</td></tr></tbody></table></div><div class="col-md-6"><form name="getDiagnosticsForm"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color: red;">*</span> <span>{{ \'DIAGNOSTICS__LOCATION\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="chargeBoxIdentity" ng-model="requestData.location" required=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'DIAGNOSTICS__START_TIME\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.requestData.startTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.requestData.startTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'DIAGNOSTICS__STOP_TIME\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.requestData.stopTime" ng-change="validateDate()" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.requestData.stopTime" ng-change="validateDate()" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'DIAGNOSTICS__RETRIES\' | translate }}:</span></div><div class="col-md-7"><input type="number" class="form-control" id="chargeBoxIdentity" ng-model="requestData.retries" required=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'DIAGNOSTICS__RETRY_INTERVAL\' | translate }}:</span></div><div class="col-md-7"><input type="number" class="form-control" id="chargeBoxIdentity" ng-model="requestData.retryInterval" required=""></div></div></form></div></div></div><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/_core_view/component/table.htm\'"></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_set_charging_profiles.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><form name="chargingProfileForm"><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__PRESET\' | translate }}:</span></div><div class="col-md-7"><select name="chargingProfilePurposeType" ng-model="itemData.chargingProfileIdentity" ng-change="loadChargingProfile(itemData.chargingProfileIdentity)" class="form-control"><option ng-repeat="item in chargingProfileIdentifiers" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-4 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__DETAILS\' | translate }}:</span></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__TRANSACTION_ID\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="transactionId" ng-model="itemData.transactionId"></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__STACK_LEVEL\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="stackLevel" ng-model="itemData.stackLevel" required=""></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__CHARGING_PROFILE_PURPOSE\' | translate }}:</span></div><div class="col-md-7"><select name="chargingProfilePurposeType" ng-model="itemData.chargingProfilePurpose" class="form-control" required=""><option ng-repeat="item in metadata.chargingProfilePurposeType" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__CHARGING_PROFILE_KIND\' | translate }}:</span></div><div class="col-md-7"><select name="chargingProfileKind" ng-model="itemData.chargingProfileKind" class="form-control" required=""><option ng-repeat="item in metadata.chargingProfileKindType" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__RECURRENCY_KIND\' | translate }}:</span></div><div class="col-md-7"><select name="recurrencyKind" ng-model="itemData.recurrencyKind" class="form-control"><option ng-repeat="item in metadata.recurrencyKindType" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__VALID_FROM\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="datePickerOptions" ng-model="$parent.itemData.validFrom" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.itemData.validFrom" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__VALID_TO\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.itemData.validTo" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.itemData.validTo" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__DURATION\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="duration" ng-model="itemData.duration"></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span>{{ \'CHARGING_PROFILE__START_SCHEDULE\' | translate }}:</span></div><div class="col-md-3" ng-controller="DatePickerPopupCtrl"><p class="input-group"><input type="text" class="form-control" readonly="" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="datePickerOptions" ng-model="$parent.itemData.startSchedule" is-open="opened" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-3" ng-controller="TimePickerPopupCtrl"><div uib-timepicker="" ng-model="$parent.itemData.startSchedule" hour-step="hstep" minute-step="mstep" show-spinners="false" show-meridian="ismeridian"></div></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__CHARGING_RATE_UNIT\' | translate }}:</span></div><div class="col-md-7"><select name="chargingRateUnit" ng-model="itemData.chargingRateUnit" class="form-control" required=""><option ng-repeat="item in metadata.chargingRateUnitType" value="{{ item }}">{{item}}</option></select></div></div><div class="row"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__MIN_CHARGING_RATE\' | translate }}:</span></div><div class="col-md-7"><input type="text" class="form-control" id="minChargingRate" ng-model="itemData.minChargingRate" required=""></div></div><div class="row" ng-if="itemData.chargingSchedulePeriod != undefined" style="margin-top: 10px;"><div class="col-md-3 text-right" style="line-height: 2.5em;"><span style="color:red;">*</span> <span>{{ \'CHARGING_PROFILE__CHARGING_SCHEDULE_PERIOD\' | translate }}:</span></div><div class="col-md-7"><table class="table" style="border: 1px solid #cbcbcb;"><thead><tr><th width="30%" style="text-align: center;">{{ \'CHARGING_PROFILE__START_PERIOD\' | translate }}</th><th width="30%" style="text-align: center;">{{ \'CHARGING_PROFILE__LIMIT\' | translate }}</th><th width="30%" style="text-align: center;">{{ \'CHARGING_PROFILE__NUMBER_PHASES\' | translate }}</th><th width="10%" style="text-align: center;"></th></tr></thead><tbody><tr ng-repeat="schedulePeriod in itemData.chargingSchedulePeriod"><td><input type="text" class="form-control" style="margin: 10px 5px; text-align: right;" ng-model="schedulePeriod.startPeriod" required=""></td><td><input type="text" class="form-control" style="margin: 10px 5px; text-align: right;" ng-model="schedulePeriod.limit" required=""></td><td><input type="text" class="form-control" style="margin: 10px 5px; text-align: right;" ng-model="schedulePeriod.numberPhases"></td><td align="center"><span style="cursor: hand; cursor: pointer; margin: 18px 5px;" ng-click="removeSchedulePeriod($index)" class="glyphicon glyphicon-trash"></span></td></tr></tbody></table></div></div><div class="row"><div class="col-md-10 text-right" style="padding: 20px;"><button class="btn btn-info" ng-click="addSchedulePeriod()">{{ \'CHARGING_PROFILE__ADD_SCHEDULE_PERIOD\' | translate }}</button></div></div><div class="row"><div class="col-md-10 text-right" style="padding: 20px;"><button ng-disabled="!chargingProfileForm.$valid" style="width: 8em;" type="submit" class="btn btn-info" ng-click="sendRequest(itemData)">{{ \'COMMONS__SEND\' | translate }}</button> <button style="width: 8em;" class="btn btn-info" ng-click="reset()">{{ \'COMMONS__RESET\' | translate }}</button> <button style="width: 8em;" class="btn btn-info" ng-click="cancel()" type="cancel" formnovalidate="">{{ \'COMMONS__CANCEL\' | translate }}</button></div></div></form></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargebox_transactions.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/chargebox/chargeboxes/component/transactions_search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div></div>');
$templateCache.put('app/chargebox/chargeboxes/view/chargeboxes.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/chargebox/chargeboxes/component/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/developer/chargeboxactivity/template/chargeboxactivity.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/developer/chargeboxactivity/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/developer/chargeboxactivity/template/chargeboxactivity_view.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><h4>{{ \'COMMONS__CHARGE_BOX\' | translate }}: {{ itemData.chargeBoxIdentity }}<span ng-show="{{ itemData.name}}">: {{ itemData.name }}</span></h4><p>{{ \'COMMONS_REQUEST__TIME\' | translate }}: {{ formatDate(itemData.activityTime) }}</p><p>{{ \'COMMONS_REQUEST__RESPONSE_STATUS\' | translate }}</p><ul><li>{{ \'COMMONS_REQUEST__STATUS\' | translate }}: {{ itemData.responseStatus }}</li><li ng-if="itemData.exceptionMessage">{{ \'COMMONS_REQUEST__EXCEPTION_MESSAGE\' | translate }}: {{ itemData.exceptionMessage }}</li></ul><div class="row"><div class="col-md-12 form-group"><label for="rawRequest">{{ \'COMMONS__REQUEST\' | translate }}</label> <textarea rows="20" ng-model="itemData.rawRequest" class="form-control" style="height: auto;" id="rawRequest"></textarea></div></div><div class="row" ng-show="itemData.rawResponse != undefined"><div class="col-md-12 form-group"><label for="rawResponse">{{ \'COMMONS__RESPONSE\' | translate }}</label> <textarea rows="20" ng-model="itemData.rawResponse" class="form-control" style="height: auto;" id="rawResponse"></textarea></div></div></div>');
$templateCache.put('app/developer/importdata/template/registration.html','<div class="col-md-12" ba-panel="" ba-panel-title="{{ \'IMPORT_REGISTRATION_DATA__TITLE\' | translate }}" ba-panel-class="with-scroll"><div ng-show="importDataSuccessMessage != undefined" class="alert bg-success closeable" role="alert"><button ng-click="clearMessage()" type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> {{ \'IMPORT_REGISTRATION_DATA__SUCCESSFULLY_IMPORTED\' | translate }}<br><br>{{ importDataSuccessMessage }}</div><form><div class="form-group"><label for="ImportDataContent">{{ \'IMPORT_REGISTRATION_DATA__CONTENT_TO_IMPORT\' | translate }}</label> <textarea ng-model="dataToImport" placeholder="{{ \'IMPORT_REGISTRATION_DATA__CONTENT_TO_IMPORT\' | translate }}" class="form-control" id="ImportDataContent"></textarea></div><button type="submit" class="btn btn-danger" ng-click="importRegistrationData(dataToImport)">{{ \'IMPORT_REGISTRATION_DATA__IMPORT\' | translate }}</button></form></div>');
$templateCache.put('app/developer/vehicledistance/template/vehicledistance.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/theme/components/actions/table_actions_top_bar.htm\'"></div><div ng-show="viewSettings.displaySearchCriteria" style="padding-top: 0.5em; padding-bottom: 0.5em; margin-bottom: 4em;"><div ng-include="\'app/developer/vehicledistance/components/search_criteria_form.htm\'"></div></div><div ng-include="\'app/_core_view/component/table.htm\'"></div></div>');
$templateCache.put('app/developer/vehicledistance/template/vehicledistance_view.html','<div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"></div>');
$templateCache.put('app/map/chargeboxes/template/chargeboxes.html','<div ui-view=""><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div id="leaflet-map"></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" ng-if="item.permission == undefined || userContext.permission[item.permission]" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-if="subitem.permission == undefined || userContext.permission[subitem.permission]" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title | translate }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">&emsp; {{ ::subSubitem.title | translate }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">&emsp; {{ ::subSubitem.title | translate }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">&emsp; {{ ::subitem.title | translate }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">&emsp; {{ ::subitem.title | translate }}</a></li></ul></li><li><transactions-preview></transactions-preview></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><div id="snackbar">{{ \'COMMONS_DATA__WAS_LOADED\' | translate }}</div><h1 class="al-title">{{ activePageTitle | translate }}</h1><ul class="breadcrumb al-breadcrumb"><li ng-repeat="breadcrumbsEntry in breadcrumbs"><a href="{{ breadcrumbsEntry.url }}">{{ breadcrumbsEntry.name | translate }}</a></li><li>{{ activePageTitle | translate }}</li></ul></div>');
$templateCache.put('app/theme/components/modals/info.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-flame modal-icon"></i><span>{{ title }}</span></div><div class="modal-body"><div class="row text-left"><div class="col-md-12"><p><strong>{{ message }}</strong></p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/theme/components/modals/serverNotAvailable.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>{{ \'COMMONS__ERROR\' | translate }}</span></div><div class="modal-body text-center">{{ \'COMMONS__SERVER_IS_NOT_AVAILABLE\' | translate }}</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/theme/components/modals/viewSettings.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-flame modal-icon"></i><span>Chargeboxes view settings</span></div><div class="modal-body"><div class="row text-left"><div class="col-md-12"><p><strong>General settings:</strong></p></div><div class="col-md-12"><div class="col-md-4 text-right">Show advanced search:</div><div class="col-md-6"><input type="checkbox" ng-model="viewMetadata.showAdvancedSearch" ng-click="storeViewSettings()"></div></div><div class="col-md-12" style="padding-top: 1em;"><p><strong>Table visible columns:</strong></p></div><div class="col-md-6" ng-repeat="(key, value) in viewMetadata.tableColumnsSettings"><div class="col-md-8 text-right">{{ key }}:</div><div class="col-md-4"><input type="checkbox" ng-model="viewMetadata.tableColumnsSettings[key]" ng-click="storeViewSettings()"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">Close</button></div></div>');
$templateCache.put('app/theme/components/modals/warning.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>{{ title }}</span></div><div class="modal-body"><div class="row text-left"><div class="col-md-12"><p><strong>{{ message }}</strong></p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="cancel()">{{ \'COMMONS__CLOSE\' | translate }}</button></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><img src="{{ appLogo }}"><br><p>{{ \'VERSION\' | translate }} 1.2.1</p></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="assets/img/theme/no-photo.png"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a style="cursor: pointer;" href="#/user/profile"><i class="fa fa-user"></i>{{ \'COMMONS__PROFILE\' | translate }}</a></li><li><a style="cursor: pointer;" ng-click="logout()"><i class="fa fa-power-off"></i>{{ \'COMMONS__SIGN_OUT\' | translate }}</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);